
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebc49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebc49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




// import "./components/QuickSearchMount.jsx";


var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");
var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
const $626bd95fa485b758$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $626bd95fa485b758$export$ff817e17bad2e091 = 'xs';
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f, Provider: $626bd95fa485b758$var$Provider } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === 'rtl';
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;



"use client";
const $49d9d24d620fa26d$var$Container = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$49d9d24d620fa26d$var$Container.displayName = 'Container';
var $49d9d24d620fa26d$export$2e2bcd8739ae039 = $49d9d24d620fa26d$var$Container;



var $acw62 = parcelRequire("acw62");
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $acw62 = parcelRequire("acw62");
var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler;
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
            $b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}



var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $b7f5460541b42e0f$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($b7f5460541b42e0f$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, key) && $b7f5460541b42e0f$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $c8a186e1757974bb$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}




var $01b4fe2088fac58b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $01b4fe2088fac58b$export$2e2bcd8739ae039(element, selector) {
    return $01b4fe2088fac58b$var$toArray(element.querySelectorAll(selector));
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $e12c5402755aae29$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $acw62.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $acw62 = parcelRequire("acw62");
const $b5599328f7cdd88d$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $b5599328f7cdd88d$export$c9058316764c140e(refA, refB) {
    const a = $b5599328f7cdd88d$var$toFnRef(refA);
    const b = $b5599328f7cdd88d$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $b5599328f7cdd88d$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$b5599328f7cdd88d$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $b5599328f7cdd88d$export$2e2bcd8739ae039 = $b5599328f7cdd88d$var$useMergedRefs;



var $acw62 = parcelRequire("acw62");
const $45c958b882f3532f$var$NavContext = /*#__PURE__*/ $acw62.createContext(null);
$45c958b882f3532f$var$NavContext.displayName = 'NavContext';
var $45c958b882f3532f$export$2e2bcd8739ae039 = $45c958b882f3532f$var$NavContext;



var $acw62 = parcelRequire("acw62");
const $9c8dd72e635c1db4$var$SelectableContext = /*#__PURE__*/ $acw62.createContext(null);
const $9c8dd72e635c1db4$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $9c8dd72e635c1db4$export$2e2bcd8739ae039 = $9c8dd72e635c1db4$var$SelectableContext;



var $acw62 = parcelRequire("acw62");
const $b72131d84963b3ba$var$TabContext = /*#__PURE__*/ $acw62.createContext(null);
var $b72131d84963b3ba$export$2e2bcd8739ae039 = $b72131d84963b3ba$var$TabContext;


const $1123d3fd1f42218c$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1123d3fd1f42218c$export$635202801f9383a0 = `rrUi`;
function $1123d3fd1f42218c$export$5cc3b7b83e34ade7(property) {
    return `${$1123d3fd1f42218c$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1123d3fd1f42218c$export$7776c0a7cd2eb3e0(property) {
    return `${$1123d3fd1f42218c$export$635202801f9383a0}${property}`;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $cbe95659e68dd1dd$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $cbe95659e68dd1dd$export$2e2bcd8739ae039 = $cbe95659e68dd1dd$var$useCommittedRef;


function $838dd0f898428a09$export$2e2bcd8739ae039(fn) {
    const ref = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}





var $acw62 = parcelRequire("acw62");

const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = 'Button';
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;





const $31dc5e0f2f162e1f$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $31dc5e0f2f162e1f$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const navContext = (0, $acw62.useContext)((0, $45c958b882f3532f$export$2e2bcd8739ae039));
    const tabContext = (0, $acw62.useContext)((0, $b72131d84963b3ba$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $31dc5e0f2f162e1f$var$NavItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $0522fa2e4977c358$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(_ref, $31dc5e0f2f162e1f$var$_excluded);
    const [props, meta] = $31dc5e0f2f162e1f$export$d7a68693710982a(Object.assign({
        key: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$31dc5e0f2f162e1f$var$NavItem.displayName = 'NavItem';
var $31dc5e0f2f162e1f$export$2e2bcd8739ae039 = $31dc5e0f2f162e1f$var$NavItem;



const $bdf8c5d517fb941c$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $bdf8c5d517fb941c$var$noop = ()=>{};
const $bdf8c5d517fb941c$var$EVENT_KEY_ATTR = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('event-key');
const $bdf8c5d517fb941c$var$Nav = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(_ref, $bdf8c5d517fb941c$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $e12c5402755aae29$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $acw62.useRef)(false);
    const parentOnSelect = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const tabContext = (0, $acw62.useContext)((0, $b72131d84963b3ba$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $acw62.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(currentListNode, `[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $1123d3fd1f42218c$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $acw62.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $b5599328f7cdd88d$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45c958b882f3532f$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $bdf8c5d517fb941c$var$noop,
                getControllerId: getControllerId || $bdf8c5d517fb941c$var$noop
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$bdf8c5d517fb941c$var$Nav.displayName = 'Nav';
var $bdf8c5d517fb941c$export$2e2bcd8739ae039 = Object.assign($bdf8c5d517fb941c$var$Nav, {
    Item: (0, $31dc5e0f2f162e1f$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");
"use client";
// TODO: check
const $46425249d1e44fce$var$context = /*#__PURE__*/ $acw62.createContext(null);
$46425249d1e44fce$var$context.displayName = 'NavbarContext';
var $46425249d1e44fce$export$2e2bcd8739ae039 = $46425249d1e44fce$var$context;



var $acw62 = parcelRequire("acw62");
"use client";
const $5eb077b72b2eb187$var$context = /*#__PURE__*/ $acw62.createContext(null);
$5eb077b72b2eb187$var$context.displayName = 'CardHeaderContext';
var $5eb077b72b2eb187$export$2e2bcd8739ae039 = $5eb077b72b2eb187$var$context;



var $acw62 = parcelRequire("acw62");



"use client";
const $b38cb042d7fdd569$var$NavItem = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$b38cb042d7fdd569$var$NavItem.displayName = 'NavItem';
var $b38cb042d7fdd569$export$2e2bcd8739ae039 = $b38cb042d7fdd569$var$NavItem;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $5251105f62ca120d$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}





var $acw62 = parcelRequire("acw62");

function $f665bd0f5e0a2735$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(listener);
    (0, $acw62.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $acw62 = parcelRequire("acw62");
function $123822626b455986$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $acw62.useCallback)(()=>document, []);
    return (0, $f665bd0f5e0a2735$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $acw62 = parcelRequire("acw62");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $9b2e3fbaf6312caa$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $acw62.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $9b2e3fbaf6312caa$export$2e2bcd8739ae039 = $9b2e3fbaf6312caa$var$useInterval;



var $acw62 = parcelRequire("acw62");

function $a09c0dd7291b0177$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $acw62.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $a09c0dd7291b0177$export$2e2bcd8739ae039 = $a09c0dd7291b0177$var$useRafInterval;



var $acw62 = parcelRequire("acw62");
function $3473f9615acd9416$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $acw62.useState)(initialState);
    const updater = (0, $acw62.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $a03001e30ff1047d$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $3473f9615acd9416$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $acw62 = parcelRequire("acw62");
function $5bd0dc278db65a7f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $acw62 = parcelRequire("acw62");
function $27d585c6d75dcd23$export$2e2bcd8739ae039(value) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $f003183c755c096a$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $acw62.useState)({
        image: null,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $6b8eaefeef7398a7$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $6b8eaefeef7398a7$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $6b8eaefeef7398a7$export$2e2bcd8739ae039 = $6b8eaefeef7398a7$var$isDOM || $6b8eaefeef7398a7$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


const $584ddec03c2e34ed$var$targetMap = new WeakMap();
let $584ddec03c2e34ed$var$resizeObserver;
function $584ddec03c2e34ed$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $584ddec03c2e34ed$var$resizeObserver = $584ddec03c2e34ed$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $584ddec03c2e34ed$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $584ddec03c2e34ed$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $acw62.useState)(null);
    (0, $6b8eaefeef7398a7$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $584ddec03c2e34ed$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $584ddec03c2e34ed$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $584ddec03c2e34ed$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $a02c1087963bbb34$var$_excluded = [
    "onKeyDown"
];
function $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a02c1087963bbb34$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a02c1087963bbb34$var$Anchor = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(_ref, $a02c1087963bbb34$var$_excluded);
    const [buttonProps] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a02c1087963bbb34$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a02c1087963bbb34$var$Anchor.displayName = 'Anchor';
var $a02c1087963bbb34$export$2e2bcd8739ae039 = $a02c1087963bbb34$var$Anchor;






"use client";
const $8dc05f39bc918f56$var$NavLink = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $a02c1087963bbb34$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $31dc5e0f2f162e1f$export$d7a68693710982a)({
        key: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$8dc05f39bc918f56$var$NavLink.displayName = 'NavLink';
var $8dc05f39bc918f56$export$2e2bcd8739ae039 = $8dc05f39bc918f56$var$NavLink;



"use client";
const $aa29ebe1e6d9cd49$var$Nav = /*#__PURE__*/ $acw62.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $acw62.useContext)((0, $5eb077b72b2eb187$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdf8c5d517fb941c$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$aa29ebe1e6d9cd49$var$Nav.displayName = 'Nav';
var $aa29ebe1e6d9cd49$export$2e2bcd8739ae039 = Object.assign($aa29ebe1e6d9cd49$var$Nav, {
    Item: (0, $b38cb042d7fdd569$export$2e2bcd8739ae039),
    Link: (0, $8dc05f39bc918f56$export$2e2bcd8739ae039)
});



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


"use client";
const $b5ed781c15448fd9$var$NavbarBrand = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix)
    });
});
$b5ed781c15448fd9$var$NavbarBrand.displayName = 'NavbarBrand';
var $b5ed781c15448fd9$export$2e2bcd8739ae039 = $b5ed781c15448fd9$var$NavbarBrand;



var $acw62 = parcelRequire("acw62");

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $da31306d5140b746$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, '-$1').toLowerCase();
}


var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $9f2c378a21ca2430$export$2e2bcd8739ae039)(string).replace($09bdad49a6503060$var$msPattern, '-ms-');
}


var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}


function $1d31c226dae4138f$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property)) || (0, $9d0d2e2a013bac9c$export$2e2bcd8739ae039)(node).getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $09bdad49a6503060$export$2e2bcd8739ae039)(key));
        else if ((0, $c8af0fa0e8553220$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $09bdad49a6503060$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



var $acw62 = parcelRequire("acw62");
function $a36e95ee292bed8b$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $a36e95ee292bed8b$export$13e065f3a74cfe36() {
    const parts = $acw62.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $a36e95ee292bed8b$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $a36e95ee292bed8b$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}




/* eslint-disable no-return-assign */ var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
        window.addEventListener('test', $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener('test', $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;


function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $28419dce7921d430$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $d690caf237d1909f$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $3966a04026e86a49$var$parseDuration(node) {
    var str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $d690caf237d1909f$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3966a04026e86a49$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3966a04026e86a49$var$parseDuration(element) || 0;
    var removeEmulate = $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $f251260f6a38a977$var$parseDuration(node, property) {
    const str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f251260f6a38a977$export$2e2bcd8739ae039(element, handler) {
    const duration = $f251260f6a38a977$var$parseDuration(element, 'transitionDuration');
    const delay = $f251260f6a38a977$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $70a5c1c5c22ba944$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $70a5c1c5c22ba944$export$2e2bcd8739ae039 = $70a5c1c5c22ba944$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $02f7800ef44133eb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $9d58c39545e3cedc$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    const a = $9d58c39545e3cedc$var$toFnRef(refA);
    const b = $9d58c39545e3cedc$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$9d58c39545e3cedc$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;



function $75718871ab216e51$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $5e18c3cbbc2321dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fef977f04119bf5$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$5e18c3cbbc2321dd$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $5e18c3cbbc2321dd$export$2e2bcd8739ae039 = $5e18c3cbbc2321dd$var$TransitionWrapper;



const $6225d171b822135d$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $6225d171b822135d$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $6225d171b822135d$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $6225d171b822135d$var$collapseStyles = {
    [(0, $0fef977f04119bf5$export$84cbff306f539230)]: 'collapse',
    [(0, $0fef977f04119bf5$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: 'collapsing',
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $6225d171b822135d$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $6225d171b822135d$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $a36e95ee292bed8b$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, children.props.className, $6225d171b822135d$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$6225d171b822135d$var$Collapse.displayName = 'Collapse';
var $6225d171b822135d$export$2e2bcd8739ae039 = $6225d171b822135d$var$Collapse;





"use client";
const $2710431f613a38bf$var$NavbarCollapse = /*#__PURE__*/ $acw62.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6225d171b822135d$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$2710431f613a38bf$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $2710431f613a38bf$export$2e2bcd8739ae039 = $2710431f613a38bf$var$NavbarCollapse;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;


function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}





"use client";
const $0ecac5fdbe294867$var$NavbarToggle = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$0ecac5fdbe294867$var$NavbarToggle.displayName = 'NavbarToggle';
var $0ecac5fdbe294867$export$2e2bcd8739ae039 = $0ecac5fdbe294867$var$NavbarToggle;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $63565b817d447aae$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $63565b817d447aae$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $63565b817d447aae$export$2e2bcd8739ae039 = $63565b817d447aae$var$isDOM || $63565b817d447aae$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
const $93efd0ca86a6ce96$var$matchersByWindow = new WeakMap();
const $93efd0ca86a6ce96$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $93efd0ca86a6ce96$var$matchersByWindow.get(targetWindow) || new Map();
    $93efd0ca86a6ce96$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $93efd0ca86a6ce96$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $93efd0ca86a6ce96$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $acw62.useState)(()=>mql ? mql.matches : false);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        let mql = $93efd0ca86a6ce96$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $93efd0ca86a6ce96$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $acw62 = parcelRequire("acw62");
function $d7a77e47f418a0f8$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $acw62.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $93efd0ca86a6ce96$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $d7a77e47f418a0f8$var$useBreakpoint = $d7a77e47f418a0f8$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $d7a77e47f418a0f8$export$2e2bcd8739ae039 = $d7a77e47f418a0f8$var$useBreakpoint;




var $acw62 = parcelRequire("acw62");

function $d26eb8849281a3d4$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $b95b475ea97df998$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $acw62 = parcelRequire("acw62");
function $7fbb0d02e065d911$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $b95b475ea97df998$export$2e2bcd8739ae039)(fn);
    (0, $acw62.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $01b2d58e52126803$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $254a0b83be45660e$export$1a88c12b8b979fa0 = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $254a0b83be45660e$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $01b2d58e52126803$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($254a0b83be45660e$export$1a88c12b8b979fa0, '');
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($254a0b83be45660e$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $254a0b83be45660e$export$2e2bcd8739ae039 = $254a0b83be45660e$var$ModalManager;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0e151397e562aebc$var$Context = /*#__PURE__*/ (0, $acw62.createContext)((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) ? window : undefined);
const $0e151397e562aebc$export$f7d306aeb1cf5fbc = $0e151397e562aebc$var$Context.Provider;
function $0e151397e562aebc$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)($0e151397e562aebc$var$Context);
}


const $1892253eb6d46162$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $fcf05e248574eb57$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $1892253eb6d46162$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $acw62.useState)(()=>$1892253eb6d46162$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $acw62.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const nextRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $83a01f83dd44ef33$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $acw62.useRef)(null);
    const hasEnteredRef = (0, $acw62.useRef)(inProp);
    const handleExited = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(onExited);
    (0, $acw62.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $b5599328f7cdd88d$export$2e2bcd8739ae039)(ref, (0, $a36e95ee292bed8b$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $83a01f83dd44ef33$export$2e2bcd8739ae039 = $83a01f83dd44ef33$var$NoopTransition;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $f822f32dd67fcc9c$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $f822f32dd67fcc9c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $f822f32dd67fcc9c$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $f822f32dd67fcc9c$var$_objectWithoutPropertiesLoose(_ref, $f822f32dd67fcc9c$var$_excluded);
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $b5599328f7cdd88d$export$2e2bcd8739ae039)(nodeRef, (0, $a36e95ee292bed8b$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $3b128d8465760c69$var$_excluded = [
    "component"
];
function $3b128d8465760c69$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $3b128d8465760c69$var$RTGTransition = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $3b128d8465760c69$var$_objectWithoutPropertiesLoose(_ref, $3b128d8465760c69$var$_excluded);
    const transitionProps = (0, $f822f32dd67fcc9c$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $3b128d8465760c69$export$2e2bcd8739ae039 = $3b128d8465760c69$var$RTGTransition;




function $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $acw62.useRef)(null);
    const isInitialRef = (0, $acw62.useRef)(true);
    const handleTransition = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(onTransition);
    (0, $6b8eaefeef7398a7$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $6b8eaefeef7398a7$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $86d0e8a9dc3b2e91$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $acw62.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $b5599328f7cdd88d$export$2e2bcd8739ae039)(ref, (0, $a36e95ee292bed8b$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
}
function $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b128d8465760c69$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($86d0e8a9dc3b2e91$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83a01f83dd44ef33$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $0173af0e859d9b0f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $0173af0e859d9b0f$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $0173af0e859d9b0f$var$getManager(window) {
    if (!$0173af0e859d9b0f$var$manager) $0173af0e859d9b0f$var$manager = new (0, $254a0b83be45660e$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $0173af0e859d9b0f$var$manager;
}
function $0173af0e859d9b0f$var$useModalManager(provided) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const modalManager = provided || $0173af0e859d9b0f$var$getManager(window);
    const modal = (0, $acw62.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $0173af0e859d9b0f$var$Modal = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(_ref, $0173af0e859d9b0f$var$_excluded);
    const ownerWindow = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(containerRef);
    const modal = $0173af0e859d9b0f$var$useModalManager(providedManager);
    const isMounted = (0, $5bd0dc278db65a7f$export$2e2bcd8739ae039)();
    const prevShow = (0, $27d585c6d75dcd23$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $acw62.useState)(!show);
    const lastFocusRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $acw62.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $acw62.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $7fbb0d02e065d911$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $acw62.useRef)();
    const removeKeydownListenerRef = (0, $acw62.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$0173af0e859d9b0f$var$Modal.displayName = 'Modal';
var $0173af0e859d9b0f$export$2e2bcd8739ae039 = Object.assign($0173af0e859d9b0f$var$Modal, {
    Manager: (0, $254a0b83be45660e$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");






const $588ffbaaa8a325aa$var$fadeStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: 'show',
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: 'show'
};
const $588ffbaaa8a325aa$var$Fade = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $acw62.useCallback)((node, isAppearing)=>{
        (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $a36e95ee292bed8b$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('fade', className, children.props.className, $588ffbaaa8a325aa$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$588ffbaaa8a325aa$var$Fade.displayName = 'Fade';
var $588ffbaaa8a325aa$export$2e2bcd8739ae039 = $588ffbaaa8a325aa$var$Fade;



var $acw62 = parcelRequire("acw62");



"use client";
const $ba423bd29b7fa4dc$var$OffcanvasBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$ba423bd29b7fa4dc$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $ba423bd29b7fa4dc$export$2e2bcd8739ae039 = $ba423bd29b7fa4dc$var$OffcanvasBody;




var $acw62 = parcelRequire("acw62");






"use client";
const $48e49b3f9b1ab2a2$var$transitionStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: 'show',
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: 'show'
};
const $48e49b3f9b1ab2a2$var$OffcanvasToggling = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $a36e95ee292bed8b$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, children.props.className, (status === (0, $0fef977f04119bf5$export$df38205c966be359) || status === (0, $0fef977f04119bf5$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $48e49b3f9b1ab2a2$var$transitionStyles[status])
            })
    });
});
$48e49b3f9b1ab2a2$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $48e49b3f9b1ab2a2$export$2e2bcd8739ae039 = $48e49b3f9b1ab2a2$var$OffcanvasToggling;



var $acw62 = parcelRequire("acw62");
"use client";
const $ce35488230cbfb2e$var$ModalContext = /*#__PURE__*/ $acw62.createContext({
    onHide () {}
});
var $ce35488230cbfb2e$export$2e2bcd8739ae039 = $ce35488230cbfb2e$var$ModalContext;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();



var $acw62 = parcelRequire("acw62");


const $52ed202a4f01c477$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'white'
    ])
};
const $52ed202a4f01c477$var$CloseButton = /*#__PURE__*/ $acw62.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$52ed202a4f01c477$var$CloseButton.displayName = 'CloseButton';
$52ed202a4f01c477$var$CloseButton.propTypes = $52ed202a4f01c477$var$propTypes;
var $52ed202a4f01c477$export$2e2bcd8739ae039 = $52ed202a4f01c477$var$CloseButton;




"use client";
const $7ed9ce9ab3e9405e$var$AbstractModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039));
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$7ed9ce9ab3e9405e$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $7ed9ce9ab3e9405e$export$2e2bcd8739ae039 = $7ed9ce9ab3e9405e$var$AbstractModalHeader;



"use client";
const $513c4c102e8b60c7$var$OffcanvasHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed9ce9ab3e9405e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$513c4c102e8b60c7$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $513c4c102e8b60c7$export$2e2bcd8739ae039 = $513c4c102e8b60c7$var$OffcanvasHeader;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $31af5e1d0c3b3c37$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $acw62.forwardRef((p, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(p.className, className)
        }));




"use client";
const $0ae39967a5cb8bc6$var$DivStyledAsH5 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)('h5');
const $0ae39967a5cb8bc6$var$OffcanvasTitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $0ae39967a5cb8bc6$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$0ae39967a5cb8bc6$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $0ae39967a5cb8bc6$export$2e2bcd8739ae039 = $0ae39967a5cb8bc6$var$OffcanvasTitle;



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $f00adc503d5cecaf$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $f00adc503d5cecaf$var$BootstrapModalManager extends (0, $254a0b83be45660e$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $f00adc503d5cecaf$var$sharedManager;
function $f00adc503d5cecaf$export$a03641438014b436(options) {
    if (!$f00adc503d5cecaf$var$sharedManager) $f00adc503d5cecaf$var$sharedManager = new $f00adc503d5cecaf$var$BootstrapModalManager(options);
    return $f00adc503d5cecaf$var$sharedManager;
}
var $f00adc503d5cecaf$export$2e2bcd8739ae039 = $f00adc503d5cecaf$var$BootstrapModalManager;



"use client";
function $ee052f1f156c566d$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48e49b3f9b1ab2a2$export$2e2bcd8739ae039), {
        ...props
    });
}
function $ee052f1f156c566d$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props
    });
}
const $ee052f1f156c566d$var$Offcanvas = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $acw62.useRef)();
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $acw62.useState)(false);
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $d7a77e47f418a0f8$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $acw62.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $acw62.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $f00adc503d5cecaf$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $f00adc503d5cecaf$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $acw62.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0173af0e859d9b0f$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $ee052f1f156c566d$var$DialogTransition,
                    backdropTransition: $ee052f1f156c566d$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$ee052f1f156c566d$var$Offcanvas.displayName = 'Offcanvas';
var $ee052f1f156c566d$export$2e2bcd8739ae039 = Object.assign($ee052f1f156c566d$var$Offcanvas, {
    Body: (0, $ba423bd29b7fa4dc$export$2e2bcd8739ae039),
    Header: (0, $513c4c102e8b60c7$export$2e2bcd8739ae039),
    Title: (0, $0ae39967a5cb8bc6$export$2e2bcd8739ae039)
});




"use client";
const $988fd6bed406a062$var$NavbarOffcanvas = /*#__PURE__*/ $acw62.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee052f1f156c566d$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$988fd6bed406a062$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $988fd6bed406a062$export$2e2bcd8739ae039 = $988fd6bed406a062$var$NavbarOffcanvas;





var $acw62 = parcelRequire("acw62");



"use client";
const $23dd3f990e4b9410$var$NavbarText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$23dd3f990e4b9410$var$NavbarText.displayName = 'NavbarText';
var $23dd3f990e4b9410$export$2e2bcd8739ae039 = $23dd3f990e4b9410$var$NavbarText;



"use client";
const $9a5709cde14ebc6a$var$Navbar = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $acw62.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $acw62.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46425249d1e44fce$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$9a5709cde14ebc6a$var$Navbar.displayName = 'Navbar';
var $9a5709cde14ebc6a$export$2e2bcd8739ae039 = Object.assign($9a5709cde14ebc6a$var$Navbar, {
    Brand: (0, $b5ed781c15448fd9$export$2e2bcd8739ae039),
    Collapse: (0, $2710431f613a38bf$export$2e2bcd8739ae039),
    Offcanvas: (0, $988fd6bed406a062$export$2e2bcd8739ae039),
    Text: (0, $23dd3f990e4b9410$export$2e2bcd8739ae039),
    Toggle: (0, $0ecac5fdbe294867$export$2e2bcd8739ae039)
});



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7060bb66c8fa08f7$var$_toPropertyKey(arg) {
    var key = $7060bb66c8fa08f7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7060bb66c8fa08f7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7060bb66c8fa08f7$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $7060bb66c8fa08f7$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $acw62.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $7060bb66c8fa08f7$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $7060bb66c8fa08f7$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($7060bb66c8fa08f7$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $7060bb66c8fa08f7$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}







var $acw62 = parcelRequire("acw62");
const $845df35e9a3b7033$var$DropdownContext = /*#__PURE__*/ $acw62.createContext(null);
var $845df35e9a3b7033$export$2e2bcd8739ae039 = $845df35e9a3b7033$var$DropdownContext;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $acw62 = parcelRequire("acw62");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $6d6e1f6e05803d7b$var$useSafeState(state) {
    const isMounted = (0, $5bd0dc278db65a7f$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $acw62.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $6d6e1f6e05803d7b$export$2e2bcd8739ae039 = $6d6e1f6e05803d7b$var$useSafeState;



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $aa2830a619d3769f$export$8f7491d57c8f97a9 = (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $69d8d7bda7717b01$export$2e2bcd8739ae039),
        (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
        (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
        (0, $e7d7845625089588$export$2e2bcd8739ae039),
        (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
        (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
        (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
        (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039)
    ]
});


const $3e96790ca7bcc44e$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $3e96790ca7bcc44e$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $3e96790ca7bcc44e$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $3e96790ca7bcc44e$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $3e96790ca7bcc44e$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $3e96790ca7bcc44e$var$EMPTY_MODIFIERS } = _ref, config = $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(_ref, $3e96790ca7bcc44e$var$_excluded);
    const prevModifiers = (0, $acw62.useRef)(modifiers);
    const popperInstanceRef = (0, $acw62.useRef)();
    const update = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $6d6e1f6e05803d7b$export$2e2bcd8739ae039)((0, $acw62.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $acw62.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $acw62.useMemo)(()=>{
        if (!(0, $371d31aa64efa655$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $3e96790ca7bcc44e$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $aa2830a619d3769f$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $3e96790ca7bcc44e$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $3e96790ca7bcc44e$export$2e2bcd8739ae039 = $3e96790ca7bcc44e$var$usePopper;






var $acw62 = parcelRequire("acw62");

var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;


const $bfacdc492f374f5e$var$noop = ()=>{};
function $bfacdc492f374f5e$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $bfacdc492f374f5e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $bfacdc492f374f5e$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $bfacdc492f374f5e$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $bfacdc492f374f5e$var$useClickOutside(ref, onClickOutside = $bfacdc492f374f5e$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $acw62.useRef)(false);
    const waitingForTrigger = (0, $acw62.useRef)(false);
    const handleMouseCapture = (0, $acw62.useCallback)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $bfacdc492f374f5e$var$isModifiedEvent(e) || !$bfacdc492f374f5e$var$isLeftClickEvent(e) || !!(0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)($bfacdc492f374f5e$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, $bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(el, 'mousemove', $bfacdc492f374f5e$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $bfacdc492f374f5e$export$2e2bcd8739ae039 = $bfacdc492f374f5e$var$useClickOutside;


function $d29a438d14321507$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $d29a438d14321507$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $d29a438d14321507$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $d29a438d14321507$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $d29a438d14321507$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



const $7b01c7ecb51f8572$var$_excluded = [
    "children",
    "usePopper"
];
function $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $7b01c7ecb51f8572$var$noop = ()=>{};
function $7b01c7ecb51f8572$export$133c4d08f3775d64(options = {}) {
    const context = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $5251105f62ca120d$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $acw62.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $3e96790ca7bcc44e$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $d29a438d14321507$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $7b01c7ecb51f8572$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $bfacdc492f374f5e$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $7b01c7ecb51f8572$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(_ref, $7b01c7ecb51f8572$var$_excluded);
    const [props, meta] = $7b01c7ecb51f8572$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children(props, meta)
    });
}
$7b01c7ecb51f8572$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $7b01c7ecb51f8572$export$2e2bcd8739ae039 = $7b01c7ecb51f8572$var$DropdownMenu;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $1235624864f90193$var$$85138adc03e1f057$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $1235624864f90193$var$$85138adc03e1f057$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($1235624864f90193$var$$85138adc03e1f057$var$defaultContext);
const $1235624864f90193$var$$85138adc03e1f057$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $1235624864f90193$var$$85138adc03e1f057$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($1235624864f90193$var$$85138adc03e1f057$var$SSRContext);
    let counter = $1235624864f90193$var$$85138adc03e1f057$var$useCounter(cur === $1235624864f90193$var$$85138adc03e1f057$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $1235624864f90193$var$$85138adc03e1f057$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $acw62.useLayoutEffect)(()=>{
        // oxlint-disable-next-line react/react-compiler
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1235624864f90193$var$$85138adc03e1f057$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1235624864f90193$var$$85138adc03e1f057$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $1235624864f90193$var$$85138adc03e1f057$var$warnedAboutSSRProvider = false;
function $1235624864f90193$export$9f8ac96af4b1b2ae(props) {
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1235624864f90193$var$$85138adc03e1f057$var$LegacySSRProvider, props);
}
let $1235624864f90193$var$$85138adc03e1f057$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $1235624864f90193$var$$85138adc03e1f057$var$componentIds = new WeakMap();
function $1235624864f90193$var$$85138adc03e1f057$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($1235624864f90193$var$$85138adc03e1f057$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $1235624864f90193$var$$85138adc03e1f057$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $1235624864f90193$var$$85138adc03e1f057$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                // oxlint-disable-next-line react/react-compiler
                ctx.current = prevComponentValue.id;
                $1235624864f90193$var$$85138adc03e1f057$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    return ref.current;
}
function $1235624864f90193$var$$85138adc03e1f057$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($1235624864f90193$var$$85138adc03e1f057$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $1235624864f90193$var$$85138adc03e1f057$var$defaultContext && $1235624864f90193$var$$85138adc03e1f057$var$canUseDOM;
    let counter = $1235624864f90193$var$$85138adc03e1f057$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $1235624864f90193$var$$85138adc03e1f057$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($1235624864f90193$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$1235624864f90193$var$$85138adc03e1f057$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $1235624864f90193$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function' ? $1235624864f90193$var$$85138adc03e1f057$var$useModernSSRSafeId : $1235624864f90193$var$$85138adc03e1f057$var$useLegacySSRSafeId;
function $1235624864f90193$var$$85138adc03e1f057$var$getSnapshot() {
    return false;
}
function $1235624864f90193$var$$85138adc03e1f057$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $1235624864f90193$var$$85138adc03e1f057$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $1235624864f90193$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore']($1235624864f90193$var$$85138adc03e1f057$var$subscribe, $1235624864f90193$var$$85138adc03e1f057$var$getSnapshot, $1235624864f90193$var$$85138adc03e1f057$var$getServerSnapshot);
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($1235624864f90193$var$$85138adc03e1f057$var$IsSSRContext);
}




const $02e50cfe922d2ca9$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $02e50cfe922d2ca9$var$noop = ()=>{};
function $02e50cfe922d2ca9$export$96df6c7c5036b9a2() {
    const id = (0, $1235624864f90193$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $02e50cfe922d2ca9$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $acw62.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $02e50cfe922d2ca9$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $02e50cfe922d2ca9$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $02e50cfe922d2ca9$var$DropdownToggle({ children: children }) {
    const [props, meta] = $02e50cfe922d2ca9$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children(props, meta)
    });
}
$02e50cfe922d2ca9$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $02e50cfe922d2ca9$export$2e2bcd8739ae039 = $02e50cfe922d2ca9$var$DropdownToggle;



var $acw62 = parcelRequire("acw62");






const $e30823bf64a2218d$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e30823bf64a2218d$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const navContext = (0, $acw62.useContext)((0, $45c958b882f3532f$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $e30823bf64a2218d$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $0522fa2e4977c358$export$2e2bcd8739ae039) } = _ref, props = $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(_ref, $e30823bf64a2218d$var$_excluded);
    const [dropdownItemProps] = $e30823bf64a2218d$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$e30823bf64a2218d$var$DropdownItem.displayName = 'DropdownItem';
var $e30823bf64a2218d$export$2e2bcd8739ae039 = $e30823bf64a2218d$var$DropdownItem;






function $583bd49bf9b8480b$var$useRefWithUpdate() {
    const forceUpdate = (0, $e12c5402755aae29$export$2e2bcd8739ae039)();
    const ref = (0, $acw62.useRef)(null);
    const attachRef = (0, $acw62.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $583bd49bf9b8480b$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $7060bb66c8fa08f7$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $27d585c6d75dcd23$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $acw62.useRef)(null);
    const focusInDropdown = (0, $acw62.useRef)(false);
    const onSelectCtx = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const toggle = (0, $acw62.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $acw62.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $02e50cfe922d2ca9$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $acw62.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $acw62.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $f665bd0f5e0a2735$export$2e2bcd8739ae039)((0, $acw62.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $28419dce7921d430$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $845df35e9a3b7033$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$583bd49bf9b8480b$var$Dropdown.displayName = 'Dropdown';
$583bd49bf9b8480b$var$Dropdown.Menu = (0, $7b01c7ecb51f8572$export$2e2bcd8739ae039);
$583bd49bf9b8480b$var$Dropdown.Toggle = (0, $02e50cfe922d2ca9$export$2e2bcd8739ae039);
$583bd49bf9b8480b$var$Dropdown.Item = (0, $e30823bf64a2218d$export$2e2bcd8739ae039);
var $583bd49bf9b8480b$export$2e2bcd8739ae039 = $583bd49bf9b8480b$var$Dropdown;





var $acw62 = parcelRequire("acw62");
"use client";
const $dca786c6a99c4e45$var$DropdownContext = /*#__PURE__*/ $acw62.createContext({});
$dca786c6a99c4e45$var$DropdownContext.displayName = 'DropdownContext';
var $dca786c6a99c4e45$export$2e2bcd8739ae039 = $dca786c6a99c4e45$var$DropdownContext;



var $acw62 = parcelRequire("acw62");



"use client";
const $5a4fb33eeda93525$var$DropdownDivider = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$5a4fb33eeda93525$var$DropdownDivider.displayName = 'DropdownDivider';
var $5a4fb33eeda93525$export$2e2bcd8739ae039 = $5a4fb33eeda93525$var$DropdownDivider;



var $acw62 = parcelRequire("acw62");



"use client";
const $ec852ac21aa53987$var$DropdownHeader = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$ec852ac21aa53987$var$DropdownHeader.displayName = 'DropdownHeader';
var $ec852ac21aa53987$export$2e2bcd8739ae039 = $ec852ac21aa53987$var$DropdownHeader;




var $acw62 = parcelRequire("acw62");




"use client";
const $c3418d2c4a03af95$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $a02c1087963bbb34$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $e30823bf64a2218d$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$c3418d2c4a03af95$var$DropdownItem.displayName = 'DropdownItem';
var $c3418d2c4a03af95$export$2e2bcd8739ae039 = $c3418d2c4a03af95$var$DropdownItem;



var $acw62 = parcelRequire("acw62");



"use client";
const $29dccf165986723f$var$DropdownItemText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$29dccf165986723f$var$DropdownItemText.displayName = 'DropdownItemText';
var $29dccf165986723f$export$2e2bcd8739ae039 = $29dccf165986723f$var$DropdownItemText;




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
"use client";
const $dda4a7e32e3b00d2$var$context = /*#__PURE__*/ $acw62.createContext(null);
$dda4a7e32e3b00d2$var$context.displayName = 'InputGroupContext';
var $dda4a7e32e3b00d2$export$2e2bcd8739ae039 = $dda4a7e32e3b00d2$var$context;





parcelRequire("acw62");

function $66831c738b74ab47$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $5d9daf1899b89eeb$var$DropdownMenu = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $acw62.useContext)((0, $dca786c6a99c4e45$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $acw62.useContext)((0, $dda4a7e32e3b00d2$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $7b01c7ecb51f8572$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)((0, $66831c738b74ab47$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$5d9daf1899b89eeb$var$DropdownMenu.displayName = 'DropdownMenu';
var $5d9daf1899b89eeb$export$2e2bcd8739ae039 = $5d9daf1899b89eeb$var$DropdownMenu;







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



"use client";
const $4ed343d4b409b2f2$var$Button = /*#__PURE__*/ $acw62.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$4ed343d4b409b2f2$var$Button.displayName = 'Button';
var $4ed343d4b409b2f2$export$2e2bcd8739ae039 = $4ed343d4b409b2f2$var$Button;





"use client";
const $6b03788ed4f0962b$var$DropdownToggle = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $02e50cfe922d2ca9$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(toggleProps.ref, (0, $66831c738b74ab47$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$6b03788ed4f0962b$var$DropdownToggle.displayName = 'DropdownToggle';
var $6b03788ed4f0962b$export$2e2bcd8739ae039 = $6b03788ed4f0962b$var$DropdownToggle;






"use client";
const $c111d4db45b07888$var$Dropdown = /*#__PURE__*/ $acw62.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $acw62.useContext)((0, $dda4a7e32e3b00d2$export$2e2bcd8739ae039));
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $5d9daf1899b89eeb$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $acw62.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dca786c6a99c4e45$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $583bd49bf9b8480b$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$c111d4db45b07888$var$Dropdown.displayName = 'Dropdown';
var $c111d4db45b07888$export$2e2bcd8739ae039 = Object.assign($c111d4db45b07888$var$Dropdown, {
    Toggle: (0, $6b03788ed4f0962b$export$2e2bcd8739ae039),
    Menu: (0, $5d9daf1899b89eeb$export$2e2bcd8739ae039),
    Item: (0, $c3418d2c4a03af95$export$2e2bcd8739ae039),
    ItemText: (0, $29dccf165986723f$export$2e2bcd8739ae039),
    Divider: (0, $5a4fb33eeda93525$export$2e2bcd8739ae039),
    Header: (0, $ec852ac21aa53987$export$2e2bcd8739ae039)
});




"use client";
const $f1177f84a674945f$var$NavDropdown = /*#__PURE__*/ $acw62.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $8dc05f39bc918f56$export$2e2bcd8739ae039),
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$f1177f84a674945f$var$NavDropdown.displayName = 'NavDropdown';
var $f1177f84a674945f$export$2e2bcd8739ae039 = Object.assign($f1177f84a674945f$var$NavDropdown, {
    Item: (0, $c111d4db45b07888$export$2e2bcd8739ae039).Item,
    ItemText: (0, $c111d4db45b07888$export$2e2bcd8739ae039).ItemText,
    Divider: (0, $c111d4db45b07888$export$2e2bcd8739ae039).Divider,
    Header: (0, $c111d4db45b07888$export$2e2bcd8739ae039).Header
});


/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


const $810dc495bedb1cb1$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim();
const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
            ref: ref,
            ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
            width: size,
            height: size,
            stroke: color,
            strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
            className: [
                "lucide",
                `lucide-${$810dc495bedb1cb1$export$73bda83cddbc7187(iconName)}`,
                className
            ].join(" "),
            ...rest
        }, [
            ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
            ...Array.isArray(children) ? children : [
                children
            ]
        ]));
    Component.displayName = `${iconName}`;
    return Component;
};


const $5473793717b51056$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LogOut", [
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 21 12 16 7",
            key: "1gabdz"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "9",
            y1: "12",
            y2: "12",
            key: "1uyos4"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0f45c1e8ae52ad76$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("User", [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
]);




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Search", [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
]);


// ---------------------------------------------------------------------------
// Data layer: EVERYTHING comes from the backend database. There is no sample
// or generated data here. When the database has nothing for a company, the
// page shows an empty table or "not available" - never made-up numbers.
// ---------------------------------------------------------------------------
const $d27dbe10f1bffb7d$export$923ea8233b386e99 = "https://spedvest.com/api";


const $75280afcc6fc2ba7$export$923ea8233b386e99 = String((0, $d27dbe10f1bffb7d$export$923ea8233b386e99) || "").replace(/\/+$/, "");
const $75280afcc6fc2ba7$export$5b9941e2da57537e = !!$75280afcc6fc2ba7$export$923ea8233b386e99;
const $75280afcc6fc2ba7$export$6386b73e306fc78b = false;
const $75280afcc6fc2ba7$export$4eb2c0a4e1820d98 = ()=>false;
const $75280afcc6fc2ba7$export$5e1ff101ad4c3610 = ()=>Promise.resolve({
        sample: false
    });
const $75280afcc6fc2ba7$export$6d6dbb911247cf75 = ()=>true;
// ---- helpers ---------------------------------------------------------------
const $75280afcc6fc2ba7$var$DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const $75280afcc6fc2ba7$var$DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
// dates arrive as text; turn them into Dates on the same calendar day / exchange clock time
const $75280afcc6fc2ba7$var$revive = (v)=>{
    if (typeof v === "string") {
        let m = $75280afcc6fc2ba7$var$DATE_ONLY.exec(v);
        if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
        m = $75280afcc6fc2ba7$var$DATE_TIME.exec(v);
        if (m) return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
        return v;
    }
    if (Array.isArray(v)) return v.map($75280afcc6fc2ba7$var$revive);
    if (v && typeof v === "object") {
        const o = {};
        for (const k of Object.keys(v))o[k] = $75280afcc6fc2ba7$var$revive(v[k]);
        return o;
    }
    return v;
};
const $75280afcc6fc2ba7$var$enc = encodeURIComponent;
const $75280afcc6fc2ba7$var$T = (t)=>String(t || "").toUpperCase();
/** GET <API_URL><path>; null when the database has nothing (or the server is down) */ function $75280afcc6fc2ba7$var$get(path) {
    if (!$75280afcc6fc2ba7$export$5b9941e2da57537e) return Promise.resolve(null);
    return fetch($75280afcc6fc2ba7$export$923ea8233b386e99 + path).then((r)=>r.ok ? r.json() : null).then((j)=>j && !j.error ? $75280afcc6fc2ba7$var$revive(j) : null).catch(()=>null);
}
const $75280afcc6fc2ba7$var$stock = (t, name, qs = "")=>$75280afcc6fc2ba7$var$get(`/stocks/${$75280afcc6fc2ba7$var$enc($75280afcc6fc2ba7$var$T(t))}/${name}${qs}`);
const $75280afcc6fc2ba7$var$orEmpty = (empty)=>(v)=>v === null ? empty : v;
function $75280afcc6fc2ba7$export$3cec9f06d358e026(query, limit = 8) {
    const q = String(query || "").trim();
    if (!q) return Promise.resolve([]);
    return $75280afcc6fc2ba7$var$get(`/search?q=${$75280afcc6fc2ba7$var$enc(q)}&limit=${limit}`).then((r)=>r || []);
}
function $75280afcc6fc2ba7$export$85d699ca8330b9a9(t) {
    return $75280afcc6fc2ba7$var$stock(t, "profile").then((db)=>{
        if (!db) return null; // company not in the database -> "couldn't find"
        const ex = db.exchange ? String(db.exchange).toUpperCase() : "";
        const classified = (v)=>v && v !== "Unclassified" ? v : "\u2014";
        return {
            ticker: db.ticker,
            name: db.name,
            exchange: ex,
            tvSymbol: ex ? `${ex}:${db.ticker}` : db.ticker,
            tvUrl: `https://www.tradingview.com/symbols/${ex ? ex + "-" : ""}${$75280afcc6fc2ba7$var$enc(db.ticker)}/`,
            sector: classified(db.sector),
            industry: classified(db.industry),
            group: classified(db.industry_group || db.industry),
            country: db.country,
            currency: db.currency,
            employees: db.employees || null,
            founded: db.founded || null,
            website: db.website || null,
            hq: db.hq || null,
            phone: db.phone || null,
            sicDescription: db.sicDescription || null,
            fiscalYearEnd: db.fiscalYearEnd || null,
            aboutSource: db.aboutSource || null,
            aboutUrl: db.aboutUrl || null,
            description: db.description || `${db.name}${ex ? ` (${ex}:${db.ticker})` : ""} is a publicly traded company${ex ? ` listed on ${ex}` : ""}.`
        };
    });
}
const $75280afcc6fc2ba7$export$2628323f89a438a6 = (t)=>$75280afcc6fc2ba7$var$stock(t, "quote");
const $75280afcc6fc2ba7$export$97ecc5e6f8db6289 = (t, range)=>$75280afcc6fc2ba7$var$stock(t, "candles", `?range=${$75280afcc6fc2ba7$var$enc(range)}`).then($75280afcc6fc2ba7$var$orEmpty({
        interval: "",
        intraday: false,
        bars: []
    }));
const $75280afcc6fc2ba7$export$62ef3e6be78b1fd6 = ()=>Promise.resolve([]);
const $75280afcc6fc2ba7$export$226017fe7f8e0ffd = (t, statement, period)=>$75280afcc6fc2ba7$var$stock(t, "statement", `?statement=${$75280afcc6fc2ba7$var$enc(statement)}&period=${$75280afcc6fc2ba7$var$enc(period)}`).then($75280afcc6fc2ba7$var$orEmpty({
        columns: [],
        rows: []
    }));
const $75280afcc6fc2ba7$export$ab60d92959c37070 = (t)=>$75280afcc6fc2ba7$var$stock(t, "snapshot").then($75280afcc6fc2ba7$var$orEmpty([]));
const $75280afcc6fc2ba7$export$478ab90bc3ebade5 = (t)=>$75280afcc6fc2ba7$var$stock(t, "key-stats").then($75280afcc6fc2ba7$var$orEmpty([]));
const $75280afcc6fc2ba7$export$c0ddd5fb189d9ef3 = (t)=>$75280afcc6fc2ba7$var$stock(t, "pros-cons").then($75280afcc6fc2ba7$var$orEmpty({
        pros: [
            "Financial data not loaded for this company yet."
        ],
        cons: [
            "Financial data not loaded for this company yet."
        ]
    }));
const $75280afcc6fc2ba7$export$cb26a1c42e348f4f = (t)=>$75280afcc6fc2ba7$var$stock(t, "filings").then($75280afcc6fc2ba7$var$orEmpty([]));
const $75280afcc6fc2ba7$export$e736a0e2de0cb508 = (t)=>$75280afcc6fc2ba7$var$stock(t, "news").then($75280afcc6fc2ba7$var$orEmpty([]));
const $75280afcc6fc2ba7$export$886b8ed8d6c424f0 = ()=>Promise.resolve({
        multiples: [],
        targets: null,
        competitors: []
    });
const $75280afcc6fc2ba7$export$12ad45ffea30e701 = ()=>Promise.resolve({
        years: [],
        lastQs: [],
        nextQs: []
    });
const $75280afcc6fc2ba7$export$4d51875102e338c8 = ()=>Promise.resolve([]);
const $75280afcc6fc2ba7$export$74746e4a0845aeda = ()=>Promise.resolve({
        holders: [],
        insiders: []
    });
const $75280afcc6fc2ba7$export$69fa50797ac575e6 = ()=>Promise.resolve([]);
const $75280afcc6fc2ba7$export$9a5907d15a0b1a7f = ()=>Promise.resolve({
        total: 0,
        rows: []
    });


// Tiny hash router for company pages:  #/stock/AAPL  or  #/stock/AAPL/financials
const $4a6071b6444d89fa$export$73b877b58963a4f = [
    {
        key: "overview",
        label: "Overview & News"
    },
    {
        key: "financials",
        label: "Financials"
    },
    {
        key: "valuation",
        label: "Valuation"
    },
    {
        key: "model",
        label: "Model"
    },
    {
        key: "estimates",
        label: "Estimates"
    },
    {
        key: "transcripts",
        label: "Transcripts"
    },
    {
        key: "filings",
        label: "Filings"
    },
    {
        key: "ownership",
        label: "Ownership"
    }
];
function $4a6071b6444d89fa$export$fddf14af0d71329f(hash = window.location.hash) {
    const m = /^#\/stock\/([^/?]+)(?:\/([a-z]+))?/i.exec(hash || "");
    if (!m) return null;
    const tab = $4a6071b6444d89fa$export$73b877b58963a4f.some((t)=>t.key === m[2]) ? m[2] : "overview";
    return {
        ticker: decodeURIComponent(m[1]).toUpperCase(),
        tab: tab
    };
}
const $4a6071b6444d89fa$export$3518935f988c2e40 = (ticker, tab)=>`#/stock/${encodeURIComponent(ticker)}${tab && tab !== "overview" ? `/${tab}` : ""}`;
function $4a6071b6444d89fa$export$677889c52ce775c5(ticker, tab) {
    window.location.hash = $4a6071b6444d89fa$export$3518935f988c2e40(ticker, tab);
}
function $4a6071b6444d89fa$export$c40b91ede3abf83a() {
    if (window.location.hash.startsWith("#/stock/")) history.pushState(null, "", window.location.pathname + window.location.search);
}


function $744722faeae46062$export$2e2bcd8739ae039({ placeholder: placeholder = "Search by company name or ticker", className: className = "", autoFocus: autoFocus = false, onSelect: onSelect }) {
    const [q, setQ] = (0, $acw62.useState)("");
    const [results, setResults] = (0, $acw62.useState)([]);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [active, setActive] = (0, $acw62.useState)(0);
    const boxRef = (0, $acw62.useRef)(null);
    const seq = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        const id = ++seq.current;
        if (!q.trim()) {
            setResults([]);
            return undefined;
        }
        const timer = setTimeout(()=>{
            (0, $75280afcc6fc2ba7$export$3cec9f06d358e026)(q, 25).then((r)=>{
                if (id === seq.current) {
                    setResults(r);
                    setActive(0);
                }
            });
        }, 120);
        return ()=>clearTimeout(timer);
    }, [
        q
    ]);
    (0, $acw62.useEffect)(()=>{
        const close = (e)=>boxRef.current && !boxRef.current.contains(e.target) && setOpen(false);
        document.addEventListener("mousedown", close);
        return ()=>document.removeEventListener("mousedown", close);
    }, []);
    const choose = (ticker)=>{
        setQ("");
        setResults([]);
        setOpen(false);
        if (onSelect) onSelect(ticker);
        (0, $4a6071b6444d89fa$export$677889c52ce775c5)(ticker);
    };
    const onKeyDown = (e)=>{
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActive((a)=>Math.min(a + 1, results.length - 1));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setActive((a)=>Math.max(a - 1, 0));
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (results[active]) choose(results[active].ticker);
            else if (q.trim()) choose(q.trim().toUpperCase());
        } else if (e.key === "Escape") setOpen(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `co-search ${className}`,
        ref: boxRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                size: 16,
                className: "co-search-icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                value: q,
                placeholder: placeholder,
                autoFocus: autoFocus,
                onChange: (e)=>{
                    setQ(e.target.value);
                    setOpen(true);
                },
                onFocus: ()=>setOpen(true),
                onKeyDown: onKeyDown,
                "aria-label": "Search companies"
            }),
            open && q.trim() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "co-search-list",
                children: [
                    results.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "co-search-empty",
                        children: "No matching companies"
                    }),
                    results.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: i === active ? "active" : "",
                            onMouseEnter: ()=>setActive(i),
                            onMouseDown: (e)=>{
                                e.preventDefault();
                                choose(c.ticker);
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "co-search-ticker",
                                    children: c.ticker
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "co-search-name",
                                    children: c.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "co-search-ind",
                                    children: c.industry
                                })
                            ]
                        }, c.ticker))
                ]
            })
        ]
    });
}


const $db9ed9a2274fc7a3$var$TOOL_PAGES = [
    "screens",
    "alerts",
    "compare",
    "portfolio"
];
function $db9ed9a2274fc7a3$export$2e2bcd8739ae039({ user: user, page: page, onNavigate: onNavigate, onOpenLogin: onOpenLogin, onOpenSignup: onOpenSignup, onLogout: onLogout }) {
    const link = (key, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
            href: "#",
            active: page === key,
            onClick: (e)=>{
                e.preventDefault();
                onNavigate(key);
            },
            children: label
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039), {
        expand: "lg",
        className: "app-navbar",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
            fluid: true,
            className: "p-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Brand, {
                    href: "#",
                    className: "fw-bold me-4",
                    onClick: (e)=>{
                        e.preventDefault();
                        onNavigate("home");
                    },
                    children: "SpedVest"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Toggle, {
                    "aria-controls": "main-nav"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Collapse, {
                    id: "main-nav",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039), {
                            className: "me-auto",
                            children: [
                                link("home", "HOME"),
                                link("feed", "FEED"),
                                link("companies", "COMPANIES"),
                                link("watchlist", "WATCHLIST"),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f1177f84a674945f$export$2e2bcd8739ae039), {
                                    title: "TOOLS",
                                    id: "tools-dropdown",
                                    active: $db9ed9a2274fc7a3$var$TOOL_PAGES.includes(page),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                            onClick: ()=>onNavigate("screens"),
                                            children: "Screens"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                            onClick: ()=>onNavigate("alerts"),
                                            children: "Stock Alerts"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                            onClick: ()=>onNavigate("compare"),
                                            children: "Compare Companies"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                            onClick: ()=>onNavigate("portfolio"),
                                            children: "Portfolio Tracker"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $744722faeae46062$export$2e2bcd8739ae039), {
                            className: "nav-search",
                            placeholder: "Search company or ticker"
                        }),
                        user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039), {
                                align: "end",
                                id: "user-dropdown",
                                className: "user-dropdown",
                                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        " ",
                                        user.name.toUpperCase()
                                    ]
                                }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                    onClick: onLogout,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                            size: 14,
                                            className: "me-2"
                                        }),
                                        "Logout"
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex align-items-center gap-2 mt-3 mt-lg-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "btn btn-outline-secondary nav-auth-btn",
                                    onClick: onOpenLogin,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        " LOGIN"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "btn btn-purple nav-auth-btn",
                                    onClick: onOpenSignup,
                                    children: "SIGN UP"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");


// Quick links under the search box (tag -> ticker)
const $74ba0581fdbb1660$var$SAMPLE_TAGS = [
    [
        "Apple",
        "AAPL"
    ],
    [
        "Microsoft",
        "MSFT"
    ],
    [
        "NVIDIA",
        "NVDA"
    ],
    [
        "Tesla",
        "TSLA"
    ],
    [
        "Amazon",
        "AMZN"
    ],
    [
        "JPMorgan",
        "JPM"
    ]
];
function $74ba0581fdbb1660$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "hero-section",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "hero-logo",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "logo-text-highlight",
                    children: "SpedVest"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hero-subtitle",
                children: "Search any US stock to see its charts, financials and valuation"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "search-box-container",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $744722faeae46062$export$2e2bcd8739ae039), {
                    className: "hero-search",
                    placeholder: "Search a company or ticker, e.g. AAPL",
                    autoFocus: true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "analyse-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "analyse-label",
                        children: "Try:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tags-container",
                        children: $74ba0581fdbb1660$var$SAMPLE_TAGS.map(([label, ticker])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "tag-btn",
                                onClick: ()=>(0, $4a6071b6444d89fa$export$677889c52ce775c5)(ticker),
                                children: label
                            }, ticker))
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68d48ea6a6653ccd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Copy", [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c52b562f10363bcd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LayoutGrid", [
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "3",
            rx: "1",
            key: "1g98yp"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "3",
            rx: "1",
            key: "6d4xhi"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "14",
            rx: "1",
            key: "nxv5o0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "14",
            rx: "1",
            key: "1bb6yr"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ef166891ec0b7b3f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("List", [
    [
        "line",
        {
            x1: "8",
            x2: "21",
            y1: "6",
            y2: "6",
            key: "7ey8pc"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "21",
            y1: "12",
            y2: "12",
            key: "rjfblc"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "21",
            y1: "18",
            y2: "18",
            key: "c3b1m8"
        }
    ],
    [
        "line",
        {
            x1: "3",
            x2: "3.01",
            y1: "6",
            y2: "6",
            key: "1g7gq3"
        }
    ],
    [
        "line",
        {
            x1: "3",
            x2: "3.01",
            y1: "12",
            y2: "12",
            key: "1pjlvk"
        }
    ],
    [
        "line",
        {
            x1: "3",
            x2: "3.01",
            y1: "18",
            y2: "18",
            key: "28t2mc"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b66c39b6083b2b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Menu", [
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "12",
            y2: "12",
            key: "1e0a9i"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "6",
            y2: "6",
            key: "1owob3"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "18",
            y2: "18",
            key: "yk5zj1"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Plus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
]);




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowLeft", [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $10da79d8875e7dff$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Rocket", [
    [
        "path",
        {
            d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
            key: "m3kijz"
        }
    ],
    [
        "path",
        {
            d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
            key: "1fmvmk"
        }
    ],
    [
        "path",
        {
            d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0",
            key: "1f8sc4"
        }
    ],
    [
        "path",
        {
            d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5",
            key: "qeys4"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $db54edda7e508228$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Save", [
    [
        "path",
        {
            d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z",
            key: "1owoqh"
        }
    ],
    [
        "polyline",
        {
            points: "17 21 17 13 7 13 7 21",
            key: "1md35c"
        }
    ],
    [
        "polyline",
        {
            points: "7 3 7 8 15 8",
            key: "8nz8an"
        }
    ]
]);


function $659779301cb4aef4$export$2e2bcd8739ae039({ existingNames: existingNames, onSave: onSave, onBack: onBack }) {
    const [name, setName] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const handleSubmit = (e)=>{
        e.preventDefault();
        const trimmed = name.trim();
        if (!trimmed) {
            setError("Please enter a name for your watchlist.");
            return;
        }
        if (existingNames.some((n)=>n.toLowerCase() === trimmed.toLowerCase())) {
            setError("You already have a watchlist with this name.");
            return;
        }
        onSave(trimmed);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "create-wl-wrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card create-wl-card",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "create-wl-title",
                            children: "Create new watchlist"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleSubmit,
                            noValidate: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "wl-name",
                                    className: "create-wl-label",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "wl-name",
                                    type: "text",
                                    className: `form-control create-wl-input ${error ? "is-invalid" : ""}`,
                                    value: name,
                                    maxLength: 40,
                                    autoFocus: true,
                                    onChange: (e)=>{
                                        setName(e.target.value);
                                        setError("");
                                    }
                                }),
                                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "invalid-feedback d-block",
                                    children: error
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "submit",
                                    className: "btn btn-purple create-wl-save",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        " SAVE"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "create-wl-info",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "create-wl-illustration",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10da79d8875e7dff$export$2e2bcd8739ae039), {
                                        size: 72
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Create separate watchlists to organize companies by idea, theme or strategy, such as long-term holds or stocks you are still researching."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-0",
                                    children: "Keep each list focused so the companies you care about most stay easy to find."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "go-back-row",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        href: "#",
                        className: "go-back",
                        onClick: (e)=>{
                            e.preventDefault();
                            onBack();
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Go Back"
                        ]
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $008e11cf932a0927$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowDown", [
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ],
    [
        "path",
        {
            d: "m19 12-7 7-7-7",
            key: "1idqje"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f05f6a77fc593bc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowUp", [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e1cfd183b457f6f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("BookOpen", [
    [
        "path",
        {
            d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z",
            key: "vv98re"
        }
    ],
    [
        "path",
        {
            d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z",
            key: "1cyq3y"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d252ca8c87a49232$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Download", [
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "polyline",
        {
            points: "7 10 12 15 17 10",
            key: "2ggqvy"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "15",
            y2: "3",
            key: "1vk2je"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $78659dd4d4ddf1e7$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Factory", [
    [
        "path",
        {
            d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
            key: "159hny"
        }
    ],
    [
        "path",
        {
            d: "M17 18h1",
            key: "uldtlt"
        }
    ],
    [
        "path",
        {
            d: "M12 18h1",
            key: "s9uhes"
        }
    ],
    [
        "path",
        {
            d: "M7 18h1",
            key: "1neino"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Settings", [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);


// Company names and sectors for any US ticker, read from your database.
// getCompany(ticker) returns { ticker, name, sector, industry, exchange, category }
// or undefined while it is loading. useCompanyInfoVersion() re-renders the page
// when new names arrive.

var $acw62 = parcelRequire("acw62");

const $0e8cef3982a5818d$var$store = new Map(); // ticker -> company, or null when unknown
const $0e8cef3982a5818d$var$pending = new Set();
const $0e8cef3982a5818d$var$listeners = new Set();
let $0e8cef3982a5818d$var$version = 0;
let $0e8cef3982a5818d$var$timer = null;
const $0e8cef3982a5818d$var$bump = ()=>{
    $0e8cef3982a5818d$var$version += 1;
    $0e8cef3982a5818d$var$listeners.forEach((l)=>l());
};
const $0e8cef3982a5818d$var$shape = (r)=>({
        ...r,
        category: r.sector || r.industry || "Other"
    });
async function $0e8cef3982a5818d$var$flush() {
    $0e8cef3982a5818d$var$timer = null;
    const batch = [
        ...$0e8cef3982a5818d$var$pending
    ];
    $0e8cef3982a5818d$var$pending.clear();
    for(let i = 0; i < batch.length; i += 100){
        const chunk = batch.slice(i, i + 100);
        try {
            const res = await fetch(`${(0, $d27dbe10f1bffb7d$export$923ea8233b386e99)}/companies?tickers=${encodeURIComponent(chunk.join(","))}`);
            const rows = res.ok ? await res.json() : [];
            chunk.forEach((t)=>$0e8cef3982a5818d$var$store.set(t, null));
            rows.forEach((r)=>$0e8cef3982a5818d$var$store.set(r.ticker, $0e8cef3982a5818d$var$shape(r)));
        } catch  {
            chunk.forEach((t)=>$0e8cef3982a5818d$var$store.set(t, null));
        }
    }
    $0e8cef3982a5818d$var$bump();
}
function $0e8cef3982a5818d$export$3fb7e631d185ccd8(ticker) {
    const t = String(ticker || "").toUpperCase();
    if ($0e8cef3982a5818d$var$store.has(t)) return $0e8cef3982a5818d$var$store.get(t) || undefined;
    if (!$0e8cef3982a5818d$var$pending.has(t)) {
        $0e8cef3982a5818d$var$pending.add(t);
        if (!$0e8cef3982a5818d$var$timer) $0e8cef3982a5818d$var$timer = setTimeout($0e8cef3982a5818d$var$flush, 20);
    }
    return undefined;
}
function $0e8cef3982a5818d$export$29d1feb935211dfc(rows) {
    rows.forEach((r)=>$0e8cef3982a5818d$var$store.set(r.ticker, $0e8cef3982a5818d$var$shape(r)));
    $0e8cef3982a5818d$var$bump();
}
function $0e8cef3982a5818d$export$4e58cf0942785ded() {
    return (0, $acw62.useSyncExternalStore)((cb)=>{
        $0e8cef3982a5818d$var$listeners.add(cb);
        return ()=>$0e8cef3982a5818d$var$listeners.delete(cb);
    }, ()=>$0e8cef3982a5818d$var$version);
}


// REAL numbers for the list pages (Companies, Watchlist, Screens, Compare,
// Alerts, Portfolio, Industry). Nothing is generated here.
// getStockStats(ticker) and getFundamentals(ticker) read from your database
// through GET /api/summaries. The first time a ticker is asked for it is queued
// and fetched in one batch; when the answer arrives the app re-renders.

var $acw62 = parcelRequire("acw62");

/** "not available": behaves like a number that prints "—" and never compares as up/down */ const $6d972d26c47ffac8$var$NA = Object.freeze({
    toFixed: ()=>"\u2014",
    toLocaleString: ()=>"\u2014",
    toString: ()=>"\u2014",
    valueOf: ()=>NaN
});
const $6d972d26c47ffac8$export$ee6ff8acf75e31b7 = (v)=>v === $6d972d26c47ffac8$var$NA;
const $6d972d26c47ffac8$var$val = (v)=>v === null || v === undefined || Number.isNaN(v) ? $6d972d26c47ffac8$var$NA : v;
const $6d972d26c47ffac8$var$store = new Map(); // ticker -> summary row, or null when the database has no such company
const $6d972d26c47ffac8$var$pending = new Set();
const $6d972d26c47ffac8$var$listeners = new Set();
let $6d972d26c47ffac8$var$version = 0;
let $6d972d26c47ffac8$var$timer = null;
const $6d972d26c47ffac8$var$notify = ()=>{
    $6d972d26c47ffac8$var$version += 1;
    $6d972d26c47ffac8$var$listeners.forEach((l)=>l());
};
async function $6d972d26c47ffac8$var$flush() {
    $6d972d26c47ffac8$var$timer = null;
    const batch = [
        ...$6d972d26c47ffac8$var$pending
    ];
    $6d972d26c47ffac8$var$pending.clear();
    for(let i = 0; i < batch.length; i += 60){
        const chunk = batch.slice(i, i + 60);
        try {
            const res = await fetch(`${(0, $d27dbe10f1bffb7d$export$923ea8233b386e99)}/summaries?tickers=${encodeURIComponent(chunk.join(","))}`);
            const rows = res.ok ? await res.json() : [];
            chunk.forEach((t)=>$6d972d26c47ffac8$var$store.set(t, null));
            rows.forEach((r)=>$6d972d26c47ffac8$var$store.set(r.ticker, r));
        } catch  {
            chunk.forEach((t)=>$6d972d26c47ffac8$var$store.set(t, null));
        }
    }
    $6d972d26c47ffac8$var$notify();
}
function $6d972d26c47ffac8$var$summary(ticker) {
    const t = String(ticker || "").toUpperCase();
    if ($6d972d26c47ffac8$var$store.has(t)) return $6d972d26c47ffac8$var$store.get(t);
    if (!$6d972d26c47ffac8$var$pending.has(t)) {
        $6d972d26c47ffac8$var$pending.add(t);
        if (!$6d972d26c47ffac8$var$timer) $6d972d26c47ffac8$var$timer = setTimeout($6d972d26c47ffac8$var$flush, 30);
    }
    return undefined;
}
function $6d972d26c47ffac8$export$ae1efb09da3bcdf9() {
    return (0, $acw62.useSyncExternalStore)((cb)=>{
        $6d972d26c47ffac8$var$listeners.add(cb);
        return ()=>$6d972d26c47ffac8$var$listeners.delete(cb);
    }, ()=>$6d972d26c47ffac8$var$version);
}
function $6d972d26c47ffac8$export$9a79ba2e7e56f601(ticker) {
    const s = $6d972d26c47ffac8$var$summary(ticker);
    return {
        series: s ? s.series : [],
        current: $6d972d26c47ffac8$var$val(s && s.price),
        high: $6d972d26c47ffac8$var$val(s && s.high),
        low: $6d972d26c47ffac8$var$val(s && s.low),
        change: $6d972d26c47ffac8$var$val(s && s.change)
    };
}
function $6d972d26c47ffac8$export$ad2c21017a759cdf(ticker) {
    const s = $6d972d26c47ffac8$var$summary(ticker);
    return {
        cmp: $6d972d26c47ffac8$var$val(s && s.price),
        pe: $6d972d26c47ffac8$var$val(s && s.pe),
        mcap: $6d972d26c47ffac8$var$val(s && s.mcap),
        div: $6d972d26c47ffac8$var$val(s && s.div),
        np: $6d972d26c47ffac8$var$val(s && s.np),
        npVar: $6d972d26c47ffac8$var$val(s && s.npVar),
        sales: $6d972d26c47ffac8$var$val(s && s.sales),
        salesVar: $6d972d26c47ffac8$var$val(s && s.salesVar),
        roce: $6d972d26c47ffac8$var$val(s && s.roce)
    };
}
const $6d972d26c47ffac8$export$9426f7da21b630b1 = (ticker)=>$6d972d26c47ffac8$export$9a79ba2e7e56f601(ticker).series;
function $6d972d26c47ffac8$export$5272b19b0fbbb839(tickers) {
    tickers.forEach((t)=>t && $6d972d26c47ffac8$var$pending.add(String(t).toUpperCase()));
    if ($6d972d26c47ffac8$var$pending.size && !$6d972d26c47ffac8$var$timer) $6d972d26c47ffac8$var$timer = setTimeout($6d972d26c47ffac8$var$flush, 30);
}


const $cde3de04f6e5e613$var$COLUMNS = [
    {
        id: "cmp",
        label: "CMP",
        unit: "$"
    },
    {
        id: "pe",
        label: "P/E",
        unit: ""
    },
    {
        id: "mcap",
        label: "Mar Cap",
        unit: "$B"
    },
    {
        id: "div",
        label: "Div Yld",
        unit: "%"
    },
    {
        id: "np",
        label: "NP Qtr",
        unit: "$M"
    },
    {
        id: "npVar",
        label: "Qtr Profit Var",
        unit: "%"
    },
    {
        id: "sales",
        label: "Sales Qtr",
        unit: "$M"
    },
    {
        id: "salesVar",
        label: "Qtr Sales Var",
        unit: "%"
    },
    {
        id: "roce",
        label: "ROCE",
        unit: "%"
    }
];
function $cde3de04f6e5e613$export$2e2bcd8739ae039({ list: list, onAdd: onAdd, onRemove: onRemove }) {
    const infoVersion = (0, $0e8cef3982a5818d$export$4e58cf0942785ded)();
    const sumVersion = (0, $6d972d26c47ffac8$export$ae1efb09da3bcdf9)();
    const [hidden, setHidden] = (0, $acw62.useState)([]);
    const [industry, setIndustry] = (0, $acw62.useState)("all");
    const [sort, setSort] = (0, $acw62.useState)({
        col: null,
        dir: "asc"
    });
    const rows = (0, $acw62.useMemo)(()=>list.tickers.map((t)=>(0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(t)).filter(Boolean).map((c)=>({
                ...c,
                f: (0, $6d972d26c47ffac8$export$ad2c21017a759cdf)(c.ticker)
            })), [
        list.tickers,
        infoVersion,
        sumVersion
    ]);
    const industries = [
        ...new Set(rows.map((r)=>r.category))
    ];
    const visibleCols = $cde3de04f6e5e613$var$COLUMNS.filter((c)=>!hidden.includes(c.id));
    const filtered = rows.filter((r)=>industry === "all" || r.category === industry);
    const sorted = sort.col ? [
        ...filtered
    ].sort((a, b)=>{
        const av = sort.col === "company" ? a.name : a.f[sort.col];
        const bv = sort.col === "company" ? b.name : b.f[sort.col];
        const cmp = typeof av === "string" ? av.localeCompare(bv) : av - bv;
        return sort.dir === "asc" ? cmp : -cmp;
    }) : filtered;
    const toggleSort = (col)=>setSort((s)=>s.col === col ? {
                col: col,
                dir: s.dir === "asc" ? "desc" : "asc"
            } : {
                col: col,
                dir: "asc"
            });
    const toggleColumn = (id)=>setHidden((h)=>h.includes(id) ? h.filter((x)=>x !== id) : [
                ...h,
                id
            ]);
    const exportCsv = ()=>{
        const esc = (v)=>`"${String(v).replace(/"/g, '""')}"`;
        const header = [
            "S.No.",
            "Company",
            "Ticker",
            "Industry",
            ...visibleCols.map((c)=>`${c.label} ${c.unit}`.trim())
        ];
        const lines = sorted.map((r, i)=>[
                i + 1,
                r.name,
                r.ticker,
                r.category,
                ...visibleCols.map((c)=>r.f[c.id].toFixed(2))
            ].map(esc).join(","));
        const blob = new Blob([
            [
                header.map(esc).join(","),
                ...lines
            ].join("\n")
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${list.name}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };
    const SortIcon = ({ col: col })=>sort.col === col ? sort.dir === "asc" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
            size: 12
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
            size: 12
        }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "card wl-table-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "wl-toolbar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                                variant: "",
                                className: "tool-btn",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78659dd4d4ddf1e7$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " ",
                                    industry === "all" ? "INDUSTRY" : industry.toUpperCase()
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                        active: industry === "all",
                                        onClick: ()=>setIndustry("all"),
                                        children: "All industries"
                                    }),
                                    industries.map((ind)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                            active: industry === ind,
                                            onClick: ()=>setIndustry(ind),
                                            children: ind
                                        }, ind))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "btn tool-btn",
                        onClick: exportCsv,
                        disabled: rows.length === 0,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " EXPORT"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                        align: "end",
                        autoClose: "outside",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                                variant: "",
                                className: "tool-btn tool-btn-primary",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da03c070d837b197$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " EDIT COLUMNS"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                                className: "columns-menu",
                                children: $cde3de04f6e5e613$var$COLUMNS.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "columns-item",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: !hidden.includes(c.id),
                                                onChange: ()=>toggleColumn(c.id)
                                            }),
                                            c.label,
                                            " ",
                                            c.unit
                                        ]
                                    }, c.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "table-responsive",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "table wl-table mb-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "wl-th-plain",
                                        children: "S.No."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "th-btn",
                                            onClick: ()=>toggleSort("company"),
                                            children: [
                                                "Company ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SortIcon, {
                                                    col: "company"
                                                })
                                            ]
                                        })
                                    }),
                                    visibleCols.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "text-end",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                className: "th-btn",
                                                onClick: ()=>toggleSort(c.id),
                                                children: [
                                                    c.label,
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "th-unit",
                                                        children: c.unit
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SortIcon, {
                                                        col: c.id
                                                    })
                                                ]
                                            })
                                        }, c.id)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                            children: [
                                sorted.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    i + 1,
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                                    size: 15,
                                                    className: "wl-book"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        className: "wl-company",
                                                        href: `#/stock/${r.ticker}`,
                                                        children: r.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-muted small ms-2",
                                                        children: r.ticker
                                                    })
                                                ]
                                            }),
                                            visibleCols.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "text-end",
                                                    children: r.f[c.id].toFixed(2)
                                                }, c.id)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "text-end",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "row-remove",
                                                    onClick: ()=>onRemove(r.ticker),
                                                    title: "Remove from watchlist",
                                                    "aria-label": `Remove ${r.name}`,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                        size: 15
                                                    })
                                                })
                                            })
                                        ]
                                    }, r.ticker)),
                                sorted.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: visibleCols.length + 4,
                                        className: "wl-empty",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-muted mb-3",
                                                children: rows.length === 0 ? "This watchlist is empty. Add companies to start tracking them." : "No companies match this industry."
                                            }),
                                            rows.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "btn btn-purple",
                                                onClick: onAdd,
                                                children: "ADD COMPANIES"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted small wl-note",
                children: "Prices are about 15 minutes delayed. Financial figures come from SEC filings. Companies without standard SEC financials (SPACs, funds, some foreign filers) show a dash."
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $814748c4d1640136$export$8b437002c2b08d1 = "trades836_session";
const $814748c4d1640136$var$SESSION_DURATION_MS = 2592000000;
function $814748c4d1640136$export$ccdf34816785229e(user) {
    localStorage.setItem($814748c4d1640136$export$8b437002c2b08d1, JSON.stringify({
        user: user,
        expiresAt: Date.now() + $814748c4d1640136$var$SESSION_DURATION_MS
    }));
}
function $814748c4d1640136$export$12151e9ef3722552() {
    try {
        const raw = localStorage.getItem($814748c4d1640136$export$8b437002c2b08d1);
        if (!raw) return null;
        const session = JSON.parse(raw);
        if (!session.expiresAt || session.expiresAt < Date.now() || !session.user || !session.user.token) {
            $814748c4d1640136$export$7809a8af6f3e4c63();
            return null;
        }
        return session;
    } catch  {
        $814748c4d1640136$export$7809a8af6f3e4c63();
        return null;
    }
}
function $814748c4d1640136$export$257b2d10b709d8ef() {
    const s = $814748c4d1640136$export$12151e9ef3722552();
    return s ? s.user.token : null;
}
function $814748c4d1640136$export$7809a8af6f3e4c63() {
    localStorage.removeItem($814748c4d1640136$export$8b437002c2b08d1);
}


class $eaaba8a5ae480d72$export$f2e832acab1bdd79 extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
    }
}
async function $eaaba8a5ae480d72$export$644d8ea042df96a6(path, { method: method = "GET", body: body, auth: auth = false } = {}) {
    const headers = {};
    if (body !== undefined) headers["Content-Type"] = "application/json";
    if (auth) {
        const t = (0, $814748c4d1640136$export$257b2d10b709d8ef)();
        if (t) headers.Authorization = `Bearer ${t}`;
    }
    let res;
    try {
        res = await fetch(`${(0, $d27dbe10f1bffb7d$export$923ea8233b386e99)}${path}`, {
            method: method,
            headers: headers,
            body: body !== undefined ? JSON.stringify(body) : undefined
        });
    } catch  {
        throw new $eaaba8a5ae480d72$export$f2e832acab1bdd79("Cannot reach the server. Is the backend running?", 0);
    }
    let data = null;
    try {
        data = await res.json();
    } catch  {}
    if (!res.ok) throw new $eaaba8a5ae480d72$export$f2e832acab1bdd79(data && data.error || `Request failed (${res.status})`, res.status);
    return data;
}



function $a9ca0e1faff7329a$export$2e2bcd8739ae039({ selected: selected, onToggle: onToggle, onClose: onClose }) {
    (0, $0e8cef3982a5818d$export$4e58cf0942785ded)();
    const [query, setQuery] = (0, $acw62.useState)("");
    const [results, setResults] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const q = query.trim();
        if (!q) {
            setResults([]);
            return undefined;
        }
        let dead = false;
        setLoading(true);
        const timer = setTimeout(()=>{
            (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/search?q=${encodeURIComponent(q)}&limit=30`).then((rows)=>{
                if (dead) return;
                (0, $0e8cef3982a5818d$export$29d1feb935211dfc)(rows);
                setResults(rows);
                setLoading(false);
            }).catch(()=>{
                if (!dead) {
                    setResults([]);
                    setLoading(false);
                }
            });
        }, 200);
        return ()=>{
            dead = true;
            clearTimeout(timer);
        };
    }, [
        query
    ]);
    const rows = query.trim() ? results : selected.map((t)=>(0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(t) || {
            ticker: t,
            name: t,
            sector: ""
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modal-backdrop",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "modal-card add-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Add companies"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "dash-search-wrap",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                            size: 16,
                            className: "add-search-icon"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            className: "form-control add-search-input",
                            placeholder: "Search any US company by name or ticker",
                            value: query,
                            autoFocus: true,
                            onChange: (e)=>setQuery(e.target.value)
                        })
                    ]
                }),
                !query.trim() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "small text-muted mt-2",
                    children: selected.length ? "In this watchlist (untick to remove):" : "Type a name or ticker, e.g. Apple or NVDA."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "add-list",
                    children: [
                        rows.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "add-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: selected.includes(c.ticker),
                                            onChange: ()=>onToggle(c.ticker)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "fw-bold",
                                            children: c.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted small",
                                            children: c.ticker
                                        }),
                                        c.sector && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "badge badge-purple ms-auto",
                                            children: c.sector
                                        })
                                    ]
                                })
                            }, c.ticker)),
                        query.trim() && !loading && rows.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            className: "text-muted p-3",
                            children: "No companies found."
                        }),
                        loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            className: "text-muted p-3",
                            children: "Searching..."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "modal-actions",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "btn btn-purple",
                        onClick: onClose,
                        children: "DONE"
                    })
                })
            ]
        })
    });
}



parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $60ce6054535c0854$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Flame", [
    [
        "path",
        {
            d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
            key: "96xj49"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b547c0f28739ad4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Play", [
    [
        "polygon",
        {
            points: "5 3 19 12 5 21 5 3",
            key: "191637"
        }
    ]
]);


function $1a6c313c2b12f9b9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
        className: "sidebar",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "card feature-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "feature-preview",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "play-button",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b547c0f28739ad4$export$2e2bcd8739ae039), {
                            size: 18,
                            fill: "#ffffff"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "feature-content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "badge badge-success mb-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60ce6054535c0854$export$2e2bcd8739ae039), {
                                    size: 12
                                }),
                                " Power Feature"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                            className: "fw-bold mb-1",
                            children: "Stock Alerts"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "small text-muted mb-0",
                            children: "Get notified if the price reaches your buy zone. Even after years. Set and forget."
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");
function $e9916e1a7ef47388$export$2e2bcd8739ae039({ data: data, width: width = 120, height: height = 36 }) {
    if (!data || data.length < 2) return null;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const pad = 2;
    const points = data.map((v, i)=>{
        const x = i / (data.length - 1) * width;
        const y = pad + (1 - (v - min) / range) * (height - pad * 2);
        return [
            x,
            y
        ];
    });
    const line = points.map(([x, y])=>`${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
    const area = `0,${height} ${line} ${width},${height}`;
    const up = data[data.length - 1] >= data[0];
    const color = up ? "#198754" : "#dc3545";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        role: "img",
        "aria-label": "52-week price chart",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                points: area,
                fill: color,
                opacity: "0.12"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                points: line,
                fill: "none",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinejoin: "round",
                strokeLinecap: "round"
            })
        ]
    });
}






// Records what the signed-in user does and sends it to the backend in small batches.


let $b1f811543f3e0211$var$queue = [];
let $b1f811543f3e0211$var$timer = null;
function $b1f811543f3e0211$var$flush() {
    $b1f811543f3e0211$var$timer = null;
    const token = (0, $814748c4d1640136$export$257b2d10b709d8ef)();
    if (!$b1f811543f3e0211$var$queue.length) return;
    const events = $b1f811543f3e0211$var$queue.splice(0, 50);
    if (token) fetch(`${(0, $d27dbe10f1bffb7d$export$923ea8233b386e99)}/me/events`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            events: events
        }),
        keepalive: true
    }).catch(()=>{});
    if ($b1f811543f3e0211$var$queue.length) $b1f811543f3e0211$var$timer = setTimeout($b1f811543f3e0211$var$flush, 1000);
}
function $b1f811543f3e0211$export$6b2a7d5132615086(type, data) {
    if (!(0, $814748c4d1640136$export$257b2d10b709d8ef)()) return;
    $b1f811543f3e0211$var$queue.push({
        type: type,
        data: data === undefined ? null : data,
        at: Date.now()
    });
    if (!$b1f811543f3e0211$var$timer) $b1f811543f3e0211$var$timer = setTimeout($b1f811543f3e0211$var$flush, 4000);
}
if (typeof window !== "undefined") {
    window.addEventListener("pagehide", $b1f811543f3e0211$var$flush);
    document.addEventListener("visibilitychange", ()=>{
        if (document.hidden) $b1f811543f3e0211$var$flush();
    });
}
const $b1f811543f3e0211$var$arr = (v)=>Array.isArray(v) ? v : [];
function $b1f811543f3e0211$var$diffList(prefix, before, after, pick) {
    const b = new Map($b1f811543f3e0211$var$arr(before).map((x)=>[
            x.id,
            x
        ]));
    for (const x of $b1f811543f3e0211$var$arr(after)){
        const old = b.get(x.id);
        if (!old) $b1f811543f3e0211$export$6b2a7d5132615086(`${prefix}_add`, pick(x));
        else if (JSON.stringify(old) !== JSON.stringify(x)) $b1f811543f3e0211$export$6b2a7d5132615086(`${prefix}_update`, pick(x));
        b.delete(x.id);
    }
    for (const x of b.values())$b1f811543f3e0211$export$6b2a7d5132615086(`${prefix}_remove`, pick(x));
}
function $b1f811543f3e0211$export$706320a461885e7(name, before, after) {
    try {
        if (name === "watchlists") {
            const b = new Map($b1f811543f3e0211$var$arr(before && before.lists).map((l)=>[
                    l.id,
                    l
                ]));
            for (const l of $b1f811543f3e0211$var$arr(after && after.lists)){
                const old = b.get(l.id);
                if (!old) $b1f811543f3e0211$export$6b2a7d5132615086("watchlist_create", {
                    name: l.name
                });
                const was = new Set(old ? old.tickers : []);
                const now = new Set(l.tickers);
                for (const t of now)if (!was.has(t)) $b1f811543f3e0211$export$6b2a7d5132615086("watchlist_add", {
                    list: l.name,
                    ticker: t
                });
                for (const t of was)if (!now.has(t)) $b1f811543f3e0211$export$6b2a7d5132615086("watchlist_remove", {
                    list: l.name,
                    ticker: t
                });
                b.delete(l.id);
            }
            for (const l of b.values())$b1f811543f3e0211$export$6b2a7d5132615086("watchlist_delete", {
                name: l.name
            });
        } else if (name === "portfolio") $b1f811543f3e0211$var$diffList("portfolio", before, after, (x)=>({
                ticker: x.ticker,
                shares: x.shares,
                cost: x.cost
            }));
        else if (name === "alerts") $b1f811543f3e0211$var$diffList("alert", before, after, (x)=>({
                ticker: x.ticker,
                condition: x.condition,
                target: x.target,
                triggeredAt: x.triggeredAt || null
            }));
        else if (name === "screens") $b1f811543f3e0211$var$diffList("screen", before, after, (x)=>({
                name: x.name,
                query: x.query
            }));
        else if (name === "notes") {
            for (const k of Object.keys(after || {}))if (JSON.stringify((before || {})[k]) !== JSON.stringify(after[k])) $b1f811543f3e0211$export$6b2a7d5132615086("note_edit", {
                ticker: k,
                count: (after[k] || []).length
            });
        } else if (name === "models") {
            for (const k of Object.keys(after || {}))if (JSON.stringify((before || {})[k]) !== JSON.stringify(after[k])) $b1f811543f3e0211$export$6b2a7d5132615086("model_save", {
                ticker: k
            });
        }
    } catch  {
    /* tracking must never break the app */ }
}


const $c8ac4ec5c1859847$var$KEYS = [
    "watchlists",
    "screens",
    "portfolio",
    "alerts"
];
const $c8ac4ec5c1859847$var$cache = new Map();
const $c8ac4ec5c1859847$var$pending = new Map();
const $c8ac4ec5c1859847$var$timers = new Map();
const $c8ac4ec5c1859847$var$legacyKey = (name, user)=>`trades836_${name}:${user && user.email || "guest"}`;
function $c8ac4ec5c1859847$var$legacy(name, user) {
    try {
        const raw = localStorage.getItem($c8ac4ec5c1859847$var$legacyKey(name, user));
        return raw ? JSON.parse(raw) : undefined;
    } catch  {
        return undefined;
    }
}
function $c8ac4ec5c1859847$var$push(name, value) {
    const token = (0, $814748c4d1640136$export$257b2d10b709d8ef)();
    if (!token) return Promise.resolve();
    return fetch(`${(0, $d27dbe10f1bffb7d$export$923ea8233b386e99)}/me/data/${name}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            value: value
        }),
        keepalive: true
    }).catch(()=>{});
}
function $c8ac4ec5c1859847$var$flush() {
    for (const [name, value] of $c8ac4ec5c1859847$var$pending)$c8ac4ec5c1859847$var$push(name, value);
    $c8ac4ec5c1859847$var$pending.clear();
    $c8ac4ec5c1859847$var$timers.forEach(clearTimeout);
    $c8ac4ec5c1859847$var$timers.clear();
}
if (typeof window !== "undefined") {
    window.addEventListener("pagehide", $c8ac4ec5c1859847$var$flush);
    document.addEventListener("visibilitychange", ()=>{
        if (document.hidden) $c8ac4ec5c1859847$var$flush();
    });
}
async function $c8ac4ec5c1859847$export$a16e60d0d9d0a6cf(user) {
    $c8ac4ec5c1859847$var$cache.clear();
    $c8ac4ec5c1859847$var$pending.clear();
    const token = (0, $814748c4d1640136$export$257b2d10b709d8ef)();
    if (!token) return false;
    try {
        const res = await fetch(`${(0, $d27dbe10f1bffb7d$export$923ea8233b386e99)}/me/data`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (res.status === 401) return false;
        if (res.ok) {
            const data = await res.json();
            for (const [k, v] of Object.entries(data))$c8ac4ec5c1859847$var$cache.set(k, v);
        }
    } catch  {
    /* server unreachable: pages start empty */ }
    for (const name of $c8ac4ec5c1859847$var$KEYS)if (!$c8ac4ec5c1859847$var$cache.has(name)) {
        const old = $c8ac4ec5c1859847$var$legacy(name, user);
        if (old !== undefined) {
            $c8ac4ec5c1859847$var$cache.set(name, old);
            $c8ac4ec5c1859847$var$push(name, old);
        }
    }
    return true;
}
function $c8ac4ec5c1859847$export$332d58514331716c(name, user, fallback) {
    return $c8ac4ec5c1859847$var$cache.has(name) ? $c8ac4ec5c1859847$var$cache.get(name) : fallback;
}
function $c8ac4ec5c1859847$export$9f43f72cb45956cb(name, user, value) {
    (0, $b1f811543f3e0211$export$706320a461885e7)(name, $c8ac4ec5c1859847$var$cache.get(name), value);
    $c8ac4ec5c1859847$var$cache.set(name, value);
    $c8ac4ec5c1859847$var$pending.set(name, value);
    clearTimeout($c8ac4ec5c1859847$var$timers.get(name));
    $c8ac4ec5c1859847$var$timers.set(name, setTimeout(()=>{
        $c8ac4ec5c1859847$var$timers.delete(name);
        $c8ac4ec5c1859847$var$pending.delete(name);
        $c8ac4ec5c1859847$var$push(name, value);
    }, 400));
}
function $c8ac4ec5c1859847$export$fab3fd6c390bad62() {
    $c8ac4ec5c1859847$var$cache.clear();
    $c8ac4ec5c1859847$var$pending.clear();
    $c8ac4ec5c1859847$var$timers.forEach(clearTimeout);
    $c8ac4ec5c1859847$var$timers.clear();
}


function $e40357b11b89adfe$export$c71e43542eef6c70(user) {
    const d = (0, $c8ac4ec5c1859847$export$332d58514331716c)("watchlists", user, null);
    return d && Array.isArray(d.lists) ? d : {
        lists: [],
        activeId: null
    };
}
function $e40357b11b89adfe$export$1224f37931278599(user, data) {
    (0, $c8ac4ec5c1859847$export$9f43f72cb45956cb)("watchlists", user, data);
}


function $6d7fd6f403e72730$export$2e2bcd8739ae039({ user: user, onBack: onBack }) {
    (0, $0e8cef3982a5818d$export$4e58cf0942785ded)();
    const [data, setData] = (0, $acw62.useState)(()=>(0, $e40357b11b89adfe$export$c71e43542eef6c70)(user));
    const [view, setView] = (0, $acw62.useState)(data.lists.length ? "list" : "create");
    const [returnView, setReturnView] = (0, $acw62.useState)("list");
    const [showAdd, setShowAdd] = (0, $acw62.useState)(false);
    const active = data.lists.find((l)=>l.id === data.activeId) || data.lists[0];
    const commit = (next)=>{
        setData(next);
        (0, $e40357b11b89adfe$export$1224f37931278599)(user, next);
    };
    const openCreate = ()=>{
        setReturnView(view === "create" ? "list" : view);
        setView("create");
    };
    const handleCreate = (name)=>{
        const id = Date.now().toString(36);
        commit({
            lists: [
                ...data.lists,
                {
                    id: id,
                    name: name,
                    tickers: []
                }
            ],
            activeId: id
        });
        setView("table"); // after creating: table view
    };
    const goBack = ()=>{
        if (data.lists.length) setView(returnView);
        else onBack();
    };
    const selectList = (id)=>commit({
            ...data,
            activeId: id
        });
    const toggleTicker = (ticker)=>{
        const lists = data.lists.map((l)=>l.id !== active.id ? l : {
                ...l,
                tickers: l.tickers.includes(ticker) ? l.tickers.filter((t)=>t !== ticker) : [
                    ...l.tickers,
                    ticker
                ]
            });
        commit({
            ...data,
            lists: lists
        });
    };
    /* ---------- BEFORE: create a watchlist ---------- */ if (view === "create" || !active) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $659779301cb4aef4$export$2e2bcd8739ae039), {
        existingNames: data.lists.map((l)=>l.name),
        onSave: handleCreate,
        onBack: goBack
    });
    const titleDropdown = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                variant: "",
                className: "wl-title-toggle",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b66c39b6083b2b9$export$2e2bcd8739ae039), {
                        size: 18
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: active.name
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                children: [
                    data.lists.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                            active: l.id === active.id,
                            onClick: ()=>selectList(l.id),
                            children: l.name
                        }, l.id)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Divider, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                        onClick: openCreate,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                size: 14,
                                className: "me-1"
                            }),
                            " Create new watchlist"
                        ]
                    })
                ]
            })
        ]
    });
    const addModal = showAdd && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9ca0e1faff7329a$export$2e2bcd8739ae039), {
        selected: active.tickers,
        onToggle: toggleTicker,
        onClose: ()=>setShowAdd(false)
    });
    /* ---------- AFTER: table view ---------- */ if (view === "table") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "page-bg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dash-main-content wl-wide",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        className: "wl-breadcrumb",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "#",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setView("list");
                                },
                                children: active.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "/"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Table View"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "top-bar",
                        children: [
                            titleDropdown,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "d-flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "btn tool-btn",
                                        onClick: ()=>setShowAdd(true),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                size: 15
                                            }),
                                            " ADD COMPANIES"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "btn tool-btn",
                                        onClick: ()=>setView("list"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef166891ec0b7b3f$export$2e2bcd8739ae039), {
                                                size: 15
                                            }),
                                            " COMPANIES"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde3de04f6e5e613$export$2e2bcd8739ae039), {
                        list: active,
                        onAdd: ()=>setShowAdd(true),
                        onRemove: toggleTicker
                    })
                ]
            }),
            addModal
        ]
    });
    /* ---------- Watchlist home (company cards) ---------- */ const companies = active.tickers.map((t)=>(0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(t)).filter(Boolean);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "page-bg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dash-main-content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "top-bar",
                        children: [
                            titleDropdown,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "view-toggle",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "toggle-btn active",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c52b562f10363bcd$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            " WATCHLIST VIEW"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "toggle-btn",
                                        onClick: ()=>setView("table"),
                                        title: "Table view",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef166891ec0b7b3f$export$2e2bcd8739ae039), {
                                            size: 14
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "dash-grid",
                        children: [
                            companies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "card empty-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "empty-icon",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                            size: 36
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                        className: "card-title fw-bold",
                                        children: "Add companies to watchlist"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "card-text text-muted",
                                        children: "Keep track of latest announcements, insider trades and credit ratings of your companies."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn btn-purple",
                                        onClick: ()=>setShowAdd(true),
                                        children: "ADD COMPANIES"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "row g-3",
                                        children: companies.map((c)=>{
                                            const stats = (0, $6d972d26c47ffac8$export$9a79ba2e7e56f601)(c.ticker);
                                            const up = stats.change >= 0;
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-12 col-md-6",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "card wl-company-card",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "d-flex justify-content-between align-items-start",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "fw-bold",
                                                                            children: c.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "text-muted small",
                                                                            children: c.ticker
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "badge badge-purple",
                                                                    children: c.category
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "d-flex justify-content-between align-items-end mt-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "wl-price",
                                                                            children: [
                                                                                "$",
                                                                                stats.current.toFixed(2)
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: `small fw-bold ${up ? "change-up" : "change-down"}`,
                                                                            children: [
                                                                                up ? "+" : "",
                                                                                stats.change.toFixed(1),
                                                                                "% (52W)"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9916e1a7ef47388$export$2e2bcd8739ae039), {
                                                                    data: stats.series
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, c.ticker);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "show-more-btn mt-3",
                                        onClick: ()=>setShowAdd(true),
                                        children: "ADD COMPANIES"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-muted small mt-3 mb-0",
                                        children: "Prices come from your database and are about 15 minutes delayed."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a6c313c2b12f9b9$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            addModal
        ]
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c35b0991cad9668$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ExternalLink", [
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ],
    [
        "polyline",
        {
            points: "15 3 21 3 21 9",
            key: "mznyad"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "21",
            y1: "14",
            y2: "3",
            key: "18c3s4"
        }
    ]
]);



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $85f2569d71bb680d$export$2e2bcd8739ae039({ symbol: symbol, height: height = 280, dateRange: dateRange = "12M" }) {
    const containerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        container.innerHTML = "";
        const widget = document.createElement("div");
        widget.className = "tradingview-widget-container__widget";
        container.appendChild(widget);
        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
            symbol: symbol,
            width: "100%",
            height: "100%",
            locale: "en",
            dateRange: dateRange,
            colorTheme: "light",
            isTransparent: true,
            autosize: true,
            largeChartUrl: ""
        });
        container.appendChild(script);
        // Clean up when the symbol changes or the component unmounts
        return ()=>{
            container.innerHTML = "";
        };
    }, [
        symbol,
        dateRange
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tradingview-widget-container",
        ref: containerRef,
        style: {
            height: height,
            width: "100%"
        }
    });
}


function $7b8317792b385123$export$2e2bcd8739ae039({ title: title, companies: companies }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                className: "fw-bold mb-3",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "row g-3",
                children: companies.slice(0, 3).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "col-12 col-lg-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "card top-company-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "top-company-header",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            className: "fw-bold wl-company",
                                            href: `#/stock/${c.ticker}`,
                                            children: c.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted small",
                                            children: c.ticker
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85f2569d71bb680d$export$2e2bcd8739ae039), {
                                    symbol: c.symbol
                                })
                            ]
                        })
                    }, c.symbol))
            })
        ]
    });
}


// Top 3 US companies by market cap (mid-2026). Edit any time.
const $d3163c93b9e14f42$var$TOP_3 = [
    {
        name: "NVIDIA",
        ticker: "NVDA",
        symbol: "NASDAQ:NVDA"
    },
    {
        name: "Alphabet",
        ticker: "GOOGL",
        symbol: "NASDAQ:GOOGL"
    },
    {
        name: "Apple Inc.",
        ticker: "AAPL",
        symbol: "NASDAQ:AAPL"
    }
];
// Placeholder announcements. `daysAgo` keeps the dates fresh whenever you open the page.
// Later: replace with real filings / news, personalized per user.
const $d3163c93b9e14f42$var$ANNOUNCEMENTS = [
    {
        company: "Apple Inc.",
        daysAgo: 1,
        title: "Investor Conference",
        summary: "Management will take part in investor meetings over the coming weeks."
    },
    {
        company: "NVIDIA",
        daysAgo: 1,
        title: "Current Report (Form 8-K)",
        summary: "NVIDIA filed a current report with the SEC covering a recent corporate update."
    },
    {
        company: "Microsoft",
        daysAgo: 2,
        title: "Quarterly Dividend Declaration",
        summary: "The board declared its regular quarterly dividend, payable to shareholders of record."
    },
    {
        company: "Tesla",
        daysAgo: 2,
        title: "Earnings Call Scheduled",
        summary: "Tesla announced the date and time of its upcoming quarterly earnings webcast."
    },
    {
        company: "Amazon",
        daysAgo: 3,
        title: "Quarterly Report (Form 10-Q)",
        summary: "Amazon filed its quarterly report with the SEC, including updated financial statements."
    },
    {
        company: "JPMorgan",
        daysAgo: 4,
        title: "Share Repurchase Update",
        summary: "JPMorgan provided an update on its ongoing share repurchase program."
    },
    {
        company: "Alphabet",
        daysAgo: 4,
        title: "Annual Meeting Materials Published",
        summary: "Proxy materials for the upcoming annual meeting of shareholders are now available."
    },
    {
        company: "Meta",
        daysAgo: 5,
        title: "Insider Transaction (Form 4)",
        summary: "An executive officer reported a transaction in company shares."
    },
    {
        company: "Eli Lilly",
        daysAgo: 6,
        title: "Press Release: Pipeline Update",
        summary: "Eli Lilly shared an update on programs in its clinical development pipeline."
    },
    {
        company: "Visa",
        daysAgo: 7,
        title: "Investor Presentation Posted",
        summary: "Visa posted a new investor presentation on its investor relations website."
    },
    {
        company: "NVIDIA",
        daysAgo: 8,
        title: "Analyst Day Announcement",
        summary: "Details of an upcoming analyst and investor event were announced."
    },
    {
        company: "Microsoft",
        daysAgo: 9,
        title: "Current Report (Form 8-K)",
        summary: "Microsoft filed a current report with the SEC regarding a corporate event."
    },
    {
        company: "Apple Inc.",
        daysAgo: 11,
        title: "Quarterly Report (Form 10-Q)",
        summary: "Apple filed its latest quarterly report with the SEC."
    },
    {
        company: "Tesla",
        daysAgo: 12,
        title: "Insider Transaction (Form 4)",
        summary: "A director reported a change in beneficial ownership of company shares."
    }
];
const $d3163c93b9e14f42$var$PAGE_SIZE = 6;
function $d3163c93b9e14f42$var$dateLabel(daysAgo) {
    if (daysAgo === 0) return "TODAY";
    if (daysAgo === 1) return "YESTERDAY";
    const d = new Date();
    d.setDate(d.getDate() - daysAgo);
    return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric"
    }).toUpperCase();
}
function $d3163c93b9e14f42$export$2e2bcd8739ae039({ user: user }) {
    const [visible, setVisible] = (0, $acw62.useState)($d3163c93b9e14f42$var$PAGE_SIZE);
    const shown = $d3163c93b9e14f42$var$ANNOUNCEMENTS.slice(0, visible);
    // Group the visible items by date label (items are already newest first)
    const groups = [];
    shown.forEach((item)=>{
        const label = $d3163c93b9e14f42$var$dateLabel(item.daysAgo);
        const last = groups[groups.length - 1];
        if (last && last.label === label) last.items.push(item);
        else groups.push({
            label: label,
            items: [
                item
            ]
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b8317792b385123$export$2e2bcd8739ae039), {
                    title: "Top 3 companies",
                    companies: $d3163c93b9e14f42$var$TOP_3
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "top-bar",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "watchlist-title",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Feed"
                                })
                            })
                        }),
                        user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "feed-empty",
                                    children: "Nothing new since your last visit."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "last-visit",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "last visit"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted mb-4",
                            children: "Sign up to get a feed personalized to the companies you follow."
                        }),
                        groups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "feed-date",
                                        children: group.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "d-flex flex-column gap-3",
                                        children: group.items.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                                className: "card feed-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                        href: "#",
                                                        className: "feed-company",
                                                        onClick: (e)=>e.preventDefault(),
                                                        children: [
                                                            item.company,
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                size: 15
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: "#",
                                                        className: "feed-title",
                                                        onClick: (e)=>e.preventDefault(),
                                                        children: item.title
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "feed-summary",
                                                        children: item.summary
                                                    })
                                                ]
                                            }, `${item.company}-${i}`))
                                    })
                                ]
                            }, group.label)),
                        visible < $d3163c93b9e14f42$var$ANNOUNCEMENTS.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "show-more-btn",
                            onClick: ()=>setVisible(visible + $d3163c93b9e14f42$var$PAGE_SIZE),
                            children: "SHOW MORE"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted small mt-4 mb-0",
                            children: "Sample content for layout purposes."
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e583651be68dae50$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowLeftRight", [
    [
        "path",
        {
            d: "M8 3 4 7l4 4",
            key: "9rb6wj"
        }
    ],
    [
        "path",
        {
            d: "M4 7h16",
            key: "6tx8e3"
        }
    ],
    [
        "path",
        {
            d: "m16 21 4-4-4-4",
            key: "siv7j2"
        }
    ],
    [
        "path",
        {
            d: "M20 17H4",
            key: "h6l3hr"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $224502d93617e0e1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Building2", [
    [
        "path",
        {
            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
            key: "1b4qmf"
        }
    ],
    [
        "path",
        {
            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
            key: "i71pzd"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
            key: "10jefs"
        }
    ],
    [
        "path",
        {
            d: "M10 6h4",
            key: "1itunk"
        }
    ],
    [
        "path",
        {
            d: "M10 10h4",
            key: "tcdvrf"
        }
    ],
    [
        "path",
        {
            d: "M10 14h4",
            key: "kelpxr"
        }
    ],
    [
        "path",
        {
            d: "M10 18h4",
            key: "1ulq68"
        }
    ]
]);




// Symbols use TradingView's EXCHANGE:TICKER format. Edit freely.
const $00dd3ee12ffb5f1a$export$a513ea61a7bee91c = [
    {
        id: "technology",
        label: "Technology",
        companies: [
            {
                name: "Apple Inc.",
                ticker: "AAPL",
                symbol: "NASDAQ:AAPL"
            },
            {
                name: "Microsoft",
                ticker: "MSFT",
                symbol: "NASDAQ:MSFT"
            },
            {
                name: "Alphabet",
                ticker: "GOOGL",
                symbol: "NASDAQ:GOOGL"
            },
            {
                name: "Meta",
                ticker: "META",
                symbol: "NASDAQ:META"
            }
        ]
    },
    {
        id: "semiconductors",
        label: "Semiconductors",
        companies: [
            {
                name: "NVIDIA",
                ticker: "NVDA",
                symbol: "NASDAQ:NVDA"
            },
            {
                name: "Broadcom",
                ticker: "AVGO",
                symbol: "NASDAQ:AVGO"
            },
            {
                name: "AMD",
                ticker: "AMD",
                symbol: "NASDAQ:AMD"
            },
            {
                name: "Micron",
                ticker: "MU",
                symbol: "NASDAQ:MU"
            }
        ]
    },
    {
        id: "financials",
        label: "Financials",
        companies: [
            {
                name: "JPMorgan",
                ticker: "JPM",
                symbol: "NYSE:JPM"
            },
            {
                name: "Visa",
                ticker: "V",
                symbol: "NYSE:V"
            },
            {
                name: "Mastercard",
                ticker: "MA",
                symbol: "NYSE:MA"
            },
            {
                name: "Bank of America",
                ticker: "BAC",
                symbol: "NYSE:BAC"
            }
        ]
    },
    {
        id: "healthcare",
        label: "Healthcare",
        companies: [
            {
                name: "Eli Lilly",
                ticker: "LLY",
                symbol: "NYSE:LLY"
            },
            {
                name: "Johnson & Johnson",
                ticker: "JNJ",
                symbol: "NYSE:JNJ"
            },
            {
                name: "UnitedHealth",
                ticker: "UNH",
                symbol: "NYSE:UNH"
            },
            {
                name: "AbbVie",
                ticker: "ABBV",
                symbol: "NYSE:ABBV"
            }
        ]
    },
    {
        id: "consumer",
        label: "Consumer",
        companies: [
            {
                name: "Amazon",
                ticker: "AMZN",
                symbol: "NASDAQ:AMZN"
            },
            {
                name: "Costco",
                ticker: "COST",
                symbol: "NASDAQ:COST"
            },
            {
                name: "Coca-Cola",
                ticker: "KO",
                symbol: "NYSE:KO"
            },
            {
                name: "McDonald's",
                ticker: "MCD",
                symbol: "NYSE:MCD"
            }
        ]
    },
    {
        id: "energy",
        label: "Energy",
        companies: [
            {
                name: "Exxon Mobil",
                ticker: "XOM",
                symbol: "NYSE:XOM"
            },
            {
                name: "Chevron",
                ticker: "CVX",
                symbol: "NYSE:CVX"
            },
            {
                name: "ConocoPhillips",
                ticker: "COP",
                symbol: "NYSE:COP"
            }
        ]
    }
];
const $00dd3ee12ffb5f1a$export$1d4ea4174a09d7d9 = $00dd3ee12ffb5f1a$export$a513ea61a7bee91c.flatMap((cat)=>cat.companies.map((c)=>({
            ...c,
            category: cat.label
        })));



// The column cycles through these, one at a time, when the header button is pressed
const $75cbce5baaa063c0$var$METRICS = [
    {
        id: "change",
        label: "52W Change"
    },
    {
        id: "current",
        label: "Current Price"
    },
    {
        id: "high",
        label: "52W High"
    },
    {
        id: "low",
        label: "52W Low"
    }
];
const $75cbce5baaa063c0$var$money = (n)=>`$${n.toFixed(2)}`;
function $75cbce5baaa063c0$var$MetricValue({ metric: metric, stats: stats }) {
    if (metric === "change") {
        const up = stats.change >= 0;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: `fw-bold ${up ? "change-up" : "change-down"}`,
            children: [
                up ? "+" : "",
                stats.change.toFixed(1),
                "%"
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "fw-bold",
        children: $75cbce5baaa063c0$var$money(stats[metric])
    });
}
// "All" view: one standout company from three different categories
const $75cbce5baaa063c0$var$ALL_FEATURED = [
    (0, $00dd3ee12ffb5f1a$export$a513ea61a7bee91c)[1].companies[0],
    (0, $00dd3ee12ffb5f1a$export$a513ea61a7bee91c)[2].companies[0],
    (0, $00dd3ee12ffb5f1a$export$a513ea61a7bee91c)[3].companies[0]
];
function $75cbce5baaa063c0$export$2e2bcd8739ae039({ user: user }) {
    const [categoryId, setCategoryId] = (0, $acw62.useState)("all");
    const [metricIndex, setMetricIndex] = (0, $acw62.useState)(0);
    const metric = $75cbce5baaa063c0$var$METRICS[metricIndex];
    const nextMetric = ()=>setMetricIndex((metricIndex + 1) % $75cbce5baaa063c0$var$METRICS.length);
    const selected = (0, $00dd3ee12ffb5f1a$export$a513ea61a7bee91c).find((c)=>c.id === categoryId);
    // Companies listed in the table, tagged with their category
    const tableRows = (selected ? [
        selected
    ] : (0, $00dd3ee12ffb5f1a$export$a513ea61a7bee91c)).flatMap((cat)=>cat.companies.map((c)=>({
                ...c,
                category: cat.label
            })));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "top-bar",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "watchlist-title",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                size: 18
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Companies"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted mb-3",
                    children: user ? "Browse companies by category. Soon you'll see suggestions based on your interests." : "Browse companies by category. Sign up to follow them and personalize your experience."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "category-pills mb-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: `category-pill ${categoryId === "all" ? "active" : ""}`,
                            onClick: ()=>setCategoryId("all"),
                            children: "All"
                        }),
                        (0, $00dd3ee12ffb5f1a$export$a513ea61a7bee91c).map((cat)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: `category-pill ${categoryId === cat.id ? "active" : ""}`,
                                onClick: ()=>setCategoryId(cat.id),
                                children: cat.label
                            }, cat.id))
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b8317792b385123$export$2e2bcd8739ae039), {
                    title: selected ? `Featured in ${selected.label}` : "Featured companies",
                    companies: selected ? selected.companies : $75cbce5baaa063c0$var$ALL_FEATURED
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                    className: "fw-bold mb-3",
                    children: selected ? `${selected.label} companies` : "All companies"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "card",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "table-responsive",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "table align-middle mb-0 companies-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Company"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Ticker"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Category"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "text-end",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    className: "metric-toggle",
                                                    onClick: nextMetric,
                                                    title: "Click to switch: 52W change, current price, 52W high, 52W low",
                                                    children: [
                                                        metric.label,
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                                                            size: 13
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "text-end",
                                                children: "52W Chart"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: tableRows.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "fw-bold",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        className: "wl-company",
                                                        href: `#/stock/${c.ticker}`,
                                                        children: c.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "text-muted",
                                                    children: c.ticker
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "badge badge-purple",
                                                        children: c.category
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "text-end",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($75cbce5baaa063c0$var$MetricValue, {
                                                        metric: metric.id,
                                                        stats: (0, $6d972d26c47ffac8$export$9a79ba2e7e56f601)(c.ticker)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "text-end",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9916e1a7ef47388$export$2e2bcd8739ae039), {
                                                        data: (0, $6d972d26c47ffac8$export$9a79ba2e7e56f601)(c.ticker).series
                                                    })
                                                })
                                            ]
                                        }, c.symbol))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted small mt-3 mb-0",
                    children: "Prices and charts in this table are sample data for layout purposes."
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);


// Sections and screens shown on the Screens page. Edit freely.
const $225dfe2e0344b28d$export$66b490aff740258f = [
    {
        id: "themes",
        title: "Popular themes",
        subtitle: "Popular investing themes",
        screens: [
            {
                id: "low-pe-10y",
                name: "Cheap vs. 10-year average earnings",
                description: "Stocks trading cheaply relative to their long-term average earnings."
            },
            {
                id: "capacity-expansion",
                name: "Capacity expansion",
                description: "Companies investing heavily to expand production capacity."
            },
            {
                id: "debt-reduction",
                name: "Debt reduction",
                description: "Companies steadily paying down their borrowings."
            },
            {
                id: "new-high",
                name: "Companies creating new highs",
                description: "Stocks trading close to their 52-week high."
            },
            {
                id: "no-dilution",
                name: "Growth without dilution",
                description: "Growing companies that have not issued many new shares."
            },
            {
                id: "institutional-buying",
                name: "Institutional buying",
                description: "Stocks where institutional ownership is rising."
            }
        ]
    },
    {
        id: "formulas",
        title: "Popular formulas",
        subtitle: "Screening formulas based on well-known investing books",
        screens: [
            {
                id: "piotroski",
                name: "Piotroski Scan",
                description: "Companies with a high Piotroski F-Score, a measure of financial strength."
            },
            {
                id: "magic-formula",
                name: "Magic Formula",
                description: "Ranks companies by earnings yield and return on capital."
            },
            {
                id: "coffee-can",
                name: "Coffee Can Portfolio",
                description: "Consistent compounders with long records of growth and returns."
            }
        ]
    },
    {
        id: "price-volume",
        title: "Price or Volume",
        subtitle: "Screens based on price or volume action",
        screens: [
            {
                id: "darvas",
                name: "Darvas Scan",
                description: "Stocks near their 52-week high on strong volume."
            },
            {
                id: "golden-cross",
                name: "Golden Crossover",
                description: "The 50-day average moves above the 200-day average."
            },
            {
                id: "bearish-cross",
                name: "Bearish Crossovers",
                description: "The 50-day average falls below the 200-day average."
            },
            {
                id: "pv-action",
                name: "Price Volume Action",
                description: "Stocks with unusual volume alongside a price move."
            },
            {
                id: "rsi-oversold",
                name: "RSI - Oversold Stocks",
                description: "Stocks with an RSI below 30."
            }
        ]
    },
    {
        id: "quarterly",
        title: "Quarterly results",
        subtitle: "Screens around the latest quarterly results",
        screens: [
            {
                id: "q-growers",
                name: "Quarterly Growers",
                description: "Sales and profit rising quarter after quarter."
            },
            {
                id: "best-quarter",
                name: "Best of latest quarter",
                description: "Companies with the strongest latest-quarter results."
            },
            {
                id: "earnings-accel",
                name: "Earnings acceleration",
                description: "Companies where profit growth is speeding up."
            },
            {
                id: "latest-results",
                name: "Latest results by date",
                description: "Newest quarterly reports, listed by announcement date."
            }
        ]
    },
    {
        id: "valuation",
        title: "Valuation Screens",
        subtitle: "Screens based on stock valuations",
        screens: [
            {
                id: "high-div",
                name: "Highest Dividend Yield",
                description: "Stocks that have consistently paid high dividends."
            },
            {
                id: "turnaround",
                name: "Loss to Profit Turnarounds",
                description: "Companies that recently moved from losses to profits."
            },
            {
                id: "fcf-yield",
                name: "FCF yield",
                description: "Companies with strong free cash flow relative to price."
            },
            {
                id: "low-peg",
                name: "Low PEG ratio",
                description: "Growth at a reasonable price."
            },
            {
                id: "high-book",
                name: "Trading below book value",
                description: "Stocks priced below their book value per share."
            }
        ]
    }
];
const $225dfe2e0344b28d$export$5328293a54900373 = [
    "magic-formula",
    "golden-cross",
    "new-high",
    "piotroski",
    "high-div",
    "q-growers",
    "capacity-expansion",
    "fcf-yield",
    "darvas"
];


// Industries (sectors) shown under "Browse sectors". Company lists are examples; extend freely.
// Each company is written as "Name|TICKER".
const $6b78bfe8146d41ea$var$ind = (name, sector, group, list)=>({
        id: name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
        name: name,
        sector: sector,
        group: group,
        companies: list.map((s)=>{
            const [n, t] = s.split("|");
            return {
                name: n,
                ticker: t
            };
        })
    });
const $6b78bfe8146d41ea$export$a135b49e5502643f = [
    // Industrials
    $6b78bfe8146d41ea$var$ind("Aerospace & Defense", "Industrials", "Capital Goods", [
        "Lockheed Martin|LMT",
        "RTX|RTX",
        "Boeing|BA",
        "General Dynamics|GD",
        "Northrop Grumman|NOC",
        "L3Harris Technologies|LHX",
        "TransDigm|TDG",
        "Howmet Aerospace|HWM",
        "Textron|TXT",
        "Huntington Ingalls|HII"
    ]),
    $6b78bfe8146d41ea$var$ind("Machinery", "Industrials", "Capital Goods", [
        "Caterpillar|CAT",
        "Deere & Company|DE",
        "Parker-Hannifin|PH",
        "Illinois Tool Works|ITW",
        "Cummins|CMI",
        "Otis Worldwide|OTIS",
        "Ingersoll Rand|IR",
        "Xylem|XYL"
    ]),
    $6b78bfe8146d41ea$var$ind("Electrical Equipment", "Industrials", "Capital Goods", [
        "Eaton|ETN",
        "Emerson Electric|EMR",
        "Rockwell Automation|ROK",
        "AMETEK|AME",
        "Vertiv|VRT",
        "Hubbell|HUBB"
    ]),
    $6b78bfe8146d41ea$var$ind("Building Products", "Industrials", "Capital Goods", [
        "Carrier Global|CARR",
        "Trane Technologies|TT",
        "Johnson Controls|JCI",
        "Lennox International|LII",
        "Masco|MAS"
    ]),
    $6b78bfe8146d41ea$var$ind("Construction & Engineering", "Industrials", "Capital Goods", [
        "Quanta Services|PWR",
        "EMCOR Group|EME",
        "Jacobs Solutions|J",
        "AECOM|ACM",
        "Fluor|FLR"
    ]),
    $6b78bfe8146d41ea$var$ind("Trading Companies & Distributors", "Industrials", "Capital Goods", [
        "Fastenal|FAST",
        "W.W. Grainger|GWW",
        "United Rentals|URI",
        "WESCO International|WCC"
    ]),
    $6b78bfe8146d41ea$var$ind("Air Freight & Logistics", "Industrials", "Transportation", [
        "United Parcel Service|UPS",
        "FedEx|FDX",
        "C.H. Robinson|CHRW",
        "Expeditors International|EXPD"
    ]),
    $6b78bfe8146d41ea$var$ind("Airlines", "Industrials", "Transportation", [
        "Delta Air Lines|DAL",
        "United Airlines|UAL",
        "Southwest Airlines|LUV",
        "American Airlines|AAL"
    ]),
    $6b78bfe8146d41ea$var$ind("Railroads", "Industrials", "Transportation", [
        "Union Pacific|UNP",
        "CSX|CSX",
        "Norfolk Southern|NSC"
    ]),
    // Consumer Discretionary
    $6b78bfe8146d41ea$var$ind("Automobiles", "Consumer Discretionary", "Automobiles & Components", [
        "Tesla|TSLA",
        "Ford Motor|F",
        "General Motors|GM"
    ]),
    $6b78bfe8146d41ea$var$ind("Auto Components", "Consumer Discretionary", "Automobiles & Components", [
        "Aptiv|APTV",
        "BorgWarner|BWA",
        "Lear|LEA",
        "Autoliv|ALV",
        "Gentex|GNTX"
    ]),
    $6b78bfe8146d41ea$var$ind("Specialty Retail", "Consumer Discretionary", "Retailing", [
        "Home Depot|HD",
        "Lowe's|LOW",
        "TJX Companies|TJX",
        "Ross Stores|ROST",
        "O'Reilly Automotive|ORLY",
        "AutoZone|AZO",
        "Best Buy|BBY"
    ]),
    $6b78bfe8146d41ea$var$ind("Broadline Retail", "Consumer Discretionary", "Retailing", [
        "Amazon|AMZN",
        "Target|TGT",
        "Dollar General|DG",
        "Dollar Tree|DLTR"
    ]),
    // Consumer Staples
    $6b78bfe8146d41ea$var$ind("Beverages", "Consumer Staples", "Food, Beverage & Tobacco", [
        "Coca-Cola|KO",
        "PepsiCo|PEP",
        "Monster Beverage|MNST",
        "Keurig Dr Pepper|KDP",
        "Constellation Brands|STZ"
    ]),
    $6b78bfe8146d41ea$var$ind("Food Products", "Consumer Staples", "Food, Beverage & Tobacco", [
        "General Mills|GIS",
        "Mondelez|MDLZ",
        "Hershey|HSY",
        "Kellanova|K",
        "Tyson Foods|TSN",
        "Archer-Daniels-Midland|ADM",
        "Hormel Foods|HRL"
    ]),
    $6b78bfe8146d41ea$var$ind("Tobacco", "Consumer Staples", "Food, Beverage & Tobacco", [
        "Philip Morris International|PM",
        "Altria|MO"
    ]),
    // Financials
    $6b78bfe8146d41ea$var$ind("Banks", "Financials", "Banks", [
        "JPMorgan Chase|JPM",
        "Bank of America|BAC",
        "Wells Fargo|WFC",
        "Citigroup|C",
        "U.S. Bancorp|USB",
        "PNC Financial|PNC",
        "Truist Financial|TFC"
    ]),
    $6b78bfe8146d41ea$var$ind("Capital Markets", "Financials", "Financial Services", [
        "Goldman Sachs|GS",
        "Morgan Stanley|MS",
        "BlackRock|BLK",
        "Charles Schwab|SCHW",
        "S&P Global|SPGI",
        "CME Group|CME",
        "Intercontinental Exchange|ICE"
    ]),
    $6b78bfe8146d41ea$var$ind("Insurance", "Financials", "Insurance", [
        "Berkshire Hathaway|BRK.B",
        "Progressive|PGR",
        "Chubb|CB",
        "American International Group|AIG",
        "Travelers|TRV",
        "MetLife|MET",
        "Aflac|AFL"
    ]),
    $6b78bfe8146d41ea$var$ind("Payments", "Financials", "Financial Services", [
        "Visa|V",
        "Mastercard|MA",
        "PayPal|PYPL",
        "Global Payments|GPN"
    ]),
    // Health Care
    $6b78bfe8146d41ea$var$ind("Pharmaceuticals", "Health Care", "Pharma, Biotech & Life Sciences", [
        "Eli Lilly|LLY",
        "Johnson & Johnson|JNJ",
        "Merck|MRK",
        "Pfizer|PFE",
        "Bristol-Myers Squibb|BMY",
        "Zoetis|ZTS"
    ]),
    $6b78bfe8146d41ea$var$ind("Biotechnology", "Health Care", "Pharma, Biotech & Life Sciences", [
        "AbbVie|ABBV",
        "Amgen|AMGN",
        "Gilead Sciences|GILD",
        "Vertex Pharmaceuticals|VRTX",
        "Regeneron|REGN",
        "Moderna|MRNA"
    ]),
    $6b78bfe8146d41ea$var$ind("Health Care Providers", "Health Care", "Health Care Equipment & Services", [
        "UnitedHealth Group|UNH",
        "Elevance Health|ELV",
        "Cigna|CI",
        "HCA Healthcare|HCA",
        "CVS Health|CVS",
        "Humana|HUM"
    ]),
    $6b78bfe8146d41ea$var$ind("Medical Devices", "Health Care", "Health Care Equipment & Services", [
        "Medtronic|MDT",
        "Abbott Laboratories|ABT",
        "Boston Scientific|BSX",
        "Stryker|SYK",
        "Intuitive Surgical|ISRG",
        "Edwards Lifesciences|EW"
    ]),
    // Information Technology
    $6b78bfe8146d41ea$var$ind("Software", "Information Technology", "Software & Services", [
        "Microsoft|MSFT",
        "Oracle|ORCL",
        "Salesforce|CRM",
        "Adobe|ADBE",
        "Intuit|INTU",
        "ServiceNow|NOW",
        "Palantir|PLTR"
    ]),
    $6b78bfe8146d41ea$var$ind("Semiconductors", "Information Technology", "Semiconductors", [
        "NVIDIA|NVDA",
        "Broadcom|AVGO",
        "AMD|AMD",
        "Qualcomm|QCOM",
        "Texas Instruments|TXN",
        "Micron|MU",
        "Intel|INTC",
        "Applied Materials|AMAT"
    ]),
    $6b78bfe8146d41ea$var$ind("IT Services", "Information Technology", "Software & Services", [
        "Accenture|ACN",
        "IBM|IBM",
        "Cognizant|CTSH",
        "Gartner|IT",
        "EPAM Systems|EPAM"
    ]),
    $6b78bfe8146d41ea$var$ind("Technology Hardware", "Information Technology", "Technology Hardware", [
        "Apple|AAPL",
        "Dell Technologies|DELL",
        "HP Inc.|HPQ",
        "Cisco|CSCO",
        "Hewlett Packard Enterprise|HPE"
    ]),
    // Communication Services
    $6b78bfe8146d41ea$var$ind("Interactive Media", "Communication Services", "Media & Entertainment", [
        "Alphabet|GOOGL",
        "Meta Platforms|META",
        "Pinterest|PINS",
        "Snap|SNAP",
        "Reddit|RDDT"
    ]),
    $6b78bfe8146d41ea$var$ind("Media & Entertainment", "Communication Services", "Media & Entertainment", [
        "Netflix|NFLX",
        "Walt Disney|DIS",
        "Comcast|CMCSA",
        "Fox Corporation|FOXA",
        "Live Nation|LYV"
    ]),
    $6b78bfe8146d41ea$var$ind("Telecom Services", "Communication Services", "Telecommunication Services", [
        "Verizon|VZ",
        "AT&T|T",
        "T-Mobile US|TMUS"
    ]),
    // Energy
    $6b78bfe8146d41ea$var$ind("Oil, Gas & Consumable Fuels", "Energy", "Energy", [
        "Exxon Mobil|XOM",
        "Chevron|CVX",
        "ConocoPhillips|COP",
        "EOG Resources|EOG",
        "Occidental Petroleum|OXY",
        "Marathon Petroleum|MPC",
        "Valero Energy|VLO"
    ]),
    $6b78bfe8146d41ea$var$ind("Energy Equipment & Services", "Energy", "Energy", [
        "Schlumberger|SLB",
        "Baker Hughes|BKR",
        "Halliburton|HAL"
    ]),
    // Utilities, Materials, Real Estate
    $6b78bfe8146d41ea$var$ind("Electric Utilities", "Utilities", "Utilities", [
        "NextEra Energy|NEE",
        "Duke Energy|DUK",
        "Southern Company|SO",
        "American Electric Power|AEP",
        "Exelon|EXC",
        "Xcel Energy|XEL"
    ]),
    $6b78bfe8146d41ea$var$ind("Chemicals", "Materials", "Materials", [
        "Linde|LIN",
        "Sherwin-Williams|SHW",
        "Air Products|APD",
        "Ecolab|ECL",
        "Dow|DOW",
        "DuPont|DD"
    ]),
    $6b78bfe8146d41ea$var$ind("Metals & Mining", "Materials", "Materials", [
        "Newmont|NEM",
        "Freeport-McMoRan|FCX",
        "Nucor|NUE",
        "Steel Dynamics|STLD",
        "Southern Copper|SCCO"
    ]),
    $6b78bfe8146d41ea$var$ind("Equity REITs", "Real Estate", "Real Estate", [
        "Prologis|PLD",
        "American Tower|AMT",
        "Equinix|EQIX",
        "Realty Income|O",
        "Simon Property Group|SPG",
        "Public Storage|PSA"
    ])
];



parcelRequire("acw62");
function $42ee54e125411b6f$export$2e2bcd8739ae039({ industries: industries, onOpen: onOpen }) {
    const sorted = [
        ...industries
    ].sort((a, b)=>a.name.localeCompare(b.name));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
        className: "card browse-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "browse-title",
                children: "Browse sectors"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sector-pills",
                children: sorted.map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "sector-pill",
                        onClick: ()=>onOpen(i),
                        children: i.name
                    }, i.id))
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $05e483c418a01d8d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Filter", [
    [
        "polygon",
        {
            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3",
            key: "1yg77f"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b51f4920eac1ba0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Globe", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a568145bb542ae81$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("PieChart", [
    [
        "path",
        {
            d: "M21.21 15.89A10 10 0 1 1 8 2.83",
            key: "k2fpak"
        }
    ],
    [
        "path",
        {
            d: "M22 12A10 10 0 0 0 12 2v10z",
            key: "1rfc4y"
        }
    ]
]);



const $5e15980506534e1a$var$COLUMNS = [
    {
        id: "cmp",
        label: "CMP",
        unit: "$",
        tip: "Current market price"
    },
    {
        id: "pe",
        label: "P/E",
        unit: "",
        tip: "Price to Earning"
    },
    {
        id: "mcap",
        label: "Mar Cap",
        unit: "$B",
        tip: "Market capitalization"
    },
    {
        id: "div",
        label: "Div Yld",
        unit: "%",
        tip: "Dividend yield"
    },
    {
        id: "np",
        label: "NP Qtr",
        unit: "$M",
        tip: "Net profit, latest quarter"
    },
    {
        id: "npVar",
        label: "Qtr Profit Var",
        unit: "%",
        tip: "Quarterly profit growth vs. the year-ago quarter"
    },
    {
        id: "sales",
        label: "Sales Qtr",
        unit: "$M",
        tip: "Sales, latest quarter"
    },
    {
        id: "salesVar",
        label: "Qtr Sales Var",
        unit: "%",
        tip: "Quarterly sales growth vs. the year-ago quarter"
    },
    {
        id: "roce",
        label: "ROCE",
        unit: "%",
        tip: "Return on capital employed"
    }
];
// Sample market-cap buckets ($B)
const $5e15980506534e1a$var$CAPS = [
    {
        id: "all",
        label: "All"
    },
    {
        id: "large",
        label: "Large cap"
    },
    {
        id: "mid",
        label: "Mid cap"
    },
    {
        id: "small",
        label: "Small cap"
    }
];
const $5e15980506534e1a$var$capOf = (mcap)=>mcap >= 500 ? "large" : mcap >= 100 ? "mid" : "small";
const $5e15980506534e1a$var$PAGE_SIZE = 25;
function $5e15980506534e1a$export$2e2bcd8739ae039({ industry: industry, onBack: onBack }) {
    const [cap, setCap] = (0, $acw62.useState)("all");
    const [hidden, setHidden] = (0, $acw62.useState)([]);
    const [sort, setSort] = (0, $acw62.useState)({
        col: "mcap",
        dir: "desc"
    });
    const [page, setPage] = (0, $acw62.useState)(1);
    const rows = (0, $acw62.useMemo)(()=>industry.companies.map((c)=>({
                ...c,
                f: (0, $6d972d26c47ffac8$export$ad2c21017a759cdf)(c.ticker)
            })), [
        industry
    ]);
    const filtered = rows.filter((r)=>cap === "all" || $5e15980506534e1a$var$capOf(r.f.mcap) === cap);
    const sorted = [
        ...filtered
    ].sort((a, b)=>{
        const av = sort.col === "company" ? a.name : a.f[sort.col];
        const bv = sort.col === "company" ? b.name : b.f[sort.col];
        const cmp = typeof av === "string" ? av.localeCompare(bv) : av - bv;
        return sort.dir === "asc" ? cmp : -cmp;
    });
    const pages = Math.max(1, Math.ceil(sorted.length / $5e15980506534e1a$var$PAGE_SIZE));
    const current = Math.min(page, pages);
    const visibleRows = sorted.slice((current - 1) * $5e15980506534e1a$var$PAGE_SIZE, current * $5e15980506534e1a$var$PAGE_SIZE);
    const visibleCols = $5e15980506534e1a$var$COLUMNS.filter((c)=>!hidden.includes(c.id));
    const toggleSort = (col)=>{
        setSort((s)=>s.col === col ? {
                col: col,
                dir: s.dir === "asc" ? "desc" : "asc"
            } : {
                col: col,
                dir: "desc"
            });
        setPage(1);
    };
    const toggleColumn = (id)=>setHidden((h)=>h.includes(id) ? h.filter((x)=>x !== id) : [
                ...h,
                id
            ]);
    const exportCsv = ()=>{
        const esc = (v)=>`"${String(v).replace(/"/g, '""')}"`;
        const header = [
            "S.No.",
            "Company",
            "Ticker",
            ...visibleCols.map((c)=>`${c.label} ${c.unit}`.trim())
        ];
        const lines = sorted.map((r, i)=>[
                i + 1,
                r.name,
                r.ticker,
                ...visibleCols.map((c)=>r.f[c.id].toFixed(2))
            ].map(esc).join(","));
        const blob = new Blob([
            [
                header.map(esc).join(","),
                ...lines
            ].join("\n")
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${industry.name}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };
    const SortIcon = ({ col: col })=>sort.col === col ? sort.dir === "asc" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f05f6a77fc593bc$export$2e2bcd8739ae039), {
            size: 12
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $008e11cf932a0927$export$2e2bcd8739ae039), {
            size: 12
        }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content wl-wide",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                    className: "wl-breadcrumb",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: "#",
                            onClick: (e)=>{
                                e.preventDefault();
                                onBack();
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c52b562f10363bcd$export$2e2bcd8739ae039), {
                                    size: 15
                                }),
                                " Industries"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "crumb",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                    size: 15
                                }),
                                " ",
                                industry.sector
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "crumb",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a568145bb542ae81$export$2e2bcd8739ae039), {
                                    size: 15
                                }),
                                " ",
                                industry.group
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "crumb crumb-current",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78659dd4d4ddf1e7$export$2e2bcd8739ae039), {
                                    size: 15
                                }),
                                " ",
                                industry.name
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card industry-card",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "industry-head",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                    className: "industry-title",
                                    children: [
                                        industry.name,
                                        " Companies"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                                            variant: "",
                                            className: "tool-btn",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05e483c418a01d8d$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                " ",
                                                $5e15980506534e1a$var$CAPS.find((c)=>c.id === cap).label.toUpperCase()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                                            children: $5e15980506534e1a$var$CAPS.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                                    active: cap === c.id,
                                                    onClick: ()=>{
                                                        setCap(c.id);
                                                        setPage(1);
                                                    },
                                                    children: c.label
                                                }, c.id))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "industry-subhead",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "results-note",
                                    children: [
                                        sorted.length,
                                        " results found: Showing page ",
                                        current,
                                        " of ",
                                        pages
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "d-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "btn tool-btn",
                                            onClick: exportCsv,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                                    size: 15
                                                }),
                                                " EXPORT"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                                            align: "end",
                                            autoClose: "outside",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                                                    variant: "",
                                                    className: "tool-btn tool-btn-primary",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da03c070d837b197$export$2e2bcd8739ae039), {
                                                            size: 15
                                                        }),
                                                        " EDIT COLUMNS"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                                                    className: "columns-menu",
                                                    children: $5e15980506534e1a$var$COLUMNS.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "columns-item",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: !hidden.includes(c.id),
                                                                    onChange: ()=>toggleColumn(c.id)
                                                                }),
                                                                c.label,
                                                                " ",
                                                                c.unit
                                                            ]
                                                        }, c.id))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "table wl-table mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain",
                                                    children: "S.No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        className: "th-btn",
                                                        onClick: ()=>toggleSort("company"),
                                                        children: [
                                                            "Company ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SortIcon, {
                                                                col: "company"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                visibleCols.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "text-end",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "th-btn",
                                                            title: c.tip,
                                                            onClick: ()=>toggleSort(c.id),
                                                            children: [
                                                                c.label,
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "th-unit",
                                                                    children: c.unit
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SortIcon, {
                                                                    col: c.id
                                                                })
                                                            ]
                                                        })
                                                    }, c.id))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            visibleRows.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                (current - 1) * $5e15980506534e1a$var$PAGE_SIZE + i + 1,
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: "wl-company",
                                                                    href: `#/stock/${r.ticker}`,
                                                                    children: r.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-muted small ms-2",
                                                                    children: r.ticker
                                                                })
                                                            ]
                                                        }),
                                                        visibleCols.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "text-end",
                                                                children: r.f[c.id].toFixed(2)
                                                            }, c.id))
                                                    ]
                                                }, r.ticker)),
                                            visibleRows.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: visibleCols.length + 2,
                                                    className: "wl-empty text-muted",
                                                    children: "No companies match this filter."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        pages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "pager",
                            children: Array.from({
                                length: pages
                            }, (_, i)=>i + 1).map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: `page-btn ${p === current ? "active" : ""}`,
                                    onClick: ()=>setPage(p),
                                    children: p
                                }, p))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted small wl-note",
                            children: "Figures shown are sample data for layout purposes."
                        })
                    ]
                })
            ]
        })
    });
}





const $a075e8c3bd1ab312$var$BUILT_IN = (0, $225dfe2e0344b28d$export$66b490aff740258f).flatMap((s)=>s.screens);
const $a075e8c3bd1ab312$var$BASE_COLS = [
    {
        key: "price",
        label: "CMP $",
        unit: "$"
    },
    {
        key: "pe",
        label: "P/E",
        unit: "x"
    },
    {
        key: "mcap",
        label: "Mar Cap $B",
        unit: "$B"
    },
    {
        key: "div_yield",
        label: "Div Yld %",
        unit: "%"
    },
    {
        key: "roce",
        label: "ROCE %",
        unit: "%"
    }
];
function $a075e8c3bd1ab312$var$fmt(v, unit) {
    if (v === null || v === undefined) return "\u2014";
    const n = Number(v);
    if (!Number.isFinite(n)) return "\u2014";
    if (unit === "flag") return n ? "Yes" : "No";
    if (unit === "days") return String(Math.round(n));
    if (unit === "$M") return Math.round(n).toLocaleString("en-US");
    if (unit === "") return Math.abs(n) >= 1000 ? Math.round(n).toLocaleString("en-US") : String(Number(n.toFixed(2)));
    return n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
const $a075e8c3bd1ab312$var$headLabel = (c)=>[
        "$",
        "$B",
        "$M",
        "%"
    ].includes(c.unit) ? `${c.label} ${c.unit}` : c.label;
function $a075e8c3bd1ab312$var$ScreenTile({ screen: screen, onOpen: onOpen }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: "screen-tile",
        onClick: ()=>onOpen(screen),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "screen-tile-title",
                children: [
                    screen.name,
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        size: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "screen-tile-desc",
                children: screen.description
            })
        ]
    });
}
function $a075e8c3bd1ab312$var$ScreenSection({ title: title, subtitle: subtitle, screens: screens, onOpen: onOpen, footer: footer }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "card screen-section",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "screen-section-title",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "screen-section-sub",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "screen-grid",
                children: screens.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a075e8c3bd1ab312$var$ScreenTile, {
                        screen: s,
                        onOpen: onOpen
                    }, s.id))
            }),
            footer
        ]
    });
}
/* ---------- Results of one screen ---------- */ function $a075e8c3bd1ab312$var$Results({ screen: screen, isCustom: isCustom, onBack: onBack, onSaveQuery: onSaveQuery, onDelete: onDelete }) {
    // override === null: run the built-in screen as it is. A string: run that query.
    const [override, setOverride] = (0, $acw62.useState)(isCustom ? screen.query || "" : null);
    const [draft, setDraft] = (0, $acw62.useState)(isCustom ? screen.query || "" : "");
    const [sort, setSort] = (0, $acw62.useState)(null);
    const [limit, setLimit] = (0, $acw62.useState)(100);
    const [state, setState] = (0, $acw62.useState)({
        loading: true,
        error: "",
        data: null
    });
    const [note, setNote] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        (0, $b1f811543f3e0211$export$6b2a7d5132615086)("open_screen", {
            id: screen.id,
            name: screen.name
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (override !== null && !override.trim()) {
            setState({
                loading: false,
                error: "",
                data: null
            });
            return undefined;
        }
        let dead = false;
        setState((s)=>({
                ...s,
                loading: true,
                error: ""
            }));
        const body = override === null ? {
            screenId: screen.id,
            limit: limit
        } : {
            query: override,
            limit: limit
        };
        if (sort) body.sort = sort;
        (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/screener/run", {
            method: "POST",
            body: body
        }).then((data)=>{
            if (dead) return;
            setState({
                loading: false,
                error: "",
                data: data
            });
            if (override === null && data.query) setDraft((d)=>d || data.query);
        }).catch((e)=>{
            if (!dead) setState({
                loading: false,
                error: e.message,
                data: null
            });
        });
        return ()=>{
            dead = true;
        };
    }, [
        override,
        sort,
        limit,
        screen.id
    ]);
    const { loading: loading, error: error, data: data } = state;
    const active = sort || data && data.sort || [];
    const run = (e)=>{
        e.preventDefault();
        setSort(null);
        setLimit(100);
        setNote("");
        (0, $b1f811543f3e0211$export$6b2a7d5132615086)("run_query", {
            screen: screen.id,
            query: draft.trim()
        });
        setOverride(draft.trim());
    };
    const toggleSort = (key)=>{
        setLimit(100);
        setSort([
            key,
            active[0] === key ? active[1] === "desc" ? "asc" : "desc" : key === "name" ? "asc" : "desc"
        ]);
    };
    const arrow = (key)=>active[0] === key ? active[1] === "asc" ? " \u25B2" : " \u25BC" : "";
    const cols = data ? [
        ...$a075e8c3bd1ab312$var$BASE_COLS,
        ...(data.columns || []).map((c)=>({
                key: c.key,
                label: $a075e8c3bd1ab312$var$headLabel(c),
                unit: c.unit
            }))
    ] : $a075e8c3bd1ab312$var$BASE_COLS;
    const rows = data ? data.rows : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content screens-wrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                    href: "#",
                    className: "go-back mb-3",
                    onClick: (e)=>{
                        e.preventDefault();
                        onBack();
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                            size: 16
                        }),
                        " All screens"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "page-title",
                    children: screen.name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted mb-3",
                    children: screen.description
                }),
                !(data && data.unavailable) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    className: "card mb-3",
                    style: {
                        padding: 14
                    },
                    onSubmit: run,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "small text-muted mb-1",
                            htmlFor: "screen-query",
                            children: "Query (edit it and press Run to try your own version)"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            id: "screen-query",
                            rows: 2,
                            value: draft,
                            onChange: (e)=>setDraft(e.target.value),
                            placeholder: 'e.g.  pe < 15 AND roce > 20 AND sector = "Technology"',
                            style: {
                                width: "100%",
                                fontFamily: "monospace",
                                fontSize: 14,
                                padding: 8,
                                border: "1px solid #ddd",
                                borderRadius: 6
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "d-flex gap-2 mt-2 align-items-center flex-wrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-purple",
                                    disabled: !draft.trim(),
                                    children: "Run"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-outline-secondary",
                                    disabled: !draft.trim(),
                                    onClick: ()=>setNote(onSaveQuery(draft.trim())),
                                    children: isCustom ? "Save changes" : "Save as my screen"
                                }),
                                isCustom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-outline-secondary",
                                    onClick: ()=>{
                                        if (window.confirm("Delete this screen?")) onDelete();
                                    },
                                    children: "Delete screen"
                                }),
                                note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "small text-muted",
                                    children: note
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "alert alert-danger",
                    children: error
                }),
                data && data.unavailable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "alert alert-secondary",
                    children: data.note
                }),
                isCustom && override !== null && !override.trim() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "alert alert-secondary",
                    children: "This screen has no query yet. Write one above and press Run."
                }),
                data && !data.unavailable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card wl-table-card",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-3 pt-3 small text-muted",
                            children: [
                                loading ? "Running..." : `${data.total.toLocaleString("en-US")} companies match`,
                                data.total > rows.length ? ` \xb7 showing ${rows.length}` : ""
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "table wl-table mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain",
                                                    children: "S.No."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                    className: "wl-th-plain",
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: ()=>toggleSort("name"),
                                                    children: [
                                                        "Company",
                                                        arrow("name")
                                                    ]
                                                }),
                                                cols.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                        className: "wl-th-plain text-end",
                                                        style: {
                                                            cursor: "pointer",
                                                            whiteSpace: "nowrap"
                                                        },
                                                        onClick: ()=>toggleSort(c.key),
                                                        children: [
                                                            c.label,
                                                            arrow(c.key)
                                                        ]
                                                    }, c.key))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            rows.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                i + 1,
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: "wl-company",
                                                                    href: `#/stock/${r.ticker}`,
                                                                    children: r.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-muted small ms-2",
                                                                    children: r.ticker
                                                                })
                                                            ]
                                                        }),
                                                        cols.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "text-end",
                                                                children: $a075e8c3bd1ab312$var$fmt(r[c.key], c.unit)
                                                            }, c.key))
                                                    ]
                                                }, r.ticker)),
                                            !rows.length && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: cols.length + 2,
                                                    className: "text-center text-muted py-4",
                                                    children: "No companies match this query."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        data.total > rows.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-3 text-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "btn btn-outline-secondary",
                                disabled: loading || limit >= 500,
                                onClick: ()=>setLimit((l)=>Math.min(l + 100, 500)),
                                children: "Show more"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted small wl-note",
                            children: "Computed from your own database: prices from Yahoo Finance (15 minutes delayed), financials from SEC filings. Numbers refresh after the market closes."
                        })
                    ]
                }),
                loading && !data && !error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted",
                    children: "Running..."
                })
            ]
        })
    });
}
/* ---------- Create a screen ---------- */ function $a075e8c3bd1ab312$var$CreateModal({ onSave: onSave, onClose: onClose }) {
    const [form, setForm] = (0, $acw62.useState)({
        name: "",
        description: "",
        query: ""
    });
    const [fields, setFields] = (0, $acw62.useState)([]);
    const [msg, setMsg] = (0, $acw62.useState)({
        type: "",
        text: ""
    });
    const [busy, setBusy] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/screener/fields").then(setFields).catch(()=>{});
    }, []);
    const groups = fields.reduce((acc, f)=>{
        (acc[f.group] = acc[f.group] || []).push(f);
        return acc;
    }, {});
    const addField = (key)=>setForm((f)=>({
                ...f,
                query: `${f.query}${f.query && !/\s$/.test(f.query) ? " " : ""}${key} `
            }));
    const check = async ()=>{
        setBusy(true);
        setMsg({
            type: "",
            text: ""
        });
        try {
            const r = await (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/screener/run", {
                method: "POST",
                body: {
                    query: form.query,
                    limit: 1
                }
            });
            setMsg({
                type: "ok",
                text: `${r.total.toLocaleString("en-US")} companies match right now.`
            });
            return true;
        } catch (e) {
            setMsg({
                type: "err",
                text: e.message
            });
            return false;
        } finally{
            setBusy(false);
        }
    };
    const submit = async (e)=>{
        e.preventDefault();
        if (!form.name.trim() || !form.query.trim()) return;
        if (await check()) onSave({
            name: form.name.trim(),
            description: form.description.trim() || "Custom screen",
            query: form.query.trim()
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modal-backdrop",
        onMouseDown: (e)=>e.target === e.currentTarget && onClose(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "modal-card",
            style: {
                maxWidth: 640,
                width: "92vw",
                maxHeight: "90vh",
                overflowY: "auto"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Create new screen"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: submit,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Screen name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    required: true,
                                    autoFocus: true,
                                    maxLength: 60,
                                    value: form.name,
                                    onChange: (e)=>setForm({
                                            ...form,
                                            name: e.target.value
                                        }),
                                    placeholder: "e.g. Cheap compounders"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Description (optional)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    maxLength: 120,
                                    value: form.description,
                                    onChange: (e)=>setForm({
                                            ...form,
                                            description: e.target.value
                                        }),
                                    placeholder: "What does this screen look for?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Query"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                    rows: 3,
                                    required: true,
                                    value: form.query,
                                    onChange: (e)=>setForm({
                                            ...form,
                                            query: e.target.value
                                        }),
                                    placeholder: 'pe < 15 AND roce > 20 AND mcap > 5 AND sector = "Technology"',
                                    style: {
                                        width: "100%",
                                        fontFamily: "monospace",
                                        fontSize: 14,
                                        padding: 8,
                                        border: "1px solid #ddd",
                                        borderRadius: 6
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "small text-muted mt-1",
                                    children: 'Compare with > >= < <= = !=. Join with AND / OR and brackets. Text fields use = or ~ (contains), e.g. industry ~ "software". Market cap is in $ billions.'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                    className: "small",
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: "Fields you can use (click to add)"
                                }),
                                Object.entries(groups).map(([g, list])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "small fw-bold",
                                                children: g
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "d-flex flex-wrap gap-1 mt-1",
                                                children: list.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        title: f.label,
                                                        onClick: ()=>addField(f.key),
                                                        style: {
                                                            border: "1px solid #ddd",
                                                            background: "#fafafa",
                                                            borderRadius: 12,
                                                            padding: "1px 8px",
                                                            fontSize: 12
                                                        },
                                                        children: f.key
                                                    }, f.key))
                                            })
                                        ]
                                    }, g))
                            ]
                        }),
                        msg.text && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: `alert ${msg.type === "ok" ? "alert-success" : "alert-danger"} py-2`,
                            children: msg.text
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn-secondary",
                                    onClick: onClose,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-outline-secondary",
                                    disabled: busy || !form.query.trim(),
                                    onClick: check,
                                    children: "Test query"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-purple",
                                    disabled: busy,
                                    children: "Save"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $a075e8c3bd1ab312$export$2e2bcd8739ae039({ user: user }) {
    const [custom, setCustom] = (0, $acw62.useState)(()=>(0, $c8ac4ec5c1859847$export$332d58514331716c)("screens", user, []));
    const [showAll, setShowAll] = (0, $acw62.useState)(false);
    const [openScreen, setOpenScreen] = (0, $acw62.useState)(null);
    const [openIndustry, setOpenIndustry] = (0, $acw62.useState)(null);
    const [creating, setCreating] = (0, $acw62.useState)(false);
    const persist = (next)=>{
        setCustom(next);
        (0, $c8ac4ec5c1859847$export$9f43f72cb45956cb)("screens", user, next);
    };
    const createScreen = (s)=>{
        persist([
            ...custom,
            {
                id: `custom-${Date.now()}`,
                ...s
            }
        ]);
        setCreating(false);
    };
    if (openIndustry) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e15980506534e1a$export$2e2bcd8739ae039), {
        industry: openIndustry,
        onBack: ()=>setOpenIndustry(null)
    });
    if (openScreen) {
        const isCustom = custom.some((c)=>c.id === openScreen.id);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a075e8c3bd1ab312$var$Results, {
            screen: openScreen,
            isCustom: isCustom,
            onBack: ()=>setOpenScreen(null),
            onDelete: ()=>{
                persist(custom.filter((c)=>c.id !== openScreen.id));
                setOpenScreen(null);
            },
            onSaveQuery: (q)=>{
                if (isCustom) {
                    persist(custom.map((c)=>c.id === openScreen.id ? {
                            ...c,
                            query: q
                        } : c));
                    return "Saved.";
                }
                persist([
                    ...custom,
                    {
                        id: `custom-${Date.now()}`,
                        name: `${openScreen.name} (my version)`,
                        description: openScreen.description,
                        query: q
                    }
                ]);
                return 'Saved under "Your screens".';
            }
        }, openScreen.id);
    }
    const popular = showAll ? $a075e8c3bd1ab312$var$BUILT_IN : (0, $225dfe2e0344b28d$export$5328293a54900373).map((id)=>$a075e8c3bd1ab312$var$BUILT_IN.find((s)=>s.id === id)).filter(Boolean);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "page-bg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dash-main-content screens-wrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "screens-layout",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "screens-main",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "screens-header",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "page-title",
                                            children: "Stock screens"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "btn btn-purple create-screen-btn",
                                            onClick: ()=>setCreating(true),
                                            children: "CREATE NEW SCREEN"
                                        })
                                    ]
                                }),
                                custom.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a075e8c3bd1ab312$var$ScreenSection, {
                                    title: "Your screens",
                                    subtitle: "Screens you created",
                                    screens: custom,
                                    onOpen: setOpenScreen
                                }),
                                (0, $225dfe2e0344b28d$export$66b490aff740258f).map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a075e8c3bd1ab312$var$ScreenSection, {
                                        title: section.title,
                                        subtitle: section.subtitle,
                                        screens: section.screens,
                                        onOpen: setOpenScreen
                                    }, section.id)),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a075e8c3bd1ab312$var$ScreenSection, {
                                    title: "Popular stock screens",
                                    subtitle: "Popular screens commonly used by investors.",
                                    screens: popular,
                                    onOpen: setOpenScreen,
                                    footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "screens-footer",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "show-all-btn",
                                            onClick: ()=>setShowAll(!showAll),
                                            children: [
                                                showAll ? "SHOW FEWER" : "SHOW ALL SCREENS",
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42ee54e125411b6f$export$2e2bcd8739ae039), {
                            industries: (0, $6b78bfe8146d41ea$export$a135b49e5502643f),
                            onOpen: setOpenIndustry
                        })
                    ]
                })
            }),
            creating && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a075e8c3bd1ab312$var$CreateModal, {
                onSave: createScreen,
                onClose: ()=>setCreating(false)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $75957e2fe5dd6cb2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Bell", [
    [
        "path",
        {
            d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9",
            key: "1qo2s2"
        }
    ],
    [
        "path",
        {
            d: "M10.3 21a1.94 1.94 0 0 0 3.4 0",
            key: "qgo35s"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Trash2", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
]);




var $acw62 = parcelRequire("acw62");


function $0802decfce96bd01$export$2e2bcd8739ae039({ value: value, onChange: onChange, placeholder: placeholder = "Search any US company", allowClear: allowClear = false }) {
    (0, $0e8cef3982a5818d$export$4e58cf0942785ded)();
    const [editing, setEditing] = (0, $acw62.useState)(false);
    const [text, setText] = (0, $acw62.useState)("");
    const [results, setResults] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const box = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!editing) return undefined;
        const close = (e)=>{
            if (box.current && !box.current.contains(e.target)) setEditing(false);
        };
        document.addEventListener("mousedown", close);
        return ()=>document.removeEventListener("mousedown", close);
    }, [
        editing
    ]);
    (0, $acw62.useEffect)(()=>{
        const q = text.trim();
        if (!editing || !q) {
            setResults([]);
            return undefined;
        }
        let dead = false;
        setLoading(true);
        const timer = setTimeout(()=>{
            (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/search?q=${encodeURIComponent(q)}&limit=8`).then((rows)=>{
                if (dead) return;
                (0, $0e8cef3982a5818d$export$29d1feb935211dfc)(rows);
                setResults(rows);
                setLoading(false);
            }).catch(()=>{
                if (!dead) {
                    setResults([]);
                    setLoading(false);
                }
            });
        }, 180);
        return ()=>{
            dead = true;
            clearTimeout(timer);
        };
    }, [
        text,
        editing
    ]);
    const company = value ? (0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(value) : null;
    const label = value ? company ? `${company.name} (${value})` : value : "";
    const pick = (r)=>{
        onChange(r.ticker);
        setEditing(false);
        setText("");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: box,
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "form-control",
                value: editing ? text : label,
                placeholder: placeholder,
                onFocus: ()=>{
                    setEditing(true);
                    setText("");
                },
                onChange: (e)=>setText(e.target.value),
                autoComplete: "off"
            }),
            allowClear && value && !editing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                "aria-label": "Clear",
                onClick: ()=>onChange(""),
                style: {
                    position: "absolute",
                    right: 8,
                    top: 4,
                    border: 0,
                    background: "transparent",
                    fontSize: 20,
                    lineHeight: 1,
                    color: "#888"
                },
                children: "\xd7"
            }),
            editing && text.trim() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                style: {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: "100%",
                    zIndex: 1000,
                    margin: "2px 0 0",
                    padding: 0,
                    listStyle: "none",
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: 6,
                    boxShadow: "0 6px 20px rgba(0,0,0,.15)",
                    maxHeight: 280,
                    overflowY: "auto"
                },
                children: [
                    results.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>pick(r),
                                style: {
                                    display: "block",
                                    width: "100%",
                                    textAlign: "left",
                                    border: 0,
                                    background: "transparent",
                                    padding: "8px 12px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: r.name
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted small",
                                        children: r.ticker
                                    }),
                                    r.exchange && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted small ms-2",
                                        children: r.exchange
                                    })
                                ]
                            })
                        }, r.ticker)),
                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "text-muted small p-2",
                        children: "Searching..."
                    }),
                    !loading && results.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "text-muted small p-2",
                        children: "No companies found."
                    })
                ]
            })
        ]
    });
}





const $923b0b47856f1271$var$num = (v)=>{
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};
function $923b0b47856f1271$export$2e2bcd8739ae039({ user: user }) {
    (0, $6d972d26c47ffac8$export$ae1efb09da3bcdf9)();
    (0, $0e8cef3982a5818d$export$4e58cf0942785ded)();
    const [alerts, setAlerts] = (0, $acw62.useState)(()=>(0, $c8ac4ec5c1859847$export$332d58514331716c)("alerts", user, []));
    const [ticker, setTicker] = (0, $acw62.useState)("");
    const [condition, setCondition] = (0, $acw62.useState)("below");
    const [target, setTarget] = (0, $acw62.useState)("");
    const commit = (next)=>{
        setAlerts(next);
        (0, $c8ac4ec5c1859847$export$9f43f72cb45956cb)("alerts", user, next);
    };
    const rows = alerts.map((a)=>{
        const current = $923b0b47856f1271$var$num((0, $6d972d26c47ffac8$export$9a79ba2e7e56f601)(a.ticker).current);
        const hit = current !== null && (a.condition === "below" ? current <= a.target : current >= a.target);
        return {
            ...a,
            current: current,
            hit: hit
        };
    });
    // keep prices current while this page is open
    const key = alerts.map((a)=>a.ticker).join(",");
    (0, $acw62.useEffect)(()=>{
        if (!key) return undefined;
        const list = [
            ...new Set(key.split(","))
        ];
        const id = setInterval(()=>(0, $6d972d26c47ffac8$export$5272b19b0fbbb839)(list), 60000);
        return ()=>clearInterval(id);
    }, [
        key
    ]);
    // remember the first time each alert triggered
    const fresh = rows.filter((r)=>r.hit && !r.triggeredAt).map((r)=>r.id).join(",");
    (0, $acw62.useEffect)(()=>{
        if (!fresh) return;
        const ids = fresh.split(",");
        commit(alerts.map((a)=>ids.includes(a.id) ? {
                ...a,
                triggeredAt: new Date().toISOString()
            } : a));
    }, [
        fresh
    ]);
    const addAlert = (e)=>{
        e.preventDefault();
        const value = parseFloat(target);
        if (!ticker || !(value > 0)) return;
        commit([
            ...alerts,
            {
                id: Date.now().toString(36),
                ticker: ticker,
                condition: condition,
                target: value
            }
        ]);
        setTarget("");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content screens-wrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "page-title",
                    children: "Stock Alerts"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted mb-4",
                    children: "Set a price and see when a stock reaches your buy or sell zone."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "card tool-card mb-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "tool-form",
                        onSubmit: addAlert,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "tool-label",
                                        children: "Company"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0802decfce96bd01$export$2e2bcd8739ae039), {
                                        value: ticker,
                                        onChange: setTicker
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "tool-label",
                                        children: "When price"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: "form-select",
                                        value: condition,
                                        onChange: (e)=>setCondition(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "below",
                                                children: "falls below"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "above",
                                                children: "rises above"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "tool-label",
                                        children: "Target price ($)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                        className: "form-control",
                                        value: target,
                                        onChange: (e)=>setTarget(e.target.value),
                                        placeholder: "0.00",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "submit",
                                className: "btn btn-purple tool-submit",
                                disabled: !ticker,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75957e2fe5dd6cb2$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " ADD ALERT"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card wl-table-card",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "table wl-table mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain",
                                                    children: "Company"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain",
                                                    children: "Condition"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain text-end",
                                                    children: "Target $"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain text-end",
                                                    children: "Current $"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain",
                                                    children: "Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            rows.map((a)=>{
                                                const company = (0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(a.ticker);
                                                const done = a.hit || a.triggeredAt;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: "wl-company",
                                                                    href: `#/stock/${a.ticker}`,
                                                                    children: company ? company.name : a.ticker
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-muted small ms-2",
                                                                    children: a.ticker
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: a.condition === "below" ? "Falls below" : "Rises above"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: a.target.toFixed(2)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: a.current === null ? "\u2014" : a.current.toFixed(2)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: `badge ${done ? "badge-success" : "badge-purple"}`,
                                                                    children: done ? "Triggered" : "Watching"
                                                                }),
                                                                a.triggeredAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-muted small ms-2",
                                                                    children: new Date(a.triggeredAt).toLocaleDateString()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "row-remove",
                                                                onClick: ()=>commit(alerts.filter((x)=>x.id !== a.id)),
                                                                "aria-label": "Delete alert",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                    size: 15
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, a.id);
                                            }),
                                            alerts.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: 6,
                                                    className: "wl-empty text-muted",
                                                    children: "No alerts yet. Create your first one above."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted small wl-note",
                            children: "Alerts are checked against your database prices (about 15 minutes delayed) whenever this page is open. Email or text notifications when the page is closed need a delivery service, which isn't set up yet."
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");





// Formats a screener number according to its unit.
function $08c3f74cc93ff925$export$b2c87b7a4514b371(v, unit) {
    if (v === null || v === undefined) return "\u2014";
    const n = Number(v);
    if (!Number.isFinite(n)) return "\u2014";
    if (unit === "flag") return n ? "Yes" : "No";
    if (unit === "days") return String(Math.round(n));
    if (unit === "$M") return Math.round(n).toLocaleString("en-US");
    if (unit === "") return Math.abs(n) >= 1000 ? Math.round(n).toLocaleString("en-US") : String(Number(n.toFixed(2)));
    return n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
const $08c3f74cc93ff925$export$f28c78b7eaed3fd3 = (unit)=>[
        "$",
        "$B",
        "$M",
        "%",
        "x"
    ].includes(unit) ? ` (${unit})` : unit === "days" ? " (days)" : "";


function $a2e242a095574dbe$export$2e2bcd8739ae039() {
    (0, $6d972d26c47ffac8$export$ae1efb09da3bcdf9)();
    (0, $0e8cef3982a5818d$export$4e58cf0942785ded)();
    const [picks, setPicks] = (0, $acw62.useState)([
        "AAPL",
        "MSFT",
        ""
    ]);
    const [fields, setFields] = (0, $acw62.useState)([]);
    const [metrics, setMetrics] = (0, $acw62.useState)({});
    const [error, setError] = (0, $acw62.useState)("");
    const setPick = (i, value)=>setPicks(picks.map((p, idx)=>idx === i ? value : p));
    const chosen = [
        ...new Set(picks.filter(Boolean))
    ];
    const key = chosen.join(",");
    (0, $acw62.useEffect)(()=>{
        (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/screener/fields").then((f)=>setFields(f.filter((x)=>x.type === "num"))).catch(()=>{});
    }, []);
    // load the numbers, and reload every minute
    (0, $acw62.useEffect)(()=>{
        if (!key) {
            setMetrics({});
            return undefined;
        }
        let dead = false;
        const load = ()=>{
            (0, $6d972d26c47ffac8$export$5272b19b0fbbb839)(key.split(","));
            (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/metrics?tickers=${encodeURIComponent(key)}`).then((rows)=>{
                if (dead) return;
                setMetrics(Object.fromEntries(rows.map((r)=>[
                        r.ticker,
                        r
                    ])));
                setError("");
            }).catch((e)=>!dead && setError(e.message));
        };
        load();
        const id = setInterval(load, 60000);
        return ()=>{
            dead = true;
            clearInterval(id);
        };
    }, [
        key
    ]);
    const groups = [];
    for (const f of fields){
        // hide rows where none of the chosen companies has a value
        if (!chosen.some((t)=>metrics[t] && metrics[t][f.key] !== null && metrics[t][f.key] !== undefined)) continue;
        let g = groups.find((x)=>x.name === f.group);
        if (!g) groups.push(g = {
            name: f.group,
            rows: []
        });
        g.rows.push(f);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content screens-wrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "page-title",
                    children: "Compare Companies"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted mb-4",
                    children: "Pick up to three US companies and compare them side by side."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "card tool-card mb-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tool-form tool-form-3",
                        children: picks.map((p, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "tool-label",
                                        children: [
                                            "Company ",
                                            i + 1,
                                            i === 2 ? " (optional)" : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0802decfce96bd01$export$2e2bcd8739ae039), {
                                        value: p,
                                        onChange: (v)=>setPick(i, v),
                                        allowClear: i > 0
                                    })
                                ]
                            }, i))
                    })
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "alert alert-danger",
                    children: error
                }),
                chosen.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card wl-table-card",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "table wl-table mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain",
                                                    children: "Metric"
                                                }),
                                                chosen.map((t)=>{
                                                    const c = (0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(t);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                        className: "text-end",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                className: "wl-company",
                                                                href: `#/stock/${t}`,
                                                                children: c ? c.name : t
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-muted small ms-2",
                                                                children: t
                                                            })
                                                        ]
                                                    }, t);
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: "Sector"
                                                    }),
                                                    chosen.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: ((0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(t) || {}).sector || "\u2014"
                                                        }, t))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: "Industry"
                                                    }),
                                                    chosen.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: ((0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(t) || {}).industry || "\u2014"
                                                        }, t))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: "52W chart"
                                                    }),
                                                    chosen.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9916e1a7ef47388$export$2e2bcd8739ae039), {
                                                                data: (0, $6d972d26c47ffac8$export$9a79ba2e7e56f601)(t).series
                                                            })
                                                        }, t))
                                                ]
                                            }),
                                            groups.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: chosen.length + 1,
                                                                className: "fw-bold",
                                                                style: {
                                                                    background: "#f7f5fb"
                                                                },
                                                                children: g.name
                                                            })
                                                        }),
                                                        g.rows.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                        children: [
                                                                            f.label,
                                                                            (0, $08c3f74cc93ff925$export$f28c78b7eaed3fd3)(f.unit)
                                                                        ]
                                                                    }),
                                                                    chosen.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            className: "text-end",
                                                                            children: (0, $08c3f74cc93ff925$export$b2c87b7a4514b371)(metrics[t] ? metrics[t][f.key] : null, f.unit)
                                                                        }, t))
                                                                ]
                                                            }, f.key))
                                                    ]
                                                }, g.name))
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted small wl-note",
                            children: "Prices come from your database (about 15 minutes delayed). Financial figures are calculated from SEC filings and update after each filing."
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");





const $199e0b543047ba11$var$money = (n)=>`$${n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
const $199e0b543047ba11$var$num = (v)=>{
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};
function $199e0b543047ba11$export$2e2bcd8739ae039({ user: user }) {
    (0, $6d972d26c47ffac8$export$ae1efb09da3bcdf9)();
    (0, $0e8cef3982a5818d$export$4e58cf0942785ded)();
    const [holdings, setHoldings] = (0, $acw62.useState)(()=>(0, $c8ac4ec5c1859847$export$332d58514331716c)("portfolio", user, []));
    const [ticker, setTicker] = (0, $acw62.useState)("");
    const [shares, setShares] = (0, $acw62.useState)("");
    const [cost, setCost] = (0, $acw62.useState)("");
    // keep prices current while this page is open
    const key = holdings.map((h)=>h.ticker).join(",");
    (0, $acw62.useEffect)(()=>{
        if (!key) return undefined;
        const list = [
            ...new Set(key.split(","))
        ];
        const id = setInterval(()=>(0, $6d972d26c47ffac8$export$5272b19b0fbbb839)(list), 60000);
        return ()=>clearInterval(id);
    }, [
        key
    ]);
    const commit = (next)=>{
        setHoldings(next);
        (0, $c8ac4ec5c1859847$export$9f43f72cb45956cb)("portfolio", user, next);
    };
    const addHolding = (e)=>{
        e.preventDefault();
        const s = parseFloat(shares);
        const c = parseFloat(cost);
        if (!ticker || !(s > 0) || !(c > 0)) return;
        commit([
            ...holdings,
            {
                id: Date.now().toString(36),
                ticker: ticker,
                shares: s,
                cost: c
            }
        ]);
        setShares("");
        setCost("");
    };
    const rows = holdings.map((h)=>{
        const company = (0, $0e8cef3982a5818d$export$3fb7e631d185ccd8)(h.ticker);
        const cmp = $199e0b543047ba11$var$num((0, $6d972d26c47ffac8$export$9a79ba2e7e56f601)(h.ticker).current);
        const invested = h.shares * h.cost;
        const value = cmp === null ? null : h.shares * cmp;
        return {
            ...h,
            name: company ? company.name : h.ticker,
            cmp: cmp,
            invested: invested,
            value: value,
            pnl: value === null ? null : value - invested
        };
    });
    const priced = rows.filter((r)=>r.value !== null);
    const invested = priced.reduce((t, r)=>t + r.invested, 0);
    const value = priced.reduce((t, r)=>t + r.value, 0);
    const pnl = value - invested;
    const pnlPct = invested ? pnl / invested * 100 : 0;
    const cls = (n)=>n >= 0 ? "change-up" : "change-down";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content screens-wrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "page-title",
                    children: "Portfolio Tracker"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted mb-4",
                    children: "Record your holdings and see how your portfolio is doing."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "row g-3 mb-4",
                    children: [
                        {
                            label: "Invested",
                            text: $199e0b543047ba11$var$money(invested)
                        },
                        {
                            label: "Current value",
                            text: $199e0b543047ba11$var$money(value)
                        },
                        {
                            label: "Profit / Loss",
                            text: `${pnl >= 0 ? "+" : ""}${$199e0b543047ba11$var$money(pnl)} (${pnlPct.toFixed(1)}%)`,
                            color: cls(pnl)
                        }
                    ].map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "col-12 col-md-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "card tool-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-muted small",
                                        children: s.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `wl-price ${s.color || ""}`,
                                        children: s.text
                                    })
                                ]
                            })
                        }, s.label))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "card tool-card mb-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "tool-form",
                        onSubmit: addHolding,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "tool-label",
                                        children: "Company"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0802decfce96bd01$export$2e2bcd8739ae039), {
                                        value: ticker,
                                        onChange: setTicker
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "tool-label",
                                        children: "Shares"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "any",
                                        className: "form-control",
                                        value: shares,
                                        onChange: (e)=>setShares(e.target.value),
                                        placeholder: "0",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "tool-label",
                                        children: "Avg. buy price ($)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                        className: "form-control",
                                        value: cost,
                                        onChange: (e)=>setCost(e.target.value),
                                        placeholder: "0.00",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "submit",
                                className: "btn btn-purple tool-submit",
                                disabled: !ticker,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " ADD HOLDING"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card wl-table-card",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "table wl-table mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain",
                                                    children: "Company"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain text-end",
                                                    children: "Shares"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain text-end",
                                                    children: "Avg. cost $"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain text-end",
                                                    children: "CMP $"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain text-end",
                                                    children: "Value $"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "wl-th-plain text-end",
                                                    children: "P&L $"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: "wl-company",
                                                                    href: `#/stock/${r.ticker}`,
                                                                    children: r.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-muted small ms-2",
                                                                    children: r.ticker
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: r.shares
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: r.cost.toFixed(2)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: r.cmp === null ? "\u2014" : r.cmp.toFixed(2)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: r.value === null ? "\u2014" : r.value.toFixed(2)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: `text-end fw-bold ${r.pnl === null ? "" : cls(r.pnl)}`,
                                                            children: r.pnl === null ? "\u2014" : `${r.pnl >= 0 ? "+" : ""}${r.pnl.toFixed(2)}`
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-end",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "row-remove",
                                                                onClick: ()=>commit(holdings.filter((h)=>h.id !== r.id)),
                                                                "aria-label": "Remove holding",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                    size: 15
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, r.id)),
                                            rows.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: 7,
                                                    className: "wl-empty text-muted",
                                                    children: "No holdings yet. Add your first one above."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-muted small wl-note",
                            children: [
                                "Prices come from your database and are about 15 minutes delayed. They refresh every minute while this page is open.",
                                priced.length < rows.length ? " Holdings without a price yet are left out of the totals." : ""
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $734775816ebf57ea$var$CLIENT_ID = "13551724303-offe4nuuggavghk109i0oakrn0f4i321.apps.googleusercontent.com";
let $734775816ebf57ea$var$scriptPromise = null;
function $734775816ebf57ea$var$loadGoogle() {
    if (window.google && window.google.accounts) return Promise.resolve();
    if (!$734775816ebf57ea$var$scriptPromise) $734775816ebf57ea$var$scriptPromise = new Promise((resolve, reject)=>{
        const s = document.createElement("script");
        s.src = "https://accounts.google.com/gsi/client";
        s.async = true;
        s.onload = resolve;
        s.onerror = ()=>{
            $734775816ebf57ea$var$scriptPromise = null;
            reject(new Error("load failed"));
        };
        document.head.appendChild(s);
    });
    return $734775816ebf57ea$var$scriptPromise;
}
function $734775816ebf57ea$export$2e2bcd8739ae039({ onSuccess: onSuccess, onError: onError }) {
    const box = (0, $acw62.useRef)(null);
    const cb = (0, $acw62.useRef)({
        onSuccess: onSuccess,
        onError: onError
    });
    cb.current = {
        onSuccess: onSuccess,
        onError: onError
    };
    (0, $acw62.useEffect)(()=>{
        if (!$734775816ebf57ea$var$CLIENT_ID) return undefined;
        let dead = false;
        $734775816ebf57ea$var$loadGoogle().then(()=>{
            if (dead || !box.current) return;
            window.google.accounts.id.initialize({
                client_id: $734775816ebf57ea$var$CLIENT_ID,
                callback: async (resp)=>{
                    try {
                        const r = await (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/auth/google", {
                            method: "POST",
                            body: {
                                credential: resp.credential
                            }
                        });
                        await cb.current.onSuccess({
                            ...r.user,
                            token: r.token
                        });
                    } catch (e) {
                        cb.current.onError(e.message);
                    }
                }
            });
            window.google.accounts.id.renderButton(box.current, {
                theme: "outline",
                size: "large",
                text: "continue_with",
                width: 300
            });
        }).catch(()=>cb.current.onError("Could not load Google sign-in. Check your internet connection."));
        return ()=>{
            dead = true;
        };
    }, []);
    if (!$734775816ebf57ea$var$CLIENT_ID) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            margin: "14px 0 6px"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                ref: box
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    textAlign: "center",
                    color: "#888",
                    fontSize: 12,
                    margin: "10px 0 0"
                },
                children: "or use email"
            })
        ]
    });
}



async function $276e2b1a147d904e$export$6f5378aa3397b877({ name: name, email: email, password: password }) {
    const r = await (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/auth/signup", {
        method: "POST",
        body: {
            name: name,
            email: email,
            password: password
        }
    });
    return {
        ...r.user,
        token: r.token
    };
}
async function $276e2b1a147d904e$export$c5c80ad9fa266e1b({ email: email, password: password }) {
    const r = await (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/auth/login", {
        method: "POST",
        body: {
            email: email,
            password: password
        }
    });
    return {
        ...r.user,
        token: r.token
    };
}
async function $276e2b1a147d904e$export$b0ac3a1c242cb1ea() {
    try {
        await (0, $eaaba8a5ae480d72$export$644d8ea042df96a6)("/auth/logout", {
            method: "POST",
            auth: true
        });
    } catch  {}
}


function $e24447910c2368c6$export$2e2bcd8739ae039({ onLogin: onLogin, onClose: onClose }) {
    const [email, setEmail] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const submit = async (e)=>{
        e.preventDefault();
        if (busy) return;
        setError("");
        setBusy(true);
        try {
            await onLogin(await (0, $276e2b1a147d904e$export$c5c80ad9fa266e1b)({
                email: email,
                password: password
            }));
        } catch (err) {
            setError(err.message);
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modal-backdrop",
        onMouseDown: (e)=>e.target === e.currentTarget && onClose(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            className: "modal-card",
            onSubmit: submit,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Login"
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "alert alert-danger py-2",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $734775816ebf57ea$export$2e2bcd8739ae039), {
                    onSuccess: onLogin,
                    onError: setError
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "li-email",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "li-email",
                            type: "email",
                            required: true,
                            autoComplete: "email",
                            value: email,
                            onChange: (e)=>setEmail(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "li-pw",
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "li-pw",
                            type: "password",
                            required: true,
                            autoComplete: "current-password",
                            value: password,
                            onChange: (e)=>setPassword(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn-outline-secondary",
                            onClick: onClose,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            className: "btn btn-purple",
                            disabled: busy,
                            children: busy ? "Signing in..." : "Login"
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


function $9ba87e0b31e6dd0e$export$2e2bcd8739ae039({ onSignup: onSignup, onClose: onClose }) {
    const [name, setName] = (0, $acw62.useState)("");
    const [email, setEmail] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const submit = async (e)=>{
        e.preventDefault();
        if (busy) return;
        setError("");
        if (password.length < 8) return setError("Password must be at least 8 characters.");
        setBusy(true);
        try {
            await onSignup(await (0, $276e2b1a147d904e$export$6f5378aa3397b877)({
                name: name,
                email: email,
                password: password
            }));
        } catch (err) {
            setError(err.message);
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modal-backdrop",
        onMouseDown: (e)=>e.target === e.currentTarget && onClose(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            className: "modal-card",
            onSubmit: submit,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Sign Up"
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "alert alert-danger py-2",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $734775816ebf57ea$export$2e2bcd8739ae039), {
                    onSuccess: onSignup,
                    onError: setError
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "su-name",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "su-name",
                            required: true,
                            autoComplete: "name",
                            maxLength: 80,
                            value: name,
                            onChange: (e)=>setName(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "su-email",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "su-email",
                            type: "email",
                            required: true,
                            autoComplete: "email",
                            value: email,
                            onChange: (e)=>setEmail(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "su-pw",
                            children: "Password (8+ characters)"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "su-pw",
                            type: "password",
                            required: true,
                            minLength: 8,
                            autoComplete: "new-password",
                            value: password,
                            onChange: (e)=>setPassword(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn-outline-secondary",
                            onClick: onClose,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            className: "btn btn-purple",
                            disabled: busy,
                            children: busy ? "Creating..." : "Create Account"
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Check", [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Eye", [
    [
        "path",
        {
            d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z",
            key: "rwhkz3"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $056e74b7b26d3329$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("EyeOff", [
    [
        "path",
        {
            d: "M9.88 9.88a3 3 0 1 0 4.24 4.24",
            key: "1jxqfv"
        }
    ],
    [
        "path",
        {
            d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68",
            key: "9wicm4"
        }
    ],
    [
        "path",
        {
            d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61",
            key: "1jreej"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "2",
            y2: "22",
            key: "a6p6uj"
        }
    ]
]);



var $acw62 = parcelRequire("acw62");
function $97588ae92ff80131$export$2e2bcd8739ae039(loader, deps) {
    const [state, setState] = (0, $acw62.useState)({
        data: null,
        loading: true,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        let live = true;
        setState((s)=>({
                ...s,
                loading: true,
                error: null
            }));
        Promise.resolve().then(loader).then((data)=>live && setState({
                data: data,
                loading: false,
                error: null
            })).catch((error)=>live && setState({
                data: null,
                loading: false,
                error: error
            }));
        return ()=>{
            live = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return state;
}





// Display helpers shared by the company page tabs.
const $45b05daa53b66210$export$79c6a2ecd3e6852e = {
    K: 0.001,
    MM: 1,
    B: 1000
}; // base data is in $ millions
const $45b05daa53b66210$export$22a613b20d100f09 = {
    K: 0,
    MM: 1,
    B: 2
};
const $45b05daa53b66210$var$group = (n, d)=>Math.abs(n).toLocaleString("en-US", {
        minimumFractionDigits: d,
        maximumFractionDigits: d
    });
function $45b05daa53b66210$export$79b4d5b1a469ce61(n, d = 2) {
    if (n === null || n === undefined || Number.isNaN(n)) return "\u2014";
    return n < 0 ? `(${$45b05daa53b66210$var$group(n, d)})` : $45b05daa53b66210$var$group(n, d);
}
function $45b05daa53b66210$export$1ef4e7f5e06ac44a(value, kind, unit = "MM") {
    if (value === null || value === undefined || Number.isNaN(value)) return "\u2014";
    switch(kind){
        case "money":
            return $45b05daa53b66210$export$79b4d5b1a469ce61(value / $45b05daa53b66210$export$79c6a2ecd3e6852e[unit], $45b05daa53b66210$export$22a613b20d100f09[unit]);
        case "ps":
            return $45b05daa53b66210$export$79b4d5b1a469ce61(value, 2);
        case "pct":
            return value < 0 ? `(${$45b05daa53b66210$var$group(value, 1)}%)` : `${$45b05daa53b66210$var$group(value, 1)}%`;
        case "x":
            return `${$45b05daa53b66210$export$79b4d5b1a469ce61(value, 2)}x`;
        case "count":
            return $45b05daa53b66210$export$79b4d5b1a469ce61(value, 1);
        default:
            return $45b05daa53b66210$export$79b4d5b1a469ce61(value, 2);
    }
}
const $45b05daa53b66210$export$850409532323fff = (n, d = 1, sign = false)=>n === null || n === undefined || Number.isNaN(n) ? "\u2014" : `${sign && n > 0 ? "+" : ""}${n < 0 ? "-" : ""}${$45b05daa53b66210$var$group(n, d)}%`;
const $45b05daa53b66210$export$d4b2b9303ce6cae8 = (n, d = 2)=>n === null || n === undefined || Number.isNaN(n) ? "\u2014" : `${n < 0 ? "-" : ""}$${$45b05daa53b66210$var$group(n, d)}`;
function $45b05daa53b66210$export$d570a62256bab7b8(d) {
    const x = new Date(d);
    return `${x.getMonth() + 1}/${x.getDate()}/${String(x.getFullYear()).slice(2)}`;
}
function $45b05daa53b66210$export$3865cc3c40061728(d) {
    return new Date(d).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
    });
}
const $45b05daa53b66210$export$fe2e3b2f2c30e584 = (d)=>new Date(d).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
function $45b05daa53b66210$export$c6d851d1877b46af(filename, rows) {
    const esc = (v)=>`"${String(v ?? "").replace(/"/g, '""')}"`;
    const blob = new Blob([
        rows.map((r)=>r.map(esc).join(",")).join("\n")
    ], {
        type: "text/csv;charset=utf-8;"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}





var $acw62 = parcelRequire("acw62");

const $d55f9b3f8627f071$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "co-loading",
        children: "Loading\u2026"
    });
const $d55f9b3f8627f071$export$f04a3ea04edc0e04 = ({ error: error })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "co-error",
        children: [
            "Could not load this data. ",
            error && String(error.message || error)
        ]
    });
function $d55f9b3f8627f071$export$4e58f3d385baec7d() {
    const [sample, setSample] = (0, $acw62.useState)((0, $75280afcc6fc2ba7$export$4eb2c0a4e1820d98)());
    (0, $acw62.useEffect)(()=>{
        let live = true;
        (0, $75280afcc6fc2ba7$export$5e1ff101ad4c3610)().then((m)=>live && setSample(!!m.sample));
        return ()=>{
            live = false;
        };
    }, []);
    if (!sample) return null;
    return null;
//   (<div className="co-sample">
//     <strong>Sample data.</strong> Prices, financials, estimates and ownership shown here are generated
//     placeholders, not real market data.
//   </div>
// );
}
function $d55f9b3f8627f071$export$f26f9c9d776b76eb({ items: items, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "co-subtabs",
        role: "tablist",
        children: items.map(([key, label])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                role: "tab",
                "aria-selected": value === key,
                className: value === key ? "active" : "",
                onClick: ()=>onChange(key),
                children: label
            }, key))
    });
}
const $d55f9b3f8627f071$export$ca60b63eaa3c28aa = ({ items: items, value: value, onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "co-chips",
        children: items.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: value === c ? "active" : "",
                onClick: ()=>onChange(c),
                children: c
            }, c))
    });





var $acw62 = parcelRequire("acw62");

const $a108ac155e22abee$var$API = "https://spedvest.com/api";
const $a108ac155e22abee$var$IMPORTANT = /^(8-K|DEF 14A|S-1|S-3|424B|6-K|SC 13|SCHEDULE 13)/i;
const $a108ac155e22abee$var$MON = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $a108ac155e22abee$var$fd = (d)=>d ? +d.slice(8, 10) + " " + $a108ac155e22abee$var$MON[+d.slice(5, 7) - 1] + " " + d.slice(0, 4) : "";
function $a108ac155e22abee$var$Card({ title: title, right: right, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "dp-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dp-title",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: title
                    }),
                    right
                ]
            }),
            children
        ]
    });
}
function $a108ac155e22abee$var$Body({ children: children, empty: empty }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "dp-body",
        children: [
            children,
            empty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted small",
                children: "Nothing found."
            })
        ]
    });
}
function $a108ac155e22abee$var$Item({ href: href, title: title, sub: sub }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "dp-item",
        children: [
            href ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noreferrer",
                children: title
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: title
            }),
            sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dp-sub",
                children: sub
            })
        ]
    });
}
function $a108ac155e22abee$export$2e2bcd8739ae039({ ticker: ticker }) {
    const [d, setD] = (0, $acw62.useState)(null);
    const [rel, setRel] = (0, $acw62.useState)(null);
    const [tab, setTab] = (0, $acw62.useState)("recent");
    const [q, setQ] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (!ticker) return;
        let on = true;
        setD(null);
        setRel(null);
        fetch(`${$a108ac155e22abee$var$API}/stocks/${ticker}/documents`).then((r)=>r.json()).then((j)=>on && setD(j)).catch(()=>on && setD({
                announcements: [],
                annual: [],
                quarterly: []
            }));
        fetch(`${$a108ac155e22abee$var$API}/stocks/${ticker}/releases`).then((r)=>r.json()).then((j)=>on && setRel(Array.isArray(j) ? j : j.items || j.releases || [])).catch(()=>on && setRel([]));
        return ()=>{
            on = false;
        };
    }, [
        ticker
    ]);
    if (!d) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted",
        children: "Loading..."
    });
    let ann = d.announcements;
    if (tab === "recent") ann = ann.slice(0, 25);
    else if (tab === "important") ann = ann.filter((r)=>$a108ac155e22abee$var$IMPORTANT.test(r.form));
    else if (tab === "search") {
        const s = q.toLowerCase();
        ann = s ? ann.filter((r)=>((r.form || "") + " " + (r.description || "")).toLowerCase().includes(s)) : ann.slice(0, 25);
    }
    const edgar = `https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=${ticker}&type=&dateb=&owner=include&count=40`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "dp-grid",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a108ac155e22abee$var$Card, {
                title: "Announcements",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "dp-tabs",
                        children: [
                            [
                                [
                                    "recent",
                                    "Recent"
                                ],
                                [
                                    "important",
                                    "Important"
                                ],
                                [
                                    "search",
                                    "Search"
                                ]
                            ].map(([k, l])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: tab === k ? "on" : "",
                                    onClick: ()=>setTab(k),
                                    children: l
                                }, k)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: tab === "all" ? "on" : "",
                                onClick: ()=>setTab("all"),
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: edgar,
                                target: "_blank",
                                rel: "noreferrer",
                                title: "Open on SEC EDGAR",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                    size: 12
                                })
                            })
                        ]
                    }),
                    tab === "search" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        className: "dp-search",
                        placeholder: "Search filings...",
                        value: q,
                        onChange: (e)=>setQ(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Body, {
                        empty: !ann.length,
                        children: ann.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Item, {
                                href: r.url,
                                title: r.form + (r.description ? " - " + r.description : ""),
                                sub: $a108ac155e22abee$var$fd(r.filed)
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Card, {
                title: "Annual reports",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Body, {
                    empty: !d.annual.length,
                    children: d.annual.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Item, {
                            href: r.url,
                            title: "Annual Report " + (r.filed || "").slice(0, 4) + " (" + r.form + ")",
                            sub: "filed " + $a108ac155e22abee$var$fd(r.filed) + " from SEC"
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Card, {
                title: "Quarterly reports",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Body, {
                    empty: !d.quarterly.length,
                    children: d.quarterly.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Item, {
                            href: r.url,
                            title: "Quarterly Report (" + r.form + ")",
                            sub: "filed " + $a108ac155e22abee$var$fd(r.filed) + " from SEC"
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a108ac155e22abee$var$Card, {
                title: "Earnings releases",
                children: [
                    !rel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted small",
                        children: "Loading..."
                    }),
                    rel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Body, {
                        empty: !rel.length,
                        children: rel.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a108ac155e22abee$var$Item, {
                                href: r.url || r.link,
                                title: r.title || r.name || r.description || "Earnings release",
                                sub: $a108ac155e22abee$var$fd((r.date || r.filed || "").slice(0, 10))
                            }, i))
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $1c272c8c9427e0c0$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $1c272c8c9427e0c0$var$Feedback = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$1c272c8c9427e0c0$var$Feedback.displayName = 'Feedback';
$1c272c8c9427e0c0$var$Feedback.propTypes = $1c272c8c9427e0c0$var$propTypes;
var $1c272c8c9427e0c0$export$2e2bcd8739ae039 = $1c272c8c9427e0c0$var$Feedback;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
// TODO
const $870809e0939c9f82$var$FormContext = /*#__PURE__*/ $acw62.createContext({});
var $870809e0939c9f82$export$2e2bcd8739ae039 = $870809e0939c9f82$var$FormContext;




"use client";
const $7164fecb4f365c4a$var$FormCheckInput = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$7164fecb4f365c4a$var$FormCheckInput.displayName = 'FormCheckInput';
var $7164fecb4f365c4a$export$2e2bcd8739ae039 = $7164fecb4f365c4a$var$FormCheckInput;




var $acw62 = parcelRequire("acw62");



"use client";
const $b0aba1aace6996b7$var$FormCheckLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix)
    });
});
$b0aba1aace6996b7$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $b0aba1aace6996b7$export$2e2bcd8739ae039 = $b0aba1aace6996b7$var$FormCheckLabel;





var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}



"use client";
const $87df01720ec94e93$var$FormCheck = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    const innerFormContext = (0, $acw62.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $d3ae4136892dd278$export$500fd6099226ffae)(children, (0, $b0aba1aace6996b7$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7164fecb4f365c4a$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0aba1aace6996b7$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c272c8c9427e0c0$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$87df01720ec94e93$var$FormCheck.displayName = 'FormCheck';
var $87df01720ec94e93$export$2e2bcd8739ae039 = Object.assign($87df01720ec94e93$var$FormCheck, {
    Input: (0, $7164fecb4f365c4a$export$2e2bcd8739ae039),
    Label: (0, $b0aba1aace6996b7$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");





"use client";
const $3023ede31d3d1660$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$3023ede31d3d1660$var$FormControl.displayName = 'FormControl';
var $3023ede31d3d1660$export$2e2bcd8739ae039 = Object.assign($3023ede31d3d1660$var$FormControl, {
    Feedback: $1c272c8c9427e0c0$export$2e2bcd8739ae039
});



var $acw62 = parcelRequire("acw62");



"use client";
const $3d8877fa5535421d$var$FormFloating = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$3d8877fa5535421d$var$FormFloating.displayName = 'FormFloating';
var $3d8877fa5535421d$export$2e2bcd8739ae039 = $3d8877fa5535421d$var$FormFloating;



var $acw62 = parcelRequire("acw62");


const $5d8599dc34b64b39$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $acw62.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$5d8599dc34b64b39$var$FormGroup.displayName = 'FormGroup';
var $5d8599dc34b64b39$export$2e2bcd8739ae039 = $5d8599dc34b64b39$var$FormGroup;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


"use client";
function $6a906738aa440808$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $6a906738aa440808$var$Col = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $6a906738aa440808$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, !spans.length && bsPrefix)
    });
});
$6a906738aa440808$var$Col.displayName = 'Col';
var $6a906738aa440808$export$2e2bcd8739ae039 = $6a906738aa440808$var$Col;





"use client";
const $5d7439d74bf97ebc$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$5d7439d74bf97ebc$var$FormLabel.displayName = 'FormLabel';
var $5d7439d74bf97ebc$export$2e2bcd8739ae039 = $5d7439d74bf97ebc$var$FormLabel;




var $acw62 = parcelRequire("acw62");



"use client";
const $b91a225b00146fdd$var$FormRange = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$b91a225b00146fdd$var$FormRange.displayName = 'FormRange';
var $b91a225b00146fdd$export$2e2bcd8739ae039 = $b91a225b00146fdd$var$FormRange;




var $acw62 = parcelRequire("acw62");



"use client";
const $7b27958f5a457ab6$var$FormSelect = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$7b27958f5a457ab6$var$FormSelect.displayName = 'FormSelect';
var $7b27958f5a457ab6$export$2e2bcd8739ae039 = $7b27958f5a457ab6$var$FormSelect;




var $acw62 = parcelRequire("acw62");


"use client";
const $bd2be22fa282ca4a$var$FormText = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$bd2be22fa282ca4a$var$FormText.displayName = 'FormText';
var $bd2be22fa282ca4a$export$2e2bcd8739ae039 = $bd2be22fa282ca4a$var$FormText;



var $acw62 = parcelRequire("acw62");


const $fbd36a2b679cb998$var$Switch = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87df01720ec94e93$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$fbd36a2b679cb998$var$Switch.displayName = 'Switch';
var $fbd36a2b679cb998$export$2e2bcd8739ae039 = Object.assign($fbd36a2b679cb998$var$Switch, {
    Input: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Input,
    Label: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Label
});




var $acw62 = parcelRequire("acw62");



"use client";
const $26b7d75a1da62deb$var$FloatingLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5d8599dc34b64b39$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$26b7d75a1da62deb$var$FloatingLabel.displayName = 'FloatingLabel';
var $26b7d75a1da62deb$export$2e2bcd8739ae039 = $26b7d75a1da62deb$var$FloatingLabel;



const $64675cdb3851f16c$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $64675cdb3851f16c$var$Form = /*#__PURE__*/ $acw62.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, validated && 'was-validated')
    }));
$64675cdb3851f16c$var$Form.displayName = 'Form';
$64675cdb3851f16c$var$Form.propTypes = $64675cdb3851f16c$var$propTypes;
var $64675cdb3851f16c$export$2e2bcd8739ae039 = Object.assign($64675cdb3851f16c$var$Form, {
    Group: (0, $5d8599dc34b64b39$export$2e2bcd8739ae039),
    Control: (0, $3023ede31d3d1660$export$2e2bcd8739ae039),
    Floating: (0, $3d8877fa5535421d$export$2e2bcd8739ae039),
    Check: (0, $87df01720ec94e93$export$2e2bcd8739ae039),
    Switch: $fbd36a2b679cb998$export$2e2bcd8739ae039,
    Label: (0, $5d7439d74bf97ebc$export$2e2bcd8739ae039),
    Text: (0, $bd2be22fa282ca4a$export$2e2bcd8739ae039),
    Range: (0, $b91a225b00146fdd$export$2e2bcd8739ae039),
    Select: (0, $7b27958f5a457ab6$export$2e2bcd8739ae039),
    FloatingLabel: $26b7d75a1da62deb$export$2e2bcd8739ae039
});







var $2d215567a00cb0b5$var$size;
function $2d215567a00cb0b5$export$2e2bcd8739ae039(recalc) {
    if (!$2d215567a00cb0b5$var$size && $2d215567a00cb0b5$var$size !== 0 || recalc) {
        if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $2d215567a00cb0b5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $2d215567a00cb0b5$var$size;
}



var $acw62 = parcelRequire("acw62");
function $6ee4f2c1aea3527b$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}





var $acw62 = parcelRequire("acw62");
function $6227e7ea0d71afb1$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $acw62 = parcelRequire("acw62");
function $63805df80cf3ca43$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $6227e7ea0d71afb1$export$2e2bcd8739ae039)(fn);
    (0, $acw62.useEffect)(()=>()=>onUnmount.current(), []);
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



"use client";
const $25947da381dd154d$var$ModalBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$25947da381dd154d$var$ModalBody.displayName = 'ModalBody';
var $25947da381dd154d$export$2e2bcd8739ae039 = $25947da381dd154d$var$ModalBody;





var $acw62 = parcelRequire("acw62");


"use client";
const $b2d89f22a8b39e63$var$ModalDialog = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$b2d89f22a8b39e63$var$ModalDialog.displayName = 'ModalDialog';
var $b2d89f22a8b39e63$export$2e2bcd8739ae039 = $b2d89f22a8b39e63$var$ModalDialog;



var $acw62 = parcelRequire("acw62");



"use client";
const $9bf8146dd7a62ed4$var$ModalFooter = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$9bf8146dd7a62ed4$var$ModalFooter.displayName = 'ModalFooter';
var $9bf8146dd7a62ed4$export$2e2bcd8739ae039 = $9bf8146dd7a62ed4$var$ModalFooter;




var $acw62 = parcelRequire("acw62");



"use client";
const $b25eacf4397cf179$var$ModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed9ce9ab3e9405e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$b25eacf4397cf179$var$ModalHeader.displayName = 'ModalHeader';
var $b25eacf4397cf179$export$2e2bcd8739ae039 = $b25eacf4397cf179$var$ModalHeader;



var $acw62 = parcelRequire("acw62");




"use client";
const $39e2ac330b33f57e$var$DivStyledAsH4 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)('h4');
const $39e2ac330b33f57e$var$ModalTitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $39e2ac330b33f57e$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$39e2ac330b33f57e$var$ModalTitle.displayName = 'ModalTitle';
var $39e2ac330b33f57e$export$2e2bcd8739ae039 = $39e2ac330b33f57e$var$ModalTitle;




"use client";
function $c17184070610a5f4$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $c17184070610a5f4$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $c17184070610a5f4$var$Modal = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $b2d89f22a8b39e63$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $acw62.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $acw62.useState)(false);
    const waitingForMouseUpRef = (0, $acw62.useRef)(false);
    const ignoreBackdropClickRef = (0, $acw62.useRef)(false);
    const removeStaticModalAnimationRef = (0, $acw62.useRef)(null);
    const [modal, setModalRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $acw62.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $f00adc503d5cecaf$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>{
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $28419dce7921d430$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $acw62.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0173af0e859d9b0f$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $c17184070610a5f4$var$DialogTransition : undefined,
            backdropTransition: animation ? $c17184070610a5f4$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$c17184070610a5f4$var$Modal.displayName = 'Modal';
var $c17184070610a5f4$export$2e2bcd8739ae039 = Object.assign($c17184070610a5f4$var$Modal, {
    Body: (0, $25947da381dd154d$export$2e2bcd8739ae039),
    Header: (0, $b25eacf4397cf179$export$2e2bcd8739ae039),
    Title: (0, $39e2ac330b33f57e$export$2e2bcd8739ae039),
    Footer: (0, $9bf8146dd7a62ed4$export$2e2bcd8739ae039),
    Dialog: (0, $b2d89f22a8b39e63$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});


/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0e8ea8c31c9fdf2b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Minus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
]);


const $287d5b51065c19f8$var$API = "https://spedvest.com/api";
const $287d5b51065c19f8$var$DASH = "\u2014";
const $287d5b51065c19f8$var$fp = (v)=>v == null ? $287d5b51065c19f8$var$DASH : v.toFixed(2) + "%";
const $287d5b51065c19f8$var$fn = (v)=>v == null ? $287d5b51065c19f8$var$DASH : Number(v).toLocaleString();
const $287d5b51065c19f8$var$MON = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $287d5b51065c19f8$var$monthLabel = (d)=>$287d5b51065c19f8$var$MON[+d.slice(5, 7) - 1] + " " + d.slice(0, 4);
function $287d5b51065c19f8$var$TradesModal({ ticker: ticker, show: show, onHide: onHide }) {
    const [tab, setTab] = (0, $acw62.useState)("insider");
    const [d, setD] = (0, $acw62.useState)(null);
    const [hide, setHide] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!show) return;
        fetch(`${$287d5b51065c19f8$var$API}/stocks/${ticker}/share-trades`).then((r)=>r.json()).then(setD).catch(()=>setD({
                insider: [],
                large: []
            }));
    }, [
        show,
        ticker
    ]);
    const rows = (d ? d.insider : []).filter((r)=>!(hide && r.price && Number(r.shares) * Number(r.price) < 10000));
    const groups = {};
    rows.forEach((r)=>{
        (groups[$287d5b51065c19f8$var$monthLabel(r.d)] = groups[$287d5b51065c19f8$var$monthLabel(r.d)] || []).push(r);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039), {
        show: show,
        onHide: onHide,
        size: "lg",
        centered: true,
        scrollable: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c17184070610a5f4$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039).Title, {
                    children: [
                        ticker,
                        " trades"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039), {
                        variant: "tabs",
                        activeKey: tab,
                        onSelect: setTab,
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                                    eventKey: "insider",
                                    children: "Insider Trades"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                                    eventKey: "large",
                                    children: "Large holder filings (13D/13G)"
                                })
                            })
                        ]
                    }),
                    !d && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted",
                        children: "Loading..."
                    }),
                    d && tab === "insider" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                type: "checkbox",
                                label: "Hide small trades (under $10,000)",
                                checked: hide,
                                onChange: (e)=>setHide(e.target.checked),
                                className: "mb-2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted small",
                                children: "Open-market purchases and sales reported on SEC Form 4."
                            }),
                            !rows.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted",
                                children: "No open-market insider trades found."
                            }),
                            Object.keys(groups).map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "sh-month",
                                            children: g
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "sh-table sh-trades",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: "Person"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "r",
                                                                children: "Quantity"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "r",
                                                                children: "Avg price"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "r",
                                                                children: "Value"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                    children: groups[g].map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    children: [
                                                                        r.insider,
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "small text-muted",
                                                                            children: [
                                                                                r.role || "",
                                                                                " ",
                                                                                r.d
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: r.code === "P" ? "sh-buy" : "sh-sell",
                                                                        children: r.code === "P" ? "Buy" : "Sell"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "r",
                                                                    children: $287d5b51065c19f8$var$fn(r.shares)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "r",
                                                                    children: r.price ? "$" + Number(r.price).toFixed(2) : $287d5b51065c19f8$var$DASH
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "r",
                                                                    children: r.price ? "$" + Math.round(Number(r.shares) * Number(r.price)).toLocaleString() : $287d5b51065c19f8$var$DASH
                                                                })
                                                            ]
                                                        }, i))
                                                })
                                            ]
                                        })
                                    ]
                                }, g))
                        ]
                    }),
                    d && tab === "large" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted small",
                                children: "Schedule 13D/13G filings: investors crossing 5% ownership. The US equivalent of India's SAST disclosures."
                            }),
                            !d.large.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted",
                                children: "No 13D/13G filings stored for this company."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "sh-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: d.large.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.filed
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.form
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.description || ""
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "r",
                                                    children: r.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: r.url,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: "View"
                                                    }) : ""
                                                })
                                            ]
                                        }, i))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $287d5b51065c19f8$export$2e2bcd8739ae039({ ticker: ticker }) {
    const [view, setView] = (0, $acw62.useState)("quarterly");
    const [d, setD] = (0, $acw62.useState)(null);
    const [open, setOpen] = (0, $acw62.useState)({});
    const [modal, setModal] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!ticker) return;
        let on = true;
        setD(null);
        fetch(`${$287d5b51065c19f8$var$API}/stocks/${ticker}/shareholding?view=${view}`).then((r)=>r.json()).then((j)=>on && setD(j)).catch(()=>on && setD({
                periods: [],
                rows: [],
                note: "Could not load shareholding."
            }));
        return ()=>{
            on = false;
        };
    }, [
        ticker,
        view
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "sh-wrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sh-head",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Shareholding Pattern"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted small",
                                children: "Numbers in % of shares outstanding"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "sh-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "sh-btn",
                                onClick: ()=>setModal(true),
                                children: "TRADES"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "sh-toggle",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: view === "quarterly" ? "on" : "",
                                        onClick: ()=>setView("quarterly"),
                                        children: "Quarterly"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: view === "yearly" ? "on" : "",
                                        onClick: ()=>setView("yearly"),
                                        children: "Yearly"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !d && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted",
                children: "Loading..."
            }),
            d && !d.periods.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted",
                children: d.note || "No data."
            }),
            d && d.periods.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sh-scroll",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "sh-table",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {}),
                                    d.periods.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "r",
                                            children: p
                                        }, p))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: d.rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "sh-label",
                                                    children: [
                                                        r.children && r.children.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "sh-x",
                                                            onClick: ()=>setOpen({
                                                                    ...open,
                                                                    [r.key]: !open[r.key]
                                                                }),
                                                            children: open[r.key] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e8ea8c31c9fdf2b$export$2e2bcd8739ae039), {
                                                                size: 12
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                                size: 12
                                                            })
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "sh-x-sp"
                                                        }),
                                                        r.label
                                                    ]
                                                }),
                                                r.values.map((v, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "r",
                                                        children: r.kind === "count" ? $287d5b51065c19f8$var$fn(v) : $287d5b51065c19f8$var$fp(v)
                                                    }, i))
                                            ]
                                        }),
                                        open[r.key] && r.children.map((c, j)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "sh-child",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "sh-label sh-ind",
                                                        children: c.label
                                                    }),
                                                    c.values.map((v, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "r",
                                                            children: $287d5b51065c19f8$var$fp(v)
                                                        }, i))
                                                ]
                                            }, r.key + j))
                                    ]
                                }, r.key))
                        })
                    ]
                })
            }),
            d && d.note && d.periods.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted small mt-2",
                children: d.note
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($287d5b51065c19f8$var$TradesModal, {
                ticker: ticker,
                show: modal,
                onHide: ()=>setModal(false)
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");

const $6a003cf53bfc86cf$var$enc = encodeURIComponent;
const $6a003cf53bfc86cf$export$9dbcdfb953196356 = (t)=>(0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/stocks/${$6a003cf53bfc86cf$var$enc(t)}/valuation`);
const $6a003cf53bfc86cf$export$cbee5bd9b9dd46d1 = (t)=>(0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/stocks/${$6a003cf53bfc86cf$var$enc(t)}/insiders`);
const $6a003cf53bfc86cf$export$2dfd31d5563ac23e = (t)=>(0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/stocks/${$6a003cf53bfc86cf$var$enc(t)}/model-inputs`);
const $6a003cf53bfc86cf$export$4f498f45d9eebbb1 = (t)=>(0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/stocks/${$6a003cf53bfc86cf$var$enc(t)}/releases`);
const $6a003cf53bfc86cf$export$b63e4da3de62140d = (t, count = 13)=>(0, $eaaba8a5ae480d72$export$644d8ea042df96a6)(`/stocks/${$6a003cf53bfc86cf$var$enc(t)}/quarterly?count=${count}`);







var $acw62 = parcelRequire("acw62");
/*!
 * @license
 * TradingView Lightweight Charts™ v4.2.3
 * Copyright (c) 2025 TradingView, Inc.
 * Licensed under Apache License 2.0 https://www.apache.org/licenses/LICENSE-2.0
 */ function $4150ff0128b161d2$export$346677f925de839c(_a) {
    var width = _a.width, height = _a.height;
    if (width < 0) throw new Error('Negative width is not allowed for Size');
    if (height < 0) throw new Error('Negative height is not allowed for Size');
    return {
        width: width,
        height: height
    };
}
function $4150ff0128b161d2$export$dfcfeaf16c0e44ed(first, second) {
    return first.width === second.width && first.height === second.height;
}



var $4efde66edb34976e$var$Observable = /** @class */ function() {
    function Observable(win) {
        var _this = this;
        this._resolutionListener = function() {
            return _this._onResolutionChanged();
        };
        this._resolutionMediaQueryList = null;
        this._observers = [];
        this._window = win;
        this._installResolutionListener();
    }
    Observable.prototype.dispose = function() {
        this._uninstallResolutionListener();
        this._window = null;
    };
    Object.defineProperty(Observable.prototype, "value", {
        get: function() {
            return this._window.devicePixelRatio;
        },
        enumerable: false,
        configurable: true
    });
    Observable.prototype.subscribe = function(next) {
        var _this = this;
        var observer = {
            next: next
        };
        this._observers.push(observer);
        return {
            unsubscribe: function() {
                _this._observers = _this._observers.filter(function(o) {
                    return o !== observer;
                });
            }
        };
    };
    Observable.prototype._installResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) throw new Error('Resolution listener is already installed');
        var dppx = this._window.devicePixelRatio;
        this._resolutionMediaQueryList = this._window.matchMedia("all and (resolution: ".concat(dppx, "dppx)"));
        // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
        this._resolutionMediaQueryList.addListener(this._resolutionListener);
    };
    Observable.prototype._uninstallResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) {
            // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
            this._resolutionMediaQueryList.removeListener(this._resolutionListener);
            this._resolutionMediaQueryList = null;
        }
    };
    Observable.prototype._reinstallResolutionListener = function() {
        this._uninstallResolutionListener();
        this._installResolutionListener();
    };
    Observable.prototype._onResolutionChanged = function() {
        var _this = this;
        this._observers.forEach(function(observer) {
            return observer.next(_this._window.devicePixelRatio);
        });
        this._reinstallResolutionListener();
    };
    return Observable;
}();
function $4efde66edb34976e$export$5e7f1682f65b2ce4(win) {
    return new $4efde66edb34976e$var$Observable(win);
}


var $02a7dfaff38a9eef$var$DevicePixelContentBoxBinding = /** @class */ function() {
    function DevicePixelContentBoxBinding(canvasElement, transformBitmapSize, options) {
        var _a;
        this._canvasElement = null;
        this._bitmapSizeChangedListeners = [];
        this._suggestedBitmapSize = null;
        this._suggestedBitmapSizeChangedListeners = [];
        // devicePixelRatio approach
        this._devicePixelRatioObservable = null;
        // ResizeObserver approach
        this._canvasElementResizeObserver = null;
        this._canvasElement = canvasElement;
        this._canvasElementClientSize = (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: this._canvasElement.clientWidth,
            height: this._canvasElement.clientHeight
        });
        this._transformBitmapSize = transformBitmapSize !== null && transformBitmapSize !== void 0 ? transformBitmapSize : function(size) {
            return size;
        };
        this._allowResizeObserver = (_a = options === null || options === void 0 ? void 0 : options.allowResizeObserver) !== null && _a !== void 0 ? _a : true;
        this._chooseAndInitObserver();
    // we MAY leave the constuctor without any bitmap size observation mechanics initialized
    }
    DevicePixelContentBoxBinding.prototype.dispose = function() {
        var _a, _b;
        if (this._canvasElement === null) throw new Error('Object is disposed');
        (_a = this._canvasElementResizeObserver) === null || _a === void 0 || _a.disconnect();
        this._canvasElementResizeObserver = null;
        (_b = this._devicePixelRatioObservable) === null || _b === void 0 || _b.dispose();
        this._devicePixelRatioObservable = null;
        this._suggestedBitmapSizeChangedListeners.length = 0;
        this._bitmapSizeChangedListeners.length = 0;
        this._canvasElement = null;
    };
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "canvasElement", {
        get: function() {
            if (this._canvasElement === null) throw new Error('Object is disposed');
            return this._canvasElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "canvasElementClientSize", {
        get: function() {
            return this._canvasElementClientSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "bitmapSize", {
        get: function() {
            return (0, $4150ff0128b161d2$export$346677f925de839c)({
                width: this.canvasElement.width,
                height: this.canvasElement.height
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Use this function to change canvas element client size until binding is disposed
     * @param clientSize New client size for bound HTMLCanvasElement
     */ DevicePixelContentBoxBinding.prototype.resizeCanvasElement = function(clientSize) {
        this._canvasElementClientSize = (0, $4150ff0128b161d2$export$346677f925de839c)(clientSize);
        this.canvasElement.style.width = "".concat(this._canvasElementClientSize.width, "px");
        this.canvasElement.style.height = "".concat(this._canvasElementClientSize.height, "px");
        this._invalidateBitmapSize();
    };
    DevicePixelContentBoxBinding.prototype.subscribeBitmapSizeChanged = function(listener) {
        this._bitmapSizeChangedListeners.push(listener);
    };
    DevicePixelContentBoxBinding.prototype.unsubscribeBitmapSizeChanged = function(listener) {
        this._bitmapSizeChangedListeners = this._bitmapSizeChangedListeners.filter(function(l) {
            return l !== listener;
        });
    };
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "suggestedBitmapSize", {
        get: function() {
            return this._suggestedBitmapSize;
        },
        enumerable: false,
        configurable: true
    });
    DevicePixelContentBoxBinding.prototype.subscribeSuggestedBitmapSizeChanged = function(listener) {
        this._suggestedBitmapSizeChangedListeners.push(listener);
    };
    DevicePixelContentBoxBinding.prototype.unsubscribeSuggestedBitmapSizeChanged = function(listener) {
        this._suggestedBitmapSizeChangedListeners = this._suggestedBitmapSizeChangedListeners.filter(function(l) {
            return l !== listener;
        });
    };
    DevicePixelContentBoxBinding.prototype.applySuggestedBitmapSize = function() {
        if (this._suggestedBitmapSize === null) // nothing to apply
        return;
        var oldSuggestedSize = this._suggestedBitmapSize;
        this._suggestedBitmapSize = null;
        this._resizeBitmap(oldSuggestedSize);
        this._emitSuggestedBitmapSizeChanged(oldSuggestedSize, this._suggestedBitmapSize);
    };
    DevicePixelContentBoxBinding.prototype._resizeBitmap = function(newSize) {
        var oldSize = this.bitmapSize;
        if ((0, $4150ff0128b161d2$export$dfcfeaf16c0e44ed)(oldSize, newSize)) return;
        this.canvasElement.width = newSize.width;
        this.canvasElement.height = newSize.height;
        this._emitBitmapSizeChanged(oldSize, newSize);
    };
    DevicePixelContentBoxBinding.prototype._emitBitmapSizeChanged = function(oldSize, newSize) {
        var _this = this;
        this._bitmapSizeChangedListeners.forEach(function(listener) {
            return listener.call(_this, oldSize, newSize);
        });
    };
    DevicePixelContentBoxBinding.prototype._suggestNewBitmapSize = function(newSize) {
        var oldSuggestedSize = this._suggestedBitmapSize;
        var finalNewSize = (0, $4150ff0128b161d2$export$346677f925de839c)(this._transformBitmapSize(newSize, this._canvasElementClientSize));
        var newSuggestedSize = (0, $4150ff0128b161d2$export$dfcfeaf16c0e44ed)(this.bitmapSize, finalNewSize) ? null : finalNewSize;
        if (oldSuggestedSize === null && newSuggestedSize === null) return;
        if (oldSuggestedSize !== null && newSuggestedSize !== null && (0, $4150ff0128b161d2$export$dfcfeaf16c0e44ed)(oldSuggestedSize, newSuggestedSize)) return;
        this._suggestedBitmapSize = newSuggestedSize;
        this._emitSuggestedBitmapSizeChanged(oldSuggestedSize, newSuggestedSize);
    };
    DevicePixelContentBoxBinding.prototype._emitSuggestedBitmapSizeChanged = function(oldSize, newSize) {
        var _this = this;
        this._suggestedBitmapSizeChangedListeners.forEach(function(listener) {
            return listener.call(_this, oldSize, newSize);
        });
    };
    DevicePixelContentBoxBinding.prototype._chooseAndInitObserver = function() {
        var _this = this;
        if (!this._allowResizeObserver) {
            this._initDevicePixelRatioObservable();
            return;
        }
        $02a7dfaff38a9eef$var$isDevicePixelContentBoxSupported().then(function(isSupported) {
            return isSupported ? _this._initResizeObserver() : _this._initDevicePixelRatioObservable();
        });
    };
    // devicePixelRatio approach
    DevicePixelContentBoxBinding.prototype._initDevicePixelRatioObservable = function() {
        var _this = this;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        var win = $02a7dfaff38a9eef$var$canvasElementWindow(this._canvasElement);
        if (win === null) throw new Error('No window is associated with the canvas');
        this._devicePixelRatioObservable = (0, $4efde66edb34976e$export$5e7f1682f65b2ce4)(win);
        this._devicePixelRatioObservable.subscribe(function() {
            return _this._invalidateBitmapSize();
        });
        this._invalidateBitmapSize();
    };
    DevicePixelContentBoxBinding.prototype._invalidateBitmapSize = function() {
        var _a, _b;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        var win = $02a7dfaff38a9eef$var$canvasElementWindow(this._canvasElement);
        if (win === null) return;
        var ratio = (_b = (_a = this._devicePixelRatioObservable) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : win.devicePixelRatio;
        var canvasRects = this._canvasElement.getClientRects();
        var newSize = // eslint-disable-next-line no-negated-condition
        canvasRects[0] !== undefined ? $02a7dfaff38a9eef$var$predictedBitmapSize(canvasRects[0], ratio) : (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: this._canvasElementClientSize.width * ratio,
            height: this._canvasElementClientSize.height * ratio
        });
        this._suggestNewBitmapSize(newSize);
    };
    // ResizeObserver approach
    DevicePixelContentBoxBinding.prototype._initResizeObserver = function() {
        var _this = this;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        this._canvasElementResizeObserver = new ResizeObserver(function(entries) {
            var entry = entries.find(function(entry) {
                return entry.target === _this._canvasElement;
            });
            if (!entry || !entry.devicePixelContentBoxSize || !entry.devicePixelContentBoxSize[0]) return;
            var entrySize = entry.devicePixelContentBoxSize[0];
            var newSize = (0, $4150ff0128b161d2$export$346677f925de839c)({
                width: entrySize.inlineSize,
                height: entrySize.blockSize
            });
            _this._suggestNewBitmapSize(newSize);
        });
        this._canvasElementResizeObserver.observe(this._canvasElement, {
            box: 'device-pixel-content-box'
        });
    };
    return DevicePixelContentBoxBinding;
}();
function $02a7dfaff38a9eef$export$7c052ae73f8acff0(canvasElement, target) {
    if (target.type === 'device-pixel-content-box') return new $02a7dfaff38a9eef$var$DevicePixelContentBoxBinding(canvasElement, target.transform, target.options);
    throw new Error('Unsupported binding target');
}
function $02a7dfaff38a9eef$var$canvasElementWindow(canvasElement) {
    // According to DOM Level 2 Core specification, ownerDocument should never be null for HTMLCanvasElement
    // see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#node-ownerDoc
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return canvasElement.ownerDocument.defaultView;
}
function $02a7dfaff38a9eef$var$isDevicePixelContentBoxSupported() {
    return new Promise(function(resolve) {
        var ro = new ResizeObserver(function(entries) {
            resolve(entries.every(function(entry) {
                return 'devicePixelContentBoxSize' in entry;
            }));
            ro.disconnect();
        });
        ro.observe(document.body, {
            box: 'device-pixel-content-box'
        });
    }).catch(function() {
        return false;
    });
}
function $02a7dfaff38a9eef$var$predictedBitmapSize(canvasRect, ratio) {
    return (0, $4150ff0128b161d2$export$346677f925de839c)({
        width: Math.round(canvasRect.left * ratio + canvasRect.width * ratio) - Math.round(canvasRect.left * ratio),
        height: Math.round(canvasRect.top * ratio + canvasRect.height * ratio) - Math.round(canvasRect.top * ratio)
    });
}


/**
 * @experimental
 */ var $d9fd08faf8e542f8$export$d9009780fa8cf0a4 = /** @class */ function() {
    function CanvasRenderingTarget2D(context, mediaSize, bitmapSize) {
        if (mediaSize.width === 0 || mediaSize.height === 0) throw new TypeError('Rendering target could only be created on a media with positive width and height');
        this._mediaSize = mediaSize;
        // !Number.isInteger(bitmapSize.width) || !Number.isInteger(bitmapSize.height)
        if (bitmapSize.width === 0 || bitmapSize.height === 0) throw new TypeError('Rendering target could only be created using a bitmap with positive integer width and height');
        this._bitmapSize = bitmapSize;
        this._context = context;
    }
    CanvasRenderingTarget2D.prototype.useMediaCoordinateSpace = function(f) {
        try {
            this._context.save();
            // do not use resetTransform to support old versions of Edge
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            this._context.scale(this._horizontalPixelRatio, this._verticalPixelRatio);
            return f({
                context: this._context,
                mediaSize: this._mediaSize
            });
        } finally{
            this._context.restore();
        }
    };
    CanvasRenderingTarget2D.prototype.useBitmapCoordinateSpace = function(f) {
        try {
            this._context.save();
            // do not use resetTransform to support old versions of Edge
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            return f({
                context: this._context,
                mediaSize: this._mediaSize,
                bitmapSize: this._bitmapSize,
                horizontalPixelRatio: this._horizontalPixelRatio,
                verticalPixelRatio: this._verticalPixelRatio
            });
        } finally{
            this._context.restore();
        }
    };
    Object.defineProperty(CanvasRenderingTarget2D.prototype, "_horizontalPixelRatio", {
        get: function() {
            return this._bitmapSize.width / this._mediaSize.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasRenderingTarget2D.prototype, "_verticalPixelRatio", {
        get: function() {
            return this._bitmapSize.height / this._mediaSize.height;
        },
        enumerable: false,
        configurable: true
    });
    return CanvasRenderingTarget2D;
}();
function $d9fd08faf8e542f8$export$279ad88fbb07063a(binding, contextOptions) {
    var mediaSize = binding.canvasElementClientSize;
    var bitmapSize = binding.bitmapSize;
    var context = binding.canvasElement.getContext('2d', contextOptions);
    if (context === null) throw new Error('Could not get 2d drawing context from bound canvas element. Has the canvas already been set to a different context mode?');
    return new $d9fd08faf8e542f8$export$d9009780fa8cf0a4(context, mediaSize, bitmapSize);
}
function $d9fd08faf8e542f8$export$7130a2243f9306b6(binding, contextOptions) {
    var mediaSize = binding.canvasElementClientSize;
    if (mediaSize.width === 0 || mediaSize.height === 0) return null;
    var bitmapSize = binding.bitmapSize;
    if (bitmapSize.width === 0 || bitmapSize.height === 0) return null;
    var context = binding.canvasElement.getContext('2d', contextOptions);
    if (context === null) return null;
    return new $d9fd08faf8e542f8$export$d9009780fa8cf0a4(context, mediaSize, bitmapSize);
}




const $a1a4d31e28ce1f0d$var$e = {
    upColor: "#26a69a",
    downColor: "#ef5350",
    wickVisible: !0,
    borderVisible: !0,
    borderColor: "#378658",
    borderUpColor: "#26a69a",
    borderDownColor: "#ef5350",
    wickColor: "#737375",
    wickUpColor: "#26a69a",
    wickDownColor: "#ef5350"
}, $a1a4d31e28ce1f0d$var$r = {
    upColor: "#26a69a",
    downColor: "#ef5350",
    openVisible: !0,
    thinBars: !0
}, $a1a4d31e28ce1f0d$var$h = {
    color: "#2196f3",
    lineStyle: 0,
    lineWidth: 3,
    lineType: 0,
    lineVisible: !0,
    crosshairMarkerVisible: !0,
    crosshairMarkerRadius: 4,
    crosshairMarkerBorderColor: "",
    crosshairMarkerBorderWidth: 2,
    crosshairMarkerBackgroundColor: "",
    lastPriceAnimation: 0,
    pointMarkersVisible: !1
}, $a1a4d31e28ce1f0d$var$l = {
    topColor: "rgba( 46, 220, 135, 0.4)",
    bottomColor: "rgba( 40, 221, 100, 0)",
    invertFilledArea: !1,
    lineColor: "#33D778",
    lineStyle: 0,
    lineWidth: 3,
    lineType: 0,
    lineVisible: !0,
    crosshairMarkerVisible: !0,
    crosshairMarkerRadius: 4,
    crosshairMarkerBorderColor: "",
    crosshairMarkerBorderWidth: 2,
    crosshairMarkerBackgroundColor: "",
    lastPriceAnimation: 0,
    pointMarkersVisible: !1
}, $a1a4d31e28ce1f0d$var$a = {
    baseValue: {
        type: "price",
        price: 0
    },
    topFillColor1: "rgba(38, 166, 154, 0.28)",
    topFillColor2: "rgba(38, 166, 154, 0.05)",
    topLineColor: "rgba(38, 166, 154, 1)",
    bottomFillColor1: "rgba(239, 83, 80, 0.05)",
    bottomFillColor2: "rgba(239, 83, 80, 0.28)",
    bottomLineColor: "rgba(239, 83, 80, 1)",
    lineWidth: 3,
    lineStyle: 0,
    lineType: 0,
    lineVisible: !0,
    crosshairMarkerVisible: !0,
    crosshairMarkerRadius: 4,
    crosshairMarkerBorderColor: "",
    crosshairMarkerBorderWidth: 2,
    crosshairMarkerBackgroundColor: "",
    lastPriceAnimation: 0,
    pointMarkersVisible: !1
}, $a1a4d31e28ce1f0d$var$o = {
    color: "#26a69a",
    base: 0
}, $a1a4d31e28ce1f0d$var$_ = {
    color: "#2196f3"
}, $a1a4d31e28ce1f0d$var$u = {
    title: "",
    visible: !0,
    lastValueVisible: !0,
    priceLineVisible: !0,
    priceLineSource: 0,
    priceLineWidth: 1,
    priceLineColor: "",
    priceLineStyle: 2,
    baseLineVisible: !0,
    baseLineWidth: 1,
    baseLineColor: "#B2B5BE",
    baseLineStyle: 0,
    priceFormat: {
        type: "price",
        precision: 2,
        minMove: .01
    }
};
var $a1a4d31e28ce1f0d$export$aa318e0578993894, $a1a4d31e28ce1f0d$export$5d24e00cfde59887;
function $a1a4d31e28ce1f0d$var$f(t, i) {
    const n = {
        0: [],
        1: [
            t.lineWidth,
            t.lineWidth
        ],
        2: [
            2 * t.lineWidth,
            2 * t.lineWidth
        ],
        3: [
            6 * t.lineWidth,
            6 * t.lineWidth
        ],
        4: [
            t.lineWidth,
            4 * t.lineWidth
        ]
    }[i];
    t.setLineDash(n);
}
function $a1a4d31e28ce1f0d$var$v(t, i, n, s) {
    t.beginPath();
    const e = t.lineWidth % 2 ? .5 : 0;
    t.moveTo(n, i + e), t.lineTo(s, i + e), t.stroke();
}
function $a1a4d31e28ce1f0d$var$p(t, i) {
    if (!t) throw new Error("Assertion failed" + (i ? ": " + i : ""));
}
function $a1a4d31e28ce1f0d$var$m(t) {
    if (void 0 === t) throw new Error("Value is undefined");
    return t;
}
function $a1a4d31e28ce1f0d$var$b(t) {
    if (null === t) throw new Error("Value is null");
    return t;
}
function $a1a4d31e28ce1f0d$var$w(t) {
    return $a1a4d31e28ce1f0d$var$b($a1a4d31e28ce1f0d$var$m(t));
}
!function(t) {
    t[t.Simple = 0] = "Simple", t[t.WithSteps = 1] = "WithSteps", t[t.Curved = 2] = "Curved";
}($a1a4d31e28ce1f0d$export$aa318e0578993894 || ($a1a4d31e28ce1f0d$export$aa318e0578993894 = {})), function(t) {
    t[t.Solid = 0] = "Solid", t[t.Dotted = 1] = "Dotted", t[t.Dashed = 2] = "Dashed", t[t.LargeDashed = 3] = "LargeDashed", t[t.SparseDotted = 4] = "SparseDotted";
}($a1a4d31e28ce1f0d$export$5d24e00cfde59887 || ($a1a4d31e28ce1f0d$export$5d24e00cfde59887 = {}));
const $a1a4d31e28ce1f0d$var$g = {
    khaki: "#f0e68c",
    azure: "#f0ffff",
    aliceblue: "#f0f8ff",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gainsboro: "#dcdcdc",
    gray: "#808080",
    green: "#008000",
    honeydew: "#f0fff0",
    floralwhite: "#fffaf0",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lemonchiffon: "#fffacd",
    hotpink: "#ff69b4",
    lightyellow: "#ffffe0",
    greenyellow: "#adff2f",
    lightgoldenrodyellow: "#fafad2",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    lightcyan: "#e0ffff",
    magenta: "#f0f",
    maroon: "#800000",
    olive: "#808000",
    orange: "#ffa500",
    oldlace: "#fdf5e6",
    mediumblue: "#0000cd",
    transparent: "#0000",
    lime: "#0f0",
    lightpink: "#ffb6c1",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    midnightblue: "#191970",
    orchid: "#da70d6",
    mediumorchid: "#ba55d3",
    mediumturquoise: "#48d1cc",
    orangered: "#ff4500",
    royalblue: "#4169e1",
    powderblue: "#b0e0e6",
    red: "#f00",
    coral: "#ff7f50",
    turquoise: "#40e0d0",
    white: "#fff",
    whitesmoke: "#f5f5f5",
    wheat: "#f5deb3",
    teal: "#008080",
    steelblue: "#4682b4",
    bisque: "#ffe4c4",
    aquamarine: "#7fffd4",
    aqua: "#0ff",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    springgreen: "#00ff7f",
    antiquewhite: "#faebd7",
    burlywood: "#deb887",
    brown: "#a52a2a",
    beige: "#f5f5dc",
    chocolate: "#d2691e",
    chartreuse: "#7fff00",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cadetblue: "#5f9ea0",
    tomato: "#ff6347",
    fuchsia: "#f0f",
    blue: "#00f",
    salmon: "#fa8072",
    blanchedalmond: "#ffebcd",
    slateblue: "#6a5acd",
    slategray: "#708090",
    thistle: "#d8bfd8",
    tan: "#d2b48c",
    cyan: "#0ff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    blueviolet: "#8a2be2",
    black: "#000",
    darkmagenta: "#8b008b",
    darkslateblue: "#483d8b",
    darkkhaki: "#bdb76b",
    darkorchid: "#9932cc",
    darkorange: "#ff8c00",
    darkgreen: "#006400",
    darkred: "#8b0000",
    dodgerblue: "#1e90ff",
    darkslategray: "#2f4f4f",
    dimgray: "#696969",
    deepskyblue: "#00bfff",
    firebrick: "#b22222",
    forestgreen: "#228b22",
    indigo: "#4b0082",
    ivory: "#fffff0",
    lavenderblush: "#fff0f5",
    feldspar: "#d19275",
    indianred: "#cd5c5c",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightskyblue: "#87cefa",
    lightslategray: "#789",
    lightslateblue: "#8470ff",
    snow: "#fffafa",
    lightseagreen: "#20b2aa",
    lightsalmon: "#ffa07a",
    darksalmon: "#e9967a",
    darkviolet: "#9400d3",
    mediumpurple: "#9370d8",
    mediumaquamarine: "#66cdaa",
    skyblue: "#87ceeb",
    lavender: "#e6e6fa",
    lightsteelblue: "#b0c4de",
    mediumvioletred: "#c71585",
    mintcream: "#f5fffa",
    navajowhite: "#ffdead",
    navy: "#000080",
    olivedrab: "#6b8e23",
    palevioletred: "#d87093",
    violetred: "#d02090",
    yellow: "#ff0",
    yellowgreen: "#9acd32",
    lawngreen: "#7cfc00",
    pink: "#ffc0cb",
    paleturquoise: "#afeeee",
    palegoldenrod: "#eee8aa",
    darkolivegreen: "#556b2f",
    darkseagreen: "#8fbc8f",
    darkturquoise: "#00ced1",
    peachpuff: "#ffdab9",
    deeppink: "#ff1493",
    violet: "#ee82ee",
    palegreen: "#98fb98",
    mediumseagreen: "#3cb371",
    peru: "#cd853f",
    saddlebrown: "#8b4513",
    sandybrown: "#f4a460",
    rosybrown: "#bc8f8f",
    purple: "#800080",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    papayawhip: "#ffefd5",
    mediumslateblue: "#7b68ee",
    plum: "#dda0dd",
    mediumspringgreen: "#00fa9a"
};
function $a1a4d31e28ce1f0d$var$M(t) {
    return t < 0 ? 0 : t > 255 ? 255 : Math.round(t) || 0;
}
function $a1a4d31e28ce1f0d$var$x(t) {
    return t <= 0 || t > 1 ? Math.min(Math.max(t, 0), 1) : Math.round(1e4 * t) / 1e4;
}
const $a1a4d31e28ce1f0d$var$S = /^#([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])?$/i, $a1a4d31e28ce1f0d$var$k = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})?$/i, $a1a4d31e28ce1f0d$var$y = /^rgb\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*\)$/, $a1a4d31e28ce1f0d$var$C = /^rgba\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d*\.?\d+)\s*\)$/;
function $a1a4d31e28ce1f0d$var$T(t) {
    (t = t.toLowerCase()) in $a1a4d31e28ce1f0d$var$g && (t = $a1a4d31e28ce1f0d$var$g[t]);
    {
        const i = $a1a4d31e28ce1f0d$var$C.exec(t) || $a1a4d31e28ce1f0d$var$y.exec(t);
        if (i) return [
            $a1a4d31e28ce1f0d$var$M(parseInt(i[1], 10)),
            $a1a4d31e28ce1f0d$var$M(parseInt(i[2], 10)),
            $a1a4d31e28ce1f0d$var$M(parseInt(i[3], 10)),
            $a1a4d31e28ce1f0d$var$x(i.length < 5 ? 1 : parseFloat(i[4]))
        ];
    }
    {
        const i = $a1a4d31e28ce1f0d$var$k.exec(t);
        if (i) return [
            $a1a4d31e28ce1f0d$var$M(parseInt(i[1], 16)),
            $a1a4d31e28ce1f0d$var$M(parseInt(i[2], 16)),
            $a1a4d31e28ce1f0d$var$M(parseInt(i[3], 16)),
            1
        ];
    }
    {
        const i = $a1a4d31e28ce1f0d$var$S.exec(t);
        if (i) return [
            $a1a4d31e28ce1f0d$var$M(17 * parseInt(i[1], 16)),
            $a1a4d31e28ce1f0d$var$M(17 * parseInt(i[2], 16)),
            $a1a4d31e28ce1f0d$var$M(17 * parseInt(i[3], 16)),
            1
        ];
    }
    throw new Error(`Cannot parse color: ${t}`);
}
function $a1a4d31e28ce1f0d$var$P(t) {
    return .199 * t[0] + .687 * t[1] + .114 * t[2];
}
function $a1a4d31e28ce1f0d$var$R(t) {
    const i = $a1a4d31e28ce1f0d$var$T(t);
    return {
        t: `rgb(${i[0]}, ${i[1]}, ${i[2]})`,
        i: $a1a4d31e28ce1f0d$var$P(i) > 160 ? "black" : "white"
    };
}
class $a1a4d31e28ce1f0d$var$D {
    constructor(){
        this.h = [];
    }
    l(t, i, n) {
        const s = {
            o: t,
            _: i,
            u: !0 === n
        };
        this.h.push(s);
    }
    v(t) {
        const i = this.h.findIndex((i)=>t === i.o);
        i > -1 && this.h.splice(i, 1);
    }
    p(t) {
        this.h = this.h.filter((i)=>i._ !== t);
    }
    m(t, i, n) {
        const s = [
            ...this.h
        ];
        this.h = this.h.filter((t)=>!t.u), s.forEach((s)=>s.o(t, i, n));
    }
    M() {
        return this.h.length > 0;
    }
    S() {
        this.h = [];
    }
}
function $a1a4d31e28ce1f0d$var$V(t, ...i) {
    for (const n of i)for(const i in n)void 0 !== n[i] && Object.prototype.hasOwnProperty.call(n, i) && ![
        "__proto__",
        "constructor",
        "prototype"
    ].includes(i) && ("object" != typeof n[i] || void 0 === t[i] || Array.isArray(n[i]) ? t[i] = n[i] : $a1a4d31e28ce1f0d$var$V(t[i], n[i]));
    return t;
}
function $a1a4d31e28ce1f0d$var$O(t) {
    return "number" == typeof t && isFinite(t);
}
function $a1a4d31e28ce1f0d$var$B(t) {
    return "number" == typeof t && t % 1 == 0;
}
function $a1a4d31e28ce1f0d$var$A(t) {
    return "string" == typeof t;
}
function $a1a4d31e28ce1f0d$var$I(t) {
    return "boolean" == typeof t;
}
function $a1a4d31e28ce1f0d$var$z(t) {
    const i = t;
    if (!i || "object" != typeof i) return i;
    let n, s, e;
    for(s in n = Array.isArray(i) ? [] : {}, i)i.hasOwnProperty(s) && (e = i[s], n[s] = e && "object" == typeof e ? $a1a4d31e28ce1f0d$var$z(e) : e);
    return n;
}
function $a1a4d31e28ce1f0d$var$L(t) {
    return null !== t;
}
function $a1a4d31e28ce1f0d$var$E(t) {
    return null === t ? void 0 : t;
}
const $a1a4d31e28ce1f0d$var$N = "-apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif";
function $a1a4d31e28ce1f0d$var$F(t, i, n) {
    return void 0 === i && (i = $a1a4d31e28ce1f0d$var$N), `${n = void 0 !== n ? `${n} ` : ""}${t}px ${i}`;
}
class $a1a4d31e28ce1f0d$var$W {
    constructor(t){
        this.k = {
            C: 1,
            T: 5,
            P: NaN,
            R: "",
            D: "",
            V: "",
            O: "",
            B: 0,
            A: 0,
            I: 0,
            L: 0,
            N: 0
        }, this.F = t;
    }
    W() {
        const t = this.k, i = this.j(), n = this.H();
        return t.P === i && t.D === n || (t.P = i, t.D = n, t.R = $a1a4d31e28ce1f0d$var$F(i, n), t.L = 2.5 / 12 * i, t.B = t.L, t.A = i / 12 * t.T, t.I = i / 12 * t.T, t.N = 0), t.V = this.$(), t.O = this.U(), this.k;
    }
    $() {
        return this.F.W().layout.textColor;
    }
    U() {
        return this.F.q();
    }
    j() {
        return this.F.W().layout.fontSize;
    }
    H() {
        return this.F.W().layout.fontFamily;
    }
}
class $a1a4d31e28ce1f0d$var$j {
    constructor(){
        this.Y = [];
    }
    Z(t) {
        this.Y = t;
    }
    X(t, i, n) {
        this.Y.forEach((s)=>{
            s.X(t, i, n);
        });
    }
}
class $a1a4d31e28ce1f0d$var$H {
    X(t, i, n) {
        t.useBitmapCoordinateSpace((t)=>this.K(t, i, n));
    }
}
class $a1a4d31e28ce1f0d$var$$ extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.G = null;
    }
    J(t) {
        this.G = t;
    }
    K({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.G || null === this.G.tt) return;
        const s = this.G.tt, e = this.G, r = Math.max(1, Math.floor(i)) % 2 / 2, h = (h)=>{
            t.beginPath();
            for(let l = s.to - 1; l >= s.from; --l){
                const s = e.it[l], a = Math.round(s.nt * i) + r, o = s.st * n, _ = h * n + r;
                t.moveTo(a, o), t.arc(a, o, _, 0, 2 * Math.PI);
            }
            t.fill();
        };
        e.et > 0 && (t.fillStyle = e.rt, h(e.ht + e.et)), t.fillStyle = e.lt, h(e.ht);
    }
}
function $a1a4d31e28ce1f0d$var$U() {
    return {
        it: [
            {
                nt: 0,
                st: 0,
                ot: 0,
                _t: 0
            }
        ],
        lt: "",
        rt: "",
        ht: 0,
        et: 0,
        tt: null
    };
}
const $a1a4d31e28ce1f0d$var$q = {
    from: 0,
    to: 1
};
class $a1a4d31e28ce1f0d$var$Y {
    constructor(t, i){
        this.ut = new $a1a4d31e28ce1f0d$var$j, this.ct = [], this.dt = [], this.ft = !0, this.F = t, this.vt = i, this.ut.Z(this.ct);
    }
    bt(t) {
        const i = this.F.wt();
        i.length !== this.ct.length && (this.dt = i.map($a1a4d31e28ce1f0d$var$U), this.ct = this.dt.map((t)=>{
            const i = new $a1a4d31e28ce1f0d$var$$;
            return i.J(t), i;
        }), this.ut.Z(this.ct)), this.ft = !0;
    }
    gt() {
        return this.ft && (this.Mt(), this.ft = !1), this.ut;
    }
    Mt() {
        const t = 2 === this.vt.W().mode, i = this.F.wt(), n = this.vt.xt(), s = this.F.St();
        i.forEach((i, e)=>{
            var r;
            const h = this.dt[e], l = i.kt(n);
            if (t || null === l || !i.yt()) return void (h.tt = null);
            const a = $a1a4d31e28ce1f0d$var$b(i.Ct());
            h.lt = l.Tt, h.ht = l.ht, h.et = l.Pt, h.it[0]._t = l._t, h.it[0].st = i.Dt().Rt(l._t, a.Vt), h.rt = null !== (r = l.Ot) && void 0 !== r ? r : this.F.Bt(h.it[0].st / i.Dt().At()), h.it[0].ot = n, h.it[0].nt = s.It(n), h.tt = $a1a4d31e28ce1f0d$var$q;
        });
    }
}
class $a1a4d31e28ce1f0d$var$Z extends $a1a4d31e28ce1f0d$var$H {
    constructor(t){
        super(), this.zt = t;
    }
    K({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.zt) return;
        const e = this.zt.Lt.yt, r = this.zt.Et.yt;
        if (!e && !r) return;
        const h = Math.round(this.zt.nt * n), l = Math.round(this.zt.st * s);
        t.lineCap = "butt", e && h >= 0 && (t.lineWidth = Math.floor(this.zt.Lt.et * n), t.strokeStyle = this.zt.Lt.V, t.fillStyle = this.zt.Lt.V, $a1a4d31e28ce1f0d$var$f(t, this.zt.Lt.Nt), function(t, i, n, s) {
            t.beginPath();
            const e = t.lineWidth % 2 ? .5 : 0;
            t.moveTo(i + e, n), t.lineTo(i + e, s), t.stroke();
        }(t, h, 0, i.height)), r && l >= 0 && (t.lineWidth = Math.floor(this.zt.Et.et * s), t.strokeStyle = this.zt.Et.V, t.fillStyle = this.zt.Et.V, $a1a4d31e28ce1f0d$var$f(t, this.zt.Et.Nt), $a1a4d31e28ce1f0d$var$v(t, l, 0, i.width));
    }
}
class $a1a4d31e28ce1f0d$var$X {
    constructor(t){
        this.ft = !0, this.Ft = {
            Lt: {
                et: 1,
                Nt: 0,
                V: "",
                yt: !1
            },
            Et: {
                et: 1,
                Nt: 0,
                V: "",
                yt: !1
            },
            nt: 0,
            st: 0
        }, this.Wt = new $a1a4d31e28ce1f0d$var$Z(this.Ft), this.jt = t;
    }
    bt() {
        this.ft = !0;
    }
    gt() {
        return this.ft && (this.Mt(), this.ft = !1), this.Wt;
    }
    Mt() {
        const t = this.jt.yt(), i = $a1a4d31e28ce1f0d$var$b(this.jt.Ht()), n = i.$t().W().crosshair, s = this.Ft;
        if (2 === n.mode) return s.Et.yt = !1, void (s.Lt.yt = !1);
        s.Et.yt = t && this.jt.Ut(i), s.Lt.yt = t && this.jt.qt(), s.Et.et = n.horzLine.width, s.Et.Nt = n.horzLine.style, s.Et.V = n.horzLine.color, s.Lt.et = n.vertLine.width, s.Lt.Nt = n.vertLine.style, s.Lt.V = n.vertLine.color, s.nt = this.jt.Yt(), s.st = this.jt.Zt();
    }
}
function $a1a4d31e28ce1f0d$var$K(t, i, n, s, e, r) {
    t.fillRect(i + r, n, s - 2 * r, r), t.fillRect(i + r, n + e - r, s - 2 * r, r), t.fillRect(i, n, r, e), t.fillRect(i + s - r, n, r, e);
}
function $a1a4d31e28ce1f0d$var$G(t, i, n, s, e, r) {
    t.save(), t.globalCompositeOperation = "copy", t.fillStyle = r, t.fillRect(i, n, s, e), t.restore();
}
function $a1a4d31e28ce1f0d$var$J(t, i, n, s, e, r) {
    t.beginPath(), t.roundRect ? t.roundRect(i, n, s, e, r) : (t.lineTo(i + s - r[1], n), 0 !== r[1] && t.arcTo(i + s, n, i + s, n + r[1], r[1]), t.lineTo(i + s, n + e - r[2]), 0 !== r[2] && t.arcTo(i + s, n + e, i + s - r[2], n + e, r[2]), t.lineTo(i + r[3], n + e), 0 !== r[3] && t.arcTo(i, n + e, i, n + e - r[3], r[3]), t.lineTo(i, n + r[0]), 0 !== r[0] && t.arcTo(i, n, i + r[0], n, r[0]));
}
function $a1a4d31e28ce1f0d$var$Q(t, i, n, s, e, r, h = 0, l = [
    0,
    0,
    0,
    0
], a = "") {
    if (t.save(), !h || !a || a === r) return $a1a4d31e28ce1f0d$var$J(t, i, n, s, e, l), t.fillStyle = r, t.fill(), void t.restore();
    const o = h / 2;
    var _;
    $a1a4d31e28ce1f0d$var$J(t, i + o, n + o, s - h, e - h, (_ = -o, l.map((t)=>0 === t ? t : t + _))), "transparent" !== r && (t.fillStyle = r, t.fill()), "transparent" !== a && (t.lineWidth = h, t.strokeStyle = a, t.closePath(), t.stroke()), t.restore();
}
function $a1a4d31e28ce1f0d$var$tt(t, i, n, s, e, r, h) {
    t.save(), t.globalCompositeOperation = "copy";
    const l = t.createLinearGradient(0, 0, 0, e);
    l.addColorStop(0, r), l.addColorStop(1, h), t.fillStyle = l, t.fillRect(i, n, s, e), t.restore();
}
class $a1a4d31e28ce1f0d$var$it {
    constructor(t, i){
        this.J(t, i);
    }
    J(t, i) {
        this.zt = t, this.Xt = i;
    }
    At(t, i) {
        return this.zt.yt ? t.P + t.L + t.B : 0;
    }
    X(t, i, n, s) {
        if (!this.zt.yt || 0 === this.zt.Kt.length) return;
        const e = this.zt.V, r = this.Xt.t, h = t.useBitmapCoordinateSpace((t)=>{
            const h = t.context;
            h.font = i.R;
            const l = this.Gt(t, i, n, s), a = l.Jt;
            return l.Qt ? $a1a4d31e28ce1f0d$var$Q(h, a.ti, a.ii, a.ni, a.si, r, a.ei, [
                a.ht,
                0,
                0,
                a.ht
            ], r) : $a1a4d31e28ce1f0d$var$Q(h, a.ri, a.ii, a.ni, a.si, r, a.ei, [
                0,
                a.ht,
                a.ht,
                0
            ], r), this.zt.hi && (h.fillStyle = e, h.fillRect(a.ri, a.li, a.ai - a.ri, a.oi)), this.zt._i && (h.fillStyle = i.O, h.fillRect(l.Qt ? a.ui - a.ei : 0, a.ii, a.ei, a.ci - a.ii)), l;
        });
        t.useMediaCoordinateSpace(({ context: t })=>{
            const n = h.di;
            t.font = i.R, t.textAlign = h.Qt ? "right" : "left", t.textBaseline = "middle", t.fillStyle = e, t.fillText(this.zt.Kt, n.fi, (n.ii + n.ci) / 2 + n.pi);
        });
    }
    Gt(t, i, n, s) {
        var e;
        const { context: r, bitmapSize: h, mediaSize: l, horizontalPixelRatio: a, verticalPixelRatio: o } = t, _ = this.zt.hi || !this.zt.mi ? i.T : 0, u = this.zt.bi ? i.C : 0, c = i.L + this.Xt.wi, d = i.B + this.Xt.gi, f = i.A, v = i.I, p = this.zt.Kt, m = i.P, b = n.Mi(r, p), w = Math.ceil(n.xi(r, p)), g = m + c + d, M = i.C + f + v + w + _, x = Math.max(1, Math.floor(o));
        let S = Math.round(g * o);
        S % 2 != x % 2 && (S += 1);
        const k = u > 0 ? Math.max(1, Math.floor(u * a)) : 0, y = Math.round(M * a), C = Math.round(_ * a), T = null !== (e = this.Xt.Si) && void 0 !== e ? e : this.Xt.ki, P = Math.round(T * o) - Math.floor(.5 * o), R = Math.floor(P + x / 2 - S / 2), D = R + S, V = "right" === s, O = V ? l.width - u : u, B = V ? h.width - k : k;
        let A, I, z;
        return V ? (A = B - y, I = B - C, z = O - _ - f - u) : (A = B + y, I = B + C, z = O + _ + f), {
            Qt: V,
            Jt: {
                ii: R,
                li: P,
                ci: D,
                ni: y,
                si: S,
                ht: 2 * a,
                ei: k,
                ti: A,
                ri: B,
                ai: I,
                oi: x,
                ui: h.width
            },
            di: {
                ii: R / o,
                ci: D / o,
                fi: z,
                pi: b
            }
        };
    }
}
class $a1a4d31e28ce1f0d$var$nt {
    constructor(t){
        this.yi = {
            ki: 0,
            t: "#000",
            gi: 0,
            wi: 0
        }, this.Ci = {
            Kt: "",
            yt: !1,
            hi: !0,
            mi: !1,
            Ot: "",
            V: "#FFF",
            _i: !1,
            bi: !1
        }, this.Ti = {
            Kt: "",
            yt: !1,
            hi: !1,
            mi: !0,
            Ot: "",
            V: "#FFF",
            _i: !0,
            bi: !0
        }, this.ft = !0, this.Pi = new (t || $a1a4d31e28ce1f0d$var$it)(this.Ci, this.yi), this.Ri = new (t || $a1a4d31e28ce1f0d$var$it)(this.Ti, this.yi);
    }
    Kt() {
        return this.Di(), this.Ci.Kt;
    }
    ki() {
        return this.Di(), this.yi.ki;
    }
    bt() {
        this.ft = !0;
    }
    At(t, i = !1) {
        return Math.max(this.Pi.At(t, i), this.Ri.At(t, i));
    }
    Vi() {
        return this.yi.Si || 0;
    }
    Oi(t) {
        this.yi.Si = t;
    }
    Bi() {
        return this.Di(), this.Ci.yt || this.Ti.yt;
    }
    Ai() {
        return this.Di(), this.Ci.yt;
    }
    gt(t) {
        return this.Di(), this.Ci.hi = this.Ci.hi && t.W().ticksVisible, this.Ti.hi = this.Ti.hi && t.W().ticksVisible, this.Pi.J(this.Ci, this.yi), this.Ri.J(this.Ti, this.yi), this.Pi;
    }
    Ii() {
        return this.Di(), this.Pi.J(this.Ci, this.yi), this.Ri.J(this.Ti, this.yi), this.Ri;
    }
    Di() {
        this.ft && (this.Ci.hi = !0, this.Ti.hi = !1, this.zi(this.Ci, this.Ti, this.yi));
    }
}
class $a1a4d31e28ce1f0d$var$st extends $a1a4d31e28ce1f0d$var$nt {
    constructor(t, i, n){
        super(), this.jt = t, this.Li = i, this.Ei = n;
    }
    zi(t, i, n) {
        if (t.yt = !1, 2 === this.jt.W().mode) return;
        const s = this.jt.W().horzLine;
        if (!s.labelVisible) return;
        const e = this.Li.Ct();
        if (!this.jt.yt() || this.Li.Ni() || null === e) return;
        const r = $a1a4d31e28ce1f0d$var$R(s.labelBackgroundColor);
        n.t = r.t, t.V = r.i;
        const h = 2 / 12 * this.Li.P();
        n.wi = h, n.gi = h;
        const l = this.Ei(this.Li);
        n.ki = l.ki, t.Kt = this.Li.Fi(l._t, e), t.yt = !0;
    }
}
const $a1a4d31e28ce1f0d$var$et = /[1-9]/g;
class $a1a4d31e28ce1f0d$var$rt {
    constructor(){
        this.zt = null;
    }
    J(t) {
        this.zt = t;
    }
    X(t, i) {
        if (null === this.zt || !1 === this.zt.yt || 0 === this.zt.Kt.length) return;
        const n = t.useMediaCoordinateSpace(({ context: t })=>(t.font = i.R, Math.round(i.Wi.xi(t, $a1a4d31e28ce1f0d$var$b(this.zt).Kt, $a1a4d31e28ce1f0d$var$et))));
        if (n <= 0) return;
        const s = i.ji, e = n + 2 * s, r = e / 2, h = this.zt.Hi;
        let l = this.zt.ki, a = Math.floor(l - r) + .5;
        a < 0 ? (l += Math.abs(0 - a), a = Math.floor(l - r) + .5) : a + e > h && (l -= Math.abs(h - (a + e)), a = Math.floor(l - r) + .5);
        const o = a + e, _ = Math.ceil(0 + i.C + i.T + i.L + i.P + i.B);
        t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: n, verticalPixelRatio: s })=>{
            const e = $a1a4d31e28ce1f0d$var$b(this.zt);
            t.fillStyle = e.t;
            const r = Math.round(a * n), h = Math.round(0 * s), l = Math.round(o * n), u = Math.round(_ * s), c = Math.round(2 * n);
            if (t.beginPath(), t.moveTo(r, h), t.lineTo(r, u - c), t.arcTo(r, u, r + c, u, c), t.lineTo(l - c, u), t.arcTo(l, u, l, u - c, c), t.lineTo(l, h), t.fill(), e.hi) {
                const r = Math.round(e.ki * n), l = h, a = Math.round((l + i.T) * s);
                t.fillStyle = e.V;
                const o = Math.max(1, Math.floor(n)), _ = Math.floor(.5 * n);
                t.fillRect(r - _, l, o, a - l);
            }
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            const n = $a1a4d31e28ce1f0d$var$b(this.zt), e = 0 + i.C + i.T + i.L + i.P / 2;
            t.font = i.R, t.textAlign = "left", t.textBaseline = "middle", t.fillStyle = n.V;
            const r = i.Wi.Mi(t, "Apr0");
            t.translate(a + s, e + r), t.fillText(n.Kt, 0, 0);
        });
    }
}
class $a1a4d31e28ce1f0d$var$ht {
    constructor(t, i, n){
        this.ft = !0, this.Wt = new $a1a4d31e28ce1f0d$var$rt, this.Ft = {
            yt: !1,
            t: "#4c525e",
            V: "white",
            Kt: "",
            Hi: 0,
            ki: NaN,
            hi: !0
        }, this.vt = t, this.$i = i, this.Ei = n;
    }
    bt() {
        this.ft = !0;
    }
    gt() {
        return this.ft && (this.Mt(), this.ft = !1), this.Wt.J(this.Ft), this.Wt;
    }
    Mt() {
        const t = this.Ft;
        if (t.yt = !1, 2 === this.vt.W().mode) return;
        const i = this.vt.W().vertLine;
        if (!i.labelVisible) return;
        const n = this.$i.St();
        if (n.Ni()) return;
        t.Hi = n.Hi();
        const s = this.Ei();
        if (null === s) return;
        t.ki = s.ki;
        const e = n.Ui(this.vt.xt());
        t.Kt = n.qi($a1a4d31e28ce1f0d$var$b(e)), t.yt = !0;
        const r = $a1a4d31e28ce1f0d$var$R(i.labelBackgroundColor);
        t.t = r.t, t.V = r.i, t.hi = n.W().ticksVisible;
    }
}
class $a1a4d31e28ce1f0d$var$lt {
    constructor(){
        this.Yi = null, this.Zi = 0;
    }
    Xi() {
        return this.Zi;
    }
    Ki(t) {
        this.Zi = t;
    }
    Dt() {
        return this.Yi;
    }
    Gi(t) {
        this.Yi = t;
    }
    Ji(t) {
        return [];
    }
    Qi() {
        return [];
    }
    yt() {
        return !0;
    }
}
var $a1a4d31e28ce1f0d$export$67315bc29c7dd713;
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Magnet = 1] = "Magnet", t[t.Hidden = 2] = "Hidden";
}($a1a4d31e28ce1f0d$export$67315bc29c7dd713 || ($a1a4d31e28ce1f0d$export$67315bc29c7dd713 = {}));
class $a1a4d31e28ce1f0d$var$ot extends $a1a4d31e28ce1f0d$var$lt {
    constructor(t, i){
        super(), this.tn = null, this.nn = NaN, this.sn = 0, this.en = !0, this.rn = new Map, this.hn = !1, this.ln = NaN, this.an = NaN, this._n = NaN, this.un = NaN, this.$i = t, this.cn = i, this.dn = new $a1a4d31e28ce1f0d$var$Y(t, this);
        this.fn = ((t, i)=>(n)=>{
                const s = i(), e = t();
                if (n === $a1a4d31e28ce1f0d$var$b(this.tn).vn()) return {
                    _t: e,
                    ki: s
                };
                {
                    const t = $a1a4d31e28ce1f0d$var$b(n.Ct());
                    return {
                        _t: n.pn(s, t),
                        ki: s
                    };
                }
            })(()=>this.nn, ()=>this.an);
        const n = ((t, i)=>()=>{
                const n = this.$i.St().mn(t()), s = i();
                return n && Number.isFinite(s) ? {
                    ot: n,
                    ki: s
                } : null;
            })(()=>this.sn, ()=>this.Yt());
        this.bn = new $a1a4d31e28ce1f0d$var$ht(this, t, n), this.wn = new $a1a4d31e28ce1f0d$var$X(this);
    }
    W() {
        return this.cn;
    }
    gn(t, i) {
        this._n = t, this.un = i;
    }
    Mn() {
        this._n = NaN, this.un = NaN;
    }
    xn() {
        return this._n;
    }
    Sn() {
        return this.un;
    }
    kn(t, i, n) {
        this.hn || (this.hn = !0), this.en = !0, this.yn(t, i, n);
    }
    xt() {
        return this.sn;
    }
    Yt() {
        return this.ln;
    }
    Zt() {
        return this.an;
    }
    yt() {
        return this.en;
    }
    Cn() {
        this.en = !1, this.Tn(), this.nn = NaN, this.ln = NaN, this.an = NaN, this.tn = null, this.Mn();
    }
    Pn(t) {
        return null !== this.tn ? [
            this.wn,
            this.dn
        ] : [];
    }
    Ut(t) {
        return t === this.tn && this.cn.horzLine.visible;
    }
    qt() {
        return this.cn.vertLine.visible;
    }
    Rn(t, i) {
        this.en && this.tn === t || this.rn.clear();
        const n = [];
        return this.tn === t && n.push(this.Dn(this.rn, i, this.fn)), n;
    }
    Qi() {
        return this.en ? [
            this.bn
        ] : [];
    }
    Ht() {
        return this.tn;
    }
    Vn() {
        this.wn.bt(), this.rn.forEach((t)=>t.bt()), this.bn.bt(), this.dn.bt();
    }
    On(t) {
        return t && !t.vn().Ni() ? t.vn() : null;
    }
    yn(t, i, n) {
        this.Bn(t, i, n) && this.Vn();
    }
    Bn(t, i, n) {
        const s = this.ln, e = this.an, r = this.nn, h = this.sn, l = this.tn, a = this.On(n);
        this.sn = t, this.ln = isNaN(t) ? NaN : this.$i.St().It(t), this.tn = n;
        const o = null !== a ? a.Ct() : null;
        return null !== a && null !== o ? (this.nn = i, this.an = a.Rt(i, o)) : (this.nn = NaN, this.an = NaN), s !== this.ln || e !== this.an || h !== this.sn || r !== this.nn || l !== this.tn;
    }
    Tn() {
        const t = this.$i.wt().map((t)=>t.In().An()).filter($a1a4d31e28ce1f0d$var$L), i = 0 === t.length ? null : Math.max(...t);
        this.sn = null !== i ? i : NaN;
    }
    Dn(t, i, n) {
        let s = t.get(i);
        return void 0 === s && (s = new $a1a4d31e28ce1f0d$var$st(this, i, n), t.set(i, s)), s;
    }
}
function $a1a4d31e28ce1f0d$var$_t(t) {
    return "left" === t || "right" === t;
}
class $a1a4d31e28ce1f0d$var$ut {
    constructor(t){
        this.zn = new Map, this.Ln = [], this.En = t;
    }
    Nn(t, i) {
        const n = function(t, i) {
            return void 0 === t ? i : {
                Fn: Math.max(t.Fn, i.Fn),
                Wn: t.Wn || i.Wn
            };
        }(this.zn.get(t), i);
        this.zn.set(t, n);
    }
    jn() {
        return this.En;
    }
    Hn(t) {
        const i = this.zn.get(t);
        return void 0 === i ? {
            Fn: this.En
        } : {
            Fn: Math.max(this.En, i.Fn),
            Wn: i.Wn
        };
    }
    $n() {
        this.Un(), this.Ln = [
            {
                qn: 0
            }
        ];
    }
    Yn(t) {
        this.Un(), this.Ln = [
            {
                qn: 1,
                Vt: t
            }
        ];
    }
    Zn(t) {
        this.Xn(), this.Ln.push({
            qn: 5,
            Vt: t
        });
    }
    Un() {
        this.Xn(), this.Ln.push({
            qn: 6
        });
    }
    Kn() {
        this.Un(), this.Ln = [
            {
                qn: 4
            }
        ];
    }
    Gn(t) {
        this.Un(), this.Ln.push({
            qn: 2,
            Vt: t
        });
    }
    Jn(t) {
        this.Un(), this.Ln.push({
            qn: 3,
            Vt: t
        });
    }
    Qn() {
        return this.Ln;
    }
    ts(t) {
        for (const i of t.Ln)this.ns(i);
        this.En = Math.max(this.En, t.En), t.zn.forEach((t, i)=>{
            this.Nn(i, t);
        });
    }
    static ss() {
        return new $a1a4d31e28ce1f0d$var$ut(2);
    }
    static es() {
        return new $a1a4d31e28ce1f0d$var$ut(3);
    }
    ns(t) {
        switch(t.qn){
            case 0:
                this.$n();
                break;
            case 1:
                this.Yn(t.Vt);
                break;
            case 2:
                this.Gn(t.Vt);
                break;
            case 3:
                this.Jn(t.Vt);
                break;
            case 4:
                this.Kn();
                break;
            case 5:
                this.Zn(t.Vt);
                break;
            case 6:
                this.Xn();
        }
    }
    Xn() {
        const t = this.Ln.findIndex((t)=>5 === t.qn);
        -1 !== t && this.Ln.splice(t, 1);
    }
}
const $a1a4d31e28ce1f0d$var$ct = ".";
function $a1a4d31e28ce1f0d$var$dt(t, i) {
    if (!$a1a4d31e28ce1f0d$var$O(t)) return "n/a";
    if (!$a1a4d31e28ce1f0d$var$B(i)) throw new TypeError("invalid length");
    if (i < 0 || i > 16) throw new TypeError("invalid length");
    if (0 === i) return t.toString();
    return ("0000000000000000" + t.toString()).slice(-i);
}
class $a1a4d31e28ce1f0d$var$ft {
    constructor(t, i){
        if (i || (i = 1), $a1a4d31e28ce1f0d$var$O(t) && $a1a4d31e28ce1f0d$var$B(t) || (t = 100), t < 0) throw new TypeError("invalid base");
        this.Li = t, this.rs = i, this.hs();
    }
    format(t) {
        const i = t < 0 ? "\u2212" : "";
        return t = Math.abs(t), i + this.ls(t);
    }
    hs() {
        if (this._s = 0, this.Li > 0 && this.rs > 0) {
            let t = this.Li;
            for(; t > 1;)t /= 10, this._s++;
        }
    }
    ls(t) {
        const i = this.Li / this.rs;
        let n = Math.floor(t), s = "";
        const e = void 0 !== this._s ? this._s : NaN;
        if (i > 1) {
            let r = +(Math.round(t * i) - n * i).toFixed(this._s);
            r >= i && (r -= i, n += 1), s = $a1a4d31e28ce1f0d$var$ct + $a1a4d31e28ce1f0d$var$dt(+r.toFixed(this._s) * this.rs, e);
        } else n = Math.round(n * i) / i, e > 0 && (s = $a1a4d31e28ce1f0d$var$ct + $a1a4d31e28ce1f0d$var$dt(0, e));
        return n.toFixed(0) + s;
    }
}
class $a1a4d31e28ce1f0d$var$vt extends $a1a4d31e28ce1f0d$var$ft {
    constructor(t = 100){
        super(t);
    }
    format(t) {
        return `${super.format(t)}%`;
    }
}
class $a1a4d31e28ce1f0d$var$pt {
    constructor(t){
        this.us = t;
    }
    format(t) {
        let i = "";
        return t < 0 && (i = "-", t = -t), t < 995 ? i + this.cs(t) : t < 999995 ? i + this.cs(t / 1e3) + "K" : t < 999999995 ? (t = 1e3 * Math.round(t / 1e3), i + this.cs(t / 1e6) + "M") : (t = 1e6 * Math.round(t / 1e6), i + this.cs(t / 1e9) + "B");
    }
    cs(t) {
        let i;
        const n = Math.pow(10, this.us);
        return i = (t = Math.round(t * n) / n) >= 1e-15 && t < 1 ? t.toFixed(this.us).replace(/\.?0+$/, "") : String(t), i.replace(/(\.[1-9]*)0+$/, (t, i)=>i);
    }
}
function $a1a4d31e28ce1f0d$var$mt(t, i, n, s, e, r, h) {
    if (0 === i.length || s.from >= i.length || s.to <= 0) return;
    const { context: l, horizontalPixelRatio: a, verticalPixelRatio: o } = t, _ = i[s.from];
    let u = r(t, _), c = _;
    if (s.to - s.from < 2) {
        const i = e / 2;
        l.beginPath();
        const n = {
            nt: _.nt - i,
            st: _.st
        }, s = {
            nt: _.nt + i,
            st: _.st
        };
        l.moveTo(n.nt * a, n.st * o), l.lineTo(s.nt * a, s.st * o), h(t, u, n, s);
    } else {
        const e = (i, n)=>{
            h(t, u, c, n), l.beginPath(), u = i, c = n;
        };
        let d = c;
        l.beginPath(), l.moveTo(_.nt * a, _.st * o);
        for(let h = s.from + 1; h < s.to; ++h){
            d = i[h];
            const s = r(t, d);
            switch(n){
                case 0:
                    l.lineTo(d.nt * a, d.st * o);
                    break;
                case 1:
                    l.lineTo(d.nt * a, i[h - 1].st * o), s !== u && (e(s, d), l.lineTo(d.nt * a, i[h - 1].st * o)), l.lineTo(d.nt * a, d.st * o);
                    break;
                case 2:
                    {
                        const [t, n] = $a1a4d31e28ce1f0d$var$Mt(i, h - 1, h);
                        l.bezierCurveTo(t.nt * a, t.st * o, n.nt * a, n.st * o, d.nt * a, d.st * o);
                        break;
                    }
            }
            1 !== n && s !== u && (e(s, d), l.moveTo(d.nt * a, d.st * o));
        }
        (c !== d || c === d && 1 === n) && h(t, u, c, d);
    }
}
const $a1a4d31e28ce1f0d$var$bt = 6;
function $a1a4d31e28ce1f0d$var$wt(t, i) {
    return {
        nt: t.nt - i.nt,
        st: t.st - i.st
    };
}
function $a1a4d31e28ce1f0d$var$gt(t, i) {
    return {
        nt: t.nt / i,
        st: t.st / i
    };
}
function $a1a4d31e28ce1f0d$var$Mt(t, i, n) {
    const s = Math.max(0, i - 1), e = Math.min(t.length - 1, n + 1);
    var r, h;
    return [
        (r = t[i], h = $a1a4d31e28ce1f0d$var$gt($a1a4d31e28ce1f0d$var$wt(t[n], t[s]), $a1a4d31e28ce1f0d$var$bt), {
            nt: r.nt + h.nt,
            st: r.st + h.st
        }),
        $a1a4d31e28ce1f0d$var$wt(t[n], $a1a4d31e28ce1f0d$var$gt($a1a4d31e28ce1f0d$var$wt(t[e], t[i]), $a1a4d31e28ce1f0d$var$bt))
    ];
}
function $a1a4d31e28ce1f0d$var$xt(t, i, n, s, e) {
    const { context: r, horizontalPixelRatio: h, verticalPixelRatio: l } = i;
    r.lineTo(e.nt * h, t * l), r.lineTo(s.nt * h, t * l), r.closePath(), r.fillStyle = n, r.fill();
}
class $a1a4d31e28ce1f0d$var$St extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.G = null;
    }
    J(t) {
        this.G = t;
    }
    K(t) {
        var i;
        if (null === this.G) return;
        const { it: n, tt: s, ds: e, et: r, Nt: h, fs: l } = this.G, a = null !== (i = this.G.vs) && void 0 !== i ? i : this.G.ps ? 0 : t.mediaSize.height;
        if (null === s) return;
        const o = t.context;
        o.lineCap = "butt", o.lineJoin = "round", o.lineWidth = r, $a1a4d31e28ce1f0d$var$f(o, h), o.lineWidth = 1, $a1a4d31e28ce1f0d$var$mt(t, n, l, s, e, this.bs.bind(this), $a1a4d31e28ce1f0d$var$xt.bind(null, a));
    }
}
function $a1a4d31e28ce1f0d$var$kt(t, i, n) {
    return Math.min(Math.max(t, i), n);
}
function $a1a4d31e28ce1f0d$var$yt(t, i, n) {
    return i - t <= n;
}
function $a1a4d31e28ce1f0d$var$Ct(t) {
    const i = Math.ceil(t);
    return i % 2 == 0 ? i - 1 : i;
}
class $a1a4d31e28ce1f0d$var$Tt {
    ws(t, i) {
        const n = this.gs, { Ms: s, xs: e, Ss: r, ks: h, ys: l, vs: a } = i;
        if (void 0 === this.Cs || void 0 === n || n.Ms !== s || n.xs !== e || n.Ss !== r || n.ks !== h || n.vs !== a || n.ys !== l) {
            const n = t.context.createLinearGradient(0, 0, 0, l);
            if (n.addColorStop(0, s), null != a) {
                const i = $a1a4d31e28ce1f0d$var$kt(a * t.verticalPixelRatio / l, 0, 1);
                n.addColorStop(i, e), n.addColorStop(i, r);
            }
            n.addColorStop(1, h), this.Cs = n, this.gs = i;
        }
        return this.Cs;
    }
}
class $a1a4d31e28ce1f0d$var$Pt extends $a1a4d31e28ce1f0d$var$St {
    constructor(){
        super(...arguments), this.Ts = new $a1a4d31e28ce1f0d$var$Tt;
    }
    bs(t, i) {
        return this.Ts.ws(t, {
            Ms: i.Ps,
            xs: "",
            Ss: "",
            ks: i.Rs,
            ys: t.bitmapSize.height
        });
    }
}
function $a1a4d31e28ce1f0d$var$Rt(t, i) {
    const n = t.context;
    n.strokeStyle = i, n.stroke();
}
class $a1a4d31e28ce1f0d$var$Dt extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.G = null;
    }
    J(t) {
        this.G = t;
    }
    K(t) {
        if (null === this.G) return;
        const { it: i, tt: n, ds: s, fs: e, et: r, Nt: h, Ds: l } = this.G;
        if (null === n) return;
        const a = t.context;
        a.lineCap = "butt", a.lineWidth = r * t.verticalPixelRatio, $a1a4d31e28ce1f0d$var$f(a, h), a.lineJoin = "round";
        const o = this.Vs.bind(this);
        void 0 !== e && $a1a4d31e28ce1f0d$var$mt(t, i, e, n, s, o, $a1a4d31e28ce1f0d$var$Rt), l && function(t, i, n, s, e) {
            const { horizontalPixelRatio: r, verticalPixelRatio: h, context: l } = t;
            let a = null;
            const o = Math.max(1, Math.floor(r)) % 2 / 2, _ = n * h + o;
            for(let n = s.to - 1; n >= s.from; --n){
                const s = i[n];
                if (s) {
                    const i = e(t, s);
                    i !== a && (l.beginPath(), null !== a && l.fill(), l.fillStyle = i, a = i);
                    const n = Math.round(s.nt * r) + o, u = s.st * h;
                    l.moveTo(n, u), l.arc(n, u, _, 0, 2 * Math.PI);
                }
            }
            l.fill();
        }(t, i, l, n, o);
    }
}
class $a1a4d31e28ce1f0d$var$Vt extends $a1a4d31e28ce1f0d$var$Dt {
    Vs(t, i) {
        return i.lt;
    }
}
function $a1a4d31e28ce1f0d$var$Ot(t, i, n, s, e = 0, r = i.length) {
    let h = r - e;
    for(; 0 < h;){
        const r = h >> 1, l = e + r;
        s(i[l], n) === t ? (e = l + 1, h -= r + 1) : h = r;
    }
    return e;
}
const $a1a4d31e28ce1f0d$var$Bt = $a1a4d31e28ce1f0d$var$Ot.bind(null, !0), $a1a4d31e28ce1f0d$var$At = $a1a4d31e28ce1f0d$var$Ot.bind(null, !1);
function $a1a4d31e28ce1f0d$var$It(t, i) {
    return t.ot < i;
}
function $a1a4d31e28ce1f0d$var$zt(t, i) {
    return i < t.ot;
}
function $a1a4d31e28ce1f0d$var$Lt(t, i, n) {
    const s = i.Os(), e = i.ui(), r = $a1a4d31e28ce1f0d$var$Bt(t, s, $a1a4d31e28ce1f0d$var$It), h = $a1a4d31e28ce1f0d$var$At(t, e, $a1a4d31e28ce1f0d$var$zt);
    if (!n) return {
        from: r,
        to: h
    };
    let l = r, a = h;
    return r > 0 && r < t.length && t[r].ot >= s && (l = r - 1), h > 0 && h < t.length && t[h - 1].ot <= e && (a = h + 1), {
        from: l,
        to: a
    };
}
class $a1a4d31e28ce1f0d$var$Et {
    constructor(t, i, n){
        this.Bs = !0, this.As = !0, this.Is = !0, this.zs = [], this.Ls = null, this.Es = t, this.Ns = i, this.Fs = n;
    }
    bt(t) {
        this.Bs = !0, "data" === t && (this.As = !0), "options" === t && (this.Is = !0);
    }
    gt() {
        return this.Es.yt() ? (this.Ws(), null === this.Ls ? null : this.js) : null;
    }
    Hs() {
        this.zs = this.zs.map((t)=>Object.assign(Object.assign({}, t), this.Es.Us().$s(t.ot)));
    }
    qs() {
        this.Ls = null;
    }
    Ws() {
        this.As && (this.Ys(), this.As = !1), this.Is && (this.Hs(), this.Is = !1), this.Bs && (this.Zs(), this.Bs = !1);
    }
    Zs() {
        const t = this.Es.Dt(), i = this.Ns.St();
        if (this.qs(), i.Ni() || t.Ni()) return;
        const n = i.Xs();
        if (null === n) return;
        if (0 === this.Es.In().Ks()) return;
        const s = this.Es.Ct();
        null !== s && (this.Ls = $a1a4d31e28ce1f0d$var$Lt(this.zs, n, this.Fs), this.Gs(t, i, s.Vt), this.Js());
    }
}
class $a1a4d31e28ce1f0d$var$Nt extends $a1a4d31e28ce1f0d$var$Et {
    constructor(t, i){
        super(t, i, !0);
    }
    Gs(t, i, n) {
        i.Qs(this.zs, $a1a4d31e28ce1f0d$var$E(this.Ls)), t.te(this.zs, n, $a1a4d31e28ce1f0d$var$E(this.Ls));
    }
    ie(t, i) {
        return {
            ot: t,
            _t: i,
            nt: NaN,
            st: NaN
        };
    }
    Ys() {
        const t = this.Es.Us();
        this.zs = this.Es.In().ne().map((i)=>{
            const n = i.Vt[3];
            return this.se(i.ee, n, t);
        });
    }
}
class $a1a4d31e28ce1f0d$var$Ft extends $a1a4d31e28ce1f0d$var$Nt {
    constructor(t, i){
        super(t, i), this.js = new $a1a4d31e28ce1f0d$var$j, this.re = new $a1a4d31e28ce1f0d$var$Pt, this.he = new $a1a4d31e28ce1f0d$var$Vt, this.js.Z([
            this.re,
            this.he
        ]);
    }
    se(t, i, n) {
        return Object.assign(Object.assign({}, this.ie(t, i)), n.$s(t));
    }
    Js() {
        const t = this.Es.W();
        this.re.J({
            fs: t.lineType,
            it: this.zs,
            Nt: t.lineStyle,
            et: t.lineWidth,
            vs: null,
            ps: t.invertFilledArea,
            tt: this.Ls,
            ds: this.Ns.St().le()
        }), this.he.J({
            fs: t.lineVisible ? t.lineType : void 0,
            it: this.zs,
            Nt: t.lineStyle,
            et: t.lineWidth,
            tt: this.Ls,
            ds: this.Ns.St().le(),
            Ds: t.pointMarkersVisible ? t.pointMarkersRadius || t.lineWidth / 2 + 2 : void 0
        });
    }
}
class $a1a4d31e28ce1f0d$var$Wt extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.zt = null, this.ae = 0, this.oe = 0;
    }
    J(t) {
        this.zt = t;
    }
    K({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.zt || 0 === this.zt.In.length || null === this.zt.tt) return;
        if (this.ae = this._e(i), this.ae >= 2) Math.max(1, Math.floor(i)) % 2 != this.ae % 2 && this.ae--;
        this.oe = this.zt.ue ? Math.min(this.ae, Math.floor(i)) : this.ae;
        let s = null;
        const e = this.oe <= this.ae && this.zt.le >= Math.floor(1.5 * i);
        for(let r = this.zt.tt.from; r < this.zt.tt.to; ++r){
            const h = this.zt.In[r];
            s !== h.ce && (t.fillStyle = h.ce, s = h.ce);
            const l = Math.floor(.5 * this.oe), a = Math.round(h.nt * i), o = a - l, _ = this.oe, u = o + _ - 1, c = Math.min(h.de, h.fe), d = Math.max(h.de, h.fe), f = Math.round(c * n) - l, v = Math.round(d * n) + l, p = Math.max(v - f, this.oe);
            t.fillRect(o, f, _, p);
            const m = Math.ceil(1.5 * this.ae);
            if (e) {
                if (this.zt.ve) {
                    const i = a - m;
                    let s = Math.max(f, Math.round(h.pe * n) - l), e = s + _ - 1;
                    e > f + p - 1 && (e = f + p - 1, s = e - _ + 1), t.fillRect(i, s, o - i, e - s + 1);
                }
                const i = a + m;
                let s = Math.max(f, Math.round(h.me * n) - l), e = s + _ - 1;
                e > f + p - 1 && (e = f + p - 1, s = e - _ + 1), t.fillRect(u + 1, s, i - u, e - s + 1);
            }
        }
    }
    _e(t) {
        const i = Math.floor(t);
        return Math.max(i, Math.floor(function(t, i) {
            return Math.floor(.3 * t * i);
        }($a1a4d31e28ce1f0d$var$b(this.zt).le, t)));
    }
}
class $a1a4d31e28ce1f0d$var$jt extends $a1a4d31e28ce1f0d$var$Et {
    constructor(t, i){
        super(t, i, !1);
    }
    Gs(t, i, n) {
        i.Qs(this.zs, $a1a4d31e28ce1f0d$var$E(this.Ls)), t.be(this.zs, n, $a1a4d31e28ce1f0d$var$E(this.Ls));
    }
    we(t, i, n) {
        return {
            ot: t,
            ge: i.Vt[0],
            Me: i.Vt[1],
            xe: i.Vt[2],
            Se: i.Vt[3],
            nt: NaN,
            pe: NaN,
            de: NaN,
            fe: NaN,
            me: NaN
        };
    }
    Ys() {
        const t = this.Es.Us();
        this.zs = this.Es.In().ne().map((i)=>this.se(i.ee, i, t));
    }
}
class $a1a4d31e28ce1f0d$var$Ht extends $a1a4d31e28ce1f0d$var$jt {
    constructor(){
        super(...arguments), this.js = new $a1a4d31e28ce1f0d$var$Wt;
    }
    se(t, i, n) {
        return Object.assign(Object.assign({}, this.we(t, i, n)), n.$s(t));
    }
    Js() {
        const t = this.Es.W();
        this.js.J({
            In: this.zs,
            le: this.Ns.St().le(),
            ve: t.openVisible,
            ue: t.thinBars,
            tt: this.Ls
        });
    }
}
class $a1a4d31e28ce1f0d$var$$t extends $a1a4d31e28ce1f0d$var$St {
    constructor(){
        super(...arguments), this.Ts = new $a1a4d31e28ce1f0d$var$Tt;
    }
    bs(t, i) {
        const n = this.G;
        return this.Ts.ws(t, {
            Ms: i.ke,
            xs: i.ye,
            Ss: i.Ce,
            ks: i.Te,
            ys: t.bitmapSize.height,
            vs: n.vs
        });
    }
}
class $a1a4d31e28ce1f0d$var$Ut extends $a1a4d31e28ce1f0d$var$Dt {
    constructor(){
        super(...arguments), this.Pe = new $a1a4d31e28ce1f0d$var$Tt;
    }
    Vs(t, i) {
        const n = this.G;
        return this.Pe.ws(t, {
            Ms: i.Re,
            xs: i.Re,
            Ss: i.De,
            ks: i.De,
            ys: t.bitmapSize.height,
            vs: n.vs
        });
    }
}
class $a1a4d31e28ce1f0d$var$qt extends $a1a4d31e28ce1f0d$var$Nt {
    constructor(t, i){
        super(t, i), this.js = new $a1a4d31e28ce1f0d$var$j, this.Ve = new $a1a4d31e28ce1f0d$var$$t, this.Oe = new $a1a4d31e28ce1f0d$var$Ut, this.js.Z([
            this.Ve,
            this.Oe
        ]);
    }
    se(t, i, n) {
        return Object.assign(Object.assign({}, this.ie(t, i)), n.$s(t));
    }
    Js() {
        const t = this.Es.Ct();
        if (null === t) return;
        const i = this.Es.W(), n = this.Es.Dt().Rt(i.baseValue.price, t.Vt), s = this.Ns.St().le();
        this.Ve.J({
            it: this.zs,
            et: i.lineWidth,
            Nt: i.lineStyle,
            fs: i.lineType,
            vs: n,
            ps: !1,
            tt: this.Ls,
            ds: s
        }), this.Oe.J({
            it: this.zs,
            et: i.lineWidth,
            Nt: i.lineStyle,
            fs: i.lineVisible ? i.lineType : void 0,
            Ds: i.pointMarkersVisible ? i.pointMarkersRadius || i.lineWidth / 2 + 2 : void 0,
            vs: n,
            tt: this.Ls,
            ds: s
        });
    }
}
class $a1a4d31e28ce1f0d$var$Yt extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.zt = null, this.ae = 0;
    }
    J(t) {
        this.zt = t;
    }
    K(t) {
        if (null === this.zt || 0 === this.zt.In.length || null === this.zt.tt) return;
        const { horizontalPixelRatio: i } = t;
        if (this.ae = function(t, i) {
            if (t >= 2.5 && t <= 4) return Math.floor(3 * i);
            const n = 1 - .2 * Math.atan(Math.max(4, t) - 4) / (.5 * Math.PI), s = Math.floor(t * n * i), e = Math.floor(t * i), r = Math.min(s, e);
            return Math.max(Math.floor(i), r);
        }(this.zt.le, i), this.ae >= 2) Math.floor(i) % 2 != this.ae % 2 && this.ae--;
        const n = this.zt.In;
        this.zt.Be && this.Ae(t, n, this.zt.tt), this.zt._i && this.Ie(t, n, this.zt.tt);
        const s = this.ze(i);
        (!this.zt._i || this.ae > 2 * s) && this.Le(t, n, this.zt.tt);
    }
    Ae(t, i, n) {
        if (null === this.zt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "", l = Math.min(Math.floor(e), Math.floor(this.zt.le * e));
        l = Math.max(Math.floor(e), Math.min(l, this.ae));
        const a = Math.floor(.5 * l);
        let o = null;
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            n.Ee !== h && (s.fillStyle = n.Ee, h = n.Ee);
            const _ = Math.round(Math.min(n.pe, n.me) * r), u = Math.round(Math.max(n.pe, n.me) * r), c = Math.round(n.de * r), d = Math.round(n.fe * r);
            let f = Math.round(e * n.nt) - a;
            const v = f + l - 1;
            null !== o && (f = Math.max(o + 1, f), f = Math.min(f, v));
            const p = v - f + 1;
            s.fillRect(f, c, p, _ - c), s.fillRect(f, u + 1, p, d - u), o = v;
        }
    }
    ze(t) {
        let i = Math.floor(1 * t);
        this.ae <= 2 * i && (i = Math.floor(.5 * (this.ae - 1)));
        const n = Math.max(Math.floor(t), i);
        return this.ae <= 2 * n ? Math.max(Math.floor(t), Math.floor(1 * t)) : n;
    }
    Ie(t, i, n) {
        if (null === this.zt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "";
        const l = this.ze(e);
        let a = null;
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            n.Ne !== h && (s.fillStyle = n.Ne, h = n.Ne);
            let o = Math.round(n.nt * e) - Math.floor(.5 * this.ae);
            const _ = o + this.ae - 1, u = Math.round(Math.min(n.pe, n.me) * r), c = Math.round(Math.max(n.pe, n.me) * r);
            if (null !== a && (o = Math.max(a + 1, o), o = Math.min(o, _)), this.zt.le * e > 2 * l) $a1a4d31e28ce1f0d$var$K(s, o, u, _ - o + 1, c - u + 1, l);
            else {
                const t = _ - o + 1;
                s.fillRect(o, u, t, c - u + 1);
            }
            a = _;
        }
    }
    Le(t, i, n) {
        if (null === this.zt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "";
        const l = this.ze(e);
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            let a = Math.round(Math.min(n.pe, n.me) * r), o = Math.round(Math.max(n.pe, n.me) * r), _ = Math.round(n.nt * e) - Math.floor(.5 * this.ae), u = _ + this.ae - 1;
            if (n.ce !== h) {
                const t = n.ce;
                s.fillStyle = t, h = t;
            }
            this.zt._i && (_ += l, a += l, u -= l, o -= l), a > o || s.fillRect(_, a, u - _ + 1, o - a + 1);
        }
    }
}
class $a1a4d31e28ce1f0d$var$Zt extends $a1a4d31e28ce1f0d$var$jt {
    constructor(){
        super(...arguments), this.js = new $a1a4d31e28ce1f0d$var$Yt;
    }
    se(t, i, n) {
        return Object.assign(Object.assign({}, this.we(t, i, n)), n.$s(t));
    }
    Js() {
        const t = this.Es.W();
        this.js.J({
            In: this.zs,
            le: this.Ns.St().le(),
            Be: t.wickVisible,
            _i: t.borderVisible,
            tt: this.Ls
        });
    }
}
class $a1a4d31e28ce1f0d$var$Xt {
    constructor(t, i){
        this.Fe = t, this.Li = i;
    }
    X(t, i, n) {
        this.Fe.draw(t, this.Li, i, n);
    }
}
class $a1a4d31e28ce1f0d$var$Kt extends $a1a4d31e28ce1f0d$var$Et {
    constructor(t, i, n){
        super(t, i, !1), this.wn = n, this.js = new $a1a4d31e28ce1f0d$var$Xt(this.wn.renderer(), (i)=>{
            const n = t.Ct();
            return null === n ? null : t.Dt().Rt(i, n.Vt);
        });
    }
    We(t) {
        return this.wn.priceValueBuilder(t);
    }
    je(t) {
        return this.wn.isWhitespace(t);
    }
    Ys() {
        const t = this.Es.Us();
        this.zs = this.Es.In().ne().map((i)=>Object.assign(Object.assign({
                ot: i.ee,
                nt: NaN
            }, t.$s(i.ee)), {
                He: i.$e
            }));
    }
    Gs(t, i) {
        i.Qs(this.zs, $a1a4d31e28ce1f0d$var$E(this.Ls));
    }
    Js() {
        this.wn.update({
            bars: this.zs.map($a1a4d31e28ce1f0d$var$Gt),
            barSpacing: this.Ns.St().le(),
            visibleRange: this.Ls
        }, this.Es.W());
    }
}
function $a1a4d31e28ce1f0d$var$Gt(t) {
    return {
        x: t.nt,
        time: t.ot,
        originalData: t.He,
        barColor: t.ce
    };
}
class $a1a4d31e28ce1f0d$var$Jt extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.zt = null, this.Ue = [];
    }
    J(t) {
        this.zt = t, this.Ue = [];
    }
    K({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.zt || 0 === this.zt.it.length || null === this.zt.tt) return;
        this.Ue.length || this.qe(i);
        const s = Math.max(1, Math.floor(n)), e = Math.round(this.zt.Ye * n) - Math.floor(s / 2), r = e + s;
        for(let i = this.zt.tt.from; i < this.zt.tt.to; i++){
            const h = this.zt.it[i], l = this.Ue[i - this.zt.tt.from], a = Math.round(h.st * n);
            let o, _;
            t.fillStyle = h.ce, a <= e ? (o = a, _ = r) : (o = e, _ = a - Math.floor(s / 2) + s), t.fillRect(l.Os, o, l.ui - l.Os + 1, _ - o);
        }
    }
    qe(t) {
        if (null === this.zt || 0 === this.zt.it.length || null === this.zt.tt) return void (this.Ue = []);
        const i = Math.ceil(this.zt.le * t) <= 1 ? 0 : Math.max(1, Math.floor(t)), n = Math.round(this.zt.le * t) - i;
        this.Ue = new Array(this.zt.tt.to - this.zt.tt.from);
        for(let i = this.zt.tt.from; i < this.zt.tt.to; i++){
            const s = this.zt.it[i], e = Math.round(s.nt * t);
            let r, h;
            if (n % 2) {
                const t = (n - 1) / 2;
                r = e - t, h = e + t;
            } else {
                const t = n / 2;
                r = e - t, h = e + t - 1;
            }
            this.Ue[i - this.zt.tt.from] = {
                Os: r,
                ui: h,
                Ze: e,
                Xe: s.nt * t,
                ot: s.ot
            };
        }
        for(let t = this.zt.tt.from + 1; t < this.zt.tt.to; t++){
            const n = this.Ue[t - this.zt.tt.from], s = this.Ue[t - this.zt.tt.from - 1];
            n.ot === s.ot + 1 && n.Os - s.ui !== i + 1 && (s.Ze > s.Xe ? s.ui = n.Os - i - 1 : n.Os = s.ui + i + 1);
        }
        let s = Math.ceil(this.zt.le * t);
        for(let t = this.zt.tt.from; t < this.zt.tt.to; t++){
            const i = this.Ue[t - this.zt.tt.from];
            i.ui < i.Os && (i.ui = i.Os);
            const n = i.ui - i.Os + 1;
            s = Math.min(n, s);
        }
        if (i > 0 && s < 4) for(let t = this.zt.tt.from; t < this.zt.tt.to; t++){
            const i = this.Ue[t - this.zt.tt.from];
            i.ui - i.Os + 1 > s && (i.Ze > i.Xe ? i.ui -= 1 : i.Os += 1);
        }
    }
}
class $a1a4d31e28ce1f0d$var$Qt extends $a1a4d31e28ce1f0d$var$Nt {
    constructor(){
        super(...arguments), this.js = new $a1a4d31e28ce1f0d$var$Jt;
    }
    se(t, i, n) {
        return Object.assign(Object.assign({}, this.ie(t, i)), n.$s(t));
    }
    Js() {
        const t = {
            it: this.zs,
            le: this.Ns.St().le(),
            tt: this.Ls,
            Ye: this.Es.Dt().Rt(this.Es.W().base, $a1a4d31e28ce1f0d$var$b(this.Es.Ct()).Vt)
        };
        this.js.J(t);
    }
}
class $a1a4d31e28ce1f0d$var$ti extends $a1a4d31e28ce1f0d$var$Nt {
    constructor(){
        super(...arguments), this.js = new $a1a4d31e28ce1f0d$var$Vt;
    }
    se(t, i, n) {
        return Object.assign(Object.assign({}, this.ie(t, i)), n.$s(t));
    }
    Js() {
        const t = this.Es.W(), i = {
            it: this.zs,
            Nt: t.lineStyle,
            fs: t.lineVisible ? t.lineType : void 0,
            et: t.lineWidth,
            Ds: t.pointMarkersVisible ? t.pointMarkersRadius || t.lineWidth / 2 + 2 : void 0,
            tt: this.Ls,
            ds: this.Ns.St().le()
        };
        this.js.J(i);
    }
}
const $a1a4d31e28ce1f0d$var$ii = /[2-9]/g;
class $a1a4d31e28ce1f0d$var$ni {
    constructor(t = 50){
        this.Ke = 0, this.Ge = 1, this.Je = 1, this.Qe = {}, this.tr = new Map, this.ir = t;
    }
    nr() {
        this.Ke = 0, this.tr.clear(), this.Ge = 1, this.Je = 1, this.Qe = {};
    }
    xi(t, i, n) {
        return this.sr(t, i, n).width;
    }
    Mi(t, i, n) {
        const s = this.sr(t, i, n);
        return ((s.actualBoundingBoxAscent || 0) - (s.actualBoundingBoxDescent || 0)) / 2;
    }
    sr(t, i, n) {
        const s = n || $a1a4d31e28ce1f0d$var$ii, e = String(i).replace(s, "0");
        if (this.tr.has(e)) return $a1a4d31e28ce1f0d$var$m(this.tr.get(e)).er;
        if (this.Ke === this.ir) {
            const t = this.Qe[this.Je];
            delete this.Qe[this.Je], this.tr.delete(t), this.Je++, this.Ke--;
        }
        t.save(), t.textBaseline = "middle";
        const r = t.measureText(e);
        return t.restore(), 0 === r.width && i.length || (this.tr.set(e, {
            er: r,
            rr: this.Ge
        }), this.Qe[this.Ge] = e, this.Ke++, this.Ge++), r;
    }
}
class $a1a4d31e28ce1f0d$var$si {
    constructor(t){
        this.hr = null, this.k = null, this.lr = "right", this.ar = t;
    }
    _r(t, i, n) {
        this.hr = t, this.k = i, this.lr = n;
    }
    X(t) {
        null !== this.k && null !== this.hr && this.hr.X(t, this.k, this.ar, this.lr);
    }
}
class $a1a4d31e28ce1f0d$var$ei {
    constructor(t, i, n){
        this.ur = t, this.ar = new $a1a4d31e28ce1f0d$var$ni(50), this.cr = i, this.F = n, this.j = -1, this.Wt = new $a1a4d31e28ce1f0d$var$si(this.ar);
    }
    gt() {
        const t = this.F.dr(this.cr);
        if (null === t) return null;
        const i = t.vr(this.cr) ? t.pr() : this.cr.Dt();
        if (null === i) return null;
        const n = t.mr(i);
        if ("overlay" === n) return null;
        const s = this.F.br();
        return s.P !== this.j && (this.j = s.P, this.ar.nr()), this.Wt._r(this.ur.Ii(), s, n), this.Wt;
    }
}
class $a1a4d31e28ce1f0d$var$ri extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.zt = null;
    }
    J(t) {
        this.zt = t;
    }
    wr(t, i) {
        var n;
        if (!(null === (n = this.zt) || void 0 === n ? void 0 : n.yt)) return null;
        const { st: s, et: e, gr: r } = this.zt;
        return i >= s - e - 7 && i <= s + e + 7 ? {
            Mr: this.zt,
            gr: r
        } : null;
    }
    K({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.zt) return;
        if (!1 === this.zt.yt) return;
        const e = Math.round(this.zt.st * s);
        e < 0 || e > i.height || (t.lineCap = "butt", t.strokeStyle = this.zt.V, t.lineWidth = Math.floor(this.zt.et * n), $a1a4d31e28ce1f0d$var$f(t, this.zt.Nt), $a1a4d31e28ce1f0d$var$v(t, e, 0, i.width));
    }
}
class $a1a4d31e28ce1f0d$var$hi {
    constructor(t){
        this.Sr = {
            st: 0,
            V: "rgba(0, 0, 0, 0)",
            et: 1,
            Nt: 0,
            yt: !1
        }, this.kr = new $a1a4d31e28ce1f0d$var$ri, this.ft = !0, this.Es = t, this.Ns = t.$t(), this.kr.J(this.Sr);
    }
    bt() {
        this.ft = !0;
    }
    gt() {
        return this.Es.yt() ? (this.ft && (this.yr(), this.ft = !1), this.kr) : null;
    }
}
class $a1a4d31e28ce1f0d$var$li extends $a1a4d31e28ce1f0d$var$hi {
    constructor(t){
        super(t);
    }
    yr() {
        this.Sr.yt = !1;
        const t = this.Es.Dt(), i = t.Cr().Cr;
        if (2 !== i && 3 !== i) return;
        const n = this.Es.W();
        if (!n.baseLineVisible || !this.Es.yt()) return;
        const s = this.Es.Ct();
        null !== s && (this.Sr.yt = !0, this.Sr.st = t.Rt(s.Vt, s.Vt), this.Sr.V = n.baseLineColor, this.Sr.et = n.baseLineWidth, this.Sr.Nt = n.baseLineStyle);
    }
}
class $a1a4d31e28ce1f0d$var$ai extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.zt = null;
    }
    J(t) {
        this.zt = t;
    }
    $e() {
        return this.zt;
    }
    K({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        const s = this.zt;
        if (null === s) return;
        const e = Math.max(1, Math.floor(i)), r = e % 2 / 2, h = Math.round(s.Xe.x * i) + r, l = s.Xe.y * n;
        t.fillStyle = s.Tr, t.beginPath();
        const a = Math.max(2, 1.5 * s.Pr) * i;
        t.arc(h, l, a, 0, 2 * Math.PI, !1), t.fill(), t.fillStyle = s.Rr, t.beginPath(), t.arc(h, l, s.ht * i, 0, 2 * Math.PI, !1), t.fill(), t.lineWidth = e, t.strokeStyle = s.Dr, t.beginPath(), t.arc(h, l, s.ht * i + e / 2, 0, 2 * Math.PI, !1), t.stroke();
    }
}
const $a1a4d31e28ce1f0d$var$oi = [
    {
        Vr: 0,
        Or: .25,
        Br: 4,
        Ar: 10,
        Ir: .25,
        zr: 0,
        Lr: .4,
        Er: .8
    },
    {
        Vr: .25,
        Or: .525,
        Br: 10,
        Ar: 14,
        Ir: 0,
        zr: 0,
        Lr: .8,
        Er: 0
    },
    {
        Vr: .525,
        Or: 1,
        Br: 14,
        Ar: 14,
        Ir: 0,
        zr: 0,
        Lr: 0,
        Er: 0
    }
];
function $a1a4d31e28ce1f0d$var$_i(t, i, n, s) {
    return function(t, i) {
        if ("transparent" === t) return t;
        const n = $a1a4d31e28ce1f0d$var$T(t), s = n[3];
        return `rgba(${n[0]}, ${n[1]}, ${n[2]}, ${i * s})`;
    }(t, n + (s - n) * i);
}
function $a1a4d31e28ce1f0d$var$ui(t, i) {
    const n = t % 2600 / 2600;
    let s;
    for (const t of $a1a4d31e28ce1f0d$var$oi)if (n >= t.Vr && n <= t.Or) {
        s = t;
        break;
    }
    $a1a4d31e28ce1f0d$var$p(void 0 !== s, "Last price animation internal logic error");
    const e = (n - s.Vr) / (s.Or - s.Vr);
    var r, h, l;
    return {
        Rr: $a1a4d31e28ce1f0d$var$_i(i, e, s.Ir, s.zr),
        Dr: $a1a4d31e28ce1f0d$var$_i(i, e, s.Lr, s.Er),
        ht: (r = e, h = s.Br, l = s.Ar, h + (l - h) * r)
    };
}
class $a1a4d31e28ce1f0d$var$ci {
    constructor(t){
        this.Wt = new $a1a4d31e28ce1f0d$var$ai, this.ft = !0, this.Nr = !0, this.Fr = performance.now(), this.Wr = this.Fr - 1, this.jr = t;
    }
    Hr() {
        this.Wr = this.Fr - 1, this.bt();
    }
    $r() {
        if (this.bt(), 2 === this.jr.W().lastPriceAnimation) {
            const t = performance.now(), i = this.Wr - t;
            if (i > 0) return void (i < 650 && (this.Wr += 2600));
            this.Fr = t, this.Wr = t + 2600;
        }
    }
    bt() {
        this.ft = !0;
    }
    Ur() {
        this.Nr = !0;
    }
    yt() {
        return 0 !== this.jr.W().lastPriceAnimation;
    }
    qr() {
        switch(this.jr.W().lastPriceAnimation){
            case 0:
                return !1;
            case 1:
                return !0;
            case 2:
                return performance.now() <= this.Wr;
        }
    }
    gt() {
        return this.ft ? (this.Mt(), this.ft = !1, this.Nr = !1) : this.Nr && (this.Yr(), this.Nr = !1), this.Wt;
    }
    Mt() {
        this.Wt.J(null);
        const t = this.jr.$t().St(), i = t.Xs(), n = this.jr.Ct();
        if (null === i || null === n) return;
        const s = this.jr.Zr(!0);
        if (s.Xr || !i.Kr(s.ee)) return;
        const e = {
            x: t.It(s.ee),
            y: this.jr.Dt().Rt(s._t, n.Vt)
        }, r = s.V, h = this.jr.W().lineWidth, l = $a1a4d31e28ce1f0d$var$ui(this.Gr(), r);
        this.Wt.J({
            Tr: r,
            Pr: h,
            Rr: l.Rr,
            Dr: l.Dr,
            ht: l.ht,
            Xe: e
        });
    }
    Yr() {
        const t = this.Wt.$e();
        if (null !== t) {
            const i = $a1a4d31e28ce1f0d$var$ui(this.Gr(), t.Tr);
            t.Rr = i.Rr, t.Dr = i.Dr, t.ht = i.ht;
        }
    }
    Gr() {
        return this.qr() ? performance.now() - this.Fr : 2599;
    }
}
function $a1a4d31e28ce1f0d$var$di(t, i) {
    return $a1a4d31e28ce1f0d$var$Ct(Math.min(Math.max(t, 12), 30) * i);
}
function $a1a4d31e28ce1f0d$var$fi(t, i) {
    switch(t){
        case "arrowDown":
        case "arrowUp":
            return $a1a4d31e28ce1f0d$var$di(i, 1);
        case "circle":
            return $a1a4d31e28ce1f0d$var$di(i, .8);
        case "square":
            return $a1a4d31e28ce1f0d$var$di(i, .7);
    }
}
function $a1a4d31e28ce1f0d$var$vi(t) {
    return function(t) {
        const i = Math.ceil(t);
        return i % 2 != 0 ? i - 1 : i;
    }($a1a4d31e28ce1f0d$var$di(t, 1));
}
function $a1a4d31e28ce1f0d$var$pi(t) {
    return Math.max($a1a4d31e28ce1f0d$var$di(t, .1), 3);
}
function $a1a4d31e28ce1f0d$var$mi(t, i, n) {
    return i ? t : n ? Math.ceil(t / 2) : 0;
}
function $a1a4d31e28ce1f0d$var$bi(t, i, n, s, e) {
    const r = $a1a4d31e28ce1f0d$var$fi("square", n), h = (r - 1) / 2, l = t - h, a = i - h;
    return s >= l && s <= l + r && e >= a && e <= a + r;
}
function $a1a4d31e28ce1f0d$var$wi(t, i, n, s) {
    const e = ($a1a4d31e28ce1f0d$var$fi("arrowUp", s) - 1) / 2 * n.Jr, r = ($a1a4d31e28ce1f0d$var$Ct(s / 2) - 1) / 2 * n.Jr;
    i.beginPath(), t ? (i.moveTo(n.nt - e, n.st), i.lineTo(n.nt, n.st - e), i.lineTo(n.nt + e, n.st), i.lineTo(n.nt + r, n.st), i.lineTo(n.nt + r, n.st + e), i.lineTo(n.nt - r, n.st + e), i.lineTo(n.nt - r, n.st)) : (i.moveTo(n.nt - e, n.st), i.lineTo(n.nt, n.st + e), i.lineTo(n.nt + e, n.st), i.lineTo(n.nt + r, n.st), i.lineTo(n.nt + r, n.st - e), i.lineTo(n.nt - r, n.st - e), i.lineTo(n.nt - r, n.st)), i.fill();
}
function $a1a4d31e28ce1f0d$var$gi(t, i, n, s, e, r) {
    return $a1a4d31e28ce1f0d$var$bi(i, n, s, e, r);
}
class $a1a4d31e28ce1f0d$var$Mi extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.zt = null, this.ar = new $a1a4d31e28ce1f0d$var$ni, this.j = -1, this.H = "", this.Qr = "";
    }
    J(t) {
        this.zt = t;
    }
    _r(t, i) {
        this.j === t && this.H === i || (this.j = t, this.H = i, this.Qr = $a1a4d31e28ce1f0d$var$F(t, i), this.ar.nr());
    }
    wr(t, i) {
        if (null === this.zt || null === this.zt.tt) return null;
        for(let n = this.zt.tt.from; n < this.zt.tt.to; n++){
            const s = this.zt.it[n];
            if ($a1a4d31e28ce1f0d$var$Si(s, t, i)) return {
                Mr: s.th,
                gr: s.gr
            };
        }
        return null;
    }
    K({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }, s, e) {
        if (null !== this.zt && null !== this.zt.tt) {
            t.textBaseline = "middle", t.font = this.Qr;
            for(let s = this.zt.tt.from; s < this.zt.tt.to; s++){
                const e = this.zt.it[s];
                void 0 !== e.Kt && (e.Kt.Hi = this.ar.xi(t, e.Kt.ih), e.Kt.At = this.j, e.Kt.nt = e.nt - e.Kt.Hi / 2), $a1a4d31e28ce1f0d$var$xi(e, t, i, n);
            }
        }
    }
}
function $a1a4d31e28ce1f0d$var$xi(t, i, n, s) {
    i.fillStyle = t.V, void 0 !== t.Kt && function(t, i, n, s, e, r) {
        t.save(), t.scale(e, r), t.fillText(i, n, s), t.restore();
    }(i, t.Kt.ih, t.Kt.nt, t.Kt.st, n, s), function(t, i, n) {
        if (0 === t.Ks) return;
        switch(t.nh){
            case "arrowDown":
                return void $a1a4d31e28ce1f0d$var$wi(!1, i, n, t.Ks);
            case "arrowUp":
                return void $a1a4d31e28ce1f0d$var$wi(!0, i, n, t.Ks);
            case "circle":
                return void function(t, i, n) {
                    const s = ($a1a4d31e28ce1f0d$var$fi("circle", n) - 1) / 2;
                    t.beginPath(), t.arc(i.nt, i.st, s * i.Jr, 0, 2 * Math.PI, !1), t.fill();
                }(i, n, t.Ks);
            case "square":
                return void function(t, i, n) {
                    const s = $a1a4d31e28ce1f0d$var$fi("square", n), e = (s - 1) * i.Jr / 2, r = i.nt - e, h = i.st - e;
                    t.fillRect(r, h, s * i.Jr, s * i.Jr);
                }(i, n, t.Ks);
        }
        t.nh;
    }(t, i, function(t, i, n) {
        const s = Math.max(1, Math.floor(i)) % 2 / 2;
        return {
            nt: Math.round(t.nt * i) + s,
            st: t.st * n,
            Jr: i
        };
    }(t, n, s));
}
function $a1a4d31e28ce1f0d$var$Si(t, i, n) {
    return !(void 0 === t.Kt || !function(t, i, n, s, e, r) {
        const h = s / 2;
        return e >= t && e <= t + n && r >= i - h && r <= i + h;
    }(t.Kt.nt, t.Kt.st, t.Kt.Hi, t.Kt.At, i, n)) || function(t, i, n) {
        if (0 === t.Ks) return !1;
        switch(t.nh){
            case "arrowDown":
            case "arrowUp":
                return $a1a4d31e28ce1f0d$var$gi(0, t.nt, t.st, t.Ks, i, n);
            case "circle":
                return function(t, i, n, s, e) {
                    const r = 2 + $a1a4d31e28ce1f0d$var$fi("circle", n) / 2, h = t - s, l = i - e;
                    return Math.sqrt(h * h + l * l) <= r;
                }(t.nt, t.st, t.Ks, i, n);
            case "square":
                return $a1a4d31e28ce1f0d$var$bi(t.nt, t.st, t.Ks, i, n);
        }
    }(t, i, n);
}
function $a1a4d31e28ce1f0d$var$ki(t, i, n, s, e, r, h, l, a) {
    const o = $a1a4d31e28ce1f0d$var$O(n) ? n : n.Se, _ = $a1a4d31e28ce1f0d$var$O(n) ? n : n.Me, u = $a1a4d31e28ce1f0d$var$O(n) ? n : n.xe, c = $a1a4d31e28ce1f0d$var$O(i.size) ? Math.max(i.size, 0) : 1, d = $a1a4d31e28ce1f0d$var$vi(l.le()) * c, f = d / 2;
    switch(t.Ks = d, i.position){
        case "inBar":
            return t.st = h.Rt(o, a), void (void 0 !== t.Kt && (t.Kt.st = t.st + f + r + .6 * e));
        case "aboveBar":
            return t.st = h.Rt(_, a) - f - s.sh, void 0 !== t.Kt && (t.Kt.st = t.st - f - .6 * e, s.sh += 1.2 * e), void (s.sh += d + r);
        case "belowBar":
            return t.st = h.Rt(u, a) + f + s.eh, void 0 !== t.Kt && (t.Kt.st = t.st + f + r + .6 * e, s.eh += 1.2 * e), void (s.eh += d + r);
    }
    i.position;
}
class $a1a4d31e28ce1f0d$var$yi {
    constructor(t, i){
        this.ft = !0, this.rh = !0, this.hh = !0, this.ah = null, this.oh = null, this.Wt = new $a1a4d31e28ce1f0d$var$Mi, this.jr = t, this.$i = i, this.zt = {
            it: [],
            tt: null
        };
    }
    bt(t) {
        this.ft = !0, this.hh = !0, "data" === t && (this.rh = !0, this.oh = null);
    }
    gt(t) {
        if (!this.jr.yt()) return null;
        this.ft && this._h();
        const i = this.$i.W().layout;
        return this.Wt._r(i.fontSize, i.fontFamily), this.Wt.J(this.zt), this.Wt;
    }
    uh() {
        if (this.hh) {
            if (this.jr.dh().length > 0) {
                const t = this.$i.St().le(), i = $a1a4d31e28ce1f0d$var$pi(t), n = 1.5 * $a1a4d31e28ce1f0d$var$vi(t) + 2 * i, s = this.fh();
                this.ah = {
                    above: $a1a4d31e28ce1f0d$var$mi(n, s.aboveBar, s.inBar),
                    below: $a1a4d31e28ce1f0d$var$mi(n, s.belowBar, s.inBar)
                };
            } else this.ah = null;
            this.hh = !1;
        }
        return this.ah;
    }
    fh() {
        return null === this.oh && (this.oh = this.jr.dh().reduce((t, i)=>(t[i.position] || (t[i.position] = !0), t), {
            inBar: !1,
            aboveBar: !1,
            belowBar: !1
        })), this.oh;
    }
    _h() {
        const t = this.jr.Dt(), i = this.$i.St(), n = this.jr.dh();
        this.rh && (this.zt.it = n.map((t)=>({
                ot: t.time,
                nt: 0,
                st: 0,
                Ks: 0,
                nh: t.shape,
                V: t.color,
                th: t.th,
                gr: t.id,
                Kt: void 0
            })), this.rh = !1);
        const s = this.$i.W().layout;
        this.zt.tt = null;
        const e = i.Xs();
        if (null === e) return;
        const r = this.jr.Ct();
        if (null === r) return;
        if (0 === this.zt.it.length) return;
        let h = NaN;
        const l = $a1a4d31e28ce1f0d$var$pi(i.le()), a = {
            sh: l,
            eh: l
        };
        this.zt.tt = $a1a4d31e28ce1f0d$var$Lt(this.zt.it, e, !0);
        for(let e = this.zt.tt.from; e < this.zt.tt.to; e++){
            const o = n[e];
            o.time !== h && (a.sh = l, a.eh = l, h = o.time);
            const _ = this.zt.it[e];
            _.nt = i.It(o.time), void 0 !== o.text && o.text.length > 0 && (_.Kt = {
                ih: o.text,
                nt: 0,
                st: 0,
                Hi: 0,
                At: 0
            });
            const u = this.jr.ph(o.time);
            null !== u && $a1a4d31e28ce1f0d$var$ki(_, o, u, a, s.fontSize, l, t, i, r.Vt);
        }
        this.ft = !1;
    }
}
class $a1a4d31e28ce1f0d$var$Ci extends $a1a4d31e28ce1f0d$var$hi {
    constructor(t){
        super(t);
    }
    yr() {
        const t = this.Sr;
        t.yt = !1;
        const i = this.Es.W();
        if (!i.priceLineVisible || !this.Es.yt()) return;
        const n = this.Es.Zr(0 === i.priceLineSource);
        n.Xr || (t.yt = !0, t.st = n.ki, t.V = this.Es.mh(n.V), t.et = i.priceLineWidth, t.Nt = i.priceLineStyle);
    }
}
class $a1a4d31e28ce1f0d$var$Ti extends $a1a4d31e28ce1f0d$var$nt {
    constructor(t){
        super(), this.jt = t;
    }
    zi(t, i, n) {
        t.yt = !1, i.yt = !1;
        const s = this.jt;
        if (!s.yt()) return;
        const e = s.W(), r = e.lastValueVisible, h = "" !== s.bh(), l = 0 === e.seriesLastValueMode, a = s.Zr(!1);
        if (a.Xr) return;
        r && (t.Kt = this.wh(a, r, l), t.yt = 0 !== t.Kt.length), (h || l) && (i.Kt = this.gh(a, r, h, l), i.yt = i.Kt.length > 0);
        const o = s.mh(a.V), _ = $a1a4d31e28ce1f0d$var$R(o);
        n.t = _.t, n.ki = a.ki, i.Ot = s.$t().Bt(a.ki / s.Dt().At()), t.Ot = o, t.V = _.i, i.V = _.i;
    }
    gh(t, i, n, s) {
        let e = "";
        const r = this.jt.bh();
        return n && 0 !== r.length && (e += `${r} `), i && s && (e += this.jt.Dt().Mh() ? t.xh : t.Sh), e.trim();
    }
    wh(t, i, n) {
        return i ? n ? this.jt.Dt().Mh() ? t.Sh : t.xh : t.Kt : "";
    }
}
function $a1a4d31e28ce1f0d$var$Pi(t, i, n, s) {
    const e = Number.isFinite(i), r = Number.isFinite(n);
    return e && r ? t(i, n) : e || r ? e ? i : n : s;
}
class $a1a4d31e28ce1f0d$var$Ri {
    constructor(t, i){
        this.kh = t, this.yh = i;
    }
    Ch(t) {
        return null !== t && this.kh === t.kh && this.yh === t.yh;
    }
    Th() {
        return new $a1a4d31e28ce1f0d$var$Ri(this.kh, this.yh);
    }
    Ph() {
        return this.kh;
    }
    Rh() {
        return this.yh;
    }
    Dh() {
        return this.yh - this.kh;
    }
    Ni() {
        return this.yh === this.kh || Number.isNaN(this.yh) || Number.isNaN(this.kh);
    }
    ts(t) {
        return null === t ? this : new $a1a4d31e28ce1f0d$var$Ri($a1a4d31e28ce1f0d$var$Pi(Math.min, this.Ph(), t.Ph(), -1 / 0), $a1a4d31e28ce1f0d$var$Pi(Math.max, this.Rh(), t.Rh(), 1 / 0));
    }
    Vh(t) {
        if (!$a1a4d31e28ce1f0d$var$O(t)) return;
        if (0 === this.yh - this.kh) return;
        const i = .5 * (this.yh + this.kh);
        let n = this.yh - i, s = this.kh - i;
        n *= t, s *= t, this.yh = i + n, this.kh = i + s;
    }
    Oh(t) {
        $a1a4d31e28ce1f0d$var$O(t) && (this.yh += t, this.kh += t);
    }
    Bh() {
        return {
            minValue: this.kh,
            maxValue: this.yh
        };
    }
    static Ah(t) {
        return null === t ? null : new $a1a4d31e28ce1f0d$var$Ri(t.minValue, t.maxValue);
    }
}
class $a1a4d31e28ce1f0d$var$Di {
    constructor(t, i){
        this.Ih = t, this.zh = i || null;
    }
    Lh() {
        return this.Ih;
    }
    Eh() {
        return this.zh;
    }
    Bh() {
        return null === this.Ih ? null : {
            priceRange: this.Ih.Bh(),
            margins: this.zh || void 0
        };
    }
    static Ah(t) {
        return null === t ? null : new $a1a4d31e28ce1f0d$var$Di($a1a4d31e28ce1f0d$var$Ri.Ah(t.priceRange), t.margins);
    }
}
class $a1a4d31e28ce1f0d$var$Vi extends $a1a4d31e28ce1f0d$var$hi {
    constructor(t, i){
        super(t), this.Nh = i;
    }
    yr() {
        const t = this.Sr;
        t.yt = !1;
        const i = this.Nh.W();
        if (!this.Es.yt() || !i.lineVisible) return;
        const n = this.Nh.Fh();
        null !== n && (t.yt = !0, t.st = n, t.V = i.color, t.et = i.lineWidth, t.Nt = i.lineStyle, t.gr = this.Nh.W().id);
    }
}
class $a1a4d31e28ce1f0d$var$Oi extends $a1a4d31e28ce1f0d$var$nt {
    constructor(t, i){
        super(), this.jr = t, this.Nh = i;
    }
    zi(t, i, n) {
        t.yt = !1, i.yt = !1;
        const s = this.Nh.W(), e = s.axisLabelVisible, r = "" !== s.title, h = this.jr;
        if (!e || !h.yt()) return;
        const l = this.Nh.Fh();
        if (null === l) return;
        r && (i.Kt = s.title, i.yt = !0), i.Ot = h.$t().Bt(l / h.Dt().At()), t.Kt = this.Wh(s.price), t.yt = !0;
        const a = $a1a4d31e28ce1f0d$var$R(s.axisLabelColor || s.color);
        n.t = a.t;
        const o = s.axisLabelTextColor || a.i;
        t.V = o, i.V = o, n.ki = l;
    }
    Wh(t) {
        const i = this.jr.Ct();
        return null === i ? "" : this.jr.Dt().Fi(t, i.Vt);
    }
}
class $a1a4d31e28ce1f0d$var$Bi {
    constructor(t, i){
        this.jr = t, this.cn = i, this.jh = new $a1a4d31e28ce1f0d$var$Vi(t, this), this.ur = new $a1a4d31e28ce1f0d$var$Oi(t, this), this.Hh = new $a1a4d31e28ce1f0d$var$ei(this.ur, t, t.$t());
    }
    $h(t) {
        $a1a4d31e28ce1f0d$var$V(this.cn, t), this.bt(), this.jr.$t().Uh();
    }
    W() {
        return this.cn;
    }
    qh() {
        return this.jh;
    }
    Yh() {
        return this.Hh;
    }
    Zh() {
        return this.ur;
    }
    bt() {
        this.jh.bt(), this.ur.bt();
    }
    Fh() {
        const t = this.jr, i = t.Dt();
        if (t.$t().St().Ni() || i.Ni()) return null;
        const n = t.Ct();
        return null === n ? null : i.Rt(this.cn.price, n.Vt);
    }
}
class $a1a4d31e28ce1f0d$var$Ai extends $a1a4d31e28ce1f0d$var$lt {
    constructor(t){
        super(), this.$i = t;
    }
    $t() {
        return this.$i;
    }
}
const $a1a4d31e28ce1f0d$var$Ii = {
    Bar: (t, i, n, s)=>{
        var e;
        const r = i.upColor, h = i.downColor, l = $a1a4d31e28ce1f0d$var$b(t(n, s)), a = $a1a4d31e28ce1f0d$var$w(l.Vt[0]) <= $a1a4d31e28ce1f0d$var$w(l.Vt[3]);
        return {
            ce: null !== (e = l.V) && void 0 !== e ? e : a ? r : h
        };
    },
    Candlestick: (t, i, n, s)=>{
        var e, r, h;
        const l = i.upColor, a = i.downColor, o = i.borderUpColor, _ = i.borderDownColor, u = i.wickUpColor, c = i.wickDownColor, d = $a1a4d31e28ce1f0d$var$b(t(n, s)), f = $a1a4d31e28ce1f0d$var$w(d.Vt[0]) <= $a1a4d31e28ce1f0d$var$w(d.Vt[3]);
        return {
            ce: null !== (e = d.V) && void 0 !== e ? e : f ? l : a,
            Ne: null !== (r = d.Ot) && void 0 !== r ? r : f ? o : _,
            Ee: null !== (h = d.Xh) && void 0 !== h ? h : f ? u : c
        };
    },
    Custom: (t, i, n, s)=>{
        var e;
        return {
            ce: null !== (e = $a1a4d31e28ce1f0d$var$b(t(n, s)).V) && void 0 !== e ? e : i.color
        };
    },
    Area: (t, i, n, s)=>{
        var e, r, h, l;
        const a = $a1a4d31e28ce1f0d$var$b(t(n, s));
        return {
            ce: null !== (e = a.lt) && void 0 !== e ? e : i.lineColor,
            lt: null !== (r = a.lt) && void 0 !== r ? r : i.lineColor,
            Ps: null !== (h = a.Ps) && void 0 !== h ? h : i.topColor,
            Rs: null !== (l = a.Rs) && void 0 !== l ? l : i.bottomColor
        };
    },
    Baseline: (t, i, n, s)=>{
        var e, r, h, l, a, o;
        const _ = $a1a4d31e28ce1f0d$var$b(t(n, s));
        return {
            ce: _.Vt[3] >= i.baseValue.price ? i.topLineColor : i.bottomLineColor,
            Re: null !== (e = _.Re) && void 0 !== e ? e : i.topLineColor,
            De: null !== (r = _.De) && void 0 !== r ? r : i.bottomLineColor,
            ke: null !== (h = _.ke) && void 0 !== h ? h : i.topFillColor1,
            ye: null !== (l = _.ye) && void 0 !== l ? l : i.topFillColor2,
            Ce: null !== (a = _.Ce) && void 0 !== a ? a : i.bottomFillColor1,
            Te: null !== (o = _.Te) && void 0 !== o ? o : i.bottomFillColor2
        };
    },
    Line: (t, i, n, s)=>{
        var e, r;
        const h = $a1a4d31e28ce1f0d$var$b(t(n, s));
        return {
            ce: null !== (e = h.V) && void 0 !== e ? e : i.color,
            lt: null !== (r = h.V) && void 0 !== r ? r : i.color
        };
    },
    Histogram: (t, i, n, s)=>{
        var e;
        return {
            ce: null !== (e = $a1a4d31e28ce1f0d$var$b(t(n, s)).V) && void 0 !== e ? e : i.color
        };
    }
};
class $a1a4d31e28ce1f0d$var$zi {
    constructor(t){
        this.Kh = (t, i)=>void 0 !== i ? i.Vt : this.jr.In().Gh(t), this.jr = t, this.Jh = $a1a4d31e28ce1f0d$var$Ii[t.Qh()];
    }
    $s(t, i) {
        return this.Jh(this.Kh, this.jr.W(), t, i);
    }
}
var $a1a4d31e28ce1f0d$export$452387148ad6f8a7;
!function(t) {
    t[t.NearestLeft = -1] = "NearestLeft", t[t.None = 0] = "None", t[t.NearestRight = 1] = "NearestRight";
}($a1a4d31e28ce1f0d$export$452387148ad6f8a7 || ($a1a4d31e28ce1f0d$export$452387148ad6f8a7 = {}));
const $a1a4d31e28ce1f0d$var$Ei = 30;
class $a1a4d31e28ce1f0d$var$Ni {
    constructor(){
        this.tl = [], this.il = new Map, this.nl = new Map;
    }
    sl() {
        return this.Ks() > 0 ? this.tl[this.tl.length - 1] : null;
    }
    el() {
        return this.Ks() > 0 ? this.rl(0) : null;
    }
    An() {
        return this.Ks() > 0 ? this.rl(this.tl.length - 1) : null;
    }
    Ks() {
        return this.tl.length;
    }
    Ni() {
        return 0 === this.Ks();
    }
    Kr(t) {
        return null !== this.hl(t, 0);
    }
    Gh(t) {
        return this.ll(t);
    }
    ll(t, i = 0) {
        const n = this.hl(t, i);
        return null === n ? null : Object.assign(Object.assign({}, this.al(n)), {
            ee: this.rl(n)
        });
    }
    ne() {
        return this.tl;
    }
    ol(t, i, n) {
        if (this.Ni()) return null;
        let s = null;
        for (const e of n)s = $a1a4d31e28ce1f0d$var$Fi(s, this._l(t, i, e));
        return s;
    }
    J(t) {
        this.nl.clear(), this.il.clear(), this.tl = t;
    }
    rl(t) {
        return this.tl[t].ee;
    }
    al(t) {
        return this.tl[t];
    }
    hl(t, i) {
        const n = this.ul(t);
        if (null === n && 0 !== i) switch(i){
            case -1:
                return this.cl(t);
            case 1:
                return this.dl(t);
            default:
                throw new TypeError("Unknown search mode");
        }
        return n;
    }
    cl(t) {
        let i = this.fl(t);
        return i > 0 && (i -= 1), i !== this.tl.length && this.rl(i) < t ? i : null;
    }
    dl(t) {
        const i = this.vl(t);
        return i !== this.tl.length && t < this.rl(i) ? i : null;
    }
    ul(t) {
        const i = this.fl(t);
        return i === this.tl.length || t < this.tl[i].ee ? null : i;
    }
    fl(t) {
        return $a1a4d31e28ce1f0d$var$Bt(this.tl, t, (t, i)=>t.ee < i);
    }
    vl(t) {
        return $a1a4d31e28ce1f0d$var$At(this.tl, t, (t, i)=>t.ee > i);
    }
    pl(t, i, n) {
        let s = null;
        for(let e = t; e < i; e++){
            const t = this.tl[e].Vt[n];
            Number.isNaN(t) || (null === s ? s = {
                ml: t,
                bl: t
            } : (t < s.ml && (s.ml = t), t > s.bl && (s.bl = t)));
        }
        return s;
    }
    _l(t, i, n) {
        if (this.Ni()) return null;
        let s = null;
        const e = $a1a4d31e28ce1f0d$var$b(this.el()), r = $a1a4d31e28ce1f0d$var$b(this.An()), h = Math.max(t, e), l = Math.min(i, r), a = Math.ceil(h / $a1a4d31e28ce1f0d$var$Ei) * $a1a4d31e28ce1f0d$var$Ei, o = Math.max(a, Math.floor(l / $a1a4d31e28ce1f0d$var$Ei) * $a1a4d31e28ce1f0d$var$Ei);
        {
            const t = this.fl(h), e = this.vl(Math.min(l, a, i));
            s = $a1a4d31e28ce1f0d$var$Fi(s, this.pl(t, e, n));
        }
        let _ = this.il.get(n);
        void 0 === _ && (_ = new Map, this.il.set(n, _));
        for(let t = Math.max(a + 1, h); t < o; t += $a1a4d31e28ce1f0d$var$Ei){
            const i = Math.floor(t / $a1a4d31e28ce1f0d$var$Ei);
            let e = _.get(i);
            if (void 0 === e) {
                const t = this.fl(i * $a1a4d31e28ce1f0d$var$Ei), s = this.vl((i + 1) * $a1a4d31e28ce1f0d$var$Ei - 1);
                e = this.pl(t, s, n), _.set(i, e);
            }
            s = $a1a4d31e28ce1f0d$var$Fi(s, e);
        }
        {
            const t = this.fl(o), i = this.vl(l);
            s = $a1a4d31e28ce1f0d$var$Fi(s, this.pl(t, i, n));
        }
        return s;
    }
}
function $a1a4d31e28ce1f0d$var$Fi(t, i) {
    if (null === t) return i;
    if (null === i) return t;
    return {
        ml: Math.min(t.ml, i.ml),
        bl: Math.max(t.bl, i.bl)
    };
}
class $a1a4d31e28ce1f0d$var$Wi {
    constructor(t){
        this.wl = t;
    }
    X(t, i, n) {
        this.wl.draw(t);
    }
    gl(t, i, n) {
        var s, e;
        null === (e = (s = this.wl).drawBackground) || void 0 === e || e.call(s, t);
    }
}
class $a1a4d31e28ce1f0d$var$ji {
    constructor(t){
        this.tr = null, this.wn = t;
    }
    gt() {
        var t;
        const i = this.wn.renderer();
        if (null === i) return null;
        if ((null === (t = this.tr) || void 0 === t ? void 0 : t.Ml) === i) return this.tr.xl;
        const n = new $a1a4d31e28ce1f0d$var$Wi(i);
        return this.tr = {
            Ml: i,
            xl: n
        }, n;
    }
    Sl() {
        var t, i, n;
        return null !== (n = null === (i = (t = this.wn).zOrder) || void 0 === i ? void 0 : i.call(t)) && void 0 !== n ? n : "normal";
    }
}
function $a1a4d31e28ce1f0d$var$Hi(t) {
    var i, n, s, e, r;
    return {
        Kt: t.text(),
        ki: t.coordinate(),
        Si: null === (i = t.fixedCoordinate) || void 0 === i ? void 0 : i.call(t),
        V: t.textColor(),
        t: t.backColor(),
        yt: null === (s = null === (n = t.visible) || void 0 === n ? void 0 : n.call(t)) || void 0 === s || s,
        hi: null === (r = null === (e = t.tickVisible) || void 0 === e ? void 0 : e.call(t)) || void 0 === r || r
    };
}
class $a1a4d31e28ce1f0d$var$$i {
    constructor(t, i){
        this.Wt = new $a1a4d31e28ce1f0d$var$rt, this.kl = t, this.yl = i;
    }
    gt() {
        return this.Wt.J(Object.assign({
            Hi: this.yl.Hi()
        }, $a1a4d31e28ce1f0d$var$Hi(this.kl))), this.Wt;
    }
}
class $a1a4d31e28ce1f0d$var$Ui extends $a1a4d31e28ce1f0d$var$nt {
    constructor(t, i){
        super(), this.kl = t, this.Li = i;
    }
    zi(t, i, n) {
        const s = $a1a4d31e28ce1f0d$var$Hi(this.kl);
        n.t = s.t, t.V = s.V;
        const e = 2 / 12 * this.Li.P();
        n.wi = e, n.gi = e, n.ki = s.ki, n.Si = s.Si, t.Kt = s.Kt, t.yt = s.yt, t.hi = s.hi;
    }
}
class $a1a4d31e28ce1f0d$var$qi {
    constructor(t, i){
        this.Cl = null, this.Tl = null, this.Pl = null, this.Rl = null, this.Dl = null, this.Vl = t, this.jr = i;
    }
    Ol() {
        return this.Vl;
    }
    Vn() {
        var t, i;
        null === (i = (t = this.Vl).updateAllViews) || void 0 === i || i.call(t);
    }
    Pn() {
        var t, i, n, s;
        const e = null !== (n = null === (i = (t = this.Vl).paneViews) || void 0 === i ? void 0 : i.call(t)) && void 0 !== n ? n : [];
        if ((null === (s = this.Cl) || void 0 === s ? void 0 : s.Ml) === e) return this.Cl.xl;
        const r = e.map((t)=>new $a1a4d31e28ce1f0d$var$ji(t));
        return this.Cl = {
            Ml: e,
            xl: r
        }, r;
    }
    Qi() {
        var t, i, n, s;
        const e = null !== (n = null === (i = (t = this.Vl).timeAxisViews) || void 0 === i ? void 0 : i.call(t)) && void 0 !== n ? n : [];
        if ((null === (s = this.Tl) || void 0 === s ? void 0 : s.Ml) === e) return this.Tl.xl;
        const r = this.jr.$t().St(), h = e.map((t)=>new $a1a4d31e28ce1f0d$var$$i(t, r));
        return this.Tl = {
            Ml: e,
            xl: h
        }, h;
    }
    Rn() {
        var t, i, n, s;
        const e = null !== (n = null === (i = (t = this.Vl).priceAxisViews) || void 0 === i ? void 0 : i.call(t)) && void 0 !== n ? n : [];
        if ((null === (s = this.Pl) || void 0 === s ? void 0 : s.Ml) === e) return this.Pl.xl;
        const r = this.jr.Dt(), h = e.map((t)=>new $a1a4d31e28ce1f0d$var$Ui(t, r));
        return this.Pl = {
            Ml: e,
            xl: h
        }, h;
    }
    Bl() {
        var t, i, n, s;
        const e = null !== (n = null === (i = (t = this.Vl).priceAxisPaneViews) || void 0 === i ? void 0 : i.call(t)) && void 0 !== n ? n : [];
        if ((null === (s = this.Rl) || void 0 === s ? void 0 : s.Ml) === e) return this.Rl.xl;
        const r = e.map((t)=>new $a1a4d31e28ce1f0d$var$ji(t));
        return this.Rl = {
            Ml: e,
            xl: r
        }, r;
    }
    Al() {
        var t, i, n, s;
        const e = null !== (n = null === (i = (t = this.Vl).timeAxisPaneViews) || void 0 === i ? void 0 : i.call(t)) && void 0 !== n ? n : [];
        if ((null === (s = this.Dl) || void 0 === s ? void 0 : s.Ml) === e) return this.Dl.xl;
        const r = e.map((t)=>new $a1a4d31e28ce1f0d$var$ji(t));
        return this.Dl = {
            Ml: e,
            xl: r
        }, r;
    }
    Il(t, i) {
        var n, s, e;
        return null !== (e = null === (s = (n = this.Vl).autoscaleInfo) || void 0 === s ? void 0 : s.call(n, t, i)) && void 0 !== e ? e : null;
    }
    wr(t, i) {
        var n, s, e;
        return null !== (e = null === (s = (n = this.Vl).hitTest) || void 0 === s ? void 0 : s.call(n, t, i)) && void 0 !== e ? e : null;
    }
}
function $a1a4d31e28ce1f0d$var$Yi(t, i, n, s) {
    t.forEach((t)=>{
        i(t).forEach((t)=>{
            t.Sl() === n && s.push(t);
        });
    });
}
function $a1a4d31e28ce1f0d$var$Zi(t) {
    return t.Pn();
}
function $a1a4d31e28ce1f0d$var$Xi(t) {
    return t.Bl();
}
function $a1a4d31e28ce1f0d$var$Ki(t) {
    return t.Al();
}
class $a1a4d31e28ce1f0d$var$Gi extends $a1a4d31e28ce1f0d$var$Ai {
    constructor(t, i, n, s, e){
        super(t), this.zt = new $a1a4d31e28ce1f0d$var$Ni, this.jh = new $a1a4d31e28ce1f0d$var$Ci(this), this.zl = [], this.Ll = new $a1a4d31e28ce1f0d$var$li(this), this.El = null, this.Nl = null, this.Fl = [], this.Wl = [], this.jl = null, this.Hl = [], this.cn = i, this.$l = n;
        const r = new $a1a4d31e28ce1f0d$var$Ti(this);
        this.rn = [
            r
        ], this.Hh = new $a1a4d31e28ce1f0d$var$ei(r, this, t), "Area" !== n && "Line" !== n && "Baseline" !== n || (this.El = new $a1a4d31e28ce1f0d$var$ci(this)), this.Ul(), this.ql(e);
    }
    S() {
        null !== this.jl && clearTimeout(this.jl);
    }
    mh(t) {
        return this.cn.priceLineColor || t;
    }
    Zr(t) {
        const i = {
            Xr: !0
        }, n = this.Dt();
        if (this.$t().St().Ni() || n.Ni() || this.zt.Ni()) return i;
        const s = this.$t().St().Xs(), e = this.Ct();
        if (null === s || null === e) return i;
        let r, h;
        if (t) {
            const t = this.zt.sl();
            if (null === t) return i;
            r = t, h = t.ee;
        } else {
            const t = this.zt.ll(s.ui(), -1);
            if (null === t) return i;
            if (r = this.zt.Gh(t.ee), null === r) return i;
            h = t.ee;
        }
        const l = r.Vt[3], a = this.Us().$s(h, {
            Vt: r
        }), o = n.Rt(l, e.Vt);
        return {
            Xr: !1,
            _t: l,
            Kt: n.Fi(l, e.Vt),
            xh: n.Yl(l),
            Sh: n.Zl(l, e.Vt),
            V: a.ce,
            ki: o,
            ee: h
        };
    }
    Us() {
        return null !== this.Nl || (this.Nl = new $a1a4d31e28ce1f0d$var$zi(this)), this.Nl;
    }
    W() {
        return this.cn;
    }
    $h(t) {
        const i = t.priceScaleId;
        void 0 !== i && i !== this.cn.priceScaleId && this.$t().Xl(this, i), $a1a4d31e28ce1f0d$var$V(this.cn, t), void 0 !== t.priceFormat && (this.Ul(), this.$t().Kl()), this.$t().Gl(this), this.$t().Jl(), this.wn.bt("options");
    }
    J(t, i) {
        this.zt.J(t), this.Ql(), this.wn.bt("data"), this.dn.bt("data"), null !== this.El && (i && i.ta ? this.El.$r() : 0 === t.length && this.El.Hr());
        const n = this.$t().dr(this);
        this.$t().ia(n), this.$t().Gl(this), this.$t().Jl(), this.$t().Uh();
    }
    na(t) {
        this.Fl = t, this.Ql();
        const i = this.$t().dr(this);
        this.dn.bt("data"), this.$t().ia(i), this.$t().Gl(this), this.$t().Jl(), this.$t().Uh();
    }
    sa() {
        return this.Fl;
    }
    dh() {
        return this.Wl;
    }
    ea(t) {
        const i = new $a1a4d31e28ce1f0d$var$Bi(this, t);
        return this.zl.push(i), this.$t().Gl(this), i;
    }
    ra(t) {
        const i = this.zl.indexOf(t);
        -1 !== i && this.zl.splice(i, 1), this.$t().Gl(this);
    }
    Qh() {
        return this.$l;
    }
    Ct() {
        const t = this.ha();
        return null === t ? null : {
            Vt: t.Vt[3],
            la: t.ot
        };
    }
    ha() {
        const t = this.$t().St().Xs();
        if (null === t) return null;
        const i = t.Os();
        return this.zt.ll(i, 1);
    }
    In() {
        return this.zt;
    }
    ph(t) {
        const i = this.zt.Gh(t);
        return null === i ? null : "Bar" === this.$l || "Candlestick" === this.$l || "Custom" === this.$l ? {
            ge: i.Vt[0],
            Me: i.Vt[1],
            xe: i.Vt[2],
            Se: i.Vt[3]
        } : i.Vt[3];
    }
    aa(t) {
        const i = [];
        $a1a4d31e28ce1f0d$var$Yi(this.Hl, $a1a4d31e28ce1f0d$var$Zi, "top", i);
        const n = this.El;
        return null !== n && n.yt() ? (null === this.jl && n.qr() && (this.jl = setTimeout(()=>{
            this.jl = null, this.$t().oa();
        }, 0)), n.Ur(), i.unshift(n), i) : i;
    }
    Pn() {
        const t = [];
        this._a() || t.push(this.Ll), t.push(this.wn, this.jh, this.dn);
        const i = this.zl.map((t)=>t.qh());
        return t.push(...i), $a1a4d31e28ce1f0d$var$Yi(this.Hl, $a1a4d31e28ce1f0d$var$Zi, "normal", t), t;
    }
    ua() {
        return this.ca($a1a4d31e28ce1f0d$var$Zi, "bottom");
    }
    da(t) {
        return this.ca($a1a4d31e28ce1f0d$var$Xi, t);
    }
    fa(t) {
        return this.ca($a1a4d31e28ce1f0d$var$Ki, t);
    }
    va(t, i) {
        return this.Hl.map((n)=>n.wr(t, i)).filter((t)=>null !== t);
    }
    Ji(t) {
        return [
            this.Hh,
            ...this.zl.map((t)=>t.Yh())
        ];
    }
    Rn(t, i) {
        if (i !== this.Yi && !this._a()) return [];
        const n = [
            ...this.rn
        ];
        for (const t of this.zl)n.push(t.Zh());
        return this.Hl.forEach((t)=>{
            n.push(...t.Rn());
        }), n;
    }
    Qi() {
        const t = [];
        return this.Hl.forEach((i)=>{
            t.push(...i.Qi());
        }), t;
    }
    Il(t, i) {
        if (void 0 !== this.cn.autoscaleInfoProvider) {
            const n = this.cn.autoscaleInfoProvider(()=>{
                const n = this.pa(t, i);
                return null === n ? null : n.Bh();
            });
            return $a1a4d31e28ce1f0d$var$Di.Ah(n);
        }
        return this.pa(t, i);
    }
    ma() {
        return this.cn.priceFormat.minMove;
    }
    ba() {
        return this.wa;
    }
    Vn() {
        var t;
        this.wn.bt(), this.dn.bt();
        for (const t of this.rn)t.bt();
        for (const t of this.zl)t.bt();
        this.jh.bt(), this.Ll.bt(), null === (t = this.El) || void 0 === t || t.bt(), this.Hl.forEach((t)=>t.Vn());
    }
    Dt() {
        return $a1a4d31e28ce1f0d$var$b(super.Dt());
    }
    kt(t) {
        if (!(("Line" === this.$l || "Area" === this.$l || "Baseline" === this.$l) && this.cn.crosshairMarkerVisible)) return null;
        const i = this.zt.Gh(t);
        if (null === i) return null;
        return {
            _t: i.Vt[3],
            ht: this.ga(),
            Ot: this.Ma(),
            Pt: this.xa(),
            Tt: this.Sa(t)
        };
    }
    bh() {
        return this.cn.title;
    }
    yt() {
        return this.cn.visible;
    }
    ka(t) {
        this.Hl.push(new $a1a4d31e28ce1f0d$var$qi(t, this));
    }
    ya(t) {
        this.Hl = this.Hl.filter((i)=>i.Ol() !== t);
    }
    Ca() {
        if (this.wn instanceof $a1a4d31e28ce1f0d$var$Kt != !1) return (t)=>this.wn.We(t);
    }
    Ta() {
        if (this.wn instanceof $a1a4d31e28ce1f0d$var$Kt != !1) return (t)=>this.wn.je(t);
    }
    _a() {
        return !$a1a4d31e28ce1f0d$var$_t(this.Dt().Pa());
    }
    pa(t, i) {
        if (!$a1a4d31e28ce1f0d$var$B(t) || !$a1a4d31e28ce1f0d$var$B(i) || this.zt.Ni()) return null;
        const n = "Line" === this.$l || "Area" === this.$l || "Baseline" === this.$l || "Histogram" === this.$l ? [
            3
        ] : [
            2,
            1
        ], s = this.zt.ol(t, i, n);
        let e = null !== s ? new $a1a4d31e28ce1f0d$var$Ri(s.ml, s.bl) : null;
        if ("Histogram" === this.Qh()) {
            const t = this.cn.base, i = new $a1a4d31e28ce1f0d$var$Ri(t, t);
            e = null !== e ? e.ts(i) : i;
        }
        let r = this.dn.uh();
        return this.Hl.forEach((n)=>{
            const s = n.Il(t, i);
            if (null == s ? void 0 : s.priceRange) {
                const t = new $a1a4d31e28ce1f0d$var$Ri(s.priceRange.minValue, s.priceRange.maxValue);
                e = null !== e ? e.ts(t) : t;
            }
            var h, l, a, o;
            (null == s ? void 0 : s.margins) && (h = r, l = s.margins, r = {
                above: Math.max(null !== (a = null == h ? void 0 : h.above) && void 0 !== a ? a : 0, l.above),
                below: Math.max(null !== (o = null == h ? void 0 : h.below) && void 0 !== o ? o : 0, l.below)
            });
        }), new $a1a4d31e28ce1f0d$var$Di(e, r);
    }
    ga() {
        switch(this.$l){
            case "Line":
            case "Area":
            case "Baseline":
                return this.cn.crosshairMarkerRadius;
        }
        return 0;
    }
    Ma() {
        switch(this.$l){
            case "Line":
            case "Area":
            case "Baseline":
                {
                    const t = this.cn.crosshairMarkerBorderColor;
                    if (0 !== t.length) return t;
                }
        }
        return null;
    }
    xa() {
        switch(this.$l){
            case "Line":
            case "Area":
            case "Baseline":
                return this.cn.crosshairMarkerBorderWidth;
        }
        return 0;
    }
    Sa(t) {
        switch(this.$l){
            case "Line":
            case "Area":
            case "Baseline":
                {
                    const t = this.cn.crosshairMarkerBackgroundColor;
                    if (0 !== t.length) return t;
                }
        }
        return this.Us().$s(t).ce;
    }
    Ul() {
        switch(this.cn.priceFormat.type){
            case "custom":
                this.wa = {
                    format: this.cn.priceFormat.formatter
                };
                break;
            case "volume":
                this.wa = new $a1a4d31e28ce1f0d$var$pt(this.cn.priceFormat.precision);
                break;
            case "percent":
                this.wa = new $a1a4d31e28ce1f0d$var$vt(this.cn.priceFormat.precision);
                break;
            default:
                {
                    const t = Math.pow(10, this.cn.priceFormat.precision);
                    this.wa = new $a1a4d31e28ce1f0d$var$ft(t, this.cn.priceFormat.minMove * t);
                }
        }
        null !== this.Yi && this.Yi.Ra();
    }
    Ql() {
        const t = this.$t().St();
        if (!t.Da() || this.zt.Ni()) return void (this.Wl = []);
        const i = $a1a4d31e28ce1f0d$var$b(this.zt.el());
        this.Wl = this.Fl.map((n, s)=>{
            const e = $a1a4d31e28ce1f0d$var$b(t.Va(n.time, !0)), r = e < i ? 1 : -1;
            return {
                time: $a1a4d31e28ce1f0d$var$b(this.zt.ll(e, r)).ee,
                position: n.position,
                shape: n.shape,
                color: n.color,
                id: n.id,
                th: s,
                text: n.text,
                size: n.size,
                originalTime: n.originalTime
            };
        });
    }
    ql(t) {
        switch(this.dn = new $a1a4d31e28ce1f0d$var$yi(this, this.$t()), this.$l){
            case "Bar":
                this.wn = new $a1a4d31e28ce1f0d$var$Ht(this, this.$t());
                break;
            case "Candlestick":
                this.wn = new $a1a4d31e28ce1f0d$var$Zt(this, this.$t());
                break;
            case "Line":
                this.wn = new $a1a4d31e28ce1f0d$var$ti(this, this.$t());
                break;
            case "Custom":
                this.wn = new $a1a4d31e28ce1f0d$var$Kt(this, this.$t(), $a1a4d31e28ce1f0d$var$m(t));
                break;
            case "Area":
                this.wn = new $a1a4d31e28ce1f0d$var$Ft(this, this.$t());
                break;
            case "Baseline":
                this.wn = new $a1a4d31e28ce1f0d$var$qt(this, this.$t());
                break;
            case "Histogram":
                this.wn = new $a1a4d31e28ce1f0d$var$Qt(this, this.$t());
                break;
            default:
                throw Error("Unknown chart style assigned: " + this.$l);
        }
    }
    ca(t, i) {
        const n = [];
        return $a1a4d31e28ce1f0d$var$Yi(this.Hl, t, i, n), n;
    }
}
class $a1a4d31e28ce1f0d$var$Ji {
    constructor(t){
        this.cn = t;
    }
    Oa(t, i, n) {
        let s = t;
        if (0 === this.cn.mode) return s;
        const e = n.vn(), r = e.Ct();
        if (null === r) return s;
        const h = e.Rt(t, r), l = n.Ba().filter((t)=>t instanceof $a1a4d31e28ce1f0d$var$Gi).reduce((t, s)=>{
            if (n.vr(s) || !s.yt()) return t;
            const e = s.Dt(), r = s.In();
            if (e.Ni() || !r.Kr(i)) return t;
            const h = r.Gh(i);
            if (null === h) return t;
            const l = $a1a4d31e28ce1f0d$var$w(s.Ct());
            return t.concat([
                e.Rt(h.Vt[3], l.Vt)
            ]);
        }, []);
        if (0 === l.length) return s;
        l.sort((t, i)=>Math.abs(t - h) - Math.abs(i - h));
        const a = l[0];
        return s = e.pn(a, r), s;
    }
}
class $a1a4d31e28ce1f0d$var$Qi extends $a1a4d31e28ce1f0d$var$H {
    constructor(){
        super(...arguments), this.zt = null;
    }
    J(t) {
        this.zt = t;
    }
    K({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.zt) return;
        const e = Math.max(1, Math.floor(n));
        t.lineWidth = e, function(t, i) {
            t.save(), t.lineWidth % 2 && t.translate(.5, .5), i(), t.restore();
        }(t, ()=>{
            const r = $a1a4d31e28ce1f0d$var$b(this.zt);
            if (r.Aa) {
                t.strokeStyle = r.Ia, $a1a4d31e28ce1f0d$var$f(t, r.za), t.beginPath();
                for (const s of r.La){
                    const r = Math.round(s.Ea * n);
                    t.moveTo(r, -e), t.lineTo(r, i.height + e);
                }
                t.stroke();
            }
            if (r.Na) {
                t.strokeStyle = r.Fa, $a1a4d31e28ce1f0d$var$f(t, r.Wa), t.beginPath();
                for (const n of r.ja){
                    const r = Math.round(n.Ea * s);
                    t.moveTo(-e, r), t.lineTo(i.width + e, r);
                }
                t.stroke();
            }
        });
    }
}
class $a1a4d31e28ce1f0d$var$tn {
    constructor(t){
        this.Wt = new $a1a4d31e28ce1f0d$var$Qi, this.ft = !0, this.tn = t;
    }
    bt() {
        this.ft = !0;
    }
    gt() {
        if (this.ft) {
            const t = this.tn.$t().W().grid, i = {
                Na: t.horzLines.visible,
                Aa: t.vertLines.visible,
                Fa: t.horzLines.color,
                Ia: t.vertLines.color,
                Wa: t.horzLines.style,
                za: t.vertLines.style,
                ja: this.tn.vn().Ha(),
                La: (this.tn.$t().St().Ha() || []).map((t)=>({
                        Ea: t.coord
                    }))
            };
            this.Wt.J(i), this.ft = !1;
        }
        return this.Wt;
    }
}
class $a1a4d31e28ce1f0d$var$nn {
    constructor(t){
        this.wn = new $a1a4d31e28ce1f0d$var$tn(t);
    }
    qh() {
        return this.wn;
    }
}
const $a1a4d31e28ce1f0d$var$sn = {
    $a: 4,
    Ua: 1e-4
};
function $a1a4d31e28ce1f0d$var$en(t, i) {
    const n = 100 * (t - i) / i;
    return i < 0 ? -n : n;
}
function $a1a4d31e28ce1f0d$var$rn(t, i) {
    const n = $a1a4d31e28ce1f0d$var$en(t.Ph(), i), s = $a1a4d31e28ce1f0d$var$en(t.Rh(), i);
    return new $a1a4d31e28ce1f0d$var$Ri(n, s);
}
function $a1a4d31e28ce1f0d$var$hn(t, i) {
    const n = 100 * (t - i) / i + 100;
    return i < 0 ? -n : n;
}
function $a1a4d31e28ce1f0d$var$ln(t, i) {
    const n = $a1a4d31e28ce1f0d$var$hn(t.Ph(), i), s = $a1a4d31e28ce1f0d$var$hn(t.Rh(), i);
    return new $a1a4d31e28ce1f0d$var$Ri(n, s);
}
function $a1a4d31e28ce1f0d$var$an(t, i) {
    const n = Math.abs(t);
    if (n < 1e-15) return 0;
    const s = Math.log10(n + i.Ua) + i.$a;
    return t < 0 ? -s : s;
}
function $a1a4d31e28ce1f0d$var$on(t, i) {
    const n = Math.abs(t);
    if (n < 1e-15) return 0;
    const s = Math.pow(10, n - i.$a) - i.Ua;
    return t < 0 ? -s : s;
}
function $a1a4d31e28ce1f0d$var$_n(t, i) {
    if (null === t) return null;
    const n = $a1a4d31e28ce1f0d$var$an(t.Ph(), i), s = $a1a4d31e28ce1f0d$var$an(t.Rh(), i);
    return new $a1a4d31e28ce1f0d$var$Ri(n, s);
}
function $a1a4d31e28ce1f0d$var$un(t, i) {
    if (null === t) return null;
    const n = $a1a4d31e28ce1f0d$var$on(t.Ph(), i), s = $a1a4d31e28ce1f0d$var$on(t.Rh(), i);
    return new $a1a4d31e28ce1f0d$var$Ri(n, s);
}
function $a1a4d31e28ce1f0d$var$cn(t) {
    if (null === t) return $a1a4d31e28ce1f0d$var$sn;
    const i = Math.abs(t.Rh() - t.Ph());
    if (i >= 1 || i < 1e-15) return $a1a4d31e28ce1f0d$var$sn;
    const n = Math.ceil(Math.abs(Math.log10(i))), s = $a1a4d31e28ce1f0d$var$sn.$a + n;
    return {
        $a: s,
        Ua: 1 / Math.pow(10, s)
    };
}
class $a1a4d31e28ce1f0d$var$dn {
    constructor(t, i){
        if (this.qa = t, this.Ya = i, function(t) {
            if (t < 0) return !1;
            for(let i = t; i > 1; i /= 10)if (i % 10 != 0) return !1;
            return !0;
        }(this.qa)) this.Za = [
            2,
            2.5,
            2
        ];
        else {
            this.Za = [];
            for(let t = this.qa; 1 !== t;){
                if (t % 2 == 0) this.Za.push(2), t /= 2;
                else {
                    if (t % 5 != 0) throw new Error("unexpected base");
                    this.Za.push(2, 2.5), t /= 5;
                }
                if (this.Za.length > 100) throw new Error("something wrong with base");
            }
        }
    }
    Xa(t, i, n) {
        const s = 0 === this.qa ? 0 : 1 / this.qa;
        let e = Math.pow(10, Math.max(0, Math.ceil(Math.log10(t - i)))), r = 0, h = this.Ya[0];
        for(;;){
            const t = $a1a4d31e28ce1f0d$var$yt(e, s, 1e-14) && e > s + 1e-14, i = $a1a4d31e28ce1f0d$var$yt(e, n * h, 1e-14), l = $a1a4d31e28ce1f0d$var$yt(e, 1, 1e-14);
            if (!(t && i && l)) break;
            e /= h, h = this.Ya[++r % this.Ya.length];
        }
        if (e <= s + 1e-14 && (e = s), e = Math.max(1, e), this.Za.length > 0 && (l = e, a = 1, o = 1e-14, Math.abs(l - a) < o)) for(r = 0, h = this.Za[0]; $a1a4d31e28ce1f0d$var$yt(e, n * h, 1e-14) && e > s + 1e-14;)e /= h, h = this.Za[++r % this.Za.length];
        var l, a, o;
        return e;
    }
}
class $a1a4d31e28ce1f0d$var$fn {
    constructor(t, i, n, s){
        this.Ka = [], this.Li = t, this.qa = i, this.Ga = n, this.Ja = s;
    }
    Xa(t, i) {
        if (t < i) throw new Error("high < low");
        const n = this.Li.At(), s = (t - i) * this.Qa() / n, e = new $a1a4d31e28ce1f0d$var$dn(this.qa, [
            2,
            2.5,
            2
        ]), r = new $a1a4d31e28ce1f0d$var$dn(this.qa, [
            2,
            2,
            2.5
        ]), h = new $a1a4d31e28ce1f0d$var$dn(this.qa, [
            2.5,
            2,
            2
        ]), l = [];
        return l.push(e.Xa(t, i, s), r.Xa(t, i, s), h.Xa(t, i, s)), function(t) {
            if (t.length < 1) throw Error("array is empty");
            let i = t[0];
            for(let n = 1; n < t.length; ++n)t[n] < i && (i = t[n]);
            return i;
        }(l);
    }
    io() {
        const t = this.Li, i = t.Ct();
        if (null === i) return void (this.Ka = []);
        const n = t.At(), s = this.Ga(n - 1, i), e = this.Ga(0, i), r = this.Li.W().entireTextOnly ? this.no() / 2 : 0, h = r, l = n - 1 - r, a = Math.max(s, e), o = Math.min(s, e);
        if (a === o) return void (this.Ka = []);
        let _ = this.Xa(a, o), u = a % _;
        u += u < 0 ? _ : 0;
        const c = a >= o ? 1 : -1;
        let d = null, f = 0;
        for(let n = a - u; n > o; n -= _){
            const s = this.Ja(n, i, !0);
            null !== d && Math.abs(s - d) < this.Qa() || s < h || s > l || (f < this.Ka.length ? (this.Ka[f].Ea = s, this.Ka[f].so = t.eo(n)) : this.Ka.push({
                Ea: s,
                so: t.eo(n)
            }), f++, d = s, t.ro() && (_ = this.Xa(n * c, o)));
        }
        this.Ka.length = f;
    }
    Ha() {
        return this.Ka;
    }
    no() {
        return this.Li.P();
    }
    Qa() {
        return Math.ceil(2.5 * this.no());
    }
}
function $a1a4d31e28ce1f0d$var$vn(t) {
    return t.slice().sort((t, i)=>$a1a4d31e28ce1f0d$var$b(t.Xi()) - $a1a4d31e28ce1f0d$var$b(i.Xi()));
}
var $a1a4d31e28ce1f0d$export$6b4fbb6217f8a7c2;
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Logarithmic = 1] = "Logarithmic", t[t.Percentage = 2] = "Percentage", t[t.IndexedTo100 = 3] = "IndexedTo100";
}($a1a4d31e28ce1f0d$export$6b4fbb6217f8a7c2 || ($a1a4d31e28ce1f0d$export$6b4fbb6217f8a7c2 = {}));
const $a1a4d31e28ce1f0d$var$mn = new $a1a4d31e28ce1f0d$var$vt, $a1a4d31e28ce1f0d$var$bn = new $a1a4d31e28ce1f0d$var$ft(100, 1);
class $a1a4d31e28ce1f0d$var$wn {
    constructor(t, i, n, s){
        this.ho = 0, this.lo = null, this.Ih = null, this.ao = null, this.oo = {
            _o: !1,
            uo: null
        }, this.co = 0, this.do = 0, this.fo = new $a1a4d31e28ce1f0d$var$D, this.vo = new $a1a4d31e28ce1f0d$var$D, this.po = [], this.mo = null, this.bo = null, this.wo = null, this.Mo = null, this.wa = $a1a4d31e28ce1f0d$var$bn, this.xo = $a1a4d31e28ce1f0d$var$cn(null), this.So = t, this.cn = i, this.ko = n, this.yo = s, this.Co = new $a1a4d31e28ce1f0d$var$fn(this, 100, this.To.bind(this), this.Po.bind(this));
    }
    Pa() {
        return this.So;
    }
    W() {
        return this.cn;
    }
    $h(t) {
        if ($a1a4d31e28ce1f0d$var$V(this.cn, t), this.Ra(), void 0 !== t.mode && this.Ro({
            Cr: t.mode
        }), void 0 !== t.scaleMargins) {
            const i = $a1a4d31e28ce1f0d$var$m(t.scaleMargins.top), n = $a1a4d31e28ce1f0d$var$m(t.scaleMargins.bottom);
            if (i < 0 || i > 1) throw new Error(`Invalid top margin - expect value between 0 and 1, given=${i}`);
            if (n < 0 || n > 1) throw new Error(`Invalid bottom margin - expect value between 0 and 1, given=${n}`);
            if (i + n > 1) throw new Error(`Invalid margins - sum of margins must be less than 1, given=${i + n}`);
            this.Do(), this.bo = null;
        }
    }
    Vo() {
        return this.cn.autoScale;
    }
    ro() {
        return 1 === this.cn.mode;
    }
    Mh() {
        return 2 === this.cn.mode;
    }
    Oo() {
        return 3 === this.cn.mode;
    }
    Cr() {
        return {
            Wn: this.cn.autoScale,
            Bo: this.cn.invertScale,
            Cr: this.cn.mode
        };
    }
    Ro(t) {
        const i = this.Cr();
        let n = null;
        void 0 !== t.Wn && (this.cn.autoScale = t.Wn), void 0 !== t.Cr && (this.cn.mode = t.Cr, 2 !== t.Cr && 3 !== t.Cr || (this.cn.autoScale = !0), this.oo._o = !1), 1 === i.Cr && t.Cr !== i.Cr && (!function(t, i) {
            if (null === t) return !1;
            const n = $a1a4d31e28ce1f0d$var$on(t.Ph(), i), s = $a1a4d31e28ce1f0d$var$on(t.Rh(), i);
            return isFinite(n) && isFinite(s);
        }(this.Ih, this.xo) ? this.cn.autoScale = !0 : (n = $a1a4d31e28ce1f0d$var$un(this.Ih, this.xo), null !== n && this.Ao(n))), 1 === t.Cr && t.Cr !== i.Cr && (n = $a1a4d31e28ce1f0d$var$_n(this.Ih, this.xo), null !== n && this.Ao(n));
        const s = i.Cr !== this.cn.mode;
        s && (2 === i.Cr || this.Mh()) && this.Ra(), s && (3 === i.Cr || this.Oo()) && this.Ra(), void 0 !== t.Bo && i.Bo !== t.Bo && (this.cn.invertScale = t.Bo, this.Io()), this.vo.m(i, this.Cr());
    }
    zo() {
        return this.vo;
    }
    P() {
        return this.ko.fontSize;
    }
    At() {
        return this.ho;
    }
    Lo(t) {
        this.ho !== t && (this.ho = t, this.Do(), this.bo = null);
    }
    Eo() {
        if (this.lo) return this.lo;
        const t = this.At() - this.No() - this.Fo();
        return this.lo = t, t;
    }
    Lh() {
        return this.Wo(), this.Ih;
    }
    Ao(t, i) {
        const n = this.Ih;
        (i || null === n && null !== t || null !== n && !n.Ch(t)) && (this.bo = null, this.Ih = t);
    }
    Ni() {
        return this.Wo(), 0 === this.ho || !this.Ih || this.Ih.Ni();
    }
    jo(t) {
        return this.Bo() ? t : this.At() - 1 - t;
    }
    Rt(t, i) {
        return this.Mh() ? t = $a1a4d31e28ce1f0d$var$en(t, i) : this.Oo() && (t = $a1a4d31e28ce1f0d$var$hn(t, i)), this.Po(t, i);
    }
    te(t, i, n) {
        this.Wo();
        const s = this.Fo(), e = $a1a4d31e28ce1f0d$var$b(this.Lh()), r = e.Ph(), h = e.Rh(), l = this.Eo() - 1, a = this.Bo(), o = l / (h - r), _ = void 0 === n ? 0 : n.from, u = void 0 === n ? t.length : n.to, c = this.Ho();
        for(let n = _; n < u; n++){
            const e = t[n], h = e._t;
            if (isNaN(h)) continue;
            let l = h;
            null !== c && (l = c(e._t, i));
            const _ = s + o * (l - r), u = a ? _ : this.ho - 1 - _;
            e.st = u;
        }
    }
    be(t, i, n) {
        this.Wo();
        const s = this.Fo(), e = $a1a4d31e28ce1f0d$var$b(this.Lh()), r = e.Ph(), h = e.Rh(), l = this.Eo() - 1, a = this.Bo(), o = l / (h - r), _ = void 0 === n ? 0 : n.from, u = void 0 === n ? t.length : n.to, c = this.Ho();
        for(let n = _; n < u; n++){
            const e = t[n];
            let h = e.ge, l = e.Me, _ = e.xe, u = e.Se;
            null !== c && (h = c(e.ge, i), l = c(e.Me, i), _ = c(e.xe, i), u = c(e.Se, i));
            let d = s + o * (h - r), f = a ? d : this.ho - 1 - d;
            e.pe = f, d = s + o * (l - r), f = a ? d : this.ho - 1 - d, e.de = f, d = s + o * (_ - r), f = a ? d : this.ho - 1 - d, e.fe = f, d = s + o * (u - r), f = a ? d : this.ho - 1 - d, e.me = f;
        }
    }
    pn(t, i) {
        const n = this.To(t, i);
        return this.$o(n, i);
    }
    $o(t, i) {
        let n = t;
        return this.Mh() ? n = function(t, i) {
            return i < 0 && (t = -t), t / 100 * i + i;
        }(n, i) : this.Oo() && (n = function(t, i) {
            return t -= 100, i < 0 && (t = -t), t / 100 * i + i;
        }(n, i)), n;
    }
    Ba() {
        return this.po;
    }
    Uo() {
        if (this.mo) return this.mo;
        let t = [];
        for(let i = 0; i < this.po.length; i++){
            const n = this.po[i];
            null === n.Xi() && n.Ki(i + 1), t.push(n);
        }
        return t = $a1a4d31e28ce1f0d$var$vn(t), this.mo = t, this.mo;
    }
    qo(t) {
        -1 === this.po.indexOf(t) && (this.po.push(t), this.Ra(), this.Yo());
    }
    Zo(t) {
        const i = this.po.indexOf(t);
        if (-1 === i) throw new Error("source is not attached to scale");
        this.po.splice(i, 1), 0 === this.po.length && (this.Ro({
            Wn: !0
        }), this.Ao(null)), this.Ra(), this.Yo();
    }
    Ct() {
        let t = null;
        for (const i of this.po){
            const n = i.Ct();
            null !== n && (null === t || n.la < t.la) && (t = n);
        }
        return null === t ? null : t.Vt;
    }
    Bo() {
        return this.cn.invertScale;
    }
    Ha() {
        const t = null === this.Ct();
        if (null !== this.bo && (t || this.bo.Xo === t)) return this.bo.Ha;
        this.Co.io();
        const i = this.Co.Ha();
        return this.bo = {
            Ha: i,
            Xo: t
        }, this.fo.m(), i;
    }
    Ko() {
        return this.fo;
    }
    Go(t) {
        this.Mh() || this.Oo() || null === this.wo && null === this.ao && (this.Ni() || (this.wo = this.ho - t, this.ao = $a1a4d31e28ce1f0d$var$b(this.Lh()).Th()));
    }
    Jo(t) {
        if (this.Mh() || this.Oo()) return;
        if (null === this.wo) return;
        this.Ro({
            Wn: !1
        }), (t = this.ho - t) < 0 && (t = 0);
        let i = (this.wo + .2 * (this.ho - 1)) / (t + .2 * (this.ho - 1));
        const n = $a1a4d31e28ce1f0d$var$b(this.ao).Th();
        i = Math.max(i, .1), n.Vh(i), this.Ao(n);
    }
    Qo() {
        this.Mh() || this.Oo() || (this.wo = null, this.ao = null);
    }
    t_(t) {
        this.Vo() || null === this.Mo && null === this.ao && (this.Ni() || (this.Mo = t, this.ao = $a1a4d31e28ce1f0d$var$b(this.Lh()).Th()));
    }
    i_(t) {
        if (this.Vo()) return;
        if (null === this.Mo) return;
        const i = $a1a4d31e28ce1f0d$var$b(this.Lh()).Dh() / (this.Eo() - 1);
        let n = t - this.Mo;
        this.Bo() && (n *= -1);
        const s = n * i, e = $a1a4d31e28ce1f0d$var$b(this.ao).Th();
        e.Oh(s), this.Ao(e, !0), this.bo = null;
    }
    n_() {
        this.Vo() || null !== this.Mo && (this.Mo = null, this.ao = null);
    }
    ba() {
        return this.wa || this.Ra(), this.wa;
    }
    Fi(t, i) {
        switch(this.cn.mode){
            case 2:
                return this.s_($a1a4d31e28ce1f0d$var$en(t, i));
            case 3:
                return this.ba().format($a1a4d31e28ce1f0d$var$hn(t, i));
            default:
                return this.Wh(t);
        }
    }
    eo(t) {
        switch(this.cn.mode){
            case 2:
                return this.s_(t);
            case 3:
                return this.ba().format(t);
            default:
                return this.Wh(t);
        }
    }
    Yl(t) {
        return this.Wh(t, $a1a4d31e28ce1f0d$var$b(this.e_()).ba());
    }
    Zl(t, i) {
        return t = $a1a4d31e28ce1f0d$var$en(t, i), this.s_(t, $a1a4d31e28ce1f0d$var$mn);
    }
    r_() {
        return this.po;
    }
    h_(t) {
        this.oo = {
            uo: t,
            _o: !1
        };
    }
    Vn() {
        this.po.forEach((t)=>t.Vn());
    }
    Ra() {
        this.bo = null;
        const t = this.e_();
        let i = 100;
        null !== t && (i = Math.round(1 / t.ma())), this.wa = $a1a4d31e28ce1f0d$var$bn, this.Mh() ? (this.wa = $a1a4d31e28ce1f0d$var$mn, i = 100) : this.Oo() ? (this.wa = new $a1a4d31e28ce1f0d$var$ft(100, 1), i = 100) : null !== t && (this.wa = t.ba()), this.Co = new $a1a4d31e28ce1f0d$var$fn(this, i, this.To.bind(this), this.Po.bind(this)), this.Co.io();
    }
    Yo() {
        this.mo = null;
    }
    e_() {
        return this.po[0] || null;
    }
    No() {
        return this.Bo() ? this.cn.scaleMargins.bottom * this.At() + this.do : this.cn.scaleMargins.top * this.At() + this.co;
    }
    Fo() {
        return this.Bo() ? this.cn.scaleMargins.top * this.At() + this.co : this.cn.scaleMargins.bottom * this.At() + this.do;
    }
    Wo() {
        this.oo._o || (this.oo._o = !0, this.l_());
    }
    Do() {
        this.lo = null;
    }
    Po(t, i) {
        if (this.Wo(), this.Ni()) return 0;
        t = this.ro() && t ? $a1a4d31e28ce1f0d$var$an(t, this.xo) : t;
        const n = $a1a4d31e28ce1f0d$var$b(this.Lh()), s = this.Fo() + (this.Eo() - 1) * (t - n.Ph()) / n.Dh();
        return this.jo(s);
    }
    To(t, i) {
        if (this.Wo(), this.Ni()) return 0;
        const n = this.jo(t), s = $a1a4d31e28ce1f0d$var$b(this.Lh()), e = s.Ph() + s.Dh() * ((n - this.Fo()) / (this.Eo() - 1));
        return this.ro() ? $a1a4d31e28ce1f0d$var$on(e, this.xo) : e;
    }
    Io() {
        this.bo = null, this.Co.io();
    }
    l_() {
        const t = this.oo.uo;
        if (null === t) return;
        let i = null;
        const n = this.r_();
        let s = 0, e = 0;
        for (const r of n){
            if (!r.yt()) continue;
            const n = r.Ct();
            if (null === n) continue;
            const h = r.Il(t.Os(), t.ui());
            let l = h && h.Lh();
            if (null !== l) {
                switch(this.cn.mode){
                    case 1:
                        l = $a1a4d31e28ce1f0d$var$_n(l, this.xo);
                        break;
                    case 2:
                        l = $a1a4d31e28ce1f0d$var$rn(l, n.Vt);
                        break;
                    case 3:
                        l = $a1a4d31e28ce1f0d$var$ln(l, n.Vt);
                }
                if (i = null === i ? l : i.ts($a1a4d31e28ce1f0d$var$b(l)), null !== h) {
                    const t = h.Eh();
                    null !== t && (s = Math.max(s, t.above), e = Math.max(e, t.below));
                }
            }
        }
        if (s === this.co && e === this.do || (this.co = s, this.do = e, this.bo = null, this.Do()), null !== i) {
            if (i.Ph() === i.Rh()) {
                const t = this.e_(), n = 5 * (null === t || this.Mh() || this.Oo() ? 1 : t.ma());
                this.ro() && (i = $a1a4d31e28ce1f0d$var$un(i, this.xo)), i = new $a1a4d31e28ce1f0d$var$Ri(i.Ph() - n, i.Rh() + n), this.ro() && (i = $a1a4d31e28ce1f0d$var$_n(i, this.xo));
            }
            if (this.ro()) {
                const t = $a1a4d31e28ce1f0d$var$un(i, this.xo), n = $a1a4d31e28ce1f0d$var$cn(t);
                if (r = n, h = this.xo, r.$a !== h.$a || r.Ua !== h.Ua) {
                    const s = null !== this.ao ? $a1a4d31e28ce1f0d$var$un(this.ao, this.xo) : null;
                    this.xo = n, i = $a1a4d31e28ce1f0d$var$_n(t, n), null !== s && (this.ao = $a1a4d31e28ce1f0d$var$_n(s, n));
                }
            }
            this.Ao(i);
        } else null === this.Ih && (this.Ao(new $a1a4d31e28ce1f0d$var$Ri(-0.5, .5)), this.xo = $a1a4d31e28ce1f0d$var$cn(null));
        var r, h;
        this.oo._o = !0;
    }
    Ho() {
        return this.Mh() ? $a1a4d31e28ce1f0d$var$en : this.Oo() ? $a1a4d31e28ce1f0d$var$hn : this.ro() ? (t)=>$a1a4d31e28ce1f0d$var$an(t, this.xo) : null;
    }
    a_(t, i, n) {
        return void 0 === i ? (void 0 === n && (n = this.ba()), n.format(t)) : i(t);
    }
    Wh(t, i) {
        return this.a_(t, this.yo.priceFormatter, i);
    }
    s_(t, i) {
        return this.a_(t, this.yo.percentageFormatter, i);
    }
}
class $a1a4d31e28ce1f0d$var$gn {
    constructor(t, i){
        this.po = [], this.o_ = new Map, this.ho = 0, this.__ = 0, this.u_ = 1e3, this.mo = null, this.c_ = new $a1a4d31e28ce1f0d$var$D, this.yl = t, this.$i = i, this.d_ = new $a1a4d31e28ce1f0d$var$nn(this);
        const n = i.W();
        this.f_ = this.v_("left", n.leftPriceScale), this.p_ = this.v_("right", n.rightPriceScale), this.f_.zo().l(this.m_.bind(this, this.f_), this), this.p_.zo().l(this.m_.bind(this, this.p_), this), this.b_(n);
    }
    b_(t) {
        if (t.leftPriceScale && this.f_.$h(t.leftPriceScale), t.rightPriceScale && this.p_.$h(t.rightPriceScale), t.localization && (this.f_.Ra(), this.p_.Ra()), t.overlayPriceScales) {
            const i = Array.from(this.o_.values());
            for (const n of i){
                const i = $a1a4d31e28ce1f0d$var$b(n[0].Dt());
                i.$h(t.overlayPriceScales), t.localization && i.Ra();
            }
        }
    }
    w_(t) {
        switch(t){
            case "left":
                return this.f_;
            case "right":
                return this.p_;
        }
        return this.o_.has(t) ? $a1a4d31e28ce1f0d$var$m(this.o_.get(t))[0].Dt() : null;
    }
    S() {
        this.$t().g_().p(this), this.f_.zo().p(this), this.p_.zo().p(this), this.po.forEach((t)=>{
            t.S && t.S();
        }), this.c_.m();
    }
    M_() {
        return this.u_;
    }
    x_(t) {
        this.u_ = t;
    }
    $t() {
        return this.$i;
    }
    Hi() {
        return this.__;
    }
    At() {
        return this.ho;
    }
    S_(t) {
        this.__ = t, this.k_();
    }
    Lo(t) {
        this.ho = t, this.f_.Lo(t), this.p_.Lo(t), this.po.forEach((i)=>{
            if (this.vr(i)) {
                const n = i.Dt();
                null !== n && n.Lo(t);
            }
        }), this.k_();
    }
    Ba() {
        return this.po;
    }
    vr(t) {
        const i = t.Dt();
        return null === i || this.f_ !== i && this.p_ !== i;
    }
    qo(t, i, n) {
        const s = void 0 !== n ? n : this.C_().y_ + 1;
        this.T_(t, i, s);
    }
    Zo(t) {
        const i = this.po.indexOf(t);
        $a1a4d31e28ce1f0d$var$p(-1 !== i, "removeDataSource: invalid data source"), this.po.splice(i, 1);
        const n = $a1a4d31e28ce1f0d$var$b(t.Dt()).Pa();
        if (this.o_.has(n)) {
            const i = $a1a4d31e28ce1f0d$var$m(this.o_.get(n)), s = i.indexOf(t);
            -1 !== s && (i.splice(s, 1), 0 === i.length && this.o_.delete(n));
        }
        const s = t.Dt();
        s && s.Ba().indexOf(t) >= 0 && s.Zo(t), null !== s && (s.Yo(), this.P_(s)), this.mo = null;
    }
    mr(t) {
        return t === this.f_ ? "left" : t === this.p_ ? "right" : "overlay";
    }
    R_() {
        return this.f_;
    }
    D_() {
        return this.p_;
    }
    V_(t, i) {
        t.Go(i);
    }
    O_(t, i) {
        t.Jo(i), this.k_();
    }
    B_(t) {
        t.Qo();
    }
    A_(t, i) {
        t.t_(i);
    }
    I_(t, i) {
        t.i_(i), this.k_();
    }
    z_(t) {
        t.n_();
    }
    k_() {
        this.po.forEach((t)=>{
            t.Vn();
        });
    }
    vn() {
        let t = null;
        return this.$i.W().rightPriceScale.visible && 0 !== this.p_.Ba().length ? t = this.p_ : this.$i.W().leftPriceScale.visible && 0 !== this.f_.Ba().length ? t = this.f_ : 0 !== this.po.length && (t = this.po[0].Dt()), null === t && (t = this.p_), t;
    }
    pr() {
        let t = null;
        return this.$i.W().rightPriceScale.visible ? t = this.p_ : this.$i.W().leftPriceScale.visible && (t = this.f_), t;
    }
    P_(t) {
        null !== t && t.Vo() && this.L_(t);
    }
    E_(t) {
        const i = this.yl.Xs();
        t.Ro({
            Wn: !0
        }), null !== i && t.h_(i), this.k_();
    }
    N_() {
        this.L_(this.f_), this.L_(this.p_);
    }
    F_() {
        this.P_(this.f_), this.P_(this.p_), this.po.forEach((t)=>{
            this.vr(t) && this.P_(t.Dt());
        }), this.k_(), this.$i.Uh();
    }
    Uo() {
        return null === this.mo && (this.mo = $a1a4d31e28ce1f0d$var$vn(this.po)), this.mo;
    }
    W_() {
        return this.c_;
    }
    j_() {
        return this.d_;
    }
    L_(t) {
        const i = t.r_();
        if (i && i.length > 0 && !this.yl.Ni()) {
            const i = this.yl.Xs();
            null !== i && t.h_(i);
        }
        t.Vn();
    }
    C_() {
        const t = this.Uo();
        if (0 === t.length) return {
            H_: 0,
            y_: 0
        };
        let i = 0, n = 0;
        for(let s = 0; s < t.length; s++){
            const e = t[s].Xi();
            null !== e && (e < i && (i = e), e > n && (n = e));
        }
        return {
            H_: i,
            y_: n
        };
    }
    T_(t, i, n) {
        let s = this.w_(i);
        if (null === s && (s = this.v_(i, this.$i.W().overlayPriceScales)), this.po.push(t), !$a1a4d31e28ce1f0d$var$_t(i)) {
            const n = this.o_.get(i) || [];
            n.push(t), this.o_.set(i, n);
        }
        s.qo(t), t.Gi(s), t.Ki(n), this.P_(s), this.mo = null;
    }
    m_(t, i, n) {
        i.Cr !== n.Cr && this.L_(t);
    }
    v_(t, i) {
        const n = Object.assign({
            visible: !0,
            autoScale: !0
        }, $a1a4d31e28ce1f0d$var$z(i)), s = new $a1a4d31e28ce1f0d$var$wn(t, n, this.$i.W().layout, this.$i.W().localization);
        return s.Lo(this.At()), s;
    }
}
class $a1a4d31e28ce1f0d$var$Mn {
    constructor(t, i, n = 50){
        this.Ke = 0, this.Ge = 1, this.Je = 1, this.tr = new Map, this.Qe = new Map, this.U_ = t, this.q_ = i, this.ir = n;
    }
    Y_(t) {
        const i = t.time, n = this.q_.cacheKey(i), s = this.tr.get(n);
        if (void 0 !== s) return s.Z_;
        if (this.Ke === this.ir) {
            const t = this.Qe.get(this.Je);
            this.Qe.delete(this.Je), this.tr.delete($a1a4d31e28ce1f0d$var$m(t)), this.Je++, this.Ke--;
        }
        const e = this.U_(t);
        return this.tr.set(n, {
            Z_: e,
            rr: this.Ge
        }), this.Qe.set(this.Ge, n), this.Ke++, this.Ge++, e;
    }
}
class $a1a4d31e28ce1f0d$var$xn {
    constructor(t, i){
        $a1a4d31e28ce1f0d$var$p(t <= i, "right should be >= left"), this.X_ = t, this.K_ = i;
    }
    Os() {
        return this.X_;
    }
    ui() {
        return this.K_;
    }
    G_() {
        return this.K_ - this.X_ + 1;
    }
    Kr(t) {
        return this.X_ <= t && t <= this.K_;
    }
    Ch(t) {
        return this.X_ === t.Os() && this.K_ === t.ui();
    }
}
function $a1a4d31e28ce1f0d$var$Sn(t, i) {
    return null === t || null === i ? t === i : t.Ch(i);
}
class $a1a4d31e28ce1f0d$var$kn {
    constructor(){
        this.J_ = new Map, this.tr = null, this.Q_ = !1;
    }
    tu(t) {
        this.Q_ = t, this.tr = null;
    }
    iu(t, i) {
        this.nu(i), this.tr = null;
        for(let n = i; n < t.length; ++n){
            const i = t[n];
            let s = this.J_.get(i.timeWeight);
            void 0 === s && (s = [], this.J_.set(i.timeWeight, s)), s.push({
                index: n,
                time: i.time,
                weight: i.timeWeight,
                originalTime: i.originalTime
            });
        }
    }
    su(t, i) {
        const n = Math.ceil(i / t);
        return null !== this.tr && this.tr.eu === n || (this.tr = {
            Ha: this.ru(n),
            eu: n
        }), this.tr.Ha;
    }
    nu(t) {
        if (0 === t) return void this.J_.clear();
        const i = [];
        this.J_.forEach((n, s)=>{
            t <= n[0].index ? i.push(s) : n.splice($a1a4d31e28ce1f0d$var$Bt(n, t, (i)=>i.index < t), 1 / 0);
        });
        for (const t of i)this.J_.delete(t);
    }
    ru(t) {
        let i = [];
        for (const n of Array.from(this.J_.keys()).sort((t, i)=>i - t)){
            if (!this.J_.get(n)) continue;
            const s = i;
            i = [];
            const e = s.length;
            let r = 0;
            const h = $a1a4d31e28ce1f0d$var$m(this.J_.get(n)), l = h.length;
            let a = 1 / 0, o = -1 / 0;
            for(let n = 0; n < l; n++){
                const l = h[n], _ = l.index;
                for(; r < e;){
                    const t = s[r], n = t.index;
                    if (!(n < _)) {
                        a = n;
                        break;
                    }
                    r++, i.push(t), o = n, a = 1 / 0;
                }
                if (a - _ >= t && _ - o >= t) i.push(l), o = _;
                else if (this.Q_) return s;
            }
            for(; r < e; r++)i.push(s[r]);
        }
        return i;
    }
}
class $a1a4d31e28ce1f0d$var$yn {
    constructor(t){
        this.hu = t;
    }
    lu() {
        return null === this.hu ? null : new $a1a4d31e28ce1f0d$var$xn(Math.floor(this.hu.Os()), Math.ceil(this.hu.ui()));
    }
    au() {
        return this.hu;
    }
    static ou() {
        return new $a1a4d31e28ce1f0d$var$yn(null);
    }
}
function $a1a4d31e28ce1f0d$var$Cn(t, i) {
    return t.weight > i.weight ? t : i;
}
class $a1a4d31e28ce1f0d$var$Tn {
    constructor(t, i, n, s){
        this.__ = 0, this._u = null, this.uu = [], this.Mo = null, this.wo = null, this.cu = new $a1a4d31e28ce1f0d$var$kn, this.du = new Map, this.fu = $a1a4d31e28ce1f0d$var$yn.ou(), this.vu = !0, this.pu = new $a1a4d31e28ce1f0d$var$D, this.mu = new $a1a4d31e28ce1f0d$var$D, this.bu = new $a1a4d31e28ce1f0d$var$D, this.wu = null, this.gu = null, this.Mu = [], this.cn = i, this.yo = n, this.xu = i.rightOffset, this.Su = i.barSpacing, this.$i = t, this.q_ = s, this.ku(), this.cu.tu(i.uniformDistribution);
    }
    W() {
        return this.cn;
    }
    yu(t) {
        $a1a4d31e28ce1f0d$var$V(this.yo, t), this.Cu(), this.ku();
    }
    $h(t, i) {
        var n;
        $a1a4d31e28ce1f0d$var$V(this.cn, t), this.cn.fixLeftEdge && this.Tu(), this.cn.fixRightEdge && this.Pu(), void 0 !== t.barSpacing && this.$i.Gn(t.barSpacing), void 0 !== t.rightOffset && this.$i.Jn(t.rightOffset), void 0 !== t.minBarSpacing && this.$i.Gn(null !== (n = t.barSpacing) && void 0 !== n ? n : this.Su), this.Cu(), this.ku(), this.bu.m();
    }
    mn(t) {
        var i, n;
        return null !== (n = null === (i = this.uu[t]) || void 0 === i ? void 0 : i.time) && void 0 !== n ? n : null;
    }
    Ui(t) {
        var i;
        return null !== (i = this.uu[t]) && void 0 !== i ? i : null;
    }
    Va(t, i) {
        if (this.uu.length < 1) return null;
        if (this.q_.key(t) > this.q_.key(this.uu[this.uu.length - 1].time)) return i ? this.uu.length - 1 : null;
        const n = $a1a4d31e28ce1f0d$var$Bt(this.uu, this.q_.key(t), (t, i)=>this.q_.key(t.time) < i);
        return this.q_.key(t) < this.q_.key(this.uu[n].time) ? i ? n : null : n;
    }
    Ni() {
        return 0 === this.__ || 0 === this.uu.length || null === this._u;
    }
    Da() {
        return this.uu.length > 0;
    }
    Xs() {
        return this.Ru(), this.fu.lu();
    }
    Du() {
        return this.Ru(), this.fu.au();
    }
    Vu() {
        const t = this.Xs();
        if (null === t) return null;
        const i = {
            from: t.Os(),
            to: t.ui()
        };
        return this.Ou(i);
    }
    Ou(t) {
        const i = Math.round(t.from), n = Math.round(t.to), s = $a1a4d31e28ce1f0d$var$b(this.Bu()), e = $a1a4d31e28ce1f0d$var$b(this.Au());
        return {
            from: $a1a4d31e28ce1f0d$var$b(this.Ui(Math.max(s, i))),
            to: $a1a4d31e28ce1f0d$var$b(this.Ui(Math.min(e, n)))
        };
    }
    Iu(t) {
        return {
            from: $a1a4d31e28ce1f0d$var$b(this.Va(t.from, !0)),
            to: $a1a4d31e28ce1f0d$var$b(this.Va(t.to, !0))
        };
    }
    Hi() {
        return this.__;
    }
    S_(t) {
        if (!isFinite(t) || t <= 0) return;
        if (this.__ === t) return;
        const i = this.Du(), n = this.__;
        if (this.__ = t, this.vu = !0, this.cn.lockVisibleTimeRangeOnResize && 0 !== n) {
            const i = this.Su * t / n;
            this.Su = i;
        }
        if (this.cn.fixLeftEdge && null !== i && i.Os() <= 0) {
            const i = n - t;
            this.xu -= Math.round(i / this.Su) + 1, this.vu = !0;
        }
        this.zu(), this.Lu();
    }
    It(t) {
        if (this.Ni() || !$a1a4d31e28ce1f0d$var$B(t)) return 0;
        const i = this.Eu() + this.xu - t;
        return this.__ - (i + .5) * this.Su - 1;
    }
    Qs(t, i) {
        const n = this.Eu(), s = void 0 === i ? 0 : i.from, e = void 0 === i ? t.length : i.to;
        for(let i = s; i < e; i++){
            const s = t[i].ot, e = n + this.xu - s, r = this.__ - (e + .5) * this.Su - 1;
            t[i].nt = r;
        }
    }
    Nu(t) {
        return Math.ceil(this.Fu(t));
    }
    Jn(t) {
        this.vu = !0, this.xu = t, this.Lu(), this.$i.Wu(), this.$i.Uh();
    }
    le() {
        return this.Su;
    }
    Gn(t) {
        this.ju(t), this.Lu(), this.$i.Wu(), this.$i.Uh();
    }
    Hu() {
        return this.xu;
    }
    Ha() {
        if (this.Ni()) return null;
        if (null !== this.gu) return this.gu;
        const t = this.Su, i = 5 * (this.$i.W().layout.fontSize + 4) / 8 * (this.cn.tickMarkMaxCharacterLength || 8), n = Math.round(i / t), s = $a1a4d31e28ce1f0d$var$b(this.Xs()), e = Math.max(s.Os(), s.Os() - n), r = Math.max(s.ui(), s.ui() - n), h = this.cu.su(t, i), l = this.Bu() + n, a = this.Au() - n, o = this.$u(), _ = this.cn.fixLeftEdge || o, u = this.cn.fixRightEdge || o;
        let c = 0;
        for (const t of h){
            if (!(e <= t.index && t.index <= r)) continue;
            let n;
            c < this.Mu.length ? (n = this.Mu[c], n.coord = this.It(t.index), n.label = this.Uu(t), n.weight = t.weight) : (n = {
                needAlignCoordinate: !1,
                coord: this.It(t.index),
                label: this.Uu(t),
                weight: t.weight
            }, this.Mu.push(n)), this.Su > i / 2 && !o ? n.needAlignCoordinate = !1 : n.needAlignCoordinate = _ && t.index <= l || u && t.index >= a, c++;
        }
        return this.Mu.length = c, this.gu = this.Mu, this.Mu;
    }
    qu() {
        this.vu = !0, this.Gn(this.cn.barSpacing), this.Jn(this.cn.rightOffset);
    }
    Yu(t) {
        this.vu = !0, this._u = t, this.Lu(), this.Tu();
    }
    Zu(t, i) {
        const n = this.Fu(t), s = this.le(), e = s + i * (s / 10);
        this.Gn(e), this.cn.rightBarStaysOnScroll || this.Jn(this.Hu() + (n - this.Fu(t)));
    }
    Go(t) {
        this.Mo && this.n_(), null === this.wo && null === this.wu && (this.Ni() || (this.wo = t, this.Xu()));
    }
    Jo(t) {
        if (null === this.wu) return;
        const i = $a1a4d31e28ce1f0d$var$kt(this.__ - t, 0, this.__), n = $a1a4d31e28ce1f0d$var$kt(this.__ - $a1a4d31e28ce1f0d$var$b(this.wo), 0, this.__);
        0 !== i && 0 !== n && this.Gn(this.wu.le * i / n);
    }
    Qo() {
        null !== this.wo && (this.wo = null, this.Ku());
    }
    t_(t) {
        null === this.Mo && null === this.wu && (this.Ni() || (this.Mo = t, this.Xu()));
    }
    i_(t) {
        if (null === this.Mo) return;
        const i = (this.Mo - t) / this.le();
        this.xu = $a1a4d31e28ce1f0d$var$b(this.wu).Hu + i, this.vu = !0, this.Lu();
    }
    n_() {
        null !== this.Mo && (this.Mo = null, this.Ku());
    }
    Gu() {
        this.Ju(this.cn.rightOffset);
    }
    Ju(t, i = 400) {
        if (!isFinite(t)) throw new RangeError("offset is required and must be finite number");
        if (!isFinite(i) || i <= 0) throw new RangeError("animationDuration (optional) must be finite positive number");
        const n = this.xu, s = performance.now();
        this.$i.Zn({
            Qu: (t)=>(t - s) / i >= 1,
            tc: (e)=>{
                const r = (e - s) / i;
                return r >= 1 ? t : n + (t - n) * r;
            }
        });
    }
    bt(t, i) {
        this.vu = !0, this.uu = t, this.cu.iu(t, i), this.Lu();
    }
    nc() {
        return this.pu;
    }
    sc() {
        return this.mu;
    }
    ec() {
        return this.bu;
    }
    Eu() {
        return this._u || 0;
    }
    rc(t) {
        const i = t.G_();
        this.ju(this.__ / i), this.xu = t.ui() - this.Eu(), this.Lu(), this.vu = !0, this.$i.Wu(), this.$i.Uh();
    }
    hc() {
        const t = this.Bu(), i = this.Au();
        null !== t && null !== i && this.rc(new $a1a4d31e28ce1f0d$var$xn(t, i + this.cn.rightOffset));
    }
    lc(t) {
        const i = new $a1a4d31e28ce1f0d$var$xn(t.from, t.to);
        this.rc(i);
    }
    qi(t) {
        return void 0 !== this.yo.timeFormatter ? this.yo.timeFormatter(t.originalTime) : this.q_.formatHorzItem(t.time);
    }
    $u() {
        const { handleScroll: t, handleScale: i } = this.$i.W();
        return !(t.horzTouchDrag || t.mouseWheel || t.pressedMouseMove || t.vertTouchDrag || i.axisDoubleClickReset.time || i.axisPressedMouseMove.time || i.mouseWheel || i.pinch);
    }
    Bu() {
        return 0 === this.uu.length ? null : 0;
    }
    Au() {
        return 0 === this.uu.length ? null : this.uu.length - 1;
    }
    ac(t) {
        return (this.__ - 1 - t) / this.Su;
    }
    Fu(t) {
        const i = this.ac(t), n = this.Eu() + this.xu - i;
        return Math.round(1e6 * n) / 1e6;
    }
    ju(t) {
        const i = this.Su;
        this.Su = t, this.zu(), i !== this.Su && (this.vu = !0, this.oc());
    }
    Ru() {
        if (!this.vu) return;
        if (this.vu = !1, this.Ni()) return void this._c($a1a4d31e28ce1f0d$var$yn.ou());
        const t = this.Eu(), i = this.__ / this.Su, n = this.xu + t, s = new $a1a4d31e28ce1f0d$var$xn(n - i + 1, n);
        this._c(new $a1a4d31e28ce1f0d$var$yn(s));
    }
    zu() {
        const t = this.uc();
        if (this.Su < t && (this.Su = t, this.vu = !0), 0 !== this.__) {
            const t = .5 * this.__;
            this.Su > t && (this.Su = t, this.vu = !0);
        }
    }
    uc() {
        return this.cn.fixLeftEdge && this.cn.fixRightEdge && 0 !== this.uu.length ? this.__ / this.uu.length : this.cn.minBarSpacing;
    }
    Lu() {
        const t = this.cc();
        null !== t && this.xu < t && (this.xu = t, this.vu = !0);
        const i = this.dc();
        this.xu > i && (this.xu = i, this.vu = !0);
    }
    cc() {
        const t = this.Bu(), i = this._u;
        if (null === t || null === i) return null;
        return t - i - 1 + (this.cn.fixLeftEdge ? this.__ / this.Su : Math.min(2, this.uu.length));
    }
    dc() {
        return this.cn.fixRightEdge ? 0 : this.__ / this.Su - Math.min(2, this.uu.length);
    }
    Xu() {
        this.wu = {
            le: this.le(),
            Hu: this.Hu()
        };
    }
    Ku() {
        this.wu = null;
    }
    Uu(t) {
        let i = this.du.get(t.weight);
        return void 0 === i && (i = new $a1a4d31e28ce1f0d$var$Mn((t)=>this.fc(t), this.q_), this.du.set(t.weight, i)), i.Y_(t);
    }
    fc(t) {
        return this.q_.formatTickmark(t, this.yo);
    }
    _c(t) {
        const i = this.fu;
        this.fu = t, $a1a4d31e28ce1f0d$var$Sn(i.lu(), this.fu.lu()) || this.pu.m(), $a1a4d31e28ce1f0d$var$Sn(i.au(), this.fu.au()) || this.mu.m(), this.oc();
    }
    oc() {
        this.gu = null;
    }
    Cu() {
        this.oc(), this.du.clear();
    }
    ku() {
        this.q_.updateFormatter(this.yo);
    }
    Tu() {
        if (!this.cn.fixLeftEdge) return;
        const t = this.Bu();
        if (null === t) return;
        const i = this.Xs();
        if (null === i) return;
        const n = i.Os() - t;
        if (n < 0) {
            const t = this.xu - n - 1;
            this.Jn(t);
        }
        this.zu();
    }
    Pu() {
        this.Lu(), this.zu();
    }
}
class $a1a4d31e28ce1f0d$var$Pn {
    X(t, i, n) {
        t.useMediaCoordinateSpace((t)=>this.K(t, i, n));
    }
    gl(t, i, n) {
        t.useMediaCoordinateSpace((t)=>this.vc(t, i, n));
    }
    vc(t, i, n) {}
}
class $a1a4d31e28ce1f0d$var$Rn extends $a1a4d31e28ce1f0d$var$Pn {
    constructor(t){
        super(), this.mc = new Map, this.zt = t;
    }
    K(t) {}
    vc(t) {
        if (!this.zt.yt) return;
        const { context: i, mediaSize: n } = t;
        let s = 0;
        for (const t of this.zt.bc){
            if (0 === t.Kt.length) continue;
            i.font = t.R;
            const e = this.wc(i, t.Kt);
            e > n.width ? t.Zu = n.width / e : t.Zu = 1, s += t.gc * t.Zu;
        }
        let e = 0;
        switch(this.zt.Mc){
            case "top":
                e = 0;
                break;
            case "center":
                e = Math.max((n.height - s) / 2, 0);
                break;
            case "bottom":
                e = Math.max(n.height - s, 0);
        }
        i.fillStyle = this.zt.V;
        for (const t of this.zt.bc){
            i.save();
            let s = 0;
            switch(this.zt.xc){
                case "left":
                    i.textAlign = "left", s = t.gc / 2;
                    break;
                case "center":
                    i.textAlign = "center", s = n.width / 2;
                    break;
                case "right":
                    i.textAlign = "right", s = n.width - 1 - t.gc / 2;
            }
            i.translate(s, e), i.textBaseline = "top", i.font = t.R, i.scale(t.Zu, t.Zu), i.fillText(t.Kt, 0, t.Sc), i.restore(), e += t.gc * t.Zu;
        }
    }
    wc(t, i) {
        const n = this.kc(t.font);
        let s = n.get(i);
        return void 0 === s && (s = t.measureText(i).width, n.set(i, s)), s;
    }
    kc(t) {
        let i = this.mc.get(t);
        return void 0 === i && (i = new Map, this.mc.set(t, i)), i;
    }
}
class $a1a4d31e28ce1f0d$var$Dn {
    constructor(t){
        this.ft = !0, this.Ft = {
            yt: !1,
            V: "",
            bc: [],
            Mc: "center",
            xc: "center"
        }, this.Wt = new $a1a4d31e28ce1f0d$var$Rn(this.Ft), this.jt = t;
    }
    bt() {
        this.ft = !0;
    }
    gt() {
        return this.ft && (this.Mt(), this.ft = !1), this.Wt;
    }
    Mt() {
        const t = this.jt.W(), i = this.Ft;
        i.yt = t.visible, i.yt && (i.V = t.color, i.xc = t.horzAlign, i.Mc = t.vertAlign, i.bc = [
            {
                Kt: t.text,
                R: $a1a4d31e28ce1f0d$var$F(t.fontSize, t.fontFamily, t.fontStyle),
                gc: 1.2 * t.fontSize,
                Sc: 0,
                Zu: 0
            }
        ]);
    }
}
class $a1a4d31e28ce1f0d$var$Vn extends $a1a4d31e28ce1f0d$var$lt {
    constructor(t, i){
        super(), this.cn = i, this.wn = new $a1a4d31e28ce1f0d$var$Dn(this);
    }
    Rn() {
        return [];
    }
    Pn() {
        return [
            this.wn
        ];
    }
    W() {
        return this.cn;
    }
    Vn() {
        this.wn.bt();
    }
}
var $a1a4d31e28ce1f0d$export$8515895ecde62c70, $a1a4d31e28ce1f0d$export$cac7f40581f5d090, $a1a4d31e28ce1f0d$export$10777445820939da, $a1a4d31e28ce1f0d$export$2cd82751acc0e609, $a1a4d31e28ce1f0d$export$2f85f4e66fc865ef;
!function(t) {
    t[t.OnTouchEnd = 0] = "OnTouchEnd", t[t.OnNextTap = 1] = "OnNextTap";
}($a1a4d31e28ce1f0d$export$8515895ecde62c70 || ($a1a4d31e28ce1f0d$export$8515895ecde62c70 = {}));
class $a1a4d31e28ce1f0d$var$Ln {
    constructor(t, i, n){
        this.yc = [], this.Cc = [], this.__ = 0, this.Tc = null, this.Pc = new $a1a4d31e28ce1f0d$var$D, this.Rc = new $a1a4d31e28ce1f0d$var$D, this.Dc = null, this.Vc = t, this.cn = i, this.q_ = n, this.Oc = new $a1a4d31e28ce1f0d$var$W(this), this.yl = new $a1a4d31e28ce1f0d$var$Tn(this, i.timeScale, this.cn.localization, n), this.vt = new $a1a4d31e28ce1f0d$var$ot(this, i.crosshair), this.Bc = new $a1a4d31e28ce1f0d$var$Ji(i.crosshair), this.Ac = new $a1a4d31e28ce1f0d$var$Vn(this, i.watermark), this.Ic(), this.yc[0].x_(2e3), this.zc = this.Lc(0), this.Ec = this.Lc(1);
    }
    Kl() {
        this.Nc($a1a4d31e28ce1f0d$var$ut.es());
    }
    Uh() {
        this.Nc($a1a4d31e28ce1f0d$var$ut.ss());
    }
    oa() {
        this.Nc(new $a1a4d31e28ce1f0d$var$ut(1));
    }
    Gl(t) {
        const i = this.Fc(t);
        this.Nc(i);
    }
    Wc() {
        return this.Tc;
    }
    jc(t) {
        const i = this.Tc;
        this.Tc = t, null !== i && this.Gl(i.Hc), null !== t && this.Gl(t.Hc);
    }
    W() {
        return this.cn;
    }
    $h(t) {
        $a1a4d31e28ce1f0d$var$V(this.cn, t), this.yc.forEach((i)=>i.b_(t)), void 0 !== t.timeScale && this.yl.$h(t.timeScale), void 0 !== t.localization && this.yl.yu(t.localization), (t.leftPriceScale || t.rightPriceScale) && this.Pc.m(), this.zc = this.Lc(0), this.Ec = this.Lc(1), this.Kl();
    }
    $c(t, i) {
        if ("left" === t) return void this.$h({
            leftPriceScale: i
        });
        if ("right" === t) return void this.$h({
            rightPriceScale: i
        });
        const n = this.Uc(t);
        null !== n && (n.Dt.$h(i), this.Pc.m());
    }
    Uc(t) {
        for (const i of this.yc){
            const n = i.w_(t);
            if (null !== n) return {
                Ht: i,
                Dt: n
            };
        }
        return null;
    }
    St() {
        return this.yl;
    }
    qc() {
        return this.yc;
    }
    Yc() {
        return this.Ac;
    }
    Zc() {
        return this.vt;
    }
    Xc() {
        return this.Rc;
    }
    Kc(t, i) {
        t.Lo(i), this.Wu();
    }
    S_(t) {
        this.__ = t, this.yl.S_(this.__), this.yc.forEach((i)=>i.S_(t)), this.Wu();
    }
    Ic(t) {
        const i = new $a1a4d31e28ce1f0d$var$gn(this.yl, this);
        void 0 !== t ? this.yc.splice(t, 0, i) : this.yc.push(i);
        const n = void 0 === t ? this.yc.length - 1 : t, s = $a1a4d31e28ce1f0d$var$ut.es();
        return s.Nn(n, {
            Fn: 0,
            Wn: !0
        }), this.Nc(s), i;
    }
    V_(t, i, n) {
        t.V_(i, n);
    }
    O_(t, i, n) {
        t.O_(i, n), this.Jl(), this.Nc(this.Gc(t, 2));
    }
    B_(t, i) {
        t.B_(i), this.Nc(this.Gc(t, 2));
    }
    A_(t, i, n) {
        i.Vo() || t.A_(i, n);
    }
    I_(t, i, n) {
        i.Vo() || (t.I_(i, n), this.Jl(), this.Nc(this.Gc(t, 2)));
    }
    z_(t, i) {
        i.Vo() || (t.z_(i), this.Nc(this.Gc(t, 2)));
    }
    E_(t, i) {
        t.E_(i), this.Nc(this.Gc(t, 2));
    }
    Jc(t) {
        this.yl.Go(t);
    }
    Qc(t, i) {
        const n = this.St();
        if (n.Ni() || 0 === i) return;
        const s = n.Hi();
        t = Math.max(1, Math.min(t, s)), n.Zu(t, i), this.Wu();
    }
    td(t) {
        this.nd(0), this.sd(t), this.ed();
    }
    rd(t) {
        this.yl.Jo(t), this.Wu();
    }
    hd() {
        this.yl.Qo(), this.Uh();
    }
    nd(t) {
        this.yl.t_(t);
    }
    sd(t) {
        this.yl.i_(t), this.Wu();
    }
    ed() {
        this.yl.n_(), this.Uh();
    }
    wt() {
        return this.Cc;
    }
    ld(t, i, n, s, e) {
        this.vt.gn(t, i);
        let r = NaN, h = this.yl.Nu(t);
        const l = this.yl.Xs();
        null !== l && (h = Math.min(Math.max(l.Os(), h), l.ui()));
        const a = s.vn(), o = a.Ct();
        null !== o && (r = a.pn(i, o)), r = this.Bc.Oa(r, h, s), this.vt.kn(h, r, s), this.oa(), e || this.Rc.m(this.vt.xt(), {
            x: t,
            y: i
        }, n);
    }
    ad(t, i, n) {
        const s = n.vn(), e = s.Ct(), r = s.Rt(t, $a1a4d31e28ce1f0d$var$b(e)), h = this.yl.Va(i, !0), l = this.yl.It($a1a4d31e28ce1f0d$var$b(h));
        this.ld(l, r, null, n, !0);
    }
    od(t) {
        this.Zc().Cn(), this.oa(), t || this.Rc.m(null, null, null);
    }
    Jl() {
        const t = this.vt.Ht();
        if (null !== t) {
            const i = this.vt.xn(), n = this.vt.Sn();
            this.ld(i, n, null, t);
        }
        this.vt.Vn();
    }
    _d(t, i, n) {
        const s = this.yl.mn(0);
        void 0 !== i && void 0 !== n && this.yl.bt(i, n);
        const e = this.yl.mn(0), r = this.yl.Eu(), h = this.yl.Xs();
        if (null !== h && null !== s && null !== e) {
            const i = h.Kr(r), l = this.q_.key(s) > this.q_.key(e), a = null !== t && t > r && !l, o = this.yl.W().allowShiftVisibleRangeOnWhitespaceReplacement, _ = i && (!(void 0 === n) || o) && this.yl.W().shiftVisibleRangeOnNewBar;
            if (a && !_) {
                const i = t - r;
                this.yl.Jn(this.yl.Hu() - i);
            }
        }
        this.yl.Yu(t);
    }
    ia(t) {
        null !== t && t.F_();
    }
    dr(t) {
        const i = this.yc.find((i)=>i.Uo().includes(t));
        return void 0 === i ? null : i;
    }
    Wu() {
        this.Ac.Vn(), this.yc.forEach((t)=>t.F_()), this.Jl();
    }
    S() {
        this.yc.forEach((t)=>t.S()), this.yc.length = 0, this.cn.localization.priceFormatter = void 0, this.cn.localization.percentageFormatter = void 0, this.cn.localization.timeFormatter = void 0;
    }
    ud() {
        return this.Oc;
    }
    br() {
        return this.Oc.W();
    }
    g_() {
        return this.Pc;
    }
    dd(t, i, n) {
        const s = this.yc[0], e = this.fd(i, t, s, n);
        return this.Cc.push(e), 1 === this.Cc.length ? this.Kl() : this.Uh(), e;
    }
    vd(t) {
        const i = this.dr(t), n = this.Cc.indexOf(t);
        $a1a4d31e28ce1f0d$var$p(-1 !== n, "Series not found"), this.Cc.splice(n, 1), $a1a4d31e28ce1f0d$var$b(i).Zo(t), t.S && t.S();
    }
    Xl(t, i) {
        const n = $a1a4d31e28ce1f0d$var$b(this.dr(t));
        n.Zo(t);
        const s = this.Uc(i);
        if (null === s) {
            const s = t.Xi();
            n.qo(t, i, s);
        } else {
            const e = s.Ht === n ? t.Xi() : void 0;
            s.Ht.qo(t, i, e);
        }
    }
    hc() {
        const t = $a1a4d31e28ce1f0d$var$ut.ss();
        t.$n(), this.Nc(t);
    }
    pd(t) {
        const i = $a1a4d31e28ce1f0d$var$ut.ss();
        i.Yn(t), this.Nc(i);
    }
    Kn() {
        const t = $a1a4d31e28ce1f0d$var$ut.ss();
        t.Kn(), this.Nc(t);
    }
    Gn(t) {
        const i = $a1a4d31e28ce1f0d$var$ut.ss();
        i.Gn(t), this.Nc(i);
    }
    Jn(t) {
        const i = $a1a4d31e28ce1f0d$var$ut.ss();
        i.Jn(t), this.Nc(i);
    }
    Zn(t) {
        const i = $a1a4d31e28ce1f0d$var$ut.ss();
        i.Zn(t), this.Nc(i);
    }
    Un() {
        const t = $a1a4d31e28ce1f0d$var$ut.ss();
        t.Un(), this.Nc(t);
    }
    md() {
        return this.cn.rightPriceScale.visible ? "right" : "left";
    }
    bd() {
        return this.Ec;
    }
    q() {
        return this.zc;
    }
    Bt(t) {
        const i = this.Ec, n = this.zc;
        if (i === n) return i;
        if (t = Math.max(0, Math.min(100, Math.round(100 * t))), null === this.Dc || this.Dc.Ps !== n || this.Dc.Rs !== i) this.Dc = {
            Ps: n,
            Rs: i,
            wd: new Map
        };
        else {
            const i = this.Dc.wd.get(t);
            if (void 0 !== i) return i;
        }
        const s = function(t, i, n) {
            const [s, e, r, h] = $a1a4d31e28ce1f0d$var$T(t), [l, a, o, _] = $a1a4d31e28ce1f0d$var$T(i), u = [
                $a1a4d31e28ce1f0d$var$M(s + n * (l - s)),
                $a1a4d31e28ce1f0d$var$M(e + n * (a - e)),
                $a1a4d31e28ce1f0d$var$M(r + n * (o - r)),
                $a1a4d31e28ce1f0d$var$x(h + n * (_ - h))
            ];
            return `rgba(${u[0]}, ${u[1]}, ${u[2]}, ${u[3]})`;
        }(n, i, t / 100);
        return this.Dc.wd.set(t, s), s;
    }
    Gc(t, i) {
        const n = new $a1a4d31e28ce1f0d$var$ut(i);
        if (null !== t) {
            const s = this.yc.indexOf(t);
            n.Nn(s, {
                Fn: i
            });
        }
        return n;
    }
    Fc(t, i) {
        return void 0 === i && (i = 2), this.Gc(this.dr(t), i);
    }
    Nc(t) {
        this.Vc && this.Vc(t), this.yc.forEach((t)=>t.j_().qh().bt());
    }
    fd(t, i, n, s) {
        const e = new $a1a4d31e28ce1f0d$var$Gi(this, t, i, n, s), r = void 0 !== t.priceScaleId ? t.priceScaleId : this.md();
        return n.qo(e, r), $a1a4d31e28ce1f0d$var$_t(r) || e.$h(t), e;
    }
    Lc(t) {
        const i = this.cn.layout;
        return "gradient" === i.background.type ? 0 === t ? i.background.topColor : i.background.bottomColor : i.background.color;
    }
}
function $a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(t) {
    return !$a1a4d31e28ce1f0d$var$O(t) && !$a1a4d31e28ce1f0d$var$A(t);
}
function $a1a4d31e28ce1f0d$export$d45648b9f1f4eae6(t) {
    return $a1a4d31e28ce1f0d$var$O(t);
}
!function(t) {
    t[t.Disabled = 0] = "Disabled", t[t.Continuous = 1] = "Continuous", t[t.OnDataUpdate = 2] = "OnDataUpdate";
}($a1a4d31e28ce1f0d$export$cac7f40581f5d090 || ($a1a4d31e28ce1f0d$export$cac7f40581f5d090 = {})), function(t) {
    t[t.LastBar = 0] = "LastBar", t[t.LastVisible = 1] = "LastVisible";
}($a1a4d31e28ce1f0d$export$10777445820939da || ($a1a4d31e28ce1f0d$export$10777445820939da = {})), function(t) {
    t.Solid = "solid", t.VerticalGradient = "gradient";
}($a1a4d31e28ce1f0d$export$2cd82751acc0e609 || ($a1a4d31e28ce1f0d$export$2cd82751acc0e609 = {})), function(t) {
    t[t.Year = 0] = "Year", t[t.Month = 1] = "Month", t[t.DayOfMonth = 2] = "DayOfMonth", t[t.Time = 3] = "Time", t[t.TimeWithSeconds = 4] = "TimeWithSeconds";
}($a1a4d31e28ce1f0d$export$2f85f4e66fc865ef || ($a1a4d31e28ce1f0d$export$2f85f4e66fc865ef = {}));
const $a1a4d31e28ce1f0d$var$Fn = (t)=>t.getUTCFullYear();
function $a1a4d31e28ce1f0d$var$Wn(t, i, n) {
    return i.replace(/yyyy/g, ((t)=>$a1a4d31e28ce1f0d$var$dt($a1a4d31e28ce1f0d$var$Fn(t), 4))(t)).replace(/yy/g, ((t)=>$a1a4d31e28ce1f0d$var$dt($a1a4d31e28ce1f0d$var$Fn(t) % 100, 2))(t)).replace(/MMMM/g, ((t, i)=>new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "long"
        }))(t, n)).replace(/MMM/g, ((t, i)=>new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "short"
        }))(t, n)).replace(/MM/g, ((t)=>$a1a4d31e28ce1f0d$var$dt(((t)=>t.getUTCMonth() + 1)(t), 2))(t)).replace(/dd/g, ((t)=>$a1a4d31e28ce1f0d$var$dt(((t)=>t.getUTCDate())(t), 2))(t));
}
class $a1a4d31e28ce1f0d$var$jn {
    constructor(t = "yyyy-MM-dd", i = "default"){
        this.gd = t, this.Md = i;
    }
    Y_(t) {
        return $a1a4d31e28ce1f0d$var$Wn(t, this.gd, this.Md);
    }
}
class $a1a4d31e28ce1f0d$var$Hn {
    constructor(t){
        this.xd = t || "%h:%m:%s";
    }
    Y_(t) {
        return this.xd.replace("%h", $a1a4d31e28ce1f0d$var$dt(t.getUTCHours(), 2)).replace("%m", $a1a4d31e28ce1f0d$var$dt(t.getUTCMinutes(), 2)).replace("%s", $a1a4d31e28ce1f0d$var$dt(t.getUTCSeconds(), 2));
    }
}
const $a1a4d31e28ce1f0d$var$$n = {
    Sd: "yyyy-MM-dd",
    kd: "%h:%m:%s",
    yd: " ",
    Cd: "default"
};
class $a1a4d31e28ce1f0d$var$Un {
    constructor(t = {}){
        const i = Object.assign(Object.assign({}, $a1a4d31e28ce1f0d$var$$n), t);
        this.Td = new $a1a4d31e28ce1f0d$var$jn(i.Sd, i.Cd), this.Pd = new $a1a4d31e28ce1f0d$var$Hn(i.kd), this.Rd = i.yd;
    }
    Y_(t) {
        return `${this.Td.Y_(t)}${this.Rd}${this.Pd.Y_(t)}`;
    }
}
function $a1a4d31e28ce1f0d$var$qn(t) {
    return 60 * t * 60000;
}
function $a1a4d31e28ce1f0d$var$Yn(t) {
    return 60 * t * 1e3;
}
const $a1a4d31e28ce1f0d$var$Zn = [
    {
        Dd: ($a1a4d31e28ce1f0d$var$Xn = 1, 1e3 * $a1a4d31e28ce1f0d$var$Xn),
        Vd: 10
    },
    {
        Dd: $a1a4d31e28ce1f0d$var$Yn(1),
        Vd: 20
    },
    {
        Dd: $a1a4d31e28ce1f0d$var$Yn(5),
        Vd: 21
    },
    {
        Dd: $a1a4d31e28ce1f0d$var$Yn(30),
        Vd: 22
    },
    {
        Dd: $a1a4d31e28ce1f0d$var$qn(1),
        Vd: 30
    },
    {
        Dd: $a1a4d31e28ce1f0d$var$qn(3),
        Vd: 31
    },
    {
        Dd: $a1a4d31e28ce1f0d$var$qn(6),
        Vd: 32
    },
    {
        Dd: $a1a4d31e28ce1f0d$var$qn(12),
        Vd: 33
    }
];
var $a1a4d31e28ce1f0d$var$Xn;
function $a1a4d31e28ce1f0d$var$Kn(t, i) {
    if (t.getUTCFullYear() !== i.getUTCFullYear()) return 70;
    if (t.getUTCMonth() !== i.getUTCMonth()) return 60;
    if (t.getUTCDate() !== i.getUTCDate()) return 50;
    for(let n = $a1a4d31e28ce1f0d$var$Zn.length - 1; n >= 0; --n)if (Math.floor(i.getTime() / $a1a4d31e28ce1f0d$var$Zn[n].Dd) !== Math.floor(t.getTime() / $a1a4d31e28ce1f0d$var$Zn[n].Dd)) return $a1a4d31e28ce1f0d$var$Zn[n].Vd;
    return 0;
}
function $a1a4d31e28ce1f0d$var$Gn(t) {
    let i = t;
    if ($a1a4d31e28ce1f0d$var$A(t) && (i = $a1a4d31e28ce1f0d$var$Qn(t)), !$a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(i)) throw new Error("time must be of type BusinessDay");
    const n = new Date(Date.UTC(i.year, i.month - 1, i.day, 0, 0, 0, 0));
    return {
        Od: Math.round(n.getTime() / 1e3),
        Bd: i
    };
}
function $a1a4d31e28ce1f0d$var$Jn(t) {
    if (!$a1a4d31e28ce1f0d$export$d45648b9f1f4eae6(t)) throw new Error("time must be of type isUTCTimestamp");
    return {
        Od: t
    };
}
function $a1a4d31e28ce1f0d$var$Qn(t) {
    const i = new Date(t);
    if (isNaN(i.getTime())) throw new Error(`Invalid date string=${t}, expected format=yyyy-mm-dd`);
    return {
        day: i.getUTCDate(),
        month: i.getUTCMonth() + 1,
        year: i.getUTCFullYear()
    };
}
function $a1a4d31e28ce1f0d$var$ts(t) {
    $a1a4d31e28ce1f0d$var$A(t.time) && (t.time = $a1a4d31e28ce1f0d$var$Qn(t.time));
}
class $a1a4d31e28ce1f0d$var$is {
    options() {
        return this.cn;
    }
    setOptions(t) {
        this.cn = t, this.updateFormatter(t.localization);
    }
    preprocessData(t) {
        Array.isArray(t) ? function(t) {
            t.forEach($a1a4d31e28ce1f0d$var$ts);
        }(t) : $a1a4d31e28ce1f0d$var$ts(t);
    }
    createConverterToInternalObj(t) {
        return $a1a4d31e28ce1f0d$var$b(function(t) {
            return 0 === t.length ? null : $a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(t[0].time) || $a1a4d31e28ce1f0d$var$A(t[0].time) ? $a1a4d31e28ce1f0d$var$Gn : $a1a4d31e28ce1f0d$var$Jn;
        }(t));
    }
    key(t) {
        return "object" == typeof t && "Od" in t ? t.Od : this.key(this.convertHorzItemToInternal(t));
    }
    cacheKey(t) {
        const i = t;
        return void 0 === i.Bd ? new Date(1e3 * i.Od).getTime() : new Date(Date.UTC(i.Bd.year, i.Bd.month - 1, i.Bd.day)).getTime();
    }
    convertHorzItemToInternal(t) {
        var i;
        return $a1a4d31e28ce1f0d$export$d45648b9f1f4eae6(i = t) ? $a1a4d31e28ce1f0d$var$Jn(i) : $a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(i) ? $a1a4d31e28ce1f0d$var$Gn(i) : $a1a4d31e28ce1f0d$var$Gn($a1a4d31e28ce1f0d$var$Qn(i));
    }
    updateFormatter(t) {
        if (!this.cn) return;
        const i = t.dateFormat;
        this.cn.timeScale.timeVisible ? this.Ad = new $a1a4d31e28ce1f0d$var$Un({
            Sd: i,
            kd: this.cn.timeScale.secondsVisible ? "%h:%m:%s" : "%h:%m",
            yd: "   ",
            Cd: t.locale
        }) : this.Ad = new $a1a4d31e28ce1f0d$var$jn(i, t.locale);
    }
    formatHorzItem(t) {
        const i = t;
        return this.Ad.Y_(new Date(1e3 * i.Od));
    }
    formatTickmark(t, i) {
        const n = function(t, i, n) {
            switch(t){
                case 0:
                case 10:
                    return i ? n ? 4 : 3 : 2;
                case 20:
                case 21:
                case 22:
                case 30:
                case 31:
                case 32:
                case 33:
                    return i ? 3 : 2;
                case 50:
                    return 2;
                case 60:
                    return 1;
                case 70:
                    return 0;
            }
        }(t.weight, this.cn.timeScale.timeVisible, this.cn.timeScale.secondsVisible), s = this.cn.timeScale;
        if (void 0 !== s.tickMarkFormatter) {
            const e = s.tickMarkFormatter(t.originalTime, n, i.locale);
            if (null !== e) return e;
        }
        return function(t, i, n) {
            const s = {};
            switch(i){
                case 0:
                    s.year = "numeric";
                    break;
                case 1:
                    s.month = "short";
                    break;
                case 2:
                    s.day = "numeric";
                    break;
                case 3:
                    s.hour12 = !1, s.hour = "2-digit", s.minute = "2-digit";
                    break;
                case 4:
                    s.hour12 = !1, s.hour = "2-digit", s.minute = "2-digit", s.second = "2-digit";
            }
            const e = void 0 === t.Bd ? new Date(1e3 * t.Od) : new Date(Date.UTC(t.Bd.year, t.Bd.month - 1, t.Bd.day));
            return new Date(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()).toLocaleString(n, s);
        }(t.time, n, i.locale);
    }
    maxTickMarkWeight(t) {
        let i = t.reduce($a1a4d31e28ce1f0d$var$Cn, t[0]).weight;
        return i > 30 && i < 50 && (i = 30), i;
    }
    fillWeightsForPoints(t, i) {
        !function(t, i = 0) {
            if (0 === t.length) return;
            let n = 0 === i ? null : t[i - 1].time.Od, s = null !== n ? new Date(1e3 * n) : null, e = 0;
            for(let r = i; r < t.length; ++r){
                const i = t[r], h = new Date(1e3 * i.time.Od);
                null !== s && (i.timeWeight = $a1a4d31e28ce1f0d$var$Kn(h, s)), e += i.time.Od - (n || i.time.Od), n = i.time.Od, s = h;
            }
            if (0 === i && t.length > 1) {
                const i = Math.ceil(e / (t.length - 1)), n = new Date(1e3 * (t[0].time.Od - i));
                t[0].timeWeight = $a1a4d31e28ce1f0d$var$Kn(new Date(1e3 * t[0].time.Od), n);
            }
        }(t, i);
    }
    static Id(t) {
        return $a1a4d31e28ce1f0d$var$V({
            localization: {
                dateFormat: "dd MMM 'yy"
            }
        }, null != t ? t : {});
    }
}
const $a1a4d31e28ce1f0d$var$ns = "undefined" != typeof window;
function $a1a4d31e28ce1f0d$var$ss() {
    return !!$a1a4d31e28ce1f0d$var$ns && window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
}
function $a1a4d31e28ce1f0d$var$es() {
    return !!$a1a4d31e28ce1f0d$var$ns && /iPhone|iPad|iPod/.test(window.navigator.platform);
}
function $a1a4d31e28ce1f0d$var$rs(t) {
    return t + t % 2;
}
function $a1a4d31e28ce1f0d$var$hs(t, i) {
    return t.zd - i.zd;
}
function $a1a4d31e28ce1f0d$var$ls(t, i, n) {
    const s = (t.zd - i.zd) / (t.ot - i.ot);
    return Math.sign(s) * Math.min(Math.abs(s), n);
}
class $a1a4d31e28ce1f0d$var$as {
    constructor(t, i, n, s){
        this.Ld = null, this.Ed = null, this.Nd = null, this.Fd = null, this.Wd = null, this.jd = 0, this.Hd = 0, this.$d = t, this.Ud = i, this.qd = n, this.rs = s;
    }
    Yd(t, i) {
        if (null !== this.Ld) {
            if (this.Ld.ot === i) return void (this.Ld.zd = t);
            if (Math.abs(this.Ld.zd - t) < this.rs) return;
        }
        this.Fd = this.Nd, this.Nd = this.Ed, this.Ed = this.Ld, this.Ld = {
            ot: i,
            zd: t
        };
    }
    Vr(t, i) {
        if (null === this.Ld || null === this.Ed) return;
        if (i - this.Ld.ot > 50) return;
        let n = 0;
        const s = $a1a4d31e28ce1f0d$var$ls(this.Ld, this.Ed, this.Ud), e = $a1a4d31e28ce1f0d$var$hs(this.Ld, this.Ed), r = [
            s
        ], h = [
            e
        ];
        if (n += e, null !== this.Nd) {
            const t = $a1a4d31e28ce1f0d$var$ls(this.Ed, this.Nd, this.Ud);
            if (Math.sign(t) === Math.sign(s)) {
                const i = $a1a4d31e28ce1f0d$var$hs(this.Ed, this.Nd);
                if (r.push(t), h.push(i), n += i, null !== this.Fd) {
                    const t = $a1a4d31e28ce1f0d$var$ls(this.Nd, this.Fd, this.Ud);
                    if (Math.sign(t) === Math.sign(s)) {
                        const i = $a1a4d31e28ce1f0d$var$hs(this.Nd, this.Fd);
                        r.push(t), h.push(i), n += i;
                    }
                }
            }
        }
        let l = 0;
        for(let t = 0; t < r.length; ++t)l += h[t] / n * r[t];
        Math.abs(l) < this.$d || (this.Wd = {
            zd: t,
            ot: i
        }, this.Hd = l, this.jd = function(t, i) {
            const n = Math.log(i);
            return Math.log(1 * n / -t) / n;
        }(Math.abs(l), this.qd));
    }
    tc(t) {
        const i = $a1a4d31e28ce1f0d$var$b(this.Wd), n = t - i.ot;
        return i.zd + this.Hd * (Math.pow(this.qd, n) - 1) / Math.log(this.qd);
    }
    Qu(t) {
        return null === this.Wd || this.Zd(t) === this.jd;
    }
    Zd(t) {
        const i = t - $a1a4d31e28ce1f0d$var$b(this.Wd).ot;
        return Math.min(i, this.jd);
    }
}
class $a1a4d31e28ce1f0d$var$os {
    constructor(t, i){
        this.Xd = void 0, this.Kd = void 0, this.Gd = void 0, this.en = !1, this.Jd = t, this.Qd = i, this.tf();
    }
    bt() {
        this.tf();
    }
    if() {
        this.Xd && this.Jd.removeChild(this.Xd), this.Kd && this.Jd.removeChild(this.Kd), this.Xd = void 0, this.Kd = void 0;
    }
    nf() {
        return this.en !== this.sf() || this.Gd !== this.ef();
    }
    ef() {
        return $a1a4d31e28ce1f0d$var$P($a1a4d31e28ce1f0d$var$T(this.Qd.W().layout.textColor)) > 160 ? "dark" : "light";
    }
    sf() {
        return this.Qd.W().layout.attributionLogo;
    }
    rf() {
        const t = new URL(location.href);
        return t.hostname ? "&utm_source=" + t.hostname + t.pathname : "";
    }
    tf() {
        this.nf() && (this.if(), this.en = this.sf(), this.en && (this.Gd = this.ef(), this.Kd = document.createElement("style"), this.Kd.innerText = "a#tv-attr-logo{--fill:#131722;--stroke:#fff;position:absolute;left:10px;bottom:10px;height:19px;width:35px;margin:0;padding:0;border:0;z-index:3;}a#tv-attr-logo[data-dark]{--fill:#D1D4DC;--stroke:#131722;}", this.Xd = document.createElement("a"), this.Xd.href = `https://www.tradingview.com/?utm_medium=lwc-link&utm_campaign=lwc-chart${this.rf()}`, this.Xd.title = "Charting by TradingView", this.Xd.id = "tv-attr-logo", this.Xd.target = "_blank", this.Xd.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 19" width="35" height="19" fill="none"><g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path fill="var(--stroke)" d="M2 0H0v10h6v9h21.4l.5-1.3 6-15 1-2.7H23.7l-.5 1.3-.2.6a5 5 0 0 0-7-.9V0H2Zm20 17h4l5.2-13 .8-2h-7l-1 2.5-.2.5-1.5 3.8-.3.7V17Zm-.8-10a3 3 0 0 0 .7-2.7A3 3 0 1 0 16.8 7h4.4ZM14 7V2H2v6h6v9h4V7h2Z"/><path fill="var(--fill)" d="M14 2H2v6h6v9h6V2Zm12 15h-7l6-15h7l-6 15Zm-7-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/></g><defs><clipPath id="a"><path fill="var(--stroke)" d="M0 0h35v19H0z"/></clipPath></defs></svg>', this.Xd.toggleAttribute("data-dark", "dark" === this.Gd), this.Jd.appendChild(this.Kd), this.Jd.appendChild(this.Xd)));
    }
}
function $a1a4d31e28ce1f0d$var$_s(t, n) {
    const s = $a1a4d31e28ce1f0d$var$b(t.ownerDocument).createElement("canvas");
    t.appendChild(s);
    const e = (0, $02a7dfaff38a9eef$export$7c052ae73f8acff0)(s, {
        type: "device-pixel-content-box",
        options: {
            allowResizeObserver: !1
        },
        transform: (t, i)=>({
                width: Math.max(t.width, i.width),
                height: Math.max(t.height, i.height)
            })
    });
    return e.resizeCanvasElement(n), e;
}
function $a1a4d31e28ce1f0d$var$us(t) {
    var i;
    t.width = 1, t.height = 1, null === (i = t.getContext("2d")) || void 0 === i || i.clearRect(0, 0, 1, 1);
}
function $a1a4d31e28ce1f0d$var$cs(t, i, n, s) {
    t.gl && t.gl(i, n, s);
}
function $a1a4d31e28ce1f0d$var$ds(t, i, n, s) {
    t.X(i, n, s);
}
function $a1a4d31e28ce1f0d$var$fs(t, i, n, s) {
    const e = t(n, s);
    for (const t of e){
        const n = t.gt();
        null !== n && i(n);
    }
}
function $a1a4d31e28ce1f0d$var$vs(t) {
    $a1a4d31e28ce1f0d$var$ns && void 0 !== window.chrome && t.addEventListener("mousedown", (t)=>{
        if (1 === t.button) return t.preventDefault(), !1;
    });
}
class $a1a4d31e28ce1f0d$var$ps {
    constructor(t, i, n){
        this.hf = 0, this.lf = null, this.af = {
            nt: Number.NEGATIVE_INFINITY,
            st: Number.POSITIVE_INFINITY
        }, this._f = 0, this.uf = null, this.cf = {
            nt: Number.NEGATIVE_INFINITY,
            st: Number.POSITIVE_INFINITY
        }, this.df = null, this.ff = !1, this.vf = null, this.pf = null, this.mf = !1, this.bf = !1, this.wf = !1, this.gf = null, this.Mf = null, this.xf = null, this.Sf = null, this.kf = null, this.yf = null, this.Cf = null, this.Tf = 0, this.Pf = !1, this.Rf = !1, this.Df = !1, this.Vf = 0, this.Of = null, this.Bf = !$a1a4d31e28ce1f0d$var$es(), this.Af = (t)=>{
            this.If(t);
        }, this.zf = (t)=>{
            if (this.Lf(t)) {
                const i = this.Ef(t);
                if (++this._f, this.uf && this._f > 1) {
                    const { Nf: n } = this.Ff($a1a4d31e28ce1f0d$var$ws(t), this.cf);
                    n < 30 && !this.wf && this.Wf(i, this.Hf.jf), this.$f();
                }
            } else {
                const i = this.Ef(t);
                if (++this.hf, this.lf && this.hf > 1) {
                    const { Nf: n } = this.Ff($a1a4d31e28ce1f0d$var$ws(t), this.af);
                    n < 5 && !this.bf && this.Uf(i, this.Hf.qf), this.Yf();
                }
            }
        }, this.Zf = t, this.Hf = i, this.cn = n, this.Xf();
    }
    S() {
        null !== this.gf && (this.gf(), this.gf = null), null !== this.Mf && (this.Mf(), this.Mf = null), null !== this.Sf && (this.Sf(), this.Sf = null), null !== this.kf && (this.kf(), this.kf = null), null !== this.yf && (this.yf(), this.yf = null), null !== this.xf && (this.xf(), this.xf = null), this.Kf(), this.Yf();
    }
    Gf(t) {
        this.Sf && this.Sf();
        const i = this.Jf.bind(this);
        if (this.Sf = ()=>{
            this.Zf.removeEventListener("mousemove", i);
        }, this.Zf.addEventListener("mousemove", i), this.Lf(t)) return;
        const n = this.Ef(t);
        this.Uf(n, this.Hf.Qf), this.Bf = !0;
    }
    Yf() {
        null !== this.lf && clearTimeout(this.lf), this.hf = 0, this.lf = null, this.af = {
            nt: Number.NEGATIVE_INFINITY,
            st: Number.POSITIVE_INFINITY
        };
    }
    $f() {
        null !== this.uf && clearTimeout(this.uf), this._f = 0, this.uf = null, this.cf = {
            nt: Number.NEGATIVE_INFINITY,
            st: Number.POSITIVE_INFINITY
        };
    }
    Jf(t) {
        if (this.Df || null !== this.pf) return;
        if (this.Lf(t)) return;
        const i = this.Ef(t);
        this.Uf(i, this.Hf.tv), this.Bf = !0;
    }
    iv(t) {
        const i = $a1a4d31e28ce1f0d$var$Ms(t.changedTouches, $a1a4d31e28ce1f0d$var$b(this.Of));
        if (null === i) return;
        if (this.Vf = $a1a4d31e28ce1f0d$var$gs(t), null !== this.Cf) return;
        if (this.Rf) return;
        this.Pf = !0;
        const n = this.Ff($a1a4d31e28ce1f0d$var$ws(i), $a1a4d31e28ce1f0d$var$b(this.pf)), { nv: s, sv: e, Nf: r } = n;
        if (this.mf || !(r < 5)) {
            if (!this.mf) {
                const t = .5 * s, i = e >= t && !this.cn.ev(), n = t > e && !this.cn.rv();
                i || n || (this.Rf = !0), this.mf = !0, this.wf = !0, this.Kf(), this.$f();
            }
            if (!this.Rf) {
                const n = this.Ef(t, i);
                this.Wf(n, this.Hf.hv), $a1a4d31e28ce1f0d$var$bs(t);
            }
        }
    }
    lv(t) {
        if (0 !== t.button) return;
        const i = this.Ff($a1a4d31e28ce1f0d$var$ws(t), $a1a4d31e28ce1f0d$var$b(this.vf)), { Nf: n } = i;
        if (n >= 5 && (this.bf = !0, this.Yf()), this.bf) {
            const i = this.Ef(t);
            this.Uf(i, this.Hf.av);
        }
    }
    Ff(t, i) {
        const n = Math.abs(i.nt - t.nt), s = Math.abs(i.st - t.st);
        return {
            nv: n,
            sv: s,
            Nf: n + s
        };
    }
    ov(t) {
        let i = $a1a4d31e28ce1f0d$var$Ms(t.changedTouches, $a1a4d31e28ce1f0d$var$b(this.Of));
        if (null === i && 0 === t.touches.length && (i = t.changedTouches[0]), null === i) return;
        this.Of = null, this.Vf = $a1a4d31e28ce1f0d$var$gs(t), this.Kf(), this.pf = null, this.yf && (this.yf(), this.yf = null);
        const n = this.Ef(t, i);
        if (this.Wf(n, this.Hf._v), ++this._f, this.uf && this._f > 1) {
            const { Nf: t } = this.Ff($a1a4d31e28ce1f0d$var$ws(i), this.cf);
            t < 30 && !this.wf && this.Wf(n, this.Hf.jf), this.$f();
        } else this.wf || (this.Wf(n, this.Hf.uv), this.Hf.uv && $a1a4d31e28ce1f0d$var$bs(t));
        0 === this._f && $a1a4d31e28ce1f0d$var$bs(t), 0 === t.touches.length && this.ff && (this.ff = !1, $a1a4d31e28ce1f0d$var$bs(t));
    }
    If(t) {
        if (0 !== t.button) return;
        const i = this.Ef(t);
        if (this.vf = null, this.Df = !1, this.kf && (this.kf(), this.kf = null), $a1a4d31e28ce1f0d$var$ss()) this.Zf.ownerDocument.documentElement.removeEventListener("mouseleave", this.Af);
        if (!this.Lf(t)) {
            if (this.Uf(i, this.Hf.cv), ++this.hf, this.lf && this.hf > 1) {
                const { Nf: n } = this.Ff($a1a4d31e28ce1f0d$var$ws(t), this.af);
                n < 5 && !this.bf && this.Uf(i, this.Hf.qf), this.Yf();
            } else this.bf || this.Uf(i, this.Hf.dv);
        }
    }
    Kf() {
        null !== this.df && (clearTimeout(this.df), this.df = null);
    }
    fv(t) {
        if (null !== this.Of) return;
        const i = t.changedTouches[0];
        this.Of = i.identifier, this.Vf = $a1a4d31e28ce1f0d$var$gs(t);
        const n = this.Zf.ownerDocument.documentElement;
        this.wf = !1, this.mf = !1, this.Rf = !1, this.pf = $a1a4d31e28ce1f0d$var$ws(i), this.yf && (this.yf(), this.yf = null);
        {
            const i = this.iv.bind(this), s = this.ov.bind(this);
            this.yf = ()=>{
                n.removeEventListener("touchmove", i), n.removeEventListener("touchend", s);
            }, n.addEventListener("touchmove", i, {
                passive: !1
            }), n.addEventListener("touchend", s, {
                passive: !1
            }), this.Kf(), this.df = setTimeout(this.vv.bind(this, t), 240);
        }
        const s = this.Ef(t, i);
        this.Wf(s, this.Hf.pv), this.uf || (this._f = 0, this.uf = setTimeout(this.$f.bind(this), 500), this.cf = $a1a4d31e28ce1f0d$var$ws(i));
    }
    mv(t) {
        if (0 !== t.button) return;
        const i = this.Zf.ownerDocument.documentElement;
        $a1a4d31e28ce1f0d$var$ss() && i.addEventListener("mouseleave", this.Af), this.bf = !1, this.vf = $a1a4d31e28ce1f0d$var$ws(t), this.kf && (this.kf(), this.kf = null);
        {
            const t = this.lv.bind(this), n = this.If.bind(this);
            this.kf = ()=>{
                i.removeEventListener("mousemove", t), i.removeEventListener("mouseup", n);
            }, i.addEventListener("mousemove", t), i.addEventListener("mouseup", n);
        }
        if (this.Df = !0, this.Lf(t)) return;
        const n = this.Ef(t);
        this.Uf(n, this.Hf.bv), this.lf || (this.hf = 0, this.lf = setTimeout(this.Yf.bind(this), 500), this.af = $a1a4d31e28ce1f0d$var$ws(t));
    }
    Xf() {
        this.Zf.addEventListener("mouseenter", this.Gf.bind(this)), this.Zf.addEventListener("touchcancel", this.Kf.bind(this));
        {
            const t = this.Zf.ownerDocument, i = (t)=>{
                this.Hf.wv && (t.composed && this.Zf.contains(t.composedPath()[0]) || t.target && this.Zf.contains(t.target) || this.Hf.wv());
            };
            this.Mf = ()=>{
                t.removeEventListener("touchstart", i);
            }, this.gf = ()=>{
                t.removeEventListener("mousedown", i);
            }, t.addEventListener("mousedown", i), t.addEventListener("touchstart", i, {
                passive: !0
            });
        }
        $a1a4d31e28ce1f0d$var$es() && (this.xf = ()=>{
            this.Zf.removeEventListener("dblclick", this.zf);
        }, this.Zf.addEventListener("dblclick", this.zf)), this.Zf.addEventListener("mouseleave", this.gv.bind(this)), this.Zf.addEventListener("touchstart", this.fv.bind(this), {
            passive: !0
        }), $a1a4d31e28ce1f0d$var$vs(this.Zf), this.Zf.addEventListener("mousedown", this.mv.bind(this)), this.Mv(), this.Zf.addEventListener("touchmove", ()=>{}, {
            passive: !1
        });
    }
    Mv() {
        void 0 === this.Hf.xv && void 0 === this.Hf.Sv && void 0 === this.Hf.kv || (this.Zf.addEventListener("touchstart", (t)=>this.yv(t.touches), {
            passive: !0
        }), this.Zf.addEventListener("touchmove", (t)=>{
            if (2 === t.touches.length && null !== this.Cf && void 0 !== this.Hf.Sv) {
                const i = $a1a4d31e28ce1f0d$var$ms(t.touches[0], t.touches[1]) / this.Tf;
                this.Hf.Sv(this.Cf, i), $a1a4d31e28ce1f0d$var$bs(t);
            }
        }, {
            passive: !1
        }), this.Zf.addEventListener("touchend", (t)=>{
            this.yv(t.touches);
        }));
    }
    yv(t) {
        1 === t.length && (this.Pf = !1), 2 !== t.length || this.Pf || this.ff ? this.Cv() : this.Tv(t);
    }
    Tv(t) {
        const i = this.Zf.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        this.Cf = {
            nt: (t[0].clientX - i.left + (t[1].clientX - i.left)) / 2,
            st: (t[0].clientY - i.top + (t[1].clientY - i.top)) / 2
        }, this.Tf = $a1a4d31e28ce1f0d$var$ms(t[0], t[1]), void 0 !== this.Hf.xv && this.Hf.xv(), this.Kf();
    }
    Cv() {
        null !== this.Cf && (this.Cf = null, void 0 !== this.Hf.kv && this.Hf.kv());
    }
    gv(t) {
        if (this.Sf && this.Sf(), this.Lf(t)) return;
        if (!this.Bf) return;
        const i = this.Ef(t);
        this.Uf(i, this.Hf.Pv), this.Bf = !$a1a4d31e28ce1f0d$var$es();
    }
    vv(t) {
        const i = $a1a4d31e28ce1f0d$var$Ms(t.touches, $a1a4d31e28ce1f0d$var$b(this.Of));
        if (null === i) return;
        const n = this.Ef(t, i);
        this.Wf(n, this.Hf.Rv), this.wf = !0, this.ff = !0;
    }
    Lf(t) {
        return t.sourceCapabilities && void 0 !== t.sourceCapabilities.firesTouchEvents ? t.sourceCapabilities.firesTouchEvents : $a1a4d31e28ce1f0d$var$gs(t) < this.Vf + 500;
    }
    Wf(t, i) {
        i && i.call(this.Hf, t);
    }
    Uf(t, i) {
        i && i.call(this.Hf, t);
    }
    Ef(t, i) {
        const n = i || t, s = this.Zf.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        return {
            clientX: n.clientX,
            clientY: n.clientY,
            pageX: n.pageX,
            pageY: n.pageY,
            screenX: n.screenX,
            screenY: n.screenY,
            localX: n.clientX - s.left,
            localY: n.clientY - s.top,
            ctrlKey: t.ctrlKey,
            altKey: t.altKey,
            shiftKey: t.shiftKey,
            metaKey: t.metaKey,
            Dv: !t.type.startsWith("mouse") && "contextmenu" !== t.type && "click" !== t.type,
            Vv: t.type,
            Ov: n.target,
            Bv: t.view,
            Av: ()=>{
                "touchstart" !== t.type && $a1a4d31e28ce1f0d$var$bs(t);
            }
        };
    }
}
function $a1a4d31e28ce1f0d$var$ms(t, i) {
    const n = t.clientX - i.clientX, s = t.clientY - i.clientY;
    return Math.sqrt(n * n + s * s);
}
function $a1a4d31e28ce1f0d$var$bs(t) {
    t.cancelable && t.preventDefault();
}
function $a1a4d31e28ce1f0d$var$ws(t) {
    return {
        nt: t.pageX,
        st: t.pageY
    };
}
function $a1a4d31e28ce1f0d$var$gs(t) {
    return t.timeStamp || performance.now();
}
function $a1a4d31e28ce1f0d$var$Ms(t, i) {
    for(let n = 0; n < t.length; ++n)if (t[n].identifier === i) return t[n];
    return null;
}
function $a1a4d31e28ce1f0d$var$xs(t) {
    return {
        Hc: t.Hc,
        Iv: {
            gr: t.zv.externalId
        },
        Lv: t.zv.cursorStyle
    };
}
function $a1a4d31e28ce1f0d$var$Ss(t, i, n) {
    for (const s of t){
        const t = s.gt();
        if (null !== t && t.wr) {
            const e = t.wr(i, n);
            if (null !== e) return {
                Bv: s,
                Iv: e
            };
        }
    }
    return null;
}
function $a1a4d31e28ce1f0d$var$ks(t, i) {
    return (n)=>{
        var s, e, r, h;
        return (null !== (e = null === (s = n.Dt()) || void 0 === s ? void 0 : s.Pa()) && void 0 !== e ? e : "") !== i ? [] : null !== (h = null === (r = n.da) || void 0 === r ? void 0 : r.call(n, t)) && void 0 !== h ? h : [];
    };
}
function $a1a4d31e28ce1f0d$var$ys(t, i, n, s) {
    if (!t.length) return;
    let e = 0;
    const r = n / 2, h = t[0].At(s, !0);
    let l = 1 === i ? r - (t[0].Vi() - h / 2) : t[0].Vi() - h / 2 - r;
    l = Math.max(0, l);
    for(let r = 1; r < t.length; r++){
        const h = t[r], a = t[r - 1], o = a.At(s, !1), _ = h.Vi(), u = a.Vi();
        if (1 === i ? _ > u - o : _ < u + o) {
            const s = u - o * i;
            h.Oi(s);
            const r = s - i * o / 2;
            if ((1 === i ? r < 0 : r > n) && l > 0) {
                const s = 1 === i ? -1 - r : r - n, h = Math.min(s, l);
                for(let n = e; n < t.length; n++)t[n].Oi(t[n].Vi() + i * h);
                l -= h;
            }
        } else e = r, l = 1 === i ? u - o - _ : _ - (u + o);
    }
}
class $a1a4d31e28ce1f0d$var$Cs {
    constructor(i, n, s, e){
        this.Li = null, this.Ev = null, this.Nv = !1, this.Fv = new $a1a4d31e28ce1f0d$var$ni(200), this.Qr = null, this.Wv = 0, this.jv = !1, this.Hv = ()=>{
            this.jv || this.tn.$v().$t().Uh();
        }, this.Uv = ()=>{
            this.jv || this.tn.$v().$t().Uh();
        }, this.tn = i, this.cn = n, this.ko = n.layout, this.Oc = s, this.qv = "left" === e, this.Yv = $a1a4d31e28ce1f0d$var$ks("normal", e), this.Zv = $a1a4d31e28ce1f0d$var$ks("top", e), this.Xv = $a1a4d31e28ce1f0d$var$ks("bottom", e), this.Kv = document.createElement("div"), this.Kv.style.height = "100%", this.Kv.style.overflow = "hidden", this.Kv.style.width = "25px", this.Kv.style.left = "0", this.Kv.style.position = "relative", this.Gv = $a1a4d31e28ce1f0d$var$_s(this.Kv, (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 16,
            height: 16
        })), this.Gv.subscribeSuggestedBitmapSizeChanged(this.Hv);
        const r = this.Gv.canvasElement;
        r.style.position = "absolute", r.style.zIndex = "1", r.style.left = "0", r.style.top = "0", this.Jv = $a1a4d31e28ce1f0d$var$_s(this.Kv, (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 16,
            height: 16
        })), this.Jv.subscribeSuggestedBitmapSizeChanged(this.Uv);
        const h = this.Jv.canvasElement;
        h.style.position = "absolute", h.style.zIndex = "2", h.style.left = "0", h.style.top = "0";
        const l = {
            bv: this.Qv.bind(this),
            pv: this.Qv.bind(this),
            av: this.tp.bind(this),
            hv: this.tp.bind(this),
            wv: this.ip.bind(this),
            cv: this.np.bind(this),
            _v: this.np.bind(this),
            qf: this.sp.bind(this),
            jf: this.sp.bind(this),
            Qf: this.ep.bind(this),
            Pv: this.rp.bind(this)
        };
        this.hp = new $a1a4d31e28ce1f0d$var$ps(this.Jv.canvasElement, l, {
            ev: ()=>!this.cn.handleScroll.vertTouchDrag,
            rv: ()=>!0
        });
    }
    S() {
        this.hp.S(), this.Jv.unsubscribeSuggestedBitmapSizeChanged(this.Uv), $a1a4d31e28ce1f0d$var$us(this.Jv.canvasElement), this.Jv.dispose(), this.Gv.unsubscribeSuggestedBitmapSizeChanged(this.Hv), $a1a4d31e28ce1f0d$var$us(this.Gv.canvasElement), this.Gv.dispose(), null !== this.Li && this.Li.Ko().p(this), this.Li = null;
    }
    lp() {
        return this.Kv;
    }
    P() {
        return this.ko.fontSize;
    }
    ap() {
        const t = this.Oc.W();
        return this.Qr !== t.R && (this.Fv.nr(), this.Qr = t.R), t;
    }
    op() {
        if (null === this.Li) return 0;
        let t = 0;
        const i = this.ap(), n = $a1a4d31e28ce1f0d$var$b(this.Gv.canvasElement.getContext("2d"));
        n.save();
        const s = this.Li.Ha();
        n.font = this._p(), s.length > 0 && (t = Math.max(this.Fv.xi(n, s[0].so), this.Fv.xi(n, s[s.length - 1].so)));
        const e = this.up();
        for(let i = e.length; i--;){
            const s = this.Fv.xi(n, e[i].Kt());
            s > t && (t = s);
        }
        const r = this.Li.Ct();
        if (null !== r && null !== this.Ev && 2 !== (h = this.cn.crosshair).mode && h.horzLine.visible && h.horzLine.labelVisible) {
            const i = this.Li.pn(1, r), s = this.Li.pn(this.Ev.height - 2, r);
            t = Math.max(t, this.Fv.xi(n, this.Li.Fi(Math.floor(Math.min(i, s)) + .11111111111111, r)), this.Fv.xi(n, this.Li.Fi(Math.ceil(Math.max(i, s)) - .11111111111111, r)));
        }
        var h;
        n.restore();
        const l = t || 34;
        return $a1a4d31e28ce1f0d$var$rs(Math.ceil(i.C + i.T + i.A + i.I + 5 + l));
    }
    cp(t) {
        null !== this.Ev && (0, $4150ff0128b161d2$export$dfcfeaf16c0e44ed)(this.Ev, t) || (this.Ev = t, this.jv = !0, this.Gv.resizeCanvasElement(t), this.Jv.resizeCanvasElement(t), this.jv = !1, this.Kv.style.width = `${t.width}px`, this.Kv.style.height = `${t.height}px`);
    }
    dp() {
        return $a1a4d31e28ce1f0d$var$b(this.Ev).width;
    }
    Gi(t) {
        this.Li !== t && (null !== this.Li && this.Li.Ko().p(this), this.Li = t, t.Ko().l(this.fo.bind(this), this));
    }
    Dt() {
        return this.Li;
    }
    nr() {
        const t = this.tn.fp();
        this.tn.$v().$t().E_(t, $a1a4d31e28ce1f0d$var$b(this.Dt()));
    }
    vp(t) {
        if (null === this.Ev) return;
        if (1 !== t) {
            this.pp(), this.Gv.applySuggestedBitmapSize();
            const t = (0, $d9fd08faf8e542f8$export$7130a2243f9306b6)(this.Gv);
            null !== t && (t.useBitmapCoordinateSpace((t)=>{
                this.mp(t), this.Ie(t);
            }), this.tn.bp(t, this.Xv), this.wp(t), this.tn.bp(t, this.Yv), this.gp(t));
        }
        this.Jv.applySuggestedBitmapSize();
        const i = (0, $d9fd08faf8e542f8$export$7130a2243f9306b6)(this.Jv);
        null !== i && (i.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.Mp(i), this.tn.bp(i, this.Zv));
    }
    xp() {
        return this.Gv.bitmapSize;
    }
    Sp(t, i, n) {
        const s = this.xp();
        s.width > 0 && s.height > 0 && t.drawImage(this.Gv.canvasElement, i, n);
    }
    bt() {
        var t;
        null === (t = this.Li) || void 0 === t || t.Ha();
    }
    Qv(t) {
        if (null === this.Li || this.Li.Ni() || !this.cn.handleScale.axisPressedMouseMove.price) return;
        const i = this.tn.$v().$t(), n = this.tn.fp();
        this.Nv = !0, i.V_(n, this.Li, t.localY);
    }
    tp(t) {
        if (null === this.Li || !this.cn.handleScale.axisPressedMouseMove.price) return;
        const i = this.tn.$v().$t(), n = this.tn.fp(), s = this.Li;
        i.O_(n, s, t.localY);
    }
    ip() {
        if (null === this.Li || !this.cn.handleScale.axisPressedMouseMove.price) return;
        const t = this.tn.$v().$t(), i = this.tn.fp(), n = this.Li;
        this.Nv && (this.Nv = !1, t.B_(i, n));
    }
    np(t) {
        if (null === this.Li || !this.cn.handleScale.axisPressedMouseMove.price) return;
        const i = this.tn.$v().$t(), n = this.tn.fp();
        this.Nv = !1, i.B_(n, this.Li);
    }
    sp(t) {
        this.cn.handleScale.axisDoubleClickReset.price && this.nr();
    }
    ep(t) {
        if (null === this.Li) return;
        !this.tn.$v().$t().W().handleScale.axisPressedMouseMove.price || this.Li.Mh() || this.Li.Oo() || this.kp(1);
    }
    rp(t) {
        this.kp(0);
    }
    up() {
        const t = [], i = null === this.Li ? void 0 : this.Li;
        return ((n)=>{
            for(let s = 0; s < n.length; ++s){
                const e = n[s].Rn(this.tn.fp(), i);
                for(let i = 0; i < e.length; i++)t.push(e[i]);
            }
        })(this.tn.fp().Uo()), t;
    }
    mp({ context: t, bitmapSize: i }) {
        const { width: n, height: s } = i, e = this.tn.fp().$t(), r = e.q(), h = e.bd();
        r === h ? $a1a4d31e28ce1f0d$var$G(t, 0, 0, n, s, r) : $a1a4d31e28ce1f0d$var$tt(t, 0, 0, n, s, r, h);
    }
    Ie({ context: t, bitmapSize: i, horizontalPixelRatio: n }) {
        if (null === this.Ev || null === this.Li || !this.Li.W().borderVisible) return;
        t.fillStyle = this.Li.W().borderColor;
        const s = Math.max(1, Math.floor(this.ap().C * n));
        let e;
        e = this.qv ? i.width - s : 0, t.fillRect(e, 0, s, i.height);
    }
    wp(t) {
        if (null === this.Ev || null === this.Li) return;
        const i = this.Li.Ha(), n = this.Li.W(), s = this.ap(), e = this.qv ? this.Ev.width - s.T : 0;
        n.borderVisible && n.ticksVisible && t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: r, verticalPixelRatio: h })=>{
            t.fillStyle = n.borderColor;
            const l = Math.max(1, Math.floor(h)), a = Math.floor(.5 * h), o = Math.round(s.T * r);
            t.beginPath();
            for (const n of i)t.rect(Math.floor(e * r), Math.round(n.Ea * h) - a, o, l);
            t.fill();
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            var r;
            t.font = this._p(), t.fillStyle = null !== (r = n.textColor) && void 0 !== r ? r : this.ko.textColor, t.textAlign = this.qv ? "right" : "left", t.textBaseline = "middle";
            const h = this.qv ? Math.round(e - s.A) : Math.round(e + s.T + s.A), l = i.map((i)=>this.Fv.Mi(t, i.so));
            for(let n = i.length; n--;){
                const s = i[n];
                t.fillText(s.so, h, s.Ea + l[n]);
            }
        });
    }
    pp() {
        if (null === this.Ev || null === this.Li) return;
        const t = [], i = this.Li.Uo().slice(), n = this.tn.fp(), s = this.ap();
        this.Li === n.pr() && this.tn.fp().Uo().forEach((t)=>{
            n.vr(t) && i.push(t);
        });
        const e = this.Li;
        i.forEach((i)=>{
            i.Rn(n, e).forEach((i)=>{
                i.Oi(null), i.Bi() && t.push(i);
            });
        }), t.forEach((t)=>t.Oi(t.ki()));
        this.Li.W().alignLabels && this.yp(t, s);
    }
    yp(t, i) {
        if (null === this.Ev) return;
        const n = this.Ev.height / 2, s = t.filter((t)=>t.ki() <= n), e = t.filter((t)=>t.ki() > n);
        s.sort((t, i)=>i.ki() - t.ki()), e.sort((t, i)=>t.ki() - i.ki());
        for (const n of t){
            const t = Math.floor(n.At(i) / 2), s = n.ki();
            s > -t && s < t && n.Oi(t), s > this.Ev.height - t && s < this.Ev.height + t && n.Oi(this.Ev.height - t);
        }
        $a1a4d31e28ce1f0d$var$ys(s, 1, this.Ev.height, i), $a1a4d31e28ce1f0d$var$ys(e, -1, this.Ev.height, i);
    }
    gp(t) {
        if (null === this.Ev) return;
        const i = this.up(), n = this.ap(), s = this.qv ? "right" : "left";
        i.forEach((i)=>{
            if (i.Ai()) i.gt($a1a4d31e28ce1f0d$var$b(this.Li)).X(t, n, this.Fv, s);
        });
    }
    Mp(t) {
        if (null === this.Ev || null === this.Li) return;
        const i = this.tn.$v().$t(), n = [], s = this.tn.fp(), e = i.Zc().Rn(s, this.Li);
        e.length && n.push(e);
        const r = this.ap(), h = this.qv ? "right" : "left";
        n.forEach((i)=>{
            i.forEach((i)=>{
                i.gt($a1a4d31e28ce1f0d$var$b(this.Li)).X(t, r, this.Fv, h);
            });
        });
    }
    kp(t) {
        this.Kv.style.cursor = 1 === t ? "ns-resize" : "default";
    }
    fo() {
        const t = this.op();
        this.Wv < t && this.tn.$v().$t().Kl(), this.Wv = t;
    }
    _p() {
        return $a1a4d31e28ce1f0d$var$F(this.ko.fontSize, this.ko.fontFamily);
    }
}
function $a1a4d31e28ce1f0d$var$Ts(t, i) {
    var n, s;
    return null !== (s = null === (n = t.ua) || void 0 === n ? void 0 : n.call(t, i)) && void 0 !== s ? s : [];
}
function $a1a4d31e28ce1f0d$var$Ps(t, i) {
    var n, s;
    return null !== (s = null === (n = t.Pn) || void 0 === n ? void 0 : n.call(t, i)) && void 0 !== s ? s : [];
}
function $a1a4d31e28ce1f0d$var$Rs(t, i) {
    var n, s;
    return null !== (s = null === (n = t.Ji) || void 0 === n ? void 0 : n.call(t, i)) && void 0 !== s ? s : [];
}
function $a1a4d31e28ce1f0d$var$Ds(t, i) {
    var n, s;
    return null !== (s = null === (n = t.aa) || void 0 === n ? void 0 : n.call(t, i)) && void 0 !== s ? s : [];
}
class $a1a4d31e28ce1f0d$var$Vs {
    constructor(i, n){
        this.Ev = (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 0,
            height: 0
        }), this.Cp = null, this.Tp = null, this.Pp = null, this.Rp = null, this.Dp = !1, this.Vp = new $a1a4d31e28ce1f0d$var$D, this.Op = new $a1a4d31e28ce1f0d$var$D, this.Bp = 0, this.Ap = !1, this.Ip = null, this.zp = !1, this.Lp = null, this.Ep = null, this.jv = !1, this.Hv = ()=>{
            this.jv || null === this.Np || this.$i().Uh();
        }, this.Uv = ()=>{
            this.jv || null === this.Np || this.$i().Uh();
        }, this.Qd = i, this.Np = n, this.Np.W_().l(this.Fp.bind(this), this, !0), this.Wp = document.createElement("td"), this.Wp.style.padding = "0", this.Wp.style.position = "relative";
        const s = document.createElement("div");
        s.style.width = "100%", s.style.height = "100%", s.style.position = "relative", s.style.overflow = "hidden", this.jp = document.createElement("td"), this.jp.style.padding = "0", this.Hp = document.createElement("td"), this.Hp.style.padding = "0", this.Wp.appendChild(s), this.Gv = $a1a4d31e28ce1f0d$var$_s(s, (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 16,
            height: 16
        })), this.Gv.subscribeSuggestedBitmapSizeChanged(this.Hv);
        const e = this.Gv.canvasElement;
        e.style.position = "absolute", e.style.zIndex = "1", e.style.left = "0", e.style.top = "0", this.Jv = $a1a4d31e28ce1f0d$var$_s(s, (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 16,
            height: 16
        })), this.Jv.subscribeSuggestedBitmapSizeChanged(this.Uv);
        const r = this.Jv.canvasElement;
        r.style.position = "absolute", r.style.zIndex = "2", r.style.left = "0", r.style.top = "0", this.$p = document.createElement("tr"), this.$p.appendChild(this.jp), this.$p.appendChild(this.Wp), this.$p.appendChild(this.Hp), this.Up(), this.hp = new $a1a4d31e28ce1f0d$var$ps(this.Jv.canvasElement, this, {
            ev: ()=>null === this.Ip && !this.Qd.W().handleScroll.vertTouchDrag,
            rv: ()=>null === this.Ip && !this.Qd.W().handleScroll.horzTouchDrag
        });
    }
    S() {
        null !== this.Cp && this.Cp.S(), null !== this.Tp && this.Tp.S(), this.Pp = null, this.Jv.unsubscribeSuggestedBitmapSizeChanged(this.Uv), $a1a4d31e28ce1f0d$var$us(this.Jv.canvasElement), this.Jv.dispose(), this.Gv.unsubscribeSuggestedBitmapSizeChanged(this.Hv), $a1a4d31e28ce1f0d$var$us(this.Gv.canvasElement), this.Gv.dispose(), null !== this.Np && this.Np.W_().p(this), this.hp.S();
    }
    fp() {
        return $a1a4d31e28ce1f0d$var$b(this.Np);
    }
    qp(t) {
        var i, n;
        null !== this.Np && this.Np.W_().p(this), this.Np = t, null !== this.Np && this.Np.W_().l($a1a4d31e28ce1f0d$var$Vs.prototype.Fp.bind(this), this, !0), this.Up(), this.Qd.Yp().indexOf(this) === this.Qd.Yp().length - 1 ? (this.Pp = null !== (i = this.Pp) && void 0 !== i ? i : new $a1a4d31e28ce1f0d$var$os(this.Wp, this.Qd), this.Pp.bt()) : (null === (n = this.Pp) || void 0 === n || n.if(), this.Pp = null);
    }
    $v() {
        return this.Qd;
    }
    lp() {
        return this.$p;
    }
    Up() {
        if (null !== this.Np && (this.Zp(), 0 !== this.$i().wt().length)) {
            if (null !== this.Cp) {
                const t = this.Np.R_();
                this.Cp.Gi($a1a4d31e28ce1f0d$var$b(t));
            }
            if (null !== this.Tp) {
                const t = this.Np.D_();
                this.Tp.Gi($a1a4d31e28ce1f0d$var$b(t));
            }
        }
    }
    Xp() {
        null !== this.Cp && this.Cp.bt(), null !== this.Tp && this.Tp.bt();
    }
    M_() {
        return null !== this.Np ? this.Np.M_() : 0;
    }
    x_(t) {
        this.Np && this.Np.x_(t);
    }
    Qf(t) {
        if (!this.Np) return;
        this.Kp();
        const i = t.localX, n = t.localY;
        this.Gp(i, n, t);
    }
    bv(t) {
        this.Kp(), this.Jp(), this.Gp(t.localX, t.localY, t);
    }
    tv(t) {
        var i;
        if (!this.Np) return;
        this.Kp();
        const n = t.localX, s = t.localY;
        this.Gp(n, s, t);
        const e = this.wr(n, s);
        this.Qd.Qp(null !== (i = null == e ? void 0 : e.Lv) && void 0 !== i ? i : null), this.$i().jc(e && {
            Hc: e.Hc,
            Iv: e.Iv
        });
    }
    dv(t) {
        null !== this.Np && (this.Kp(), this.tm(t));
    }
    qf(t) {
        null !== this.Np && this.im(this.Op, t);
    }
    jf(t) {
        this.qf(t);
    }
    av(t) {
        this.Kp(), this.nm(t), this.Gp(t.localX, t.localY, t);
    }
    cv(t) {
        null !== this.Np && (this.Kp(), this.Ap = !1, this.sm(t));
    }
    uv(t) {
        null !== this.Np && this.tm(t);
    }
    Rv(t) {
        if (this.Ap = !0, null === this.Ip) {
            const i = {
                x: t.localX,
                y: t.localY
            };
            this.rm(i, i, t);
        }
    }
    Pv(t) {
        null !== this.Np && (this.Kp(), this.Np.$t().jc(null), this.hm());
    }
    lm() {
        return this.Vp;
    }
    am() {
        return this.Op;
    }
    xv() {
        this.Bp = 1, this.$i().Un();
    }
    Sv(t, i) {
        if (!this.Qd.W().handleScale.pinch) return;
        const n = 5 * (i - this.Bp);
        this.Bp = i, this.$i().Qc(t.nt, n);
    }
    pv(t) {
        this.Ap = !1, this.zp = null !== this.Ip, this.Jp();
        const i = this.$i().Zc();
        null !== this.Ip && i.yt() && (this.Lp = {
            x: i.Yt(),
            y: i.Zt()
        }, this.Ip = {
            x: t.localX,
            y: t.localY
        });
    }
    hv(t) {
        if (null === this.Np) return;
        const i = t.localX, n = t.localY;
        if (null === this.Ip) this.nm(t);
        else {
            this.zp = !1;
            const s = $a1a4d31e28ce1f0d$var$b(this.Lp), e = s.x + (i - this.Ip.x), r = s.y + (n - this.Ip.y);
            this.Gp(e, r, t);
        }
    }
    _v(t) {
        0 === this.$v().W().trackingMode.exitMode && (this.zp = !0), this.om(), this.sm(t);
    }
    wr(t, i) {
        const n = this.Np;
        return null === n ? null : function(t, i, n) {
            const s = t.Uo(), e = function(t, i, n) {
                var s, e;
                let r, h;
                for (const o of t){
                    const t = null !== (e = null === (s = o.va) || void 0 === s ? void 0 : s.call(o, i, n)) && void 0 !== e ? e : [];
                    for (const i of t)l = i.zOrder, (!(a = null == r ? void 0 : r.zOrder) || "top" === l && "top" !== a || "normal" === l && "bottom" === a) && (r = i, h = o);
                }
                var l, a;
                return r && h ? {
                    zv: r,
                    Hc: h
                } : null;
            }(s, i, n);
            if ("top" === (null == e ? void 0 : e.zv.zOrder)) return $a1a4d31e28ce1f0d$var$xs(e);
            for (const r of s){
                if (e && e.Hc === r && "bottom" !== e.zv.zOrder && !e.zv.isBackground) return $a1a4d31e28ce1f0d$var$xs(e);
                const s = $a1a4d31e28ce1f0d$var$Ss(r.Pn(t), i, n);
                if (null !== s) return {
                    Hc: r,
                    Bv: s.Bv,
                    Iv: s.Iv
                };
                if (e && e.Hc === r && "bottom" !== e.zv.zOrder && e.zv.isBackground) return $a1a4d31e28ce1f0d$var$xs(e);
            }
            return (null == e ? void 0 : e.zv) ? $a1a4d31e28ce1f0d$var$xs(e) : null;
        }(n, t, i);
    }
    _m(i, n) {
        $a1a4d31e28ce1f0d$var$b("left" === n ? this.Cp : this.Tp).cp((0, $4150ff0128b161d2$export$346677f925de839c)({
            width: i,
            height: this.Ev.height
        }));
    }
    um() {
        return this.Ev;
    }
    cp(t) {
        (0, $4150ff0128b161d2$export$dfcfeaf16c0e44ed)(this.Ev, t) || (this.Ev = t, this.jv = !0, this.Gv.resizeCanvasElement(t), this.Jv.resizeCanvasElement(t), this.jv = !1, this.Wp.style.width = t.width + "px", this.Wp.style.height = t.height + "px");
    }
    dm() {
        const t = $a1a4d31e28ce1f0d$var$b(this.Np);
        t.P_(t.R_()), t.P_(t.D_());
        for (const i of t.Ba())if (t.vr(i)) {
            const n = i.Dt();
            null !== n && t.P_(n), i.Vn();
        }
    }
    xp() {
        return this.Gv.bitmapSize;
    }
    Sp(t, i, n) {
        const s = this.xp();
        s.width > 0 && s.height > 0 && t.drawImage(this.Gv.canvasElement, i, n);
    }
    vp(t) {
        if (0 === t) return;
        if (null === this.Np) return;
        if (t > 1 && this.dm(), null !== this.Cp && this.Cp.vp(t), null !== this.Tp && this.Tp.vp(t), 1 !== t) {
            this.Gv.applySuggestedBitmapSize();
            const t = (0, $d9fd08faf8e542f8$export$7130a2243f9306b6)(this.Gv);
            null !== t && (t.useBitmapCoordinateSpace((t)=>{
                this.mp(t);
            }), this.Np && (this.fm(t, $a1a4d31e28ce1f0d$var$Ts), this.vm(t), this.pm(t), this.fm(t, $a1a4d31e28ce1f0d$var$Ps), this.fm(t, $a1a4d31e28ce1f0d$var$Rs)));
        }
        this.Jv.applySuggestedBitmapSize();
        const i = (0, $d9fd08faf8e542f8$export$7130a2243f9306b6)(this.Jv);
        null !== i && (i.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.bm(i), this.fm(i, $a1a4d31e28ce1f0d$var$Ds));
    }
    wm() {
        return this.Cp;
    }
    gm() {
        return this.Tp;
    }
    bp(t, i) {
        this.fm(t, i);
    }
    Fp() {
        null !== this.Np && this.Np.W_().p(this), this.Np = null;
    }
    tm(t) {
        this.im(this.Vp, t);
    }
    im(t, i) {
        const n = i.localX, s = i.localY;
        t.M() && t.m(this.$i().St().Nu(n), {
            x: n,
            y: s
        }, i);
    }
    mp({ context: t, bitmapSize: i }) {
        const { width: n, height: s } = i, e = this.$i(), r = e.q(), h = e.bd();
        r === h ? $a1a4d31e28ce1f0d$var$G(t, 0, 0, n, s, h) : $a1a4d31e28ce1f0d$var$tt(t, 0, 0, n, s, r, h);
    }
    vm(t) {
        const i = $a1a4d31e28ce1f0d$var$b(this.Np).j_().qh().gt();
        null !== i && i.X(t, !1);
    }
    pm(t) {
        const i = this.$i().Yc();
        this.Mm(t, $a1a4d31e28ce1f0d$var$Ps, $a1a4d31e28ce1f0d$var$cs, i), this.Mm(t, $a1a4d31e28ce1f0d$var$Ps, $a1a4d31e28ce1f0d$var$ds, i);
    }
    bm(t) {
        this.Mm(t, $a1a4d31e28ce1f0d$var$Ps, $a1a4d31e28ce1f0d$var$ds, this.$i().Zc());
    }
    fm(t, i) {
        const n = $a1a4d31e28ce1f0d$var$b(this.Np).Uo();
        for (const s of n)this.Mm(t, i, $a1a4d31e28ce1f0d$var$cs, s);
        for (const s of n)this.Mm(t, i, $a1a4d31e28ce1f0d$var$ds, s);
    }
    Mm(t, i, n, s) {
        const e = $a1a4d31e28ce1f0d$var$b(this.Np), r = e.$t().Wc(), h = null !== r && r.Hc === s, l = null !== r && h && void 0 !== r.Iv ? r.Iv.Mr : void 0;
        $a1a4d31e28ce1f0d$var$fs(i, (i)=>n(i, t, h, l), s, e);
    }
    Zp() {
        if (null === this.Np) return;
        const t = this.Qd, i = this.Np.R_().W().visible, n = this.Np.D_().W().visible;
        i || null === this.Cp || (this.jp.removeChild(this.Cp.lp()), this.Cp.S(), this.Cp = null), n || null === this.Tp || (this.Hp.removeChild(this.Tp.lp()), this.Tp.S(), this.Tp = null);
        const s = t.$t().ud();
        i && null === this.Cp && (this.Cp = new $a1a4d31e28ce1f0d$var$Cs(this, t.W(), s, "left"), this.jp.appendChild(this.Cp.lp())), n && null === this.Tp && (this.Tp = new $a1a4d31e28ce1f0d$var$Cs(this, t.W(), s, "right"), this.Hp.appendChild(this.Tp.lp()));
    }
    xm(t) {
        return t.Dv && this.Ap || null !== this.Ip;
    }
    Sm(t) {
        return Math.max(0, Math.min(t, this.Ev.width - 1));
    }
    km(t) {
        return Math.max(0, Math.min(t, this.Ev.height - 1));
    }
    Gp(t, i, n) {
        this.$i().ld(this.Sm(t), this.km(i), n, $a1a4d31e28ce1f0d$var$b(this.Np));
    }
    hm() {
        this.$i().od();
    }
    om() {
        this.zp && (this.Ip = null, this.hm());
    }
    rm(t, i, n) {
        this.Ip = t, this.zp = !1, this.Gp(i.x, i.y, n);
        const s = this.$i().Zc();
        this.Lp = {
            x: s.Yt(),
            y: s.Zt()
        };
    }
    $i() {
        return this.Qd.$t();
    }
    sm(t) {
        if (!this.Dp) return;
        const i = this.$i(), n = this.fp();
        if (i.z_(n, n.vn()), this.Rp = null, this.Dp = !1, i.ed(), null !== this.Ep) {
            const t = performance.now(), n = i.St();
            this.Ep.Vr(n.Hu(), t), this.Ep.Qu(t) || i.Zn(this.Ep);
        }
    }
    Kp() {
        this.Ip = null;
    }
    Jp() {
        if (!this.Np) return;
        if (this.$i().Un(), document.activeElement !== document.body && document.activeElement !== document.documentElement) $a1a4d31e28ce1f0d$var$b(document.activeElement).blur();
        else {
            const t = document.getSelection();
            null !== t && t.removeAllRanges();
        }
        !this.Np.vn().Ni() && this.$i().St().Ni();
    }
    nm(t) {
        if (null === this.Np) return;
        const i = this.$i(), n = i.St();
        if (n.Ni()) return;
        const s = this.Qd.W(), e = s.handleScroll, r = s.kineticScroll;
        if ((!e.pressedMouseMove || t.Dv) && (!e.horzTouchDrag && !e.vertTouchDrag || !t.Dv)) return;
        const h = this.Np.vn(), l = performance.now();
        if (null !== this.Rp || this.xm(t) || (this.Rp = {
            x: t.clientX,
            y: t.clientY,
            Od: l,
            ym: t.localX,
            Cm: t.localY
        }), null !== this.Rp && !this.Dp && (this.Rp.x !== t.clientX || this.Rp.y !== t.clientY)) {
            if (t.Dv && r.touch || !t.Dv && r.mouse) {
                const t = n.le();
                this.Ep = new $a1a4d31e28ce1f0d$var$as(.2 / t, 7 / t, .997, 15 / t), this.Ep.Yd(n.Hu(), this.Rp.Od);
            } else this.Ep = null;
            h.Ni() || i.A_(this.Np, h, t.localY), i.nd(t.localX), this.Dp = !0;
        }
        this.Dp && (h.Ni() || i.I_(this.Np, h, t.localY), i.sd(t.localX), null !== this.Ep && this.Ep.Yd(n.Hu(), l));
    }
}
class $a1a4d31e28ce1f0d$var$Os {
    constructor(i, n, s, e, r){
        this.ft = !0, this.Ev = (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 0,
            height: 0
        }), this.Hv = ()=>this.vp(3), this.qv = "left" === i, this.Oc = s.ud, this.cn = n, this.Tm = e, this.Pm = r, this.Kv = document.createElement("div"), this.Kv.style.width = "25px", this.Kv.style.height = "100%", this.Kv.style.overflow = "hidden", this.Gv = $a1a4d31e28ce1f0d$var$_s(this.Kv, (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 16,
            height: 16
        })), this.Gv.subscribeSuggestedBitmapSizeChanged(this.Hv);
    }
    S() {
        this.Gv.unsubscribeSuggestedBitmapSizeChanged(this.Hv), $a1a4d31e28ce1f0d$var$us(this.Gv.canvasElement), this.Gv.dispose();
    }
    lp() {
        return this.Kv;
    }
    um() {
        return this.Ev;
    }
    cp(t) {
        (0, $4150ff0128b161d2$export$dfcfeaf16c0e44ed)(this.Ev, t) || (this.Ev = t, this.Gv.resizeCanvasElement(t), this.Kv.style.width = `${t.width}px`, this.Kv.style.height = `${t.height}px`, this.ft = !0);
    }
    vp(t) {
        if (t < 3 && !this.ft) return;
        if (0 === this.Ev.width || 0 === this.Ev.height) return;
        this.ft = !1, this.Gv.applySuggestedBitmapSize();
        const i = (0, $d9fd08faf8e542f8$export$7130a2243f9306b6)(this.Gv);
        null !== i && i.useBitmapCoordinateSpace((t)=>{
            this.mp(t), this.Ie(t);
        });
    }
    xp() {
        return this.Gv.bitmapSize;
    }
    Sp(t, i, n) {
        const s = this.xp();
        s.width > 0 && s.height > 0 && t.drawImage(this.Gv.canvasElement, i, n);
    }
    Ie({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (!this.Tm()) return;
        t.fillStyle = this.cn.timeScale.borderColor;
        const e = Math.floor(this.Oc.W().C * n), r = Math.floor(this.Oc.W().C * s), h = this.qv ? i.width - e : 0;
        t.fillRect(h, 0, e, r);
    }
    mp({ context: t, bitmapSize: i }) {
        $a1a4d31e28ce1f0d$var$G(t, 0, 0, i.width, i.height, this.Pm());
    }
}
function $a1a4d31e28ce1f0d$var$Bs(t) {
    return (i)=>{
        var n, s;
        return null !== (s = null === (n = i.fa) || void 0 === n ? void 0 : n.call(i, t)) && void 0 !== s ? s : [];
    };
}
const $a1a4d31e28ce1f0d$var$As = $a1a4d31e28ce1f0d$var$Bs("normal"), $a1a4d31e28ce1f0d$var$Is = $a1a4d31e28ce1f0d$var$Bs("top"), $a1a4d31e28ce1f0d$var$zs = $a1a4d31e28ce1f0d$var$Bs("bottom");
class $a1a4d31e28ce1f0d$var$Ls {
    constructor(i, n){
        this.Rm = null, this.Dm = null, this.k = null, this.Vm = !1, this.Ev = (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 0,
            height: 0
        }), this.Om = new $a1a4d31e28ce1f0d$var$D, this.Fv = new $a1a4d31e28ce1f0d$var$ni(5), this.jv = !1, this.Hv = ()=>{
            this.jv || this.Qd.$t().Uh();
        }, this.Uv = ()=>{
            this.jv || this.Qd.$t().Uh();
        }, this.Qd = i, this.q_ = n, this.cn = i.W().layout, this.Xd = document.createElement("tr"), this.Bm = document.createElement("td"), this.Bm.style.padding = "0", this.Am = document.createElement("td"), this.Am.style.padding = "0", this.Kv = document.createElement("td"), this.Kv.style.height = "25px", this.Kv.style.padding = "0", this.Im = document.createElement("div"), this.Im.style.width = "100%", this.Im.style.height = "100%", this.Im.style.position = "relative", this.Im.style.overflow = "hidden", this.Kv.appendChild(this.Im), this.Gv = $a1a4d31e28ce1f0d$var$_s(this.Im, (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 16,
            height: 16
        })), this.Gv.subscribeSuggestedBitmapSizeChanged(this.Hv);
        const s = this.Gv.canvasElement;
        s.style.position = "absolute", s.style.zIndex = "1", s.style.left = "0", s.style.top = "0", this.Jv = $a1a4d31e28ce1f0d$var$_s(this.Im, (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: 16,
            height: 16
        })), this.Jv.subscribeSuggestedBitmapSizeChanged(this.Uv);
        const e = this.Jv.canvasElement;
        e.style.position = "absolute", e.style.zIndex = "2", e.style.left = "0", e.style.top = "0", this.Xd.appendChild(this.Bm), this.Xd.appendChild(this.Kv), this.Xd.appendChild(this.Am), this.zm(), this.Qd.$t().g_().l(this.zm.bind(this), this), this.hp = new $a1a4d31e28ce1f0d$var$ps(this.Jv.canvasElement, this, {
            ev: ()=>!0,
            rv: ()=>!this.Qd.W().handleScroll.horzTouchDrag
        });
    }
    S() {
        this.hp.S(), null !== this.Rm && this.Rm.S(), null !== this.Dm && this.Dm.S(), this.Jv.unsubscribeSuggestedBitmapSizeChanged(this.Uv), $a1a4d31e28ce1f0d$var$us(this.Jv.canvasElement), this.Jv.dispose(), this.Gv.unsubscribeSuggestedBitmapSizeChanged(this.Hv), $a1a4d31e28ce1f0d$var$us(this.Gv.canvasElement), this.Gv.dispose();
    }
    lp() {
        return this.Xd;
    }
    Lm() {
        return this.Rm;
    }
    Em() {
        return this.Dm;
    }
    bv(t) {
        if (this.Vm) return;
        this.Vm = !0;
        const i = this.Qd.$t();
        !i.St().Ni() && this.Qd.W().handleScale.axisPressedMouseMove.time && i.Jc(t.localX);
    }
    pv(t) {
        this.bv(t);
    }
    wv() {
        const t = this.Qd.$t();
        !t.St().Ni() && this.Vm && (this.Vm = !1, this.Qd.W().handleScale.axisPressedMouseMove.time && t.hd());
    }
    av(t) {
        const i = this.Qd.$t();
        !i.St().Ni() && this.Qd.W().handleScale.axisPressedMouseMove.time && i.rd(t.localX);
    }
    hv(t) {
        this.av(t);
    }
    cv() {
        this.Vm = !1;
        const t = this.Qd.$t();
        t.St().Ni() && !this.Qd.W().handleScale.axisPressedMouseMove.time || t.hd();
    }
    _v() {
        this.cv();
    }
    qf() {
        this.Qd.W().handleScale.axisDoubleClickReset.time && this.Qd.$t().Kn();
    }
    jf() {
        this.qf();
    }
    Qf() {
        this.Qd.$t().W().handleScale.axisPressedMouseMove.time && this.kp(1);
    }
    Pv() {
        this.kp(0);
    }
    um() {
        return this.Ev;
    }
    Nm() {
        return this.Om;
    }
    Fm(i, s, e) {
        (0, $4150ff0128b161d2$export$dfcfeaf16c0e44ed)(this.Ev, i) || (this.Ev = i, this.jv = !0, this.Gv.resizeCanvasElement(i), this.Jv.resizeCanvasElement(i), this.jv = !1, this.Kv.style.width = `${i.width}px`, this.Kv.style.height = `${i.height}px`, this.Om.m(i)), null !== this.Rm && this.Rm.cp((0, $4150ff0128b161d2$export$346677f925de839c)({
            width: s,
            height: i.height
        })), null !== this.Dm && this.Dm.cp((0, $4150ff0128b161d2$export$346677f925de839c)({
            width: e,
            height: i.height
        }));
    }
    Wm() {
        const t = this.jm();
        return Math.ceil(t.C + t.T + t.P + t.L + t.B + t.Hm);
    }
    bt() {
        this.Qd.$t().St().Ha();
    }
    xp() {
        return this.Gv.bitmapSize;
    }
    Sp(t, i, n) {
        const s = this.xp();
        s.width > 0 && s.height > 0 && t.drawImage(this.Gv.canvasElement, i, n);
    }
    vp(t) {
        if (0 === t) return;
        if (1 !== t) {
            this.Gv.applySuggestedBitmapSize();
            const i = (0, $d9fd08faf8e542f8$export$7130a2243f9306b6)(this.Gv);
            null !== i && (i.useBitmapCoordinateSpace((t)=>{
                this.mp(t), this.Ie(t), this.$m(i, $a1a4d31e28ce1f0d$var$zs);
            }), this.wp(i), this.$m(i, $a1a4d31e28ce1f0d$var$As)), null !== this.Rm && this.Rm.vp(t), null !== this.Dm && this.Dm.vp(t);
        }
        this.Jv.applySuggestedBitmapSize();
        const i = (0, $d9fd08faf8e542f8$export$7130a2243f9306b6)(this.Jv);
        null !== i && (i.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.Um([
            ...this.Qd.$t().wt(),
            this.Qd.$t().Zc()
        ], i), this.$m(i, $a1a4d31e28ce1f0d$var$Is));
    }
    $m(t, i) {
        const n = this.Qd.$t().wt();
        for (const s of n)$a1a4d31e28ce1f0d$var$fs(i, (i)=>$a1a4d31e28ce1f0d$var$cs(i, t, !1, void 0), s, void 0);
        for (const s of n)$a1a4d31e28ce1f0d$var$fs(i, (i)=>$a1a4d31e28ce1f0d$var$ds(i, t, !1, void 0), s, void 0);
    }
    mp({ context: t, bitmapSize: i }) {
        $a1a4d31e28ce1f0d$var$G(t, 0, 0, i.width, i.height, this.Qd.$t().bd());
    }
    Ie({ context: t, bitmapSize: i, verticalPixelRatio: n }) {
        if (this.Qd.W().timeScale.borderVisible) {
            t.fillStyle = this.qm();
            const s = Math.max(1, Math.floor(this.jm().C * n));
            t.fillRect(0, 0, i.width, s);
        }
    }
    wp(t) {
        const i = this.Qd.$t().St(), n = i.Ha();
        if (!n || 0 === n.length) return;
        const s = this.q_.maxTickMarkWeight(n), e = this.jm(), r = i.W();
        r.borderVisible && r.ticksVisible && t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: i, verticalPixelRatio: s })=>{
            t.strokeStyle = this.qm(), t.fillStyle = this.qm();
            const r = Math.max(1, Math.floor(i)), h = Math.floor(.5 * i);
            t.beginPath();
            const l = Math.round(e.T * s);
            for(let s = n.length; s--;){
                const e = Math.round(n[s].coord * i);
                t.rect(e - h, 0, r, l);
            }
            t.fill();
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            const i = e.C + e.T + e.L + e.P / 2;
            t.textAlign = "center", t.textBaseline = "middle", t.fillStyle = this.$(), t.font = this._p();
            for (const e of n)if (e.weight < s) {
                const n = e.needAlignCoordinate ? this.Ym(t, e.coord, e.label) : e.coord;
                t.fillText(e.label, n, i);
            }
            this.Qd.W().timeScale.allowBoldLabels && (t.font = this.Zm());
            for (const e of n)if (e.weight >= s) {
                const n = e.needAlignCoordinate ? this.Ym(t, e.coord, e.label) : e.coord;
                t.fillText(e.label, n, i);
            }
        });
    }
    Ym(t, i, n) {
        const s = this.Fv.xi(t, n), e = s / 2, r = Math.floor(i - e) + .5;
        return r < 0 ? i += Math.abs(0 - r) : r + s > this.Ev.width && (i -= Math.abs(this.Ev.width - (r + s))), i;
    }
    Um(t, i) {
        const n = this.jm();
        for (const s of t)for (const t of s.Qi())t.gt().X(i, n);
    }
    qm() {
        return this.Qd.W().timeScale.borderColor;
    }
    $() {
        return this.cn.textColor;
    }
    j() {
        return this.cn.fontSize;
    }
    _p() {
        return $a1a4d31e28ce1f0d$var$F(this.j(), this.cn.fontFamily);
    }
    Zm() {
        return $a1a4d31e28ce1f0d$var$F(this.j(), this.cn.fontFamily, "bold");
    }
    jm() {
        null === this.k && (this.k = {
            C: 1,
            N: NaN,
            L: NaN,
            B: NaN,
            ji: NaN,
            T: 5,
            P: NaN,
            R: "",
            Wi: new $a1a4d31e28ce1f0d$var$ni,
            Hm: 0
        });
        const t = this.k, i = this._p();
        if (t.R !== i) {
            const n = this.j();
            t.P = n, t.R = i, t.L = 3 * n / 12, t.B = 3 * n / 12, t.ji = 9 * n / 12, t.N = 0, t.Hm = 4 * n / 12, t.Wi.nr();
        }
        return this.k;
    }
    kp(t) {
        this.Kv.style.cursor = 1 === t ? "ew-resize" : "default";
    }
    zm() {
        const t = this.Qd.$t(), i = t.W();
        i.leftPriceScale.visible || null === this.Rm || (this.Bm.removeChild(this.Rm.lp()), this.Rm.S(), this.Rm = null), i.rightPriceScale.visible || null === this.Dm || (this.Am.removeChild(this.Dm.lp()), this.Dm.S(), this.Dm = null);
        const n = {
            ud: this.Qd.$t().ud()
        }, s = ()=>i.leftPriceScale.borderVisible && t.St().W().borderVisible, e = ()=>t.bd();
        i.leftPriceScale.visible && null === this.Rm && (this.Rm = new $a1a4d31e28ce1f0d$var$Os("left", i, n, s, e), this.Bm.appendChild(this.Rm.lp())), i.rightPriceScale.visible && null === this.Dm && (this.Dm = new $a1a4d31e28ce1f0d$var$Os("right", i, n, s, e), this.Am.appendChild(this.Dm.lp()));
    }
}
const $a1a4d31e28ce1f0d$var$Es = !!$a1a4d31e28ce1f0d$var$ns && !!navigator.userAgentData && navigator.userAgentData.brands.some((t)=>t.brand.includes("Chromium")) && !!$a1a4d31e28ce1f0d$var$ns && ((null === ($a1a4d31e28ce1f0d$var$Ns = null === navigator || void 0 === navigator ? void 0 : navigator.userAgentData) || void 0 === $a1a4d31e28ce1f0d$var$Ns ? void 0 : $a1a4d31e28ce1f0d$var$Ns.platform) ? "Windows" === navigator.userAgentData.platform : navigator.userAgent.toLowerCase().indexOf("win") >= 0);
var $a1a4d31e28ce1f0d$var$Ns;
class $a1a4d31e28ce1f0d$var$Fs {
    constructor(t, i, n){
        var s;
        this.Xm = [], this.Km = 0, this.ho = 0, this.__ = 0, this.Gm = 0, this.Jm = 0, this.Qm = null, this.tb = !1, this.Vp = new $a1a4d31e28ce1f0d$var$D, this.Op = new $a1a4d31e28ce1f0d$var$D, this.Rc = new $a1a4d31e28ce1f0d$var$D, this.ib = null, this.nb = null, this.Jd = t, this.cn = i, this.q_ = n, this.Xd = document.createElement("div"), this.Xd.classList.add("tv-lightweight-charts"), this.Xd.style.overflow = "hidden", this.Xd.style.direction = "ltr", this.Xd.style.width = "100%", this.Xd.style.height = "100%", (s = this.Xd).style.userSelect = "none", s.style.webkitUserSelect = "none", s.style.msUserSelect = "none", s.style.MozUserSelect = "none", s.style.webkitTapHighlightColor = "transparent", this.sb = document.createElement("table"), this.sb.setAttribute("cellspacing", "0"), this.Xd.appendChild(this.sb), this.eb = this.rb.bind(this), $a1a4d31e28ce1f0d$var$Ws(this.cn) && this.hb(!0), this.$i = new $a1a4d31e28ce1f0d$var$Ln(this.Vc.bind(this), this.cn, n), this.$t().Xc().l(this.lb.bind(this), this), this.ab = new $a1a4d31e28ce1f0d$var$Ls(this, this.q_), this.sb.appendChild(this.ab.lp());
        const e = i.autoSize && this.ob();
        let r = this.cn.width, h = this.cn.height;
        if (e || 0 === r || 0 === h) {
            const i = t.getBoundingClientRect();
            r = r || i.width, h = h || i.height;
        }
        this._b(r, h), this.ub(), t.appendChild(this.Xd), this.cb(), this.$i.St().ec().l(this.$i.Kl.bind(this.$i), this), this.$i.g_().l(this.$i.Kl.bind(this.$i), this);
    }
    $t() {
        return this.$i;
    }
    W() {
        return this.cn;
    }
    Yp() {
        return this.Xm;
    }
    fb() {
        return this.ab;
    }
    S() {
        this.hb(!1), 0 !== this.Km && window.cancelAnimationFrame(this.Km), this.$i.Xc().p(this), this.$i.St().ec().p(this), this.$i.g_().p(this), this.$i.S();
        for (const t of this.Xm)this.sb.removeChild(t.lp()), t.lm().p(this), t.am().p(this), t.S();
        this.Xm = [], $a1a4d31e28ce1f0d$var$b(this.ab).S(), null !== this.Xd.parentElement && this.Xd.parentElement.removeChild(this.Xd), this.Rc.S(), this.Vp.S(), this.Op.S(), this.pb();
    }
    _b(i, n, s = !1) {
        if (this.ho === n && this.__ === i) return;
        const e = function(i) {
            const n = Math.floor(i.width), s = Math.floor(i.height);
            return (0, $4150ff0128b161d2$export$346677f925de839c)({
                width: n - n % 2,
                height: s - s % 2
            });
        }((0, $4150ff0128b161d2$export$346677f925de839c)({
            width: i,
            height: n
        }));
        this.ho = e.height, this.__ = e.width;
        const r = this.ho + "px", h = this.__ + "px";
        $a1a4d31e28ce1f0d$var$b(this.Xd).style.height = r, $a1a4d31e28ce1f0d$var$b(this.Xd).style.width = h, this.sb.style.height = r, this.sb.style.width = h, s ? this.mb($a1a4d31e28ce1f0d$var$ut.es(), performance.now()) : this.$i.Kl();
    }
    vp(t) {
        void 0 === t && (t = $a1a4d31e28ce1f0d$var$ut.es());
        for(let i = 0; i < this.Xm.length; i++)this.Xm[i].vp(t.Hn(i).Fn);
        this.cn.timeScale.visible && this.ab.vp(t.jn());
    }
    $h(t) {
        const i = $a1a4d31e28ce1f0d$var$Ws(this.cn);
        this.$i.$h(t);
        const n = $a1a4d31e28ce1f0d$var$Ws(this.cn);
        n !== i && this.hb(n), this.cb(), this.bb(t);
    }
    lm() {
        return this.Vp;
    }
    am() {
        return this.Op;
    }
    Xc() {
        return this.Rc;
    }
    wb() {
        null !== this.Qm && (this.mb(this.Qm, performance.now()), this.Qm = null);
        const t = this.gb(null), i = document.createElement("canvas");
        i.width = t.width, i.height = t.height;
        const n = $a1a4d31e28ce1f0d$var$b(i.getContext("2d"));
        return this.gb(n), i;
    }
    Mb(t) {
        if ("left" === t && !this.xb()) return 0;
        if ("right" === t && !this.Sb()) return 0;
        if (0 === this.Xm.length) return 0;
        return $a1a4d31e28ce1f0d$var$b("left" === t ? this.Xm[0].wm() : this.Xm[0].gm()).dp();
    }
    kb() {
        return this.cn.autoSize && null !== this.ib;
    }
    yb() {
        return this.Xd;
    }
    Qp(t) {
        this.nb = t, this.nb ? this.yb().style.setProperty("cursor", t) : this.yb().style.removeProperty("cursor");
    }
    Cb() {
        return this.nb;
    }
    Tb() {
        return $a1a4d31e28ce1f0d$var$m(this.Xm[0]).um();
    }
    bb(t) {
        (void 0 !== t.autoSize || !this.ib || void 0 === t.width && void 0 === t.height) && (t.autoSize && !this.ib && this.ob(), !1 === t.autoSize && null !== this.ib && this.pb(), t.autoSize || void 0 === t.width && void 0 === t.height || this._b(t.width || this.__, t.height || this.ho));
    }
    gb(i) {
        let n = 0, s = 0;
        const e = this.Xm[0], r = (t, n)=>{
            let s = 0;
            for(let e = 0; e < this.Xm.length; e++){
                const r = this.Xm[e], h = $a1a4d31e28ce1f0d$var$b("left" === t ? r.wm() : r.gm()), l = h.xp();
                null !== i && h.Sp(i, n, s), s += l.height;
            }
        };
        if (this.xb()) {
            r("left", 0);
            n += $a1a4d31e28ce1f0d$var$b(e.wm()).xp().width;
        }
        for(let t = 0; t < this.Xm.length; t++){
            const e = this.Xm[t], r = e.xp();
            null !== i && e.Sp(i, n, s), s += r.height;
        }
        if (n += e.xp().width, this.Sb()) {
            r("right", n);
            n += $a1a4d31e28ce1f0d$var$b(e.gm()).xp().width;
        }
        const h = (t, n, s)=>{
            $a1a4d31e28ce1f0d$var$b("left" === t ? this.ab.Lm() : this.ab.Em()).Sp($a1a4d31e28ce1f0d$var$b(i), n, s);
        };
        if (this.cn.timeScale.visible) {
            const t = this.ab.xp();
            if (null !== i) {
                let n = 0;
                this.xb() && (h("left", n, s), n = $a1a4d31e28ce1f0d$var$b(e.wm()).xp().width), this.ab.Sp(i, n, s), n += t.width, this.Sb() && h("right", n, s);
            }
            s += t.height;
        }
        return (0, $4150ff0128b161d2$export$346677f925de839c)({
            width: n,
            height: s
        });
    }
    Pb() {
        let i = 0, n = 0, s = 0;
        for (const t of this.Xm)this.xb() && (n = Math.max(n, $a1a4d31e28ce1f0d$var$b(t.wm()).op(), this.cn.leftPriceScale.minimumWidth)), this.Sb() && (s = Math.max(s, $a1a4d31e28ce1f0d$var$b(t.gm()).op(), this.cn.rightPriceScale.minimumWidth)), i += t.M_();
        n = $a1a4d31e28ce1f0d$var$rs(n), s = $a1a4d31e28ce1f0d$var$rs(s);
        const e = this.__, r = this.ho, h = Math.max(e - n - s, 0), l = this.cn.timeScale.visible;
        let a = l ? Math.max(this.ab.Wm(), this.cn.timeScale.minimumHeight) : 0;
        var o;
        a = (o = a) + o % 2;
        const _ = 0 + a, u = r < _ ? 0 : r - _, c = u / i;
        let d = 0;
        for(let i = 0; i < this.Xm.length; ++i){
            const e = this.Xm[i];
            e.qp(this.$i.qc()[i]);
            let r = 0, l = 0;
            l = i === this.Xm.length - 1 ? u - d : Math.round(e.M_() * c), r = Math.max(l, 2), d += r, e.cp((0, $4150ff0128b161d2$export$346677f925de839c)({
                width: h,
                height: r
            })), this.xb() && e._m(n, "left"), this.Sb() && e._m(s, "right"), e.fp() && this.$i.Kc(e.fp(), r);
        }
        this.ab.Fm((0, $4150ff0128b161d2$export$346677f925de839c)({
            width: l ? h : 0,
            height: a
        }), l ? n : 0, l ? s : 0), this.$i.S_(h), this.Gm !== n && (this.Gm = n), this.Jm !== s && (this.Jm = s);
    }
    hb(t) {
        t ? this.Xd.addEventListener("wheel", this.eb, {
            passive: !1
        }) : this.Xd.removeEventListener("wheel", this.eb);
    }
    Rb(t) {
        switch(t.deltaMode){
            case t.DOM_DELTA_PAGE:
                return 120;
            case t.DOM_DELTA_LINE:
                return 32;
        }
        return $a1a4d31e28ce1f0d$var$Es ? 1 / window.devicePixelRatio : 1;
    }
    rb(t) {
        if (!(0 !== t.deltaX && this.cn.handleScroll.mouseWheel || 0 !== t.deltaY && this.cn.handleScale.mouseWheel)) return;
        const i = this.Rb(t), n = i * t.deltaX / 100, s = -i * t.deltaY / 100;
        if (t.cancelable && t.preventDefault(), 0 !== s && this.cn.handleScale.mouseWheel) {
            const i = Math.sign(s) * Math.min(1, Math.abs(s)), n = t.clientX - this.Xd.getBoundingClientRect().left;
            this.$t().Qc(n, i);
        }
        0 !== n && this.cn.handleScroll.mouseWheel && this.$t().td(-80 * n);
    }
    mb(t, i) {
        var n;
        const s = t.jn();
        3 === s && this.Db(), 3 !== s && 2 !== s || (this.Vb(t), this.Ob(t, i), this.ab.bt(), this.Xm.forEach((t)=>{
            t.Xp();
        }), 3 === (null === (n = this.Qm) || void 0 === n ? void 0 : n.jn()) && (this.Qm.ts(t), this.Db(), this.Vb(this.Qm), this.Ob(this.Qm, i), t = this.Qm, this.Qm = null)), this.vp(t);
    }
    Ob(t, i) {
        for (const n of t.Qn())this.ns(n, i);
    }
    Vb(t) {
        const i = this.$i.qc();
        for(let n = 0; n < i.length; n++)t.Hn(n).Wn && i[n].N_();
    }
    ns(t, i) {
        const n = this.$i.St();
        switch(t.qn){
            case 0:
                n.hc();
                break;
            case 1:
                n.lc(t.Vt);
                break;
            case 2:
                n.Gn(t.Vt);
                break;
            case 3:
                n.Jn(t.Vt);
                break;
            case 4:
                n.qu();
                break;
            case 5:
                t.Vt.Qu(i) || n.Jn(t.Vt.tc(i));
        }
    }
    Vc(t) {
        null !== this.Qm ? this.Qm.ts(t) : this.Qm = t, this.tb || (this.tb = !0, this.Km = window.requestAnimationFrame((t)=>{
            if (this.tb = !1, this.Km = 0, null !== this.Qm) {
                const i = this.Qm;
                this.Qm = null, this.mb(i, t);
                for (const n of i.Qn())if (5 === n.qn && !n.Vt.Qu(t)) {
                    this.$t().Zn(n.Vt);
                    break;
                }
            }
        }));
    }
    Db() {
        this.ub();
    }
    ub() {
        const t = this.$i.qc(), i = t.length, n = this.Xm.length;
        for(let t = i; t < n; t++){
            const t = $a1a4d31e28ce1f0d$var$m(this.Xm.pop());
            this.sb.removeChild(t.lp()), t.lm().p(this), t.am().p(this), t.S();
        }
        for(let s = n; s < i; s++){
            const i = new $a1a4d31e28ce1f0d$var$Vs(this, t[s]);
            i.lm().l(this.Bb.bind(this), this), i.am().l(this.Ab.bind(this), this), this.Xm.push(i), this.sb.insertBefore(i.lp(), this.ab.lp());
        }
        for(let n = 0; n < i; n++){
            const i = t[n], s = this.Xm[n];
            s.fp() !== i ? s.qp(i) : s.Up();
        }
        this.cb(), this.Pb();
    }
    Ib(t, i, n) {
        var s;
        const e = new Map;
        if (null !== t) this.$i.wt().forEach((i)=>{
            const n = i.In().ll(t);
            null !== n && e.set(i, n);
        });
        let r;
        if (null !== t) {
            const i = null === (s = this.$i.St().Ui(t)) || void 0 === s ? void 0 : s.originalTime;
            void 0 !== i && (r = i);
        }
        const h = this.$t().Wc(), l = null !== h && h.Hc instanceof $a1a4d31e28ce1f0d$var$Gi ? h.Hc : void 0, a = null !== h && void 0 !== h.Iv ? h.Iv.gr : void 0;
        return {
            zb: r,
            ee: null != t ? t : void 0,
            Lb: null != i ? i : void 0,
            Eb: l,
            Nb: e,
            Fb: a,
            Wb: null != n ? n : void 0
        };
    }
    Bb(t, i, n) {
        this.Vp.m(()=>this.Ib(t, i, n));
    }
    Ab(t, i, n) {
        this.Op.m(()=>this.Ib(t, i, n));
    }
    lb(t, i, n) {
        this.Rc.m(()=>this.Ib(t, i, n));
    }
    cb() {
        const t = this.cn.timeScale.visible ? "" : "none";
        this.ab.lp().style.display = t;
    }
    xb() {
        return this.Xm[0].fp().R_().W().visible;
    }
    Sb() {
        return this.Xm[0].fp().D_().W().visible;
    }
    ob() {
        return "ResizeObserver" in window && (this.ib = new ResizeObserver((t)=>{
            const i = t.find((t)=>t.target === this.Jd);
            i && this._b(i.contentRect.width, i.contentRect.height);
        }), this.ib.observe(this.Jd, {
            box: "border-box"
        }), !0);
    }
    pb() {
        null !== this.ib && this.ib.disconnect(), this.ib = null;
    }
}
function $a1a4d31e28ce1f0d$var$Ws(t) {
    return Boolean(t.handleScroll.mouseWheel || t.handleScale.mouseWheel);
}
function $a1a4d31e28ce1f0d$var$js(t) {
    return function(t) {
        return void 0 !== t.open;
    }(t) || function(t) {
        return void 0 !== t.value;
    }(t);
}
function $a1a4d31e28ce1f0d$var$Hs(t, i) {
    var n = {};
    for(var s in t)Object.prototype.hasOwnProperty.call(t, s) && i.indexOf(s) < 0 && (n[s] = t[s]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var e = 0;
        for(s = Object.getOwnPropertySymbols(t); e < s.length; e++)i.indexOf(s[e]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[e]) && (n[s[e]] = t[s[e]]);
    }
    return n;
}
function $a1a4d31e28ce1f0d$var$$s(t, i, n, s) {
    const e = n.value, r = {
        ee: i,
        ot: t,
        Vt: [
            e,
            e,
            e,
            e
        ],
        zb: s
    };
    return void 0 !== n.color && (r.V = n.color), r;
}
function $a1a4d31e28ce1f0d$var$Us(t, i, n, s) {
    const e = n.value, r = {
        ee: i,
        ot: t,
        Vt: [
            e,
            e,
            e,
            e
        ],
        zb: s
    };
    return void 0 !== n.lineColor && (r.lt = n.lineColor), void 0 !== n.topColor && (r.Ps = n.topColor), void 0 !== n.bottomColor && (r.Rs = n.bottomColor), r;
}
function $a1a4d31e28ce1f0d$var$qs(t, i, n, s) {
    const e = n.value, r = {
        ee: i,
        ot: t,
        Vt: [
            e,
            e,
            e,
            e
        ],
        zb: s
    };
    return void 0 !== n.topLineColor && (r.Re = n.topLineColor), void 0 !== n.bottomLineColor && (r.De = n.bottomLineColor), void 0 !== n.topFillColor1 && (r.ke = n.topFillColor1), void 0 !== n.topFillColor2 && (r.ye = n.topFillColor2), void 0 !== n.bottomFillColor1 && (r.Ce = n.bottomFillColor1), void 0 !== n.bottomFillColor2 && (r.Te = n.bottomFillColor2), r;
}
function $a1a4d31e28ce1f0d$var$Ys(t, i, n, s) {
    const e = {
        ee: i,
        ot: t,
        Vt: [
            n.open,
            n.high,
            n.low,
            n.close
        ],
        zb: s
    };
    return void 0 !== n.color && (e.V = n.color), e;
}
function $a1a4d31e28ce1f0d$var$Zs(t, i, n, s) {
    const e = {
        ee: i,
        ot: t,
        Vt: [
            n.open,
            n.high,
            n.low,
            n.close
        ],
        zb: s
    };
    return void 0 !== n.color && (e.V = n.color), void 0 !== n.borderColor && (e.Ot = n.borderColor), void 0 !== n.wickColor && (e.Xh = n.wickColor), e;
}
function $a1a4d31e28ce1f0d$var$Xs(t, i, n, s, e) {
    const r = $a1a4d31e28ce1f0d$var$m(e)(n), h = Math.max(...r), l = Math.min(...r), a = r[r.length - 1], o = [
        a,
        h,
        l,
        a
    ], _ = n, { time: u, color: c } = _;
    return {
        ee: i,
        ot: t,
        Vt: o,
        zb: s,
        $e: $a1a4d31e28ce1f0d$var$Hs(_, [
            "time",
            "color"
        ]),
        V: c
    };
}
function $a1a4d31e28ce1f0d$var$Ks(t) {
    return void 0 !== t.Vt;
}
function $a1a4d31e28ce1f0d$var$Gs(t, i) {
    return void 0 !== i.customValues && (t.jb = i.customValues), t;
}
function $a1a4d31e28ce1f0d$var$Js(t) {
    return (i, n, s, e, r, h)=>(function(t, i) {
            var n;
            return i ? i(t) : void 0 === (n = t).open && void 0 === n.value;
        })(s, h) ? $a1a4d31e28ce1f0d$var$Gs({
            ot: i,
            ee: n,
            zb: e
        }, s) : $a1a4d31e28ce1f0d$var$Gs(t(i, n, s, e, r), s);
}
function $a1a4d31e28ce1f0d$var$Qs(t) {
    return ({
        Candlestick: $a1a4d31e28ce1f0d$var$Js($a1a4d31e28ce1f0d$var$Zs),
        Bar: $a1a4d31e28ce1f0d$var$Js($a1a4d31e28ce1f0d$var$Ys),
        Area: $a1a4d31e28ce1f0d$var$Js($a1a4d31e28ce1f0d$var$Us),
        Baseline: $a1a4d31e28ce1f0d$var$Js($a1a4d31e28ce1f0d$var$qs),
        Histogram: $a1a4d31e28ce1f0d$var$Js($a1a4d31e28ce1f0d$var$$s),
        Line: $a1a4d31e28ce1f0d$var$Js($a1a4d31e28ce1f0d$var$$s),
        Custom: $a1a4d31e28ce1f0d$var$Js($a1a4d31e28ce1f0d$var$Xs)
    })[t];
}
function $a1a4d31e28ce1f0d$var$te(t) {
    return {
        ee: 0,
        Hb: new Map,
        la: t
    };
}
function $a1a4d31e28ce1f0d$var$ie(t, i) {
    if (void 0 !== t && 0 !== t.length) return {
        $b: i.key(t[0].ot),
        Ub: i.key(t[t.length - 1].ot)
    };
}
function $a1a4d31e28ce1f0d$var$ne(t) {
    let i;
    return t.forEach((t)=>{
        void 0 === i && (i = t.zb);
    }), $a1a4d31e28ce1f0d$var$m(i);
}
class $a1a4d31e28ce1f0d$var$se {
    constructor(t){
        this.qb = new Map, this.Yb = new Map, this.Zb = new Map, this.Xb = [], this.q_ = t;
    }
    S() {
        this.qb.clear(), this.Yb.clear(), this.Zb.clear(), this.Xb = [];
    }
    Kb(t, i) {
        let n = 0 !== this.qb.size, s = !1;
        const e = this.Yb.get(t);
        if (void 0 !== e) {
            if (1 === this.Yb.size) n = !1, s = !0, this.qb.clear();
            else for (const i of this.Xb)i.pointData.Hb.delete(t) && (s = !0);
        }
        let r = [];
        if (0 !== i.length) {
            const n = i.map((t)=>t.time), e = this.q_.createConverterToInternalObj(i), h = $a1a4d31e28ce1f0d$var$Qs(t.Qh()), l = t.Ca(), a = t.Ta();
            r = i.map((i, r)=>{
                const o = e(i.time), _ = this.q_.key(o);
                let u = this.qb.get(_);
                void 0 === u && (u = $a1a4d31e28ce1f0d$var$te(o), this.qb.set(_, u), s = !0);
                const c = h(o, u.ee, i, n[r], l, a);
                return u.Hb.set(t, c), c;
            });
        }
        n && this.Gb(), this.Jb(t, r);
        let h = -1;
        if (s) {
            const t = [];
            this.qb.forEach((i)=>{
                t.push({
                    timeWeight: 0,
                    time: i.la,
                    pointData: i,
                    originalTime: $a1a4d31e28ce1f0d$var$ne(i.Hb)
                });
            }), t.sort((t, i)=>this.q_.key(t.time) - this.q_.key(i.time)), h = this.Qb(t);
        }
        return this.tw(t, h, function(t, i, n) {
            const s = $a1a4d31e28ce1f0d$var$ie(t, n), e = $a1a4d31e28ce1f0d$var$ie(i, n);
            if (void 0 !== s && void 0 !== e) return {
                ta: s.Ub >= e.Ub && s.$b >= e.$b
            };
        }(this.Yb.get(t), e, this.q_));
    }
    vd(t) {
        return this.Kb(t, []);
    }
    iw(t, i) {
        const n = i;
        !function(t) {
            void 0 === t.zb && (t.zb = t.time);
        }(n), this.q_.preprocessData(i);
        const s = this.q_.createConverterToInternalObj([
            i
        ])(i.time), e = this.Zb.get(t);
        if (void 0 !== e && this.q_.key(s) < this.q_.key(e)) throw new Error(`Cannot update oldest data, last time=${e}, new time=${s}`);
        let r = this.qb.get(this.q_.key(s));
        const h = void 0 === r;
        void 0 === r && (r = $a1a4d31e28ce1f0d$var$te(s), this.qb.set(this.q_.key(s), r));
        const l = $a1a4d31e28ce1f0d$var$Qs(t.Qh()), a = t.Ca(), o = t.Ta(), _ = l(s, r.ee, i, n.zb, a, o);
        r.Hb.set(t, _), this.nw(t, _);
        const u = {
            ta: $a1a4d31e28ce1f0d$var$Ks(_)
        };
        if (!h) return this.tw(t, -1, u);
        const c = {
            timeWeight: 0,
            time: r.la,
            pointData: r,
            originalTime: $a1a4d31e28ce1f0d$var$ne(r.Hb)
        }, d = $a1a4d31e28ce1f0d$var$Bt(this.Xb, this.q_.key(c.time), (t, i)=>this.q_.key(t.time) < i);
        this.Xb.splice(d, 0, c);
        for(let t = d; t < this.Xb.length; ++t)$a1a4d31e28ce1f0d$var$ee(this.Xb[t].pointData, t);
        return this.q_.fillWeightsForPoints(this.Xb, d), this.tw(t, d, u);
    }
    nw(t, i) {
        let n = this.Yb.get(t);
        void 0 === n && (n = [], this.Yb.set(t, n));
        const s = 0 !== n.length ? n[n.length - 1] : null;
        null === s || this.q_.key(i.ot) > this.q_.key(s.ot) ? $a1a4d31e28ce1f0d$var$Ks(i) && n.push(i) : $a1a4d31e28ce1f0d$var$Ks(i) ? n[n.length - 1] = i : n.splice(-1, 1), this.Zb.set(t, i.ot);
    }
    Jb(t, i) {
        0 !== i.length ? (this.Yb.set(t, i.filter($a1a4d31e28ce1f0d$var$Ks)), this.Zb.set(t, i[i.length - 1].ot)) : (this.Yb.delete(t), this.Zb.delete(t));
    }
    Gb() {
        for (const t of this.Xb)0 === t.pointData.Hb.size && this.qb.delete(this.q_.key(t.time));
    }
    Qb(t) {
        let i = -1;
        for(let n = 0; n < this.Xb.length && n < t.length; ++n){
            const s = this.Xb[n], e = t[n];
            if (this.q_.key(s.time) !== this.q_.key(e.time)) {
                i = n;
                break;
            }
            e.timeWeight = s.timeWeight, $a1a4d31e28ce1f0d$var$ee(e.pointData, n);
        }
        if (-1 === i && this.Xb.length !== t.length && (i = Math.min(this.Xb.length, t.length)), -1 === i) return -1;
        for(let n = i; n < t.length; ++n)$a1a4d31e28ce1f0d$var$ee(t[n].pointData, n);
        return this.q_.fillWeightsForPoints(t, i), this.Xb = t, i;
    }
    sw() {
        if (0 === this.Yb.size) return null;
        let t = 0;
        return this.Yb.forEach((i)=>{
            0 !== i.length && (t = Math.max(t, i[i.length - 1].ee));
        }), t;
    }
    tw(t, i, n) {
        const s = {
            ew: new Map,
            St: {
                Eu: this.sw()
            }
        };
        if (-1 !== i) this.Yb.forEach((i, e)=>{
            s.ew.set(e, {
                $e: i,
                rw: e === t ? n : void 0
            });
        }), this.Yb.has(t) || s.ew.set(t, {
            $e: [],
            rw: n
        }), s.St.hw = this.Xb, s.St.lw = i;
        else {
            const i = this.Yb.get(t);
            s.ew.set(t, {
                $e: i || [],
                rw: n
            });
        }
        return s;
    }
}
function $a1a4d31e28ce1f0d$var$ee(t, i) {
    t.ee = i, t.Hb.forEach((t)=>{
        t.ee = i;
    });
}
function $a1a4d31e28ce1f0d$var$re(t) {
    const i = {
        value: t.Vt[3],
        time: t.zb
    };
    return void 0 !== t.jb && (i.customValues = t.jb), i;
}
function $a1a4d31e28ce1f0d$var$he(t) {
    const i = $a1a4d31e28ce1f0d$var$re(t);
    return void 0 !== t.V && (i.color = t.V), i;
}
function $a1a4d31e28ce1f0d$var$le(t) {
    const i = $a1a4d31e28ce1f0d$var$re(t);
    return void 0 !== t.lt && (i.lineColor = t.lt), void 0 !== t.Ps && (i.topColor = t.Ps), void 0 !== t.Rs && (i.bottomColor = t.Rs), i;
}
function $a1a4d31e28ce1f0d$var$ae(t) {
    const i = $a1a4d31e28ce1f0d$var$re(t);
    return void 0 !== t.Re && (i.topLineColor = t.Re), void 0 !== t.De && (i.bottomLineColor = t.De), void 0 !== t.ke && (i.topFillColor1 = t.ke), void 0 !== t.ye && (i.topFillColor2 = t.ye), void 0 !== t.Ce && (i.bottomFillColor1 = t.Ce), void 0 !== t.Te && (i.bottomFillColor2 = t.Te), i;
}
function $a1a4d31e28ce1f0d$var$oe(t) {
    const i = {
        open: t.Vt[0],
        high: t.Vt[1],
        low: t.Vt[2],
        close: t.Vt[3],
        time: t.zb
    };
    return void 0 !== t.jb && (i.customValues = t.jb), i;
}
function $a1a4d31e28ce1f0d$var$_e(t) {
    const i = $a1a4d31e28ce1f0d$var$oe(t);
    return void 0 !== t.V && (i.color = t.V), i;
}
function $a1a4d31e28ce1f0d$var$ue(t) {
    const i = $a1a4d31e28ce1f0d$var$oe(t), { V: n, Ot: s, Xh: e } = t;
    return void 0 !== n && (i.color = n), void 0 !== s && (i.borderColor = s), void 0 !== e && (i.wickColor = e), i;
}
function $a1a4d31e28ce1f0d$var$ce(t) {
    return ({
        Area: $a1a4d31e28ce1f0d$var$le,
        Line: $a1a4d31e28ce1f0d$var$he,
        Baseline: $a1a4d31e28ce1f0d$var$ae,
        Histogram: $a1a4d31e28ce1f0d$var$he,
        Bar: $a1a4d31e28ce1f0d$var$_e,
        Candlestick: $a1a4d31e28ce1f0d$var$ue,
        Custom: $a1a4d31e28ce1f0d$var$de
    })[t];
}
function $a1a4d31e28ce1f0d$var$de(t) {
    const i = t.zb;
    return Object.assign(Object.assign({}, t.$e), {
        time: i
    });
}
const $a1a4d31e28ce1f0d$var$fe = {
    vertLine: {
        color: "#9598A1",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#131722"
    },
    horzLine: {
        color: "#9598A1",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#131722"
    },
    mode: 1
}, $a1a4d31e28ce1f0d$var$ve = {
    vertLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
    },
    horzLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
    }
}, $a1a4d31e28ce1f0d$var$pe = {
    background: {
        type: "solid",
        color: "#FFFFFF"
    },
    textColor: "#191919",
    fontSize: 12,
    fontFamily: $a1a4d31e28ce1f0d$var$N,
    attributionLogo: !0
}, $a1a4d31e28ce1f0d$var$me = {
    autoScale: !0,
    mode: 0,
    invertScale: !1,
    alignLabels: !0,
    borderVisible: !0,
    borderColor: "#2B2B43",
    entireTextOnly: !1,
    visible: !1,
    ticksVisible: !1,
    scaleMargins: {
        bottom: .1,
        top: .2
    },
    minimumWidth: 0
}, $a1a4d31e28ce1f0d$var$be = {
    rightOffset: 0,
    barSpacing: 6,
    minBarSpacing: .5,
    fixLeftEdge: !1,
    fixRightEdge: !1,
    lockVisibleTimeRangeOnResize: !1,
    rightBarStaysOnScroll: !1,
    borderVisible: !0,
    borderColor: "#2B2B43",
    visible: !0,
    timeVisible: !1,
    secondsVisible: !0,
    shiftVisibleRangeOnNewBar: !0,
    allowShiftVisibleRangeOnWhitespaceReplacement: !1,
    ticksVisible: !1,
    uniformDistribution: !1,
    minimumHeight: 0,
    allowBoldLabels: !0
}, $a1a4d31e28ce1f0d$var$we = {
    color: "rgba(0, 0, 0, 0)",
    visible: !1,
    fontSize: 48,
    fontFamily: $a1a4d31e28ce1f0d$var$N,
    fontStyle: "",
    text: "",
    horzAlign: "center",
    vertAlign: "center"
};
function $a1a4d31e28ce1f0d$var$ge() {
    return {
        width: 0,
        height: 0,
        autoSize: !1,
        layout: $a1a4d31e28ce1f0d$var$pe,
        crosshair: $a1a4d31e28ce1f0d$var$fe,
        grid: $a1a4d31e28ce1f0d$var$ve,
        overlayPriceScales: Object.assign({}, $a1a4d31e28ce1f0d$var$me),
        leftPriceScale: Object.assign(Object.assign({}, $a1a4d31e28ce1f0d$var$me), {
            visible: !1
        }),
        rightPriceScale: Object.assign(Object.assign({}, $a1a4d31e28ce1f0d$var$me), {
            visible: !0
        }),
        timeScale: $a1a4d31e28ce1f0d$var$be,
        watermark: $a1a4d31e28ce1f0d$var$we,
        localization: {
            locale: $a1a4d31e28ce1f0d$var$ns ? navigator.language : "",
            dateFormat: "dd MMM 'yy"
        },
        handleScroll: {
            mouseWheel: !0,
            pressedMouseMove: !0,
            horzTouchDrag: !0,
            vertTouchDrag: !0
        },
        handleScale: {
            axisPressedMouseMove: {
                time: !0,
                price: !0
            },
            axisDoubleClickReset: {
                time: !0,
                price: !0
            },
            mouseWheel: !0,
            pinch: !0
        },
        kineticScroll: {
            mouse: !1,
            touch: !0
        },
        trackingMode: {
            exitMode: 1
        }
    };
}
class $a1a4d31e28ce1f0d$var$Me {
    constructor(t, i){
        this.aw = t, this.ow = i;
    }
    applyOptions(t) {
        this.aw.$t().$c(this.ow, t);
    }
    options() {
        return this.Li().W();
    }
    width() {
        return $a1a4d31e28ce1f0d$var$_t(this.ow) ? this.aw.Mb(this.ow) : 0;
    }
    Li() {
        return $a1a4d31e28ce1f0d$var$b(this.aw.$t().Uc(this.ow)).Dt;
    }
}
function $a1a4d31e28ce1f0d$var$xe(t, i, n) {
    const s = $a1a4d31e28ce1f0d$var$Hs(t, [
        "time",
        "originalTime"
    ]), e = Object.assign({
        time: i
    }, s);
    return void 0 !== n && (e.originalTime = n), e;
}
const $a1a4d31e28ce1f0d$var$Se = {
    color: "#FF0000",
    price: 0,
    lineStyle: 2,
    lineWidth: 1,
    lineVisible: !0,
    axisLabelVisible: !0,
    title: "",
    axisLabelColor: "",
    axisLabelTextColor: ""
};
class $a1a4d31e28ce1f0d$var$ke {
    constructor(t){
        this.Nh = t;
    }
    applyOptions(t) {
        this.Nh.$h(t);
    }
    options() {
        return this.Nh.W();
    }
    _w() {
        return this.Nh;
    }
}
class $a1a4d31e28ce1f0d$var$ye {
    constructor(t, i, n, s, e){
        this.uw = new $a1a4d31e28ce1f0d$var$D, this.Es = t, this.cw = i, this.dw = n, this.q_ = e, this.fw = s;
    }
    S() {
        this.uw.S();
    }
    priceFormatter() {
        return this.Es.ba();
    }
    priceToCoordinate(t) {
        const i = this.Es.Ct();
        return null === i ? null : this.Es.Dt().Rt(t, i.Vt);
    }
    coordinateToPrice(t) {
        const i = this.Es.Ct();
        return null === i ? null : this.Es.Dt().pn(t, i.Vt);
    }
    barsInLogicalRange(t) {
        if (null === t) return null;
        const i = new $a1a4d31e28ce1f0d$var$yn(new $a1a4d31e28ce1f0d$var$xn(t.from, t.to)).lu(), n = this.Es.In();
        if (n.Ni()) return null;
        const s = n.ll(i.Os(), 1), e = n.ll(i.ui(), -1), r = $a1a4d31e28ce1f0d$var$b(n.el()), h = $a1a4d31e28ce1f0d$var$b(n.An());
        if (null !== s && null !== e && s.ee > e.ee) return {
            barsBefore: t.from - r,
            barsAfter: h - t.to
        };
        const l = {
            barsBefore: null === s || s.ee === r ? t.from - r : s.ee - r,
            barsAfter: null === e || e.ee === h ? h - t.to : h - e.ee
        };
        return null !== s && null !== e && (l.from = s.zb, l.to = e.zb), l;
    }
    setData(t) {
        this.q_, this.Es.Qh(), this.cw.pw(this.Es, t), this.mw("full");
    }
    update(t) {
        this.Es.Qh(), this.cw.bw(this.Es, t), this.mw("update");
    }
    dataByIndex(t, i) {
        const n = this.Es.In().ll(t, i);
        if (null === n) return null;
        return $a1a4d31e28ce1f0d$var$ce(this.seriesType())(n);
    }
    data() {
        const t = $a1a4d31e28ce1f0d$var$ce(this.seriesType());
        return this.Es.In().ne().map((i)=>t(i));
    }
    subscribeDataChanged(t) {
        this.uw.l(t);
    }
    unsubscribeDataChanged(t) {
        this.uw.v(t);
    }
    setMarkers(t) {
        this.q_;
        const i = t.map((t)=>$a1a4d31e28ce1f0d$var$xe(t, this.q_.convertHorzItemToInternal(t.time), t.time));
        this.Es.na(i);
    }
    markers() {
        return this.Es.sa().map((t)=>$a1a4d31e28ce1f0d$var$xe(t, t.originalTime, void 0));
    }
    applyOptions(t) {
        this.Es.$h(t);
    }
    options() {
        return $a1a4d31e28ce1f0d$var$z(this.Es.W());
    }
    priceScale() {
        return this.dw.priceScale(this.Es.Dt().Pa());
    }
    createPriceLine(t) {
        const i = $a1a4d31e28ce1f0d$var$V($a1a4d31e28ce1f0d$var$z($a1a4d31e28ce1f0d$var$Se), t), n = this.Es.ea(i);
        return new $a1a4d31e28ce1f0d$var$ke(n);
    }
    removePriceLine(t) {
        this.Es.ra(t._w());
    }
    seriesType() {
        return this.Es.Qh();
    }
    attachPrimitive(t) {
        this.Es.ka(t), t.attached && t.attached({
            chart: this.fw,
            series: this,
            requestUpdate: ()=>this.Es.$t().Kl()
        });
    }
    detachPrimitive(t) {
        this.Es.ya(t), t.detached && t.detached();
    }
    mw(t) {
        this.uw.M() && this.uw.m(t);
    }
}
class $a1a4d31e28ce1f0d$var$Ce {
    constructor(t, i, n){
        this.ww = new $a1a4d31e28ce1f0d$var$D, this.mu = new $a1a4d31e28ce1f0d$var$D, this.Om = new $a1a4d31e28ce1f0d$var$D, this.$i = t, this.yl = t.St(), this.ab = i, this.yl.nc().l(this.gw.bind(this)), this.yl.sc().l(this.Mw.bind(this)), this.ab.Nm().l(this.xw.bind(this)), this.q_ = n;
    }
    S() {
        this.yl.nc().p(this), this.yl.sc().p(this), this.ab.Nm().p(this), this.ww.S(), this.mu.S(), this.Om.S();
    }
    scrollPosition() {
        return this.yl.Hu();
    }
    scrollToPosition(t, i) {
        i ? this.yl.Ju(t, 1e3) : this.$i.Jn(t);
    }
    scrollToRealTime() {
        this.yl.Gu();
    }
    getVisibleRange() {
        const t = this.yl.Vu();
        return null === t ? null : {
            from: t.from.originalTime,
            to: t.to.originalTime
        };
    }
    setVisibleRange(t) {
        const i = {
            from: this.q_.convertHorzItemToInternal(t.from),
            to: this.q_.convertHorzItemToInternal(t.to)
        }, n = this.yl.Iu(i);
        this.$i.pd(n);
    }
    getVisibleLogicalRange() {
        const t = this.yl.Du();
        return null === t ? null : {
            from: t.Os(),
            to: t.ui()
        };
    }
    setVisibleLogicalRange(t) {
        $a1a4d31e28ce1f0d$var$p(t.from <= t.to, "The from index cannot be after the to index."), this.$i.pd(t);
    }
    resetTimeScale() {
        this.$i.Kn();
    }
    fitContent() {
        this.$i.hc();
    }
    logicalToCoordinate(t) {
        const i = this.$i.St();
        return i.Ni() ? null : i.It(t);
    }
    coordinateToLogical(t) {
        return this.yl.Ni() ? null : this.yl.Nu(t);
    }
    timeToCoordinate(t) {
        const i = this.q_.convertHorzItemToInternal(t), n = this.yl.Va(i, !1);
        return null === n ? null : this.yl.It(n);
    }
    coordinateToTime(t) {
        const i = this.$i.St(), n = i.Nu(t), s = i.Ui(n);
        return null === s ? null : s.originalTime;
    }
    width() {
        return this.ab.um().width;
    }
    height() {
        return this.ab.um().height;
    }
    subscribeVisibleTimeRangeChange(t) {
        this.ww.l(t);
    }
    unsubscribeVisibleTimeRangeChange(t) {
        this.ww.v(t);
    }
    subscribeVisibleLogicalRangeChange(t) {
        this.mu.l(t);
    }
    unsubscribeVisibleLogicalRangeChange(t) {
        this.mu.v(t);
    }
    subscribeSizeChange(t) {
        this.Om.l(t);
    }
    unsubscribeSizeChange(t) {
        this.Om.v(t);
    }
    applyOptions(t) {
        this.yl.$h(t);
    }
    options() {
        return Object.assign(Object.assign({}, $a1a4d31e28ce1f0d$var$z(this.yl.W())), {
            barSpacing: this.yl.le()
        });
    }
    gw() {
        this.ww.M() && this.ww.m(this.getVisibleRange());
    }
    Mw() {
        this.mu.M() && this.mu.m(this.getVisibleLogicalRange());
    }
    xw(t) {
        this.Om.m(t.width, t.height);
    }
}
function $a1a4d31e28ce1f0d$var$Te(t) {
    if (void 0 === t || "custom" === t.type) return;
    const i = t;
    void 0 !== i.minMove && void 0 === i.precision && (i.precision = function(t) {
        if (t >= 1) return 0;
        let i = 0;
        for(; i < 8; i++){
            const n = Math.round(t);
            if (Math.abs(n - t) < 1e-8) return i;
            t *= 10;
        }
        return i;
    }(i.minMove));
}
function $a1a4d31e28ce1f0d$var$Pe(t) {
    return function(t) {
        if ($a1a4d31e28ce1f0d$var$I(t.handleScale)) {
            const i = t.handleScale;
            t.handleScale = {
                axisDoubleClickReset: {
                    time: i,
                    price: i
                },
                axisPressedMouseMove: {
                    time: i,
                    price: i
                },
                mouseWheel: i,
                pinch: i
            };
        } else if (void 0 !== t.handleScale) {
            const { axisPressedMouseMove: i, axisDoubleClickReset: n } = t.handleScale;
            $a1a4d31e28ce1f0d$var$I(i) && (t.handleScale.axisPressedMouseMove = {
                time: i,
                price: i
            }), $a1a4d31e28ce1f0d$var$I(n) && (t.handleScale.axisDoubleClickReset = {
                time: n,
                price: n
            });
        }
        const i = t.handleScroll;
        $a1a4d31e28ce1f0d$var$I(i) && (t.handleScroll = {
            horzTouchDrag: i,
            vertTouchDrag: i,
            mouseWheel: i,
            pressedMouseMove: i
        });
    }(t), t;
}
class $a1a4d31e28ce1f0d$var$Re {
    constructor(t, i, n){
        this.Sw = new Map, this.kw = new Map, this.yw = new $a1a4d31e28ce1f0d$var$D, this.Cw = new $a1a4d31e28ce1f0d$var$D, this.Tw = new $a1a4d31e28ce1f0d$var$D, this.Pw = new $a1a4d31e28ce1f0d$var$se(i);
        const s = void 0 === n ? $a1a4d31e28ce1f0d$var$z($a1a4d31e28ce1f0d$var$ge()) : $a1a4d31e28ce1f0d$var$V($a1a4d31e28ce1f0d$var$z($a1a4d31e28ce1f0d$var$ge()), $a1a4d31e28ce1f0d$var$Pe(n));
        this.q_ = i, this.aw = new $a1a4d31e28ce1f0d$var$Fs(t, s, i), this.aw.lm().l((t)=>{
            this.yw.M() && this.yw.m(this.Rw(t()));
        }, this), this.aw.am().l((t)=>{
            this.Cw.M() && this.Cw.m(this.Rw(t()));
        }, this), this.aw.Xc().l((t)=>{
            this.Tw.M() && this.Tw.m(this.Rw(t()));
        }, this);
        const e = this.aw.$t();
        this.Dw = new $a1a4d31e28ce1f0d$var$Ce(e, this.aw.fb(), this.q_);
    }
    remove() {
        this.aw.lm().p(this), this.aw.am().p(this), this.aw.Xc().p(this), this.Dw.S(), this.aw.S(), this.Sw.clear(), this.kw.clear(), this.yw.S(), this.Cw.S(), this.Tw.S(), this.Pw.S();
    }
    resize(t, i, n) {
        this.autoSizeActive() || this.aw._b(t, i, n);
    }
    addCustomSeries(t, i) {
        const n = $a1a4d31e28ce1f0d$var$w(t), s = Object.assign(Object.assign({}, $a1a4d31e28ce1f0d$var$_), n.defaultOptions());
        return this.Vw("Custom", s, i, n);
    }
    addAreaSeries(t) {
        return this.Vw("Area", $a1a4d31e28ce1f0d$var$l, t);
    }
    addBaselineSeries(t) {
        return this.Vw("Baseline", $a1a4d31e28ce1f0d$var$a, t);
    }
    addBarSeries(t) {
        return this.Vw("Bar", $a1a4d31e28ce1f0d$var$r, t);
    }
    addCandlestickSeries(t = {}) {
        return function(t) {
            void 0 !== t.borderColor && (t.borderUpColor = t.borderColor, t.borderDownColor = t.borderColor), void 0 !== t.wickColor && (t.wickUpColor = t.wickColor, t.wickDownColor = t.wickColor);
        }(t), this.Vw("Candlestick", $a1a4d31e28ce1f0d$var$e, t);
    }
    addHistogramSeries(t) {
        return this.Vw("Histogram", $a1a4d31e28ce1f0d$var$o, t);
    }
    addLineSeries(t) {
        return this.Vw("Line", $a1a4d31e28ce1f0d$var$h, t);
    }
    removeSeries(t) {
        const i = $a1a4d31e28ce1f0d$var$m(this.Sw.get(t)), n = this.Pw.vd(i);
        this.aw.$t().vd(i), this.Ow(n), this.Sw.delete(t), this.kw.delete(i);
    }
    pw(t, i) {
        this.Ow(this.Pw.Kb(t, i));
    }
    bw(t, i) {
        this.Ow(this.Pw.iw(t, i));
    }
    subscribeClick(t) {
        this.yw.l(t);
    }
    unsubscribeClick(t) {
        this.yw.v(t);
    }
    subscribeCrosshairMove(t) {
        this.Tw.l(t);
    }
    unsubscribeCrosshairMove(t) {
        this.Tw.v(t);
    }
    subscribeDblClick(t) {
        this.Cw.l(t);
    }
    unsubscribeDblClick(t) {
        this.Cw.v(t);
    }
    priceScale(t) {
        return new $a1a4d31e28ce1f0d$var$Me(this.aw, t);
    }
    timeScale() {
        return this.Dw;
    }
    applyOptions(t) {
        this.aw.$h($a1a4d31e28ce1f0d$var$Pe(t));
    }
    options() {
        return this.aw.W();
    }
    takeScreenshot() {
        return this.aw.wb();
    }
    autoSizeActive() {
        return this.aw.kb();
    }
    chartElement() {
        return this.aw.yb();
    }
    paneSize() {
        const t = this.aw.Tb();
        return {
            height: t.height,
            width: t.width
        };
    }
    setCrosshairPosition(t, i, n) {
        const s = this.Sw.get(n);
        if (void 0 === s) return;
        const e = this.aw.$t().dr(s);
        null !== e && this.aw.$t().ad(t, i, e);
    }
    clearCrosshairPosition() {
        this.aw.$t().od(!0);
    }
    Vw(t, i, n = {}, s) {
        $a1a4d31e28ce1f0d$var$Te(n.priceFormat);
        const e = $a1a4d31e28ce1f0d$var$V($a1a4d31e28ce1f0d$var$z($a1a4d31e28ce1f0d$var$u), $a1a4d31e28ce1f0d$var$z(i), n), r = this.aw.$t().dd(t, e, s), h = new $a1a4d31e28ce1f0d$var$ye(r, this, this, this, this.q_);
        return this.Sw.set(h, r), this.kw.set(r, h), h;
    }
    Ow(t) {
        const i = this.aw.$t();
        i._d(t.St.Eu, t.St.hw, t.St.lw), t.ew.forEach((t, i)=>i.J(t.$e, t.rw)), i.Wu();
    }
    Bw(t) {
        return $a1a4d31e28ce1f0d$var$m(this.kw.get(t));
    }
    Rw(t) {
        const i = new Map;
        t.Nb.forEach((t, n)=>{
            const s = n.Qh(), e = $a1a4d31e28ce1f0d$var$ce(s)(t);
            if ("Custom" !== s) $a1a4d31e28ce1f0d$var$p($a1a4d31e28ce1f0d$var$js(e));
            else {
                const t = n.Ta();
                $a1a4d31e28ce1f0d$var$p(!t || !1 === t(e));
            }
            i.set(this.Bw(n), e);
        });
        const n = void 0 !== t.Eb && this.kw.has(t.Eb) ? this.Bw(t.Eb) : void 0;
        return {
            time: t.zb,
            logical: t.ee,
            point: t.Lb,
            hoveredSeries: n,
            hoveredObjectId: t.Fb,
            seriesData: i,
            sourceEvent: t.Wb
        };
    }
}
function $a1a4d31e28ce1f0d$export$8982e77ac5c107b4(t, i, n) {
    let s;
    if ($a1a4d31e28ce1f0d$var$A(t)) {
        const i = document.getElementById(t);
        $a1a4d31e28ce1f0d$var$p(null !== i, `Cannot find element in DOM with id=${t}`), s = i;
    } else s = t;
    const e = new $a1a4d31e28ce1f0d$var$Re(s, i, n);
    return i.setOptions(e.options()), e;
}
function $a1a4d31e28ce1f0d$export$c870ec99876cb45c(t, i) {
    return $a1a4d31e28ce1f0d$export$8982e77ac5c107b4(t, new $a1a4d31e28ce1f0d$var$is, $a1a4d31e28ce1f0d$var$is.Id(i));
}
function $a1a4d31e28ce1f0d$export$cb3a039e5379c857() {
    return $a1a4d31e28ce1f0d$var$is;
}
const $a1a4d31e28ce1f0d$export$fa49a2a1caf269cf = Object.assign(Object.assign({}, $a1a4d31e28ce1f0d$var$u), $a1a4d31e28ce1f0d$var$_);
function $a1a4d31e28ce1f0d$export$83d89fbfd8236492() {
    return "4.2.3";
}



// Constants only. All real data comes from the backend (see stockApi.js).
// The old random-number generators that lived here have been removed.
const $4f8fb6d4b6efdb53$export$42c0d05b1dc5dcd5 = [
    "1d",
    "1w",
    "3m",
    "6m",
    "ytd",
    "1yr",
    "5yr",
    "all"
];
const $4f8fb6d4b6efdb53$export$69d9f8c3dda1164c = [
    "All",
    "Earnings Calls",
    "Conferences",
    "Shareholder Meetings",
    "Guidance"
];
const $4f8fb6d4b6efdb53$export$c8734b77a7cc822 = [
    "All",
    "10-K",
    "10-Q",
    "8-K",
    "DEF 14A",
    "4",
    "S-8"
];



// TradingView-style chart built with TradingView's open-source Lightweight
// Charts: candles + volume, OHLC read-out, crosshair, timeframe bar.
// Hover for prices; the mouse wheel scrolls the PAGE; drag to pan.
// The 1D and 1W charts reload every minute so the newest candle appears.
const $1fec4f43cce9c4a2$var$UP = "#089981";
const $1fec4f43cce9c4a2$var$DOWN = "#f23645";
const $1fec4f43cce9c4a2$var$LABELS = {
    "1d": "1D",
    "1w": "1W",
    "3m": "3M",
    "6m": "6M",
    ytd: "YTD",
    "1yr": "1Y",
    "5yr": "5Y",
    all: "All"
};
const $1fec4f43cce9c4a2$var$TYPES = [
    [
        "candles",
        "Candles"
    ],
    [
        "line",
        "Line"
    ],
    [
        "area",
        "Area"
    ]
];
const $1fec4f43cce9c4a2$var$LIVE_RANGES = [
    "1d",
    "1w"
];
const $1fec4f43cce9c4a2$var$REFRESH_MS = 60000;
const $1fec4f43cce9c4a2$var$day = (d)=>`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// intraday bars use a UTC timestamp built from the exchange clock time, so the axis shows 9:30, 10:30...
const $1fec4f43cce9c4a2$var$stamp = (d)=>Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes()) / 1000;
const $1fec4f43cce9c4a2$var$when = (d, intraday)=>d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    }) + (intraday ? ` ${d.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit"
    })}` : "");
const $1fec4f43cce9c4a2$var$f2 = (n)=>n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
const $1fec4f43cce9c4a2$var$vol = (n)=>n >= 1e9 ? `${(n / 1e9).toFixed(2)}B` : n >= 1e6 ? `${(n / 1e6).toFixed(2)}M` : `${(n / 1e3).toFixed(1)}K`;
function $1fec4f43cce9c4a2$export$2e2bcd8739ae039({ ticker: ticker }) {
    const hostRef = (0, $acw62.useRef)(null);
    const chartRef = (0, $acw62.useRef)(null);
    const mainRef = (0, $acw62.useRef)(null);
    const volRef = (0, $acw62.useRef)(null);
    const barsRef = (0, $acw62.useRef)([]);
    const keyRef = (0, $acw62.useRef)(""); // ticker|range|type of the last draw, to tell a refresh from a new view
    const [range, setRange] = (0, $acw62.useState)("1yr");
    const [interval, setIntervalLabel] = (0, $acw62.useState)("1W");
    const [intraday, setIntraday] = (0, $acw62.useState)(false);
    const [type, setType] = (0, $acw62.useState)("candles");
    const [tick, setTick] = (0, $acw62.useState)(0); // bumped every minute on the 1D / 1W charts
    const [bar, setBar] = (0, $acw62.useState)(null); // { o,h,l,c,v,prev,date }
    const profile = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$85d699ca8330b9a9)(ticker), [
        ticker
    ]);
    // create chart + volume once
    (0, $acw62.useEffect)(()=>{
        const host = hostRef.current;
        const chart = (0, $a1a4d31e28ce1f0d$export$c870ec99876cb45c)(host, {
            width: host.clientWidth,
            height: host.clientHeight,
            layout: {
                background: {
                    type: "solid",
                    color: "#ffffff"
                },
                textColor: "#131722",
                fontFamily: "inherit",
                fontSize: 12
            },
            grid: {
                vertLines: {
                    color: "#f0f3fa"
                },
                horzLines: {
                    color: "#f0f3fa"
                }
            },
            crosshair: {
                mode: (0, $a1a4d31e28ce1f0d$export$67315bc29c7dd713).Normal,
                vertLine: {
                    color: "#9598a1",
                    style: (0, $a1a4d31e28ce1f0d$export$5d24e00cfde59887).Dashed,
                    width: 1,
                    labelBackgroundColor: "#131722"
                },
                horzLine: {
                    color: "#9598a1",
                    style: (0, $a1a4d31e28ce1f0d$export$5d24e00cfde59887).Dashed,
                    width: 1,
                    labelBackgroundColor: "#131722"
                }
            },
            rightPriceScale: {
                borderColor: "#e0e3eb",
                scaleMargins: {
                    top: 0.08,
                    bottom: 0.28
                }
            },
            timeScale: {
                borderColor: "#e0e3eb",
                timeVisible: false,
                rightOffset: 4
            },
            handleScroll: {
                mouseWheel: false,
                pressedMouseMove: true,
                horzTouchDrag: true,
                vertTouchDrag: false
            },
            handleScale: {
                mouseWheel: false,
                pinch: true,
                axisPressedMouseMove: true
            }
        });
        const volume = chart.addHistogramSeries({
            priceFormat: {
                type: "volume"
            },
            priceScaleId: "vol",
            lastValueVisible: false,
            priceLineVisible: false
        });
        chart.priceScale("vol").applyOptions({
            scaleMargins: {
                top: 0.82,
                bottom: 0
            }
        });
        chartRef.current = chart;
        volRef.current = volume;
        chart.subscribeCrosshairMove((param)=>{
            const bars = barsRef.current;
            if (!bars.length) return;
            let i = bars.length - 1;
            if (param.time && param.point) {
                const hit = bars.findIndex((b)=>b.time === param.time);
                if (hit >= 0) i = hit;
            }
            const b = bars[i];
            setBar({
                ...b,
                prev: i > 0 ? bars[i - 1].close : b.open
            });
        });
        const ro = new ResizeObserver(()=>chart.applyOptions({
                width: host.clientWidth,
                height: host.clientHeight
            }));
        ro.observe(host);
        return ()=>{
            ro.disconnect();
            chart.remove();
        };
    }, []);
    // 1D and 1W: reload every minute (only while the browser tab is visible)
    (0, $acw62.useEffect)(()=>{
        if (!$1fec4f43cce9c4a2$var$LIVE_RANGES.includes(range)) return;
        const id = setInterval(()=>{
            if (!document.hidden) setTick((t)=>t + 1);
        }, $1fec4f43cce9c4a2$var$REFRESH_MS);
        return ()=>clearInterval(id);
    }, [
        range,
        ticker
    ]);
    // load data
    (0, $acw62.useEffect)(()=>{
        let live = true;
        (0, $75280afcc6fc2ba7$export$97ecc5e6f8db6289)(ticker, range).then((res)=>{
            if (!live || !chartRef.current || !res) return;
            setIntervalLabel(res.interval);
            setIntraday(res.intraday);
            chartRef.current.applyOptions({
                timeScale: {
                    timeVisible: res.intraday,
                    secondsVisible: false
                }
            });
            const bars = res.bars.map((r)=>({
                    time: res.intraday ? $1fec4f43cce9c4a2$var$stamp(r.t) : $1fec4f43cce9c4a2$var$day(r.t),
                    date: r.t,
                    open: r.open,
                    high: r.high,
                    low: r.low,
                    close: r.close,
                    volume: r.volume
                }));
            barsRef.current = bars;
            if (!bars.length) {
                // no candles stored for this stock yet: show an empty chart instead of crashing
                volRef.current.setData([]);
                if (mainRef.current) {
                    chartRef.current.removeSeries(mainRef.current);
                    mainRef.current = null;
                }
                setBar(null);
                return;
            }
            volRef.current.setData(bars.map((b)=>({
                    time: b.time,
                    value: b.volume,
                    color: b.close >= b.open ? "rgba(8,153,129,0.35)" : "rgba(242,54,69,0.35)"
                })));
            // (re)build the main series for the chosen chart type
            if (mainRef.current) chartRef.current.removeSeries(mainRef.current);
            let s;
            if (type === "candles") {
                s = chartRef.current.addCandlestickSeries({
                    upColor: $1fec4f43cce9c4a2$var$UP,
                    downColor: $1fec4f43cce9c4a2$var$DOWN,
                    borderUpColor: $1fec4f43cce9c4a2$var$UP,
                    borderDownColor: $1fec4f43cce9c4a2$var$DOWN,
                    wickUpColor: $1fec4f43cce9c4a2$var$UP,
                    wickDownColor: $1fec4f43cce9c4a2$var$DOWN
                });
                s.setData(bars.map(({ time: time, open: open, high: high, low: low, close: close })=>({
                        time: time,
                        open: open,
                        high: high,
                        low: low,
                        close: close
                    })));
            } else if (type === "line") {
                s = chartRef.current.addLineSeries({
                    color: "#2962ff",
                    lineWidth: 2
                });
                s.setData(bars.map(({ time: time, close: close })=>({
                        time: time,
                        value: close
                    })));
            } else {
                s = chartRef.current.addAreaSeries({
                    lineColor: "#2962ff",
                    topColor: "rgba(41,98,255,0.28)",
                    bottomColor: "rgba(41,98,255,0.02)",
                    lineWidth: 2
                });
                s.setData(bars.map(({ time: time, close: close })=>({
                        time: time,
                        value: close
                    })));
            }
            mainRef.current = s;
            // fit the chart only when the view really changed; a minute-refresh keeps the user's pan/zoom
            const key = `${ticker}|${range}|${type}`;
            if (keyRef.current !== key) {
                keyRef.current = key;
                chartRef.current.timeScale().setVisibleLogicalRange({
                    from: -1.5,
                    to: bars.length + 2
                }); // small margin so the first and last candles aren't clipped
            }
            const last = bars[bars.length - 1];
            setBar({
                ...last,
                prev: bars.length > 1 ? bars[bars.length - 2].close : last.open
            });
        }).catch(()=>{
            if (live) setBar(null);
        });
        return ()=>{
            live = false;
        };
    }, [
        ticker,
        range,
        type,
        tick
    ]);
    const chg = bar ? bar.close - bar.prev : 0;
    const chgPct = bar ? chg / bar.prev * 100 : 0;
    const color = chg >= 0 ? $1fec4f43cce9c4a2$var$UP : $1fec4f43cce9c4a2$var$DOWN;
    const p = profile.data;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "lc-wrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "lc-toolbar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "lc-types",
                        children: $1fec4f43cce9c4a2$var$TYPES.map(([k, l])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: type === k ? "active" : "",
                                onClick: ()=>setType(k),
                                children: l
                            }, k))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "lc-tf",
                        title: "Candle size",
                        children: interval
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "lc-stage",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "lc-host",
                        ref: hostRef
                    }),
                    bar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "lc-legend",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "lc-title",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: p ? p.name : ticker
                                    }),
                                    " \xb7 ",
                                    interval,
                                    " ",
                                    p ? `\xb7 ${p.exchange}` : "",
                                    " \xb7 ",
                                    $1fec4f43cce9c4a2$var$when(bar.date, intraday)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "lc-ohlc",
                                style: {
                                    color: color
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "O ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                children: $1fec4f43cce9c4a2$var$f2(bar.open)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "H ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                children: $1fec4f43cce9c4a2$var$f2(bar.high)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "L ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                children: $1fec4f43cce9c4a2$var$f2(bar.low)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "C ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                children: $1fec4f43cce9c4a2$var$f2(bar.close)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("i", {
                                            children: [
                                                chg >= 0 ? "+" : "",
                                                $1fec4f43cce9c4a2$var$f2(chg),
                                                " (",
                                                chg >= 0 ? "+" : "",
                                                chgPct.toFixed(2),
                                                "%)"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "lc-vol",
                                children: [
                                    "Volume ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        style: {
                                            color: color
                                        },
                                        children: $1fec4f43cce9c4a2$var$vol(bar.volume)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "lc-ranges",
                children: (0, $4f8fb6d4b6efdb53$export$42c0d05b1dc5dcd5).map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: r === range ? "active" : "",
                        onClick: ()=>setRange(r),
                        children: $1fec4f43cce9c4a2$var$LABELS[r]
                    }, r))
            })
        ]
    });
}



parcelRequire("acw62");




function $7b871066593b2fcc$export$2e2bcd8739ae039({ ticker: ticker, statement: statement, period: period, keys: keys, cols: cols = 8 }) {
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$226017fe7f8e0ffd)(ticker, statement, period), [
        ticker,
        statement,
        period
    ]);
    if (loading && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f04a3ea04edc0e04), {
        error: error
    });
    const columns = data.columns.slice(-cols);
    const rows = keys.map((k)=>data.rows.find((r)=>r.key === k)).filter(Boolean);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "co-table-wrap",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
            className: "co-table",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                className: "co-sticky",
                                children: statement === "ratios" ? "" : "USD millions"
                            }),
                            columns.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                    children: [
                                        c.label,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: c.sub
                                        })
                                    ]
                                }, c.label))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                    children: rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: `${r.bold ? "bold" : ""} ${r.italic ? "italic" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: `co-sticky ${r.indent ? "indent" : ""}`,
                                    children: r.label
                                }),
                                r.values.slice(-cols).map((v, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: v < 0 && r.kind !== "money" ? "neg" : "",
                                        children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(v, r.kind, "MM")
                                    }, i))
                            ]
                        }, r.key))
                })
            ]
        })
    });
}








parcelRequire("acw62");
/**
 * @license lucide-react v0.300.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("FileText", [
    [
        "path",
        {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            key: "1nnpy2"
        }
    ],
    [
        "polyline",
        {
            points: "14 2 14 8 20 8",
            key: "1ew0cm"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "8",
            y1: "13",
            y2: "13",
            key: "14keom"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "8",
            y1: "17",
            y2: "17",
            key: "17nazh"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "8",
            y1: "9",
            y2: "9",
            key: "1a5vjj"
        }
    ]
]);





function $5882e73e4858513f$var$fmt(v, kind, unit) {
    if (v === null || v === undefined || Number.isNaN(v)) return "-";
    if (kind === "pct") return `${Math.round(v)}%`;
    if (kind === "eps") return v.toFixed(2);
    const x = unit === "K" ? v * 1000 : unit === "B" ? v / 1000 : v;
    const d = unit === "B" ? 2 : 0;
    return x.toLocaleString("en-US", {
        minimumFractionDigits: d,
        maximumFractionDigits: d
    });
}
function $5882e73e4858513f$export$2e2bcd8739ae039({ ticker: ticker, count: count = 13, unit: unit = "MM" }) {
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $6a003cf53bfc86cf$export$b63e4da3de62140d)(ticker, count), [
        ticker,
        count
    ]);
    if (loading && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error || !data || data.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "co-hint",
        children: "No quarterly results for this company. It needs SEC financial statements."
    });
    const n = data.columns.length;
    const band = (i)=>Math.floor((n - 1 - i) / 4) % 2 === 0 ? "band" : "";
    const unitName = unit === "K" ? "thousands" : unit === "B" ? "billions" : "millions";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "qt-wrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "qt",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {}),
                                    data.columns.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: band(i),
                                            children: c.label
                                        }, c.end))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                            children: [
                                data.rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: r.strong ? "strong" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: r.label
                                            }),
                                            r.values.map((v, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: band(i),
                                                    children: $5882e73e4858513f$var$fmt(v, r.kind, unit)
                                                }, i))
                                        ]
                                    }, r.key)),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "filing",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: "Filing"
                                        }),
                                        data.filings.map((f, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: band(i),
                                                children: f ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: f.url,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: `${f.form}, filed ${f.filed}. Opens the original report on SEC EDGAR`,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                        size: 17
                                                    })
                                                }) : "-"
                                            }, i))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "co-hint",
                children: [
                    "US$ in ",
                    unitName,
                    " (EPS in $). From SEC 10-Q and 10-K filings; the fourth quarter is the full year minus the first nine months. The Filing row opens the original report on SEC EDGAR (the SEC publishes these as web documents, not PDFs; use your browser's Print, then Save as PDF)."
                ]
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");

function $84a6c4c924edb7af$export$2e2bcd8739ae039(ticker, ms = 30000) {
    const [state, setState] = (0, $acw62.useState)({
        data: null,
        loading: true,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        let live = true;
        setState({
            data: null,
            loading: true,
            error: null
        });
        const load = ()=>(0, $75280afcc6fc2ba7$export$2628323f89a438a6)(ticker).then((data)=>live && setState({
                    data: data,
                    loading: false,
                    error: null
                })).catch((error)=>live && setState((s)=>({
                        data: s.data,
                        loading: false,
                        error: s.data ? null : error
                    })));
        load();
        const id = setInterval(()=>{
            if (!document.hidden) load();
        }, ms);
        return ()=>{
            live = false;
            clearInterval(id);
        };
    }, [
        ticker,
        ms
    ]);
    return state;
}


function $11a79a9cbce8187a$var$Section({ title: title, ticker: ticker, tab: tab, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "co-section",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "co-section-head",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        children: title
                    }),
                    tab && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: (0, $4a6071b6444d89fa$export$3518935f988c2e40)(ticker, tab),
                        children: "View full \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "card co-card",
                children: children
            })
        ]
    });
}
function $11a79a9cbce8187a$var$StatBlock({ block: block }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "card co-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                className: "co-card-title",
                children: block.title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                className: "co-stats",
                children: block.items.map(([label, value, kind])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                children: label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(value, kind, "MM")
                            })
                        ]
                    }, label))
            })
        ]
    });
}
// ---- 1. top card: price, links, ratio grid, about --------------------------
function $11a79a9cbce8187a$var$HeaderCard({ ticker: ticker, profile: profile, quote: quote, snapshot: snapshot }) {
    const [more, setMore] = (0, $acw62.useState)(false);
    const p = profile;
    const q = quote;
    const up = q && q.change >= 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "card co-card co-top-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "co-top-left",
                children: [
                    p ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            q ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "co-top-price",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(q.price)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: up ? "change-up" : "change-down",
                                        children: (0, $45b05daa53b66210$export$850409532323fff)(q.changePct, 2, true)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                        children: [
                                            "Close \xb7 ",
                                            (0, $45b05daa53b66210$export$fe2e3b2f2c30e584)(q.date)
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "co-top-price",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                    children: "No price data loaded yet"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "co-links",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: p.tvUrl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                size: 13
                                            }),
                                            " ",
                                            p.exchange,
                                            ": ",
                                            p.ticker
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: `https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=${encodeURIComponent(p.ticker)}&owner=include&count=40`,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                size: 13
                                            }),
                                            " SEC filings"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: (0, $4a6071b6444d89fa$export$3518935f988c2e40)(ticker, "financials"),
                                        children: "Financials"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Ratios, {
                        ticker: ticker,
                        snapshot: snapshot
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "co-top-right",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                        className: "co-section-label",
                        children: "About"
                    }),
                    p ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$AboutPoints, {
                                text: p.description,
                                ticker: ticker
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Facts, {
                                p: p,
                                ticker: ticker
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {})
                ]
            })
        ]
    });
}
function $11a79a9cbce8187a$var$ProsCons({ ticker: ticker }) {
    const { data: data } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$c0ddd5fb189d9ef3)(ticker), [
        ticker
    ]);
    if (!data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "co-proscons",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-pros",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                        className: "co-card-title",
                        children: "Pros"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        children: data.pros.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    t
                                ]
                            }, t))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-cons",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                        className: "co-card-title",
                        children: "Cons"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        children: data.cons.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    t
                                ]
                            }, t))
                    })
                ]
            })
        ]
    });
}
function $11a79a9cbce8187a$var$OldPeers({ ticker: ticker }) {
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$886b8ed8d6c424f0)(ticker), [
        ticker
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f04a3ea04edc0e04), {
        error: error
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "co-table-wrap",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
            className: "co-table co-table-left",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Company"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Price"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Mkt Cap ($B)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "P/E"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Sales Growth"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Net Margin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "ROCE"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                    children: data.competitors.slice(0, 6).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: c.self ? "selected" : "",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            className: "wl-company",
                                            href: (0, $4a6071b6444d89fa$export$3518935f988c2e40)(c.ticker),
                                            children: c.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            className: "co-tk",
                                            children: c.ticker
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(c.price)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.mcap, "count")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.pe, "x")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $45b05daa53b66210$export$850409532323fff)(c.salesVar, 1)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $45b05daa53b66210$export$850409532323fff)(c.margin, 1)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $45b05daa53b66210$export$850409532323fff)(c.roce, 1)
                                })
                            ]
                        }, c.ticker))
                })
            ]
        })
    });
}
function $11a79a9cbce8187a$var$OldHolders({ ticker: ticker }) {
    const { data: data, loading: loading } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$74746e4a0845aeda)(ticker), [
        ticker
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    const top = data.holders.slice(0, 5);
    const inst = data.holders.reduce((s, h)=>s + h.pct, 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "co-hint",
                children: [
                    "Top holders own ",
                    (0, $45b05daa53b66210$export$850409532323fff)(top.reduce((s, h)=>s + h.pct, 0), 1),
                    " of shares; all listed institutions together hold ",
                    (0, $45b05daa53b66210$export$850409532323fff)(inst, 1),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "co-table-wrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "co-table co-table-left",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Holder"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "% Out."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Change"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: top.map((h)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: h.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: h.type
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: (0, $45b05daa53b66210$export$850409532323fff)(h.pct, 2)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: h.change >= 0 ? "change-up" : "change-down",
                                            children: (0, $45b05daa53b66210$export$850409532323fff)(h.change, 2, true)
                                        })
                                    ]
                                }, h.name))
                        })
                    ]
                })
            })
        ]
    });
}
function $11a79a9cbce8187a$var$Documents({ ticker: ticker }) {
    const { data: data, loading: loading } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$cb26a1c42e348f4f)(ticker), [
        ticker
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "co-table-wrap",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
            className: "co-table co-table-left",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Date"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Form"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Description"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                    children: data.slice(0, 6).map((f, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $45b05daa53b66210$export$fe2e3b2f2c30e584)(f.date)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "badge-purple",
                                        children: f.form
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: f.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: f.url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            "EDGAR ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                size: 12
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, i))
                })
            ]
        })
    });
}
function $11a79a9cbce8187a$export$2e2bcd8739ae039({ ticker: ticker, showChart: showChart }) {
    const profile = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$85d699ca8330b9a9)(ticker), [
        ticker
    ]);
    const quote = (0, $84a6c4c924edb7af$export$2e2bcd8739ae039)(ticker);
    const snapshot = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$ab60d92959c37070)(ticker), [
        ticker
    ]);
    const stats = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$478ab90bc3ebade5)(ticker), [
        ticker
    ]);
    const news = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$e736a0e2de0cb508)(ticker), [
        ticker
    ]);
    const p = profile.data;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "co-overview",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$HeaderCard, {
                ticker: ticker,
                profile: p,
                quote: quote.data,
                snapshot: snapshot.data
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `co-chart-row ${showChart ? "" : "no-chart"}`,
                children: [
                    showChart && p && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "card co-card co-chart-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                className: "co-card-title",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Price Chart"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        className: "btn tool-btn tv-link",
                                        href: p.tvUrl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        title: `Open ${p.ticker} on TradingView`,
                                        "aria-label": `Open ${p.ticker} on TradingView`,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                            size: 16
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tv-chart-box",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fec4f43cce9c4a2$export$2e2bcd8739ae039), {
                                    ticker: ticker
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$ProsCons, {
                        ticker: ticker
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "co-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "co-section-head",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                            children: "Key Statistics"
                        })
                    }),
                    stats.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {}) : stats.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f04a3ea04edc0e04), {
                        error: stats.error
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "co-stat-grid",
                        children: stats.data.map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$StatBlock, {
                                block: b
                            }, b.title))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "Quarterly Results",
                ticker: ticker,
                tab: "financials",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5882e73e4858513f$export$2e2bcd8739ae039), {
                    ticker: ticker,
                    count: 13
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "Profit & Loss",
                ticker: ticker,
                tab: "financials",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b871066593b2fcc$export$2e2bcd8739ae039), {
                    ticker: ticker,
                    statement: "income",
                    period: "annual",
                    cols: 10,
                    keys: [
                        "revenue",
                        "revG",
                        "gp",
                        "ebitda",
                        "opInc",
                        "opm",
                        "ni",
                        "nim",
                        "eps",
                        "epsG"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "Balance Sheet",
                ticker: ticker,
                tab: "financials",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b871066593b2fcc$export$2e2bcd8739ae039), {
                    ticker: ticker,
                    statement: "balance",
                    period: "annual",
                    cols: 10,
                    keys: [
                        "cash",
                        "tca",
                        "ppe",
                        "ta",
                        "tcl",
                        "debt",
                        "tl",
                        "equity"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "Cash Flow",
                ticker: ticker,
                tab: "financials",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b871066593b2fcc$export$2e2bcd8739ae039), {
                    ticker: ticker,
                    statement: "cashflow",
                    period: "annual",
                    cols: 10,
                    keys: [
                        "cfo",
                        "capexNeg",
                        "cfi",
                        "cff",
                        "netChange",
                        "fcf"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "Ratios",
                ticker: ticker,
                tab: "financials",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b871066593b2fcc$export$2e2bcd8739ae039), {
                    ticker: ticker,
                    statement: "ratios",
                    period: "annual",
                    cols: 10,
                    keys: [
                        "gm",
                        "opm",
                        "nim",
                        "roe",
                        "roa",
                        "roic",
                        "currentRatio",
                        "debtEquity",
                        "interestCover"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "Shareholding",
                ticker: ticker,
                tab: "ownership",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Holders, {
                    ticker: ticker
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "Documents",
                ticker: ticker,
                tab: "filings",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a108ac155e22abee$export$2e2bcd8739ae039), {
                    ticker: ticker
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a79a9cbce8187a$var$Section, {
                title: "News",
                children: news.data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    className: "co-news",
                    children: news.data.map((n)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                n.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: n.url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: n.title
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: n.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                    children: [
                                        n.source,
                                        " \xb7 ",
                                        (0, $45b05daa53b66210$export$fe2e3b2f2c30e584)(n.date)
                                    ]
                                })
                            ]
                        }, n.title))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {})
            })
        ]
    });
}
const $11a79a9cbce8187a$var$dash = (v, f)=>v === null || v === undefined ? "\u2014" : f(v);
function $11a79a9cbce8187a$var$Peers({ ticker: ticker }) {
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $6a003cf53bfc86cf$export$9dbcdfb953196356)(ticker), [
        ticker
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error || !data || data.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "co-hint",
        children: "No peer data yet. This company needs a price and SEC financials."
    });
    const rows = [
        {
            ...data.self,
            self: true
        },
        ...data.peers
    ].slice(0, 6);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "co-table-wrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "co-table co-table-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Company"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Price"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Mkt Cap ($B)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "P/E"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Sales Growth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "Net Margin"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: "ROCE"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        children: rows.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                className: c.self ? "selected" : "",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                className: "wl-company",
                                                href: (0, $4a6071b6444d89fa$export$3518935f988c2e40)(c.ticker),
                                                children: c.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "co-tk",
                                                children: c.ticker
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: $11a79a9cbce8187a$var$dash(c.price, (0, $45b05daa53b66210$export$d4b2b9303ce6cae8))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: $11a79a9cbce8187a$var$dash(c.mcap, (v)=>(0, $45b05daa53b66210$export$79b4d5b1a469ce61)(v, 1))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.pe, "x")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: $11a79a9cbce8187a$var$dash(c.sales_g, (v)=>(0, $45b05daa53b66210$export$850409532323fff)(v, 1))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: $11a79a9cbce8187a$var$dash(c.nim, (v)=>(0, $45b05daa53b66210$export$850409532323fff)(v, 1))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: $11a79a9cbce8187a$var$dash(c.roce, (v)=>(0, $45b05daa53b66210$export$850409532323fff)(v, 1))
                                    })
                                ]
                            }, c.ticker))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "co-hint",
                children: [
                    "Closest in size in the same ",
                    data.groupType,
                    "."
                ]
            })
        ]
    });
}
function $11a79a9cbce8187a$var$HoldersOld({ ticker: ticker }) {
    const [st, setSt] = (0, $acw62.useState)({
        data: null,
        loading: true
    });
    (0, $acw62.useEffect)(()=>{
        let dead = false, timer = null;
        setSt({
            data: null,
            loading: true
        });
        const load = ()=>(0, $6a003cf53bfc86cf$export$cbee5bd9b9dd46d1)(ticker).then((d)=>{
                if (dead) return;
                setSt({
                    data: d,
                    loading: false
                });
                if (d && d.syncing) timer = setTimeout(load, 3000);
            }).catch(()=>!dead && setSt({
                    data: null,
                    loading: false
                }));
        load();
        return ()=>{
            dead = true;
            clearTimeout(timer);
        };
    }, [
        ticker
    ]);
    if (st.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    const d = st.data;
    if (!d || d.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "co-hint",
        children: "No insider data for this company."
    });
    const top = d.holdings.slice(0, 5);
    const so = d.sharesOutstandingMM ? d.sharesOutstandingMM * 1e6 : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            d.syncing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "co-hint",
                children: "Reading insider filings from the SEC\u2026 about 10 seconds the first time."
            }),
            !d.syncing && !top.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "co-hint",
                children: "No insider filings (Form 4) in the last 13 months."
            }),
            top.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table co-table-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Insider"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Role"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Shares"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "% Out."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: top.map((h, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: h.insider
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: h.role || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(h.shares, 0)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: so && /common|ordinary/i.test(h.security) ? (0, $45b05daa53b66210$export$850409532323fff)(h.shares / so * 100, 3) : "\u2014"
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "co-hint",
                        children: "Insiders only (SEC Form 4). Fund holdings are not available yet."
                    })
                ]
            })
        ]
    });
}
// Company description as bullet points (one per sentence) in a scrollable box.
function $11a79a9cbce8187a$var$AboutPointsOld({ text: text }) {
    const safe = String(text || "").replace(/\b(Inc|Corp|Co|Ltd|Jr|Sr|St|No|vs|Mr|Dr|Ms|Mrs|etc)\./g, "$1\u0000").replace(/\b([A-Z])\./g, "$1\u0000");
    const points = [];
    for (const para of safe.split(/\n+/)){
        const parts = para.match(/[^.!?]+(?:[.!?]+["')\]]*(?=\s|$)|$)/g) || [];
        for (const s of parts){
            const t = s.replace(/\u0000/g, ".").replace(/\s+/g, " ").trim();
            if (t.length > 2) points.push(t);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            maxHeight: 230,
            overflowY: "auto",
            paddingRight: 8,
            marginBottom: 12
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
            style: {
                margin: 0,
                paddingLeft: "1.1rem"
            },
            children: points.map((t, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                    style: {
                        marginBottom: 6
                    },
                    children: t
                }, i))
        })
    });
}
function $11a79a9cbce8187a$var$splitPoints(text) {
    const safe = String(text || "").replace(/\b(Inc|Corp|Co|Ltd|Jr|Sr|St|No|vs|Mr|Dr|Ms|Mrs|etc)\./g, "$1\u0000").replace(/\b([A-Z])\./g, "$1\u0000");
    const out = [];
    for (const para of safe.split(/\n+/))for (const s of para.match(/[^.!?]+(?:[.!?]+["')\]]*(?=\s|$)|$)/g) || []){
        const t = s.replace(/\u0000/g, ".").replace(/\s+/g, " ").trim();
        if (t.length > 2) out.push(t);
    }
    return out;
}
// Company description as bullet points, one visible at a time (scroll for more).
function $11a79a9cbce8187a$var$AboutPoints({ text: text }) {
    const points = $11a79a9cbce8187a$var$splitPoints(text);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            marginBottom: 12
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    height: 100,
                    overflowY: "auto",
                    scrollSnapType: "y mandatory",
                    paddingRight: 8
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    style: {
                        margin: 0,
                        paddingLeft: "1.1rem"
                    },
                    children: points.map((t, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            style: {
                                marginBottom: 6,
                                scrollSnapAlign: "start"
                            },
                            children: t
                        }, i))
                })
            }),
            points.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                className: "text-muted d-block mt-1",
                children: [
                    points.length,
                    " points \xb7 scroll for more"
                ]
            })
        ]
    });
}
// Company facts (read-only).
function $11a79a9cbce8187a$var$Facts({ p: p }) {
    const clean = (v)=>v !== null && v !== undefined && /[A-Za-z0-9]/.test(String(v)) ? String(v) : "";
    const rows = [
        [
            "Sector",
            clean(p.sector)
        ],
        [
            "Industry",
            clean(p.industry)
        ],
        [
            "Country",
            clean(p.country)
        ],
        [
            "Headquarters",
            clean(p.hq)
        ],
        [
            "SEC industry",
            clean(p.sicDescription)
        ],
        [
            "Fiscal year ends",
            clean(p.fiscalYearEnd)
        ],
        [
            "Phone",
            clean(p.phone)
        ],
        [
            "Website",
            clean(p.website)
        ],
        [
            "Employees",
            p.employees ? Number(p.employees).toLocaleString("en-US") : ""
        ]
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
        className: "co-stats co-overview-facts",
        children: [
            rows.map(([label, val])=>val || label === "Employees" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                            children: label
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                            children: label === "Website" && val ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: /^https?:/i.test(val) ? val : `https://${val}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: val
                            }) : val || "-"
                        })
                    ]
                }, label) : null),
            p.aboutSource && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    gridColumn: "1 / -1"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        children: "Description source"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: p.aboutUrl,
                                target: "_blank",
                                rel: "noreferrer",
                                children: p.aboutSource
                            }),
                            " (CC BY-SA)"
                        ]
                    })
                ]
            })
        ]
    });
}
// ---- editable ratio grid (like Screener's "Edit ratios") ------------------------------
const $11a79a9cbce8187a$var$RATIO_CATALOG = [
    [
        "price",
        "Current price",
        "$"
    ],
    [
        "change_1d",
        "1 day change",
        "%"
    ],
    [
        "ret_1y",
        "1 year return",
        "%"
    ],
    [
        "high_52w",
        "52W high",
        "$"
    ],
    [
        "low_52w",
        "52W low",
        "$"
    ],
    [
        "pct_off_high",
        "% from 52W high",
        "%"
    ],
    [
        "sma50",
        "50-day average",
        "$"
    ],
    [
        "sma200",
        "200-day average",
        "$"
    ],
    [
        "rsi14",
        "RSI (14)",
        ""
    ],
    [
        "avg_vol",
        "Average volume (3M)",
        ""
    ],
    [
        "vol_ratio",
        "Volume vs average",
        "x"
    ],
    [
        "mcap",
        "Market cap",
        "$B"
    ],
    [
        "pe",
        "Stock P/E",
        "x"
    ],
    [
        "pe_avg10",
        "P/E on 10Y average profit",
        "x"
    ],
    [
        "ps",
        "Price / sales",
        "x"
    ],
    [
        "pb",
        "Price / book",
        "x"
    ],
    [
        "ev_ebitda",
        "EV / EBITDA",
        "x"
    ],
    [
        "earnings_yield",
        "Earnings yield (EBIT/EV)",
        "%"
    ],
    [
        "fcf_yield",
        "FCF yield",
        "%"
    ],
    [
        "div_yield",
        "Dividend yield",
        "%"
    ],
    [
        "peg",
        "PEG",
        "x"
    ],
    [
        "roce",
        "ROCE",
        "%"
    ],
    [
        "roce_avg_3y",
        "ROCE, 3Y average",
        "%"
    ],
    [
        "roe",
        "ROE",
        "%"
    ],
    [
        "roa",
        "ROA",
        "%"
    ],
    [
        "roic",
        "ROIC",
        "%"
    ],
    [
        "gm",
        "Gross margin",
        "%"
    ],
    [
        "opm",
        "Operating margin",
        "%"
    ],
    [
        "nim",
        "Net margin",
        "%"
    ],
    [
        "sales",
        "Sales (LTM)",
        "$M"
    ],
    [
        "np",
        "Net profit (LTM)",
        "$M"
    ],
    [
        "sales_g",
        "Sales growth (LTM YoY)",
        "%"
    ],
    [
        "profit_g",
        "Profit growth (LTM YoY)",
        "%"
    ],
    [
        "sales_cagr_3y",
        "Sales CAGR 3Y",
        "%"
    ],
    [
        "sales_cagr_5y",
        "Sales CAGR 5Y",
        "%"
    ],
    [
        "profit_cagr_3y",
        "Profit CAGR 3Y",
        "%"
    ],
    [
        "profit_cagr_5y",
        "Profit CAGR 5Y",
        "%"
    ],
    [
        "q_sales",
        "Sales (latest quarter)",
        "$M"
    ],
    [
        "q_sales_g",
        "Quarter sales growth YoY",
        "%"
    ],
    [
        "q_np",
        "Net profit (latest quarter)",
        "$M"
    ],
    [
        "q_np_g",
        "Quarter profit growth YoY",
        "%"
    ],
    [
        "debt_equity",
        "Debt / equity",
        "x"
    ],
    [
        "current_ratio",
        "Current ratio",
        "x"
    ],
    [
        "interest_cover",
        "Interest coverage",
        "x"
    ],
    [
        "debt_chg_3y",
        "Debt change, 3Y",
        "%"
    ],
    [
        "capex_sales",
        "Capex / sales",
        "%"
    ],
    [
        "shares_chg_3y",
        "Share count change, 3Y",
        "%"
    ],
    [
        "piotroski",
        "Piotroski F-score",
        ""
    ],
    [
        "magic_rank",
        "Magic Formula rank",
        ""
    ]
].map(([key, label, unit])=>({
        key: key,
        label: label,
        unit: unit
    }));
const $11a79a9cbce8187a$var$DEFAULT_RATIOS = [
    "mcap",
    "price",
    "high_52w",
    "low_52w",
    "pe",
    "pb",
    "div_yield",
    "roce",
    "roe",
    "sales",
    "nim",
    "debt_equity"
];
function $11a79a9cbce8187a$var$fmtRatio(v, unit) {
    if (v === null || v === undefined || Number.isNaN(Number(v))) return "-";
    const n = Number(v);
    const c = (x, d = 2)=>x.toLocaleString("en-US", {
            minimumFractionDigits: d,
            maximumFractionDigits: d
        });
    switch(unit){
        case "$":
            return `$${c(n)}`;
        case "%":
            return `${c(n, 1)}%`;
        case "$B":
            return n >= 1000 ? `$${c(n / 1000)} T` : `$${c(n)} B`;
        case "$M":
            return Math.abs(n) >= 1000 ? `$${c(n / 1000)} B` : `$${c(n, 0)} M`;
        case "x":
            return `${c(n)}x`;
        default:
            return Math.abs(n) >= 1000 ? c(n, 0) : c(n, 2);
    }
}
function $11a79a9cbce8187a$var$Ratios({ ticker: ticker, snapshot: snapshot }) {
    const loggedIn = !!(0, $814748c4d1640136$export$257b2d10b709d8ef)();
    const [saved, setSaved] = (0, $acw62.useState)(()=>(0, $c8ac4ec5c1859847$export$332d58514331716c)("ratios", null, []));
    const [draft, setDraft] = (0, $acw62.useState)(null); // null = not editing
    const [q, setQ] = (0, $acw62.useState)("");
    const [row, setRow] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let dead = false;
        setRow(null);
        (0, $6a003cf53bfc86cf$export$9dbcdfb953196356)(ticker).then((d)=>!dead && setRow(d && d.self ? d.self : {})).catch(()=>!dead && setRow({}));
        return ()=>{
            dead = true;
        };
    }, [
        ticker
    ]);
    const list = draft || (saved && saved.length ? saved : null);
    const find = (k)=>$11a79a9cbce8187a$var$RATIO_CATALOG.find((r)=>r.key === k);
    const term = q.trim().toLowerCase();
    const matches = term && draft ? $11a79a9cbce8187a$var$RATIO_CATALOG.filter((r)=>!draft.includes(r.key) && (r.label.toLowerCase().includes(term) || r.key.includes(term.replace(/\s+/g, "_")))).slice(0, 8) : [];
    const startEdit = ()=>setDraft(saved && saved.length ? [
            ...saved
        ] : [
            ...$11a79a9cbce8187a$var$DEFAULT_RATIOS
        ]);
    const add = (k)=>{
        if (draft.length < 24) setDraft([
            ...draft,
            k
        ]);
        setQ("");
    };
    const save = ()=>{
        (0, $c8ac4ec5c1859847$export$9f43f72cb45956cb)("ratios", null, draft);
        setSaved(draft);
        setDraft(null);
        setQ("");
    };
    const reset = ()=>{
        (0, $c8ac4ec5c1859847$export$9f43f72cb45956cb)("ratios", null, []);
        setSaved([]);
        setDraft(null);
        setQ("");
    };
    const link = {
        background: "none",
        border: 0,
        color: "#6f42c1",
        letterSpacing: "0.15em",
        fontWeight: 600,
        textTransform: "uppercase",
        fontSize: "0.85rem",
        padding: "0 0 0 1rem"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "co-ratios",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "co-snapshot",
                children: list ? list.map((k)=>{
                    const r = find(k);
                    if (!r) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: r.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: row ? $11a79a9cbce8187a$var$fmtRatio(row[k], r.unit) : "..."
                            }),
                            draft && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                "aria-label": `Remove ${r.label}`,
                                onClick: ()=>setDraft(draft.filter((x)=>x !== k)),
                                style: {
                                    border: 0,
                                    background: "none",
                                    color: "#c0392b",
                                    fontSize: "1.1rem",
                                    lineHeight: 1,
                                    padding: "0 0 0 8px"
                                },
                                children: "\xd7"
                            })
                        ]
                    }, k);
                }) : (snapshot || []).map(([label, text])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: text
                            })
                        ]
                    }, label))
            }),
            loggedIn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    gap: "1rem",
                    marginTop: "1rem"
                },
                children: [
                    draft ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            position: "relative",
                            maxWidth: 520
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontWeight: 600,
                                    marginBottom: 6,
                                    color: "#000"
                                },
                                children: "Add ratio to table"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                className: "form-control",
                                placeholder: "eg. Debt / equity",
                                value: q,
                                autoComplete: "off",
                                onChange: (e)=>setQ(e.target.value),
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter" && matches[0]) add(matches[0].key);
                                }
                            }),
                            matches.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                style: {
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    top: "100%",
                                    zIndex: 50,
                                    margin: "2px 0 0",
                                    padding: 0,
                                    listStyle: "none",
                                    background: "#fff",
                                    color: "#000",
                                    border: "1px solid #ddd",
                                    borderRadius: 6,
                                    boxShadow: "0 6px 20px rgba(0,0,0,.15)"
                                },
                                children: matches.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onMouseDown: (e)=>{
                                                e.preventDefault();
                                                add(r.key);
                                            },
                                            style: {
                                                display: "block",
                                                width: "100%",
                                                textAlign: "left",
                                                border: 0,
                                                background: "transparent",
                                                color: "#000",
                                                padding: "8px 12px"
                                            },
                                            children: r.label
                                        })
                                    }, r.key))
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            whiteSpace: "nowrap"
                        },
                        children: draft ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    style: link,
                                    onClick: save,
                                    children: "Save"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    style: {
                                        ...link,
                                        color: "#555"
                                    },
                                    onClick: ()=>{
                                        setDraft(null);
                                        setQ("");
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    style: {
                                        ...link,
                                        color: "#c0392b"
                                    },
                                    onClick: reset,
                                    children: "Reset"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            style: link,
                            onClick: startEdit,
                            children: "Edit ratios"
                        })
                    })
                ]
            })
        ]
    });
}
function $11a79a9cbce8187a$var$Holders(p) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $287d5b51065c19f8$export$2e2bcd8739ae039), {
        ticker: p.ticker || p.symbol || p.stock && p.stock.ticker
    });
}




var $acw62 = parcelRequire("acw62");


function $146c4d921355ff51$export$2e2bcd8739ae039({ ticker: ticker, user: user, onRequireLogin: onRequireLogin }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)(()=>(0, $e40357b11b89adfe$export$c71e43542eef6c70)(user));
    const [name, setName] = (0, $acw62.useState)("");
    const [error, setError] = (0, $acw62.useState)("");
    const box = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (open) setData((0, $e40357b11b89adfe$export$c71e43542eef6c70)(user));
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const close = (e)=>{
            if (box.current && !box.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", close);
        return ()=>document.removeEventListener("mousedown", close);
    }, [
        open
    ]);
    const inAny = data.lists.some((l)=>l.tickers.includes(ticker));
    const commit = (next)=>{
        setData(next);
        (0, $e40357b11b89adfe$export$1224f37931278599)(user, next);
    };
    const toggle = (id)=>commit({
            ...data,
            lists: data.lists.map((l)=>l.id !== id ? l : {
                    ...l,
                    tickers: l.tickers.includes(ticker) ? l.tickers.filter((t)=>t !== ticker) : [
                        ...l.tickers,
                        ticker
                    ]
                })
        });
    const create = (e)=>{
        e.preventDefault();
        const n = name.trim();
        if (!n) return;
        if (data.lists.some((l)=>l.name.toLowerCase() === n.toLowerCase())) return setError("You already have a watchlist with that name.");
        const id = Date.now().toString(36);
        commit({
            lists: [
                ...data.lists,
                {
                    id: id,
                    name: n,
                    tickers: [
                        ticker
                    ]
                }
            ],
            activeId: data.activeId || id
        });
        setName("");
        setError("");
    };
    const click = ()=>{
        if (!user) return onRequireLogin();
        setOpen((o)=>!o);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: box,
        style: {
            position: "relative",
            display: "inline-block"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: `btn ${inAny ? "tool-btn" : "btn-purple"}`,
                onClick: click,
                children: [
                    inAny ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                        size: 15
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                        size: 15
                    }),
                    " ",
                    inAny ? "In Watchlist" : "Add to Watchlist",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 14
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    position: "absolute",
                    right: 0,
                    top: "calc(100% + 6px)",
                    width: 260,
                    zIndex: 1000,
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    boxShadow: "0 6px 20px rgba(0,0,0,.15)",
                    padding: 8,
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "small text-muted px-2 pb-1",
                        children: [
                            "Save ",
                            ticker,
                            " to:"
                        ]
                    }),
                    data.lists.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "small px-2 py-1 text-muted",
                        children: "You have no watchlists yet. Create one below."
                    }),
                    data.lists.map((l)=>{
                        const on = l.tickers.includes(ticker);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "d-flex align-items-center gap-2 px-2 py-1",
                            style: {
                                cursor: "pointer"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: on,
                                    onChange: ()=>toggle(l.id)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "flex-grow-1",
                                    children: l.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "small text-muted",
                                    children: l.tickers.length
                                })
                            ]
                        }, l.id);
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: create,
                        className: "d-flex gap-1 mt-2 pt-2",
                        style: {
                            borderTop: "1px solid #eee"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                className: "form-control form-control-sm",
                                placeholder: "New watchlist name",
                                maxLength: 40,
                                value: name,
                                onChange: (e)=>{
                                    setName(e.target.value);
                                    setError("");
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                className: "btn btn-purple btn-sm",
                                disabled: !name.trim(),
                                children: "Create"
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "small text-danger px-1 pt-1",
                        children: error
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");
function $1c873d4017ff6826$export$2e2bcd8739ae039({ labels: labels, values: values, format: format }) {
    const W = 900;
    const H = 200;
    const pad = {
        t: 22,
        b: 26,
        l: 10,
        r: 10
    };
    const nums = values.map((v)=>v === null || Number.isNaN(v) ? 0 : v);
    const max = Math.max(...nums, 0);
    const min = Math.min(...nums, 0);
    const span = max - min || 1;
    const bw = (W - pad.l - pad.r) / values.length;
    const y = (v)=>pad.t + (max - v) / span * (H - pad.t - pad.b);
    const zero = y(0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: `0 0 ${W} ${H}`,
        className: "bar-chart",
        role: "img",
        "aria-label": "Bar chart",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: pad.l,
                x2: W - pad.r,
                y1: zero,
                y2: zero,
                className: "pc-grid"
            }),
            nums.map((v, i)=>{
                const x = pad.l + i * bw + bw * 0.18;
                const top = Math.min(y(v), zero);
                const h = Math.max(1, Math.abs(y(v) - zero));
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: x,
                            y: top,
                            width: bw * 0.64,
                            height: h,
                            rx: "2",
                            className: v < 0 ? "bar-neg" : "bar-pos"
                        }),
                        values.length <= 14 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                            x: x + bw * 0.32,
                            y: v < 0 ? top + h + 12 : top - 5,
                            textAnchor: "middle",
                            className: "bar-val",
                            children: format(values[i])
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                            x: x + bw * 0.32,
                            y: H - 8,
                            textAnchor: "middle",
                            className: "pc-axis",
                            children: labels[i]
                        })
                    ]
                }, labels[i]);
            })
        ]
    });
}



const $d2ef8bad7964abbc$var$STATEMENT_TABS = [
    [
        "income",
        "Income Statement"
    ],
    [
        "balance",
        "Balance Sheet"
    ],
    [
        "cashflow",
        "Cash Flow"
    ],
    [
        "ratios",
        "Ratios"
    ]
];
const $d2ef8bad7964abbc$var$PERIODS = [
    [
        "annual",
        "Annual"
    ],
    [
        "quarterly",
        "Quarterly"
    ],
    [
        "ltm",
        "LTM"
    ]
];
const $d2ef8bad7964abbc$var$UNITS = [
    "K",
    "MM",
    "B"
];
function $d2ef8bad7964abbc$export$2e2bcd8739ae039({ ticker: ticker }) {
    const [statement, setStatement] = (0, $acw62.useState)("income");
    const [period, setPeriod] = (0, $acw62.useState)("annual");
    const [unit, setUnit] = (0, $acw62.useState)("MM");
    const [selected, setSelected] = (0, $acw62.useState)(null);
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$226017fe7f8e0ffd)(ticker, statement, period), [
        ticker,
        statement,
        period
    ]);
    const chartRow = data && (data.rows.find((r)=>r.key === selected) || null);
    const exportCsv = ()=>{
        if (!data) return;
        (0, $45b05daa53b66210$export$c6d851d1877b46af)(`${ticker}-${statement}-${period}.csv`, [
            [
                "($MM unless noted)",
                ...data.columns.map((c)=>c.label)
            ],
            ...data.rows.map((r)=>[
                    r.label,
                    ...r.values.map((v)=>v === null ? "" : v)
                ])
        ]);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "co-toolbar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f26f9c9d776b76eb), {
                        items: $d2ef8bad7964abbc$var$STATEMENT_TABS,
                        value: statement,
                        onChange: (s)=>{
                            setStatement(s);
                            setSelected(null);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "co-toolbar-right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "co-seg",
                                children: $d2ef8bad7964abbc$var$PERIODS.map(([k, l])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: period === k ? "active" : "",
                                        onClick: ()=>setPeriod(k),
                                        children: l
                                    }, k))
                            }),
                            statement !== "ratios" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "co-seg",
                                title: "Display units",
                                children: $d2ef8bad7964abbc$var$UNITS.map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: unit === u ? "active" : "",
                                        onClick: ()=>setUnit(u),
                                        children: u
                                    }, u))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "btn tool-btn",
                                onClick: exportCsv,
                                disabled: !data,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " Export"
                                ]
                            })
                        ]
                    })
                ]
            }),
            statement === "income" && period === "quarterly" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "card co-card",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5882e73e4858513f$export$2e2bcd8739ae039), {
                    ticker: ticker,
                    count: 24,
                    unit: unit
                })
            }) : loading && !data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {}) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f04a3ea04edc0e04), {
                error: error
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    chartRow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "card co-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                className: "co-card-title",
                                children: [
                                    chartRow.label,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "co-link",
                                        onClick: ()=>setSelected(null),
                                        children: "close"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c873d4017ff6826$export$2e2bcd8739ae039), {
                                labels: data.columns.map((c)=>c.label),
                                values: chartRow.values,
                                format: (v)=>(0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(v, chartRow.kind, unit)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "card co-card co-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "co-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "co-sticky",
                                                children: statement === "ratios" ? "Ratios" : `USD in ${unit === "K" ? "thousands" : unit === "MM" ? "millions" : "billions"}`
                                            }),
                                            data.columns.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                    children: [
                                                        c.label,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            children: c.sub
                                                        })
                                                    ]
                                                }, c.label))
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: data.rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: `${r.bold ? "bold" : ""} ${r.italic ? "italic" : ""} ${selected === r.key ? "selected" : ""}`,
                                            onClick: ()=>setSelected(r.key === selected ? null : r.key),
                                            title: "Click to chart this row",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: `co-sticky ${r.indent ? "indent" : ""}`,
                                                    children: r.label
                                                }),
                                                r.values.map((v, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: v < 0 && r.kind !== "money" ? "neg" : "",
                                                        children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(v, r.kind, unit)
                                                    }, i))
                                            ]
                                        }, r.key))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "co-hint",
                        children: "Click any row to see it as a chart."
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





const $189f08c74fc76ae1$var$ROWS = [
    [
        "pe",
        "P/E",
        "x"
    ],
    [
        "ps",
        "Price / Sales",
        "x"
    ],
    [
        "pb",
        "Price / Book",
        "x"
    ],
    [
        "ev_ebitda",
        "EV / EBITDA",
        "x"
    ],
    [
        "roce",
        "ROCE",
        "pct"
    ],
    [
        "nim",
        "Net margin",
        "pct"
    ],
    [
        "sales_g",
        "Sales growth (LTM)",
        "pct"
    ],
    [
        "div_yield",
        "Dividend yield",
        "pct"
    ]
];
function $189f08c74fc76ae1$export$2e2bcd8739ae039({ ticker: ticker }) {
    const [view, setView] = (0, $acw62.useState)("multiples");
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $6a003cf53bfc86cf$export$9dbcdfb953196356)(ticker), [
        ticker
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error || !data || data.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "card co-card",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "co-hint",
            children: "No valuation data for this company yet. It needs a share price and SEC financials."
        })
    });
    const label = data.group ? `${data.n.toLocaleString("en-US")} companies in ${data.groupType === "industry" ? "the" : "the"} ${data.group} ${data.groupType}` : "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f26f9c9d776b76eb), {
                items: [
                    [
                        "multiples",
                        "Multiples"
                    ],
                    [
                        "competitors",
                        "Competitors"
                    ],
                    [
                        "targets",
                        "Street Targets"
                    ]
                ],
                value: view,
                onChange: setView
            }),
            view === "multiples" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table co-table-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Measure"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: ticker
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Industry median"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    $189f08c74fc76ae1$var$ROWS.map(([k, name, kind])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(data.self[k], kind)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(data.medians[k], kind)
                                                })
                                            ]
                                        }, k)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: "P/E on 10-year average profit"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(data.self.pe_avg10, "x")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: "\u2014"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "co-hint",
                        children: [
                            label ? `Median of ${label}. ` : "",
                            "Calculated from SEC financials and your latest price. Financial companies have different accounting, so compare them with each other."
                        ]
                    })
                ]
            }),
            view === "competitors" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table co-table-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Company"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Price"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Mkt Cap ($B)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "P/E"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Sales Growth"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Net Margin"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "ROCE"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    [
                                        {
                                            ...data.self,
                                            self: true
                                        },
                                        ...data.peers
                                    ].map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: c.self ? "selected" : "",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            className: "wl-company",
                                                            href: (0, $4a6071b6444d89fa$export$3518935f988c2e40)(c.ticker),
                                                            children: c.name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            className: "co-tk",
                                                            children: c.ticker
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(c.price)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.mcap, "count")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.pe, "x")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.sales_g, "pct")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.nim, "pct")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(c.roce, "pct")
                                                })
                                            ]
                                        }, c.ticker)),
                                    !data.peers.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: 7,
                                            className: "co-hint",
                                            children: "No peers found."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "co-hint",
                        children: [
                            "The ten companies closest in size within the same ",
                            data.groupType,
                            "."
                        ]
                    })
                ]
            }),
            view === "targets" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "card co-card",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "co-hint",
                    children: "Analyst price targets and ratings come from brokerage research, which data vendors sell under licence. There is no free source, so this view stays empty until a data feed is connected."
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




const $bd7e115d4c0afd7c$var$clamp = (v, lo, hi)=>Math.min(hi, Math.max(lo, v));
const $bd7e115d4c0afd7c$var$r1 = (v)=>Math.round(v * 10) / 10;
function $bd7e115d4c0afd7c$export$2e2bcd8739ae039({ ticker: ticker, user: user, onRequireLogin: onRequireLogin }) {
    const [base, setBase] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)("");
    const [m, setM] = (0, $acw62.useState)(null);
    const [saved, setSaved] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let dead = false;
        setBase(null);
        setError("");
        (0, $6a003cf53bfc86cf$export$2dfd31d5563ac23e)(ticker).then((d)=>{
            if (dead) return;
            if (d.error) return setError("This company has no SEC financials to build a model from.");
            setBase(d);
            const mine = user ? ((0, $c8ac4ec5c1859847$export$332d58514331716c)("models", user, {}) || {})[ticker] : null;
            const margin = d.ltm.revenue > 0 ? d.ltm.ni / d.ltm.revenue * 100 : 10;
            const pe = d.ltm.eps > 0 ? d.price / d.ltm.eps : 15;
            setM(mine || {
                growth: $bd7e115d4c0afd7c$var$r1($bd7e115d4c0afd7c$var$clamp(d.rev3yCagr === null ? 8 : d.rev3yCagr, 0, 25)),
                margin: $bd7e115d4c0afd7c$var$r1($bd7e115d4c0afd7c$var$clamp(margin, 1, 60)),
                exitPe: Math.round($bd7e115d4c0afd7c$var$clamp(pe, 8, 30)),
                ret: 10,
                shares: 0,
                years: 5
            });
        }).catch((e)=>!dead && setError(e.message));
        return ()=>{
            dead = true;
        };
    }, [
        ticker
    ]);
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "card co-card",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "co-hint",
            children: error
        })
    });
    if (!base || !m) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    const set = (k)=>(e)=>{
            setSaved(false);
            setM({
                ...m,
                [k]: parseFloat(e.target.value) || 0
            });
        };
    const rows = [];
    for(let y = 1; y <= m.years; y++){
        const revenue = base.ltm.revenue * Math.pow(1 + m.growth / 100, y);
        const ni = revenue * (m.margin / 100);
        const sh = base.sharesMM * Math.pow(1 + m.shares / 100, y);
        rows.push({
            y: y,
            revenue: revenue,
            ni: ni,
            eps: ni / sh
        });
    }
    const last = rows[rows.length - 1];
    const futurePrice = last.eps * m.exitPe;
    const fair = futurePrice / Math.pow(1 + m.ret / 100, m.years);
    const upside = base.price ? (fair / base.price - 1) * 100 : null;
    const save = ()=>{
        if (!user) return onRequireLogin && onRequireLogin();
        (0, $c8ac4ec5c1859847$export$9f43f72cb45956cb)("models", user, {
            ...(0, $c8ac4ec5c1859847$export$332d58514331716c)("models", user, {}) || {},
            [ticker]: m
        });
        setSaved(true);
    };
    const Field = ({ k: k, label: label, step: step = "0.1" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    className: "tool-label",
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "number",
                    step: step,
                    className: "form-control",
                    value: m[k],
                    onChange: set(k)
                })
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                        className: "co-card-title",
                        children: [
                            "Your assumptions for ",
                            ticker
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tool-form",
                        style: {
                            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, {
                                k: "growth",
                                label: "Revenue growth / yr (%)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, {
                                k: "margin",
                                label: "Net margin (%)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, {
                                k: "exitPe",
                                label: "P/E at the end",
                                step: "1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, {
                                k: "ret",
                                label: "Return you want / yr (%)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, {
                                k: "shares",
                                label: "Share count change / yr (%)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, {
                                k: "years",
                                label: "Years",
                                step: "1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "co-hint",
                        children: [
                            "Starting from real figures: revenue ",
                            (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(base.ltm.revenue, 0),
                            " MM, net income ",
                            (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(base.ltm.ni, 0),
                            " MM (",
                            base.rev3yCagr === null ? "3-year growth n/a" : `${(0, $45b05daa53b66210$export$850409532323fff)(base.rev3yCagr, 1)} revenue growth over 3 years`,
                            "), price ",
                            (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(base.price),
                            ", ",
                            (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(base.sharesMM, 0),
                            " MM shares."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                        className: "co-card-title",
                        children: "Result"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "co-stats",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        children: "Fair value today"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        children: (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(fair)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        children: "Current price"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        children: (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(base.price)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        children: "Upside / downside"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        className: upside >= 0 ? "change-up" : "change-down",
                                        children: upside === null ? "\u2014" : (0, $45b05daa53b66210$export$850409532323fff)(upside, 1, true)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                                        children: [
                                            "Price in ",
                                            m.years,
                                            " years"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        children: (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(futurePrice)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "btn btn-purple",
                        onClick: save,
                        children: user ? saved ? "Saved" : "Save this model" : "Log in to save"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "co-sticky"
                                        }),
                                        rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                children: [
                                                    "Year ",
                                                    r.y
                                                ]
                                            }, r.y))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "co-sticky",
                                                children: "Revenue ($MM)"
                                            }),
                                            rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(r.revenue, 0)
                                                }, r.y))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "co-sticky",
                                                children: "Net income ($MM)"
                                            }),
                                            rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(r.ni, 0)
                                                }, r.y))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "bold",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "co-sticky",
                                                children: "EPS ($)"
                                            }),
                                            rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(r.eps, 2)
                                                }, r.y))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "co-hint",
                        children: "A simple earnings model: grow revenue, apply your margin, multiply the final EPS by your exit P/E, then discount back at the return you want. It is a tool for thinking, not a prediction or advice."
                    })
                ]
            })
        ]
    });
}



parcelRequire("acw62");




function $5edce8265a0e4632$export$2e2bcd8739ae039({ ticker: ticker }) {
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $6a003cf53bfc86cf$export$2dfd31d5563ac23e)(ticker), [
        ticker
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error || !data || data.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "card co-card",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "co-hint",
            children: "No SEC financials for this company, so there is no history to show."
        })
    });
    const years = data.annual;
    const row = (label, key, kind, cls)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
            className: cls,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    className: "co-sticky",
                    children: label
                }),
                years.map((y)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        children: (0, $45b05daa53b66210$export$1ef4e7f5e06ac44a)(y[key], kind, "MM")
                    }, y.label))
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                        className: "co-card-title",
                        children: "Reported results by fiscal year ($MM, EPS in $)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "co-sticky"
                                        }),
                                        years.map((y)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: y.label
                                            }, y.label))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    row("Revenue", "revenue", "money"),
                                    row("Revenue growth", "revG", "pct", "italic"),
                                    row("EBITDA", "ebitda", "money"),
                                    row("Net income", "ni", "money"),
                                    row("EPS", "eps", "ps", "bold"),
                                    row("Free cash flow", "fcf", "money")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "co-hint",
                        children: "From SEC filings. Per-share figures are as originally reported, so years before a stock split are not adjusted."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "card co-card",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "co-hint",
                    children: "Forward estimates (analyst consensus for revenue and EPS, the number of analysts, and earnings surprises) come from brokerage research that data vendors sell under licence. There is no free source, so they are not shown. You can build your own forecast in the Model tab."
                })
            })
        ]
    });
}



parcelRequire("acw62");





function $76affa0f86275e4c$export$2e2bcd8739ae039({ ticker: ticker }) {
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $6a003cf53bfc86cf$export$4f498f45d9eebbb1)(ticker), [
        ticker
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    const list = Array.isArray(data) ? data : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                        className: "co-card-title",
                        children: "Earnings releases"
                    }),
                    error || !list.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "co-hint",
                        children: "No earnings releases found on SEC EDGAR for this company."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table co-table-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Filing"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Documents"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: list.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$3865cc3c40061728)(r.date)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "badge-purple",
                                                        children: r.form
                                                    }),
                                                    " Results of operations (Item 2.02)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                        href: r.index,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: [
                                                            "All documents ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                size: 12
                                                            })
                                                        ]
                                                    }),
                                                    r.doc && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                        className: "ms-3",
                                                        href: r.doc,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: [
                                                            "8-K ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                size: 12
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, r.index))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "co-hint",
                children: "These are the companies' own earnings announcements filed with the SEC (the press release is attached as Exhibit 99.1). Call transcripts are licensed content and are not available from a free source."
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $784b206569457de8$export$2e2bcd8739ae039({ ticker: ticker }) {
    const { data: data, loading: loading, error: error } = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$cb26a1c42e348f4f)(ticker), [
        ticker
    ]);
    const [form, setForm] = (0, $acw62.useState)("All");
    const [limit, setLimit] = (0, $acw62.useState)(15);
    const rows = (0, $acw62.useMemo)(()=>(data || []).filter((f)=>form === "All" || f.form === form), [
        data,
        form
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f04a3ea04edc0e04), {
        error: error
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "co-toolbar",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$ca60b63eaa3c28aa), {
                    items: (0, $4f8fb6d4b6efdb53$export$c8734b77a7cc822),
                    value: form,
                    onChange: (f)=>{
                        setForm(f);
                        setLimit(15);
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table co-table-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Form"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Description"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.slice(0, limit).map((f, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$3865cc3c40061728)(f.date)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "badge-purple",
                                                    children: f.form
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: f.description
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                    href: f.url,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: "Find on SEC EDGAR",
                                                    children: [
                                                        "EDGAR ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                            size: 12
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    rows.length > limit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "co-more",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "btn tool-btn",
                            onClick: ()=>setLimit(limit + 15),
                            children: "Show more"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "co-hint",
                children: "Dates are sample values; links open the company's real filing list on SEC EDGAR."
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $bb509ef0ec3befe7$var$CODES = {
    P: "Buy",
    S: "Sell",
    A: "Award",
    M: "Option exercise",
    X: "Option exercise",
    F: "Tax withholding",
    G: "Gift",
    D: "Sold to company",
    C: "Conversion",
    I: "Discretionary",
    J: "Other",
    W: "Inheritance"
};
const $bb509ef0ec3befe7$var$day = (s)=>Date.parse(`${s}T00:00:00Z`);
const $bb509ef0ec3befe7$var$amount = (t)=>(t.shares || 0) * (t.price || 0);
function $bb509ef0ec3befe7$export$2e2bcd8739ae039({ ticker: ticker }) {
    const [view, setView] = (0, $acw62.useState)("holders");
    const [state, setState] = (0, $acw62.useState)({
        data: null,
        loading: true,
        error: ""
    });
    // the first visit to a company reads its filings from the SEC, so keep checking until it is done
    (0, $acw62.useEffect)(()=>{
        let dead = false;
        let timer = null;
        setState({
            data: null,
            loading: true,
            error: ""
        });
        const load = ()=>(0, $6a003cf53bfc86cf$export$cbee5bd9b9dd46d1)(ticker).then((d)=>{
                if (dead) return;
                if (d.error) return setState({
                    data: null,
                    loading: false,
                    error: "No insider data for this company."
                });
                setState({
                    data: d,
                    loading: false,
                    error: ""
                });
                if (d.syncing) timer = setTimeout(load, 3000);
            }).catch((e)=>!dead && setState({
                    data: null,
                    loading: false,
                    error: e.message
                }));
        load();
        return ()=>{
            dead = true;
            clearTimeout(timer);
        };
    }, [
        ticker
    ]);
    const { data: data, loading: loading, error: error } = state;
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {});
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "card co-card",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "co-hint",
            children: error
        })
    });
    const year = Date.now() - 365 * 864e5;
    const recent = data.trades.filter((t)=>$bb509ef0ec3befe7$var$day(t.date) >= year);
    const buys = recent.filter((t)=>t.code === "P");
    const sells = recent.filter((t)=>t.code === "S");
    const sum = (a)=>a.reduce((s, t)=>s + $bb509ef0ec3befe7$var$amount(t), 0);
    const so = data.sharesOutstandingMM ? data.sharesOutstandingMM * 1e6 : null;
    const empty = !data.trades.length && !data.holdings.length;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$f26f9c9d776b76eb), {
                items: [
                    [
                        "holders",
                        "Insider Holdings"
                    ],
                    [
                        "insiders",
                        "Insider Transactions"
                    ]
                ],
                value: view,
                onChange: setView
            }),
            data.syncing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "co-hint",
                children: "Reading this company's insider filings from the SEC\u2026 this takes about 10 seconds the first time."
            }),
            empty && !data.syncing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "card co-card",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "co-hint",
                    children: "No insider filings (SEC Form 4) found in the last 13 months."
                })
            }),
            !empty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "co-hint",
                children: [
                    "Last 12 months, open-market: ",
                    buys.length,
                    " buys (",
                    (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(sum(buys), 0),
                    ") and ",
                    sells.length,
                    " sells (",
                    (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(sum(sells), 0),
                    ")."
                ]
            }),
            !empty && view === "holders" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table co-table-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Holder"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Role"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Security"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Held"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Shares"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "% of shares out."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Value ($)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "As of"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: data.holdings.map((h, i)=>{
                                    const pct = so && /common|ordinary/i.test(h.security) ? h.shares / so * 100 : null;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: h.insider
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: h.role || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: h.security || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: h.direct ? "Directly" : "Indirectly"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(h.shares, 0)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: pct === null ? "\u2014" : (0, $45b05daa53b66210$export$850409532323fff)(pct, 3)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: data.price ? (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(h.shares * data.price, 0) : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$3865cc3c40061728)(h.as_of)
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "co-hint",
                        children: "Positions reported by company insiders (officers, directors, 10% owners) in their latest SEC Form 4. Institutional shareholders (funds) are not shown yet."
                    })
                ]
            }),
            !empty && view === "insiders" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "card co-card co-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "co-table co-table-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Insider"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Role"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Shares"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Price"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Value"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Held after"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: data.trades.map((t, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$3865cc3c40061728)(t.date)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: t.insider
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: t.role || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: t.code === "P" ? "change-up" : t.code === "S" ? "change-down" : "",
                                                children: $bb509ef0ec3befe7$var$CODES[t.code] || t.code || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(t.shares, 0)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: t.price ? (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(t.price) : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: t.price && t.shares ? (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)($bb509ef0ec3befe7$var$amount(t), 0) : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: t.owned_after === null ? "\u2014" : (0, $45b05daa53b66210$export$79b4d5b1a469ce61)(t.owned_after, 0)
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "co-hint",
                        children: "From SEC Form 4 filings. Awards and tax withholding are routine; open-market buys and sells are the informative ones."
                    })
                ]
            })
        ]
    });
}



function $fd7229c0bec47ef0$var$OldWatchButton({ ticker: ticker, user: user, onRequireLogin: onRequireLogin }) {
    const [, force] = (0, $acw62.useState)(0);
    const data = (0, $e40357b11b89adfe$export$c71e43542eef6c70)(user);
    const active = data.lists.find((l)=>l.id === data.activeId) || data.lists[0];
    const inList = !!active && active.tickers.includes(ticker);
    const add = ()=>{
        if (!user) return onRequireLogin();
        let next = data;
        if (!active) {
            const id = Date.now().toString(36);
            next = {
                lists: [
                    {
                        id: id,
                        name: "My Watchlist",
                        tickers: [
                            ticker
                        ]
                    }
                ],
                activeId: id
            };
        } else next = {
            ...data,
            lists: data.lists.map((l)=>l.id === active.id ? {
                    ...l,
                    tickers: l.tickers.includes(ticker) ? l.tickers.filter((t)=>t !== ticker) : [
                        ...l.tickers,
                        ticker
                    ]
                } : l)
        };
        (0, $e40357b11b89adfe$export$1224f37931278599)(user, next);
        force((n)=>n + 1);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: `btn ${inList ? "tool-btn" : "btn-purple"}`,
        onClick: add,
        children: [
            inList ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                size: 15
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                size: 15
            }),
            " ",
            inList ? "In Watchlist" : "Add to Watchlist"
        ]
    });
}
function $fd7229c0bec47ef0$export$2e2bcd8739ae039({ ticker: ticker, tab: tab, user: user, onRequireLogin: onRequireLogin }) {
    const [showChart, setShowChart] = (0, $acw62.useState)(true);
    const profile = (0, $97588ae92ff80131$export$2e2bcd8739ae039)(()=>(0, $75280afcc6fc2ba7$export$85d699ca8330b9a9)(ticker), [
        ticker
    ]);
    const quote = (0, $84a6c4c924edb7af$export$2e2bcd8739ae039)(ticker);
    const known = profile.loading || profile.error || profile.data !== null;
    if (!known) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "co-page",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "card co-card co-empty",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                    children: [
                        "We couldn't find \u201C",
                        ticker,
                        "\u201D"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Check the ticker or search for the company by name."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $744722faeae46062$export$2e2bcd8739ae039), {
                    autoFocus: true
                })
            ]
        })
    });
    const q = quote.data;
    const p = profile.data;
    const up = q && q.change >= 0;
    let body;
    switch(tab){
        case "financials":
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2ef8bad7964abbc$export$2e2bcd8739ae039), {
                ticker: ticker
            });
            break;
        case "valuation":
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $189f08c74fc76ae1$export$2e2bcd8739ae039), {
                ticker: ticker
            });
            break;
        case "model":
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd7e115d4c0afd7c$export$2e2bcd8739ae039), {
                ticker: ticker,
                user: user,
                onRequireLogin: onRequireLogin
            });
            break;
        case "estimates":
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5edce8265a0e4632$export$2e2bcd8739ae039), {
                ticker: ticker
            });
            break;
        case "transcripts":
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76affa0f86275e4c$export$2e2bcd8739ae039), {
                ticker: ticker
            });
            break;
        case "filings":
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $784b206569457de8$export$2e2bcd8739ae039), {
                ticker: ticker
            });
            break;
        case "ownership":
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb509ef0ec3befe7$export$2e2bcd8739ae039), {
                ticker: ticker
            });
            break;
        default:
            body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a79a9cbce8187a$export$2e2bcd8739ae039), {
                ticker: ticker,
                showChart: showChart
            });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "co-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$4e58f3d385baec7d), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "co-sticky-bar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "co-bar-top",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "co-bar-name",
                                children: p ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: p.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "co-exch",
                                            children: [
                                                p.exchange,
                                                ":",
                                                p.ticker
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55f9b3f8627f071$export$669f6ea7d267feaf), {})
                            }),
                            q && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "co-bar-price",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: (0, $45b05daa53b66210$export$d4b2b9303ce6cae8)(q.price)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: up ? "change-up" : "change-down",
                                        children: [
                                            up ? "+" : "",
                                            q.change.toFixed(2),
                                            " (",
                                            (0, $45b05daa53b66210$export$850409532323fff)(q.changePct, 2, true),
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: (0, $45b05daa53b66210$export$3865cc3c40061728)(q.date)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "co-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $146c4d921355ff51$export$2e2bcd8739ae039), {
                                        ticker: ticker,
                                        user: user,
                                        onRequireLogin: onRequireLogin
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        className: "co-currency",
                                        defaultValue: "USD",
                                        "aria-label": "Currency",
                                        title: "Only USD is available right now",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "USD",
                                            children: "USD"
                                        })
                                    }),
                                    tab === "overview" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "btn tool-btn",
                                        onClick: ()=>setShowChart(!showChart),
                                        children: [
                                            showChart ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                                size: 15
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                size: 15
                                            }),
                                            " ",
                                            showChart ? "Hide Chart" : "Show Chart"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                        className: "co-tabs",
                        "aria-label": "Company sections",
                        children: (0, $4a6071b6444d89fa$export$73b877b58963a4f).map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: (0, $4a6071b6444d89fa$export$3518935f988c2e40)(ticker, t.key),
                                className: tab === t.key ? "active" : "",
                                children: t.label
                            }, t.key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "co-body",
                children: body
            })
        ]
    });
}








const $1b8e0994176c9ade$var$MEMBER_ONLY = [
    "watchlist",
    "screens",
    "alerts",
    "compare",
    "portfolio"
];
const $1b8e0994176c9ade$var$TITLES = {
    screens: "Screens",
    alerts: "Stock Alerts",
    compare: "Compare Companies",
    portfolio: "Portfolio Tracker"
};
function $1b8e0994176c9ade$var$ComingSoon({ title: title }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "page-bg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dash-main-content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "fw-bold mb-2",
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted",
                    children: "This section is coming soon."
                })
            ]
        })
    });
}
function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    (0, $6d972d26c47ffac8$export$ae1efb09da3bcdf9)();
    const [currentUser, setCurrentUser] = (0, $acw62.useState)(null);
    const [checkingSession, setCheckingSession] = (0, $acw62.useState)(true);
    const [page, setPage] = (0, $acw62.useState)("home");
    const [pendingPage, setPendingPage] = (0, $acw62.useState)(null);
    const [showLogin, setShowLogin] = (0, $acw62.useState)(false);
    const [showSignup, setShowSignup] = (0, $acw62.useState)(false);
    const [route, setRoute] = (0, $acw62.useState)(()=>(0, $4a6071b6444d89fa$export$fddf14af0d71329f)());
    (0, $acw62.useEffect)(()=>{
        if (route && currentUser) (0, $b1f811543f3e0211$export$6b2a7d5132615086)("view_stock", {
            ticker: route.ticker,
            tab: route.tab || "overview"
        });
    }, [
        route && route.ticker,
        route && route.tab,
        currentUser && currentUser.id
    ]);
    (0, $acw62.useEffect)(()=>{
        const onHash = ()=>{
            setRoute((0, $4a6071b6444d89fa$export$fddf14af0d71329f)());
            window.scrollTo(0, 0);
        };
        window.addEventListener("hashchange", onHash);
        return ()=>window.removeEventListener("hashchange", onHash);
    }, []);
    (0, $acw62.useEffect)(()=>{
        let alive = true;
        (async ()=>{
            const session = (0, $814748c4d1640136$export$12151e9ef3722552)();
            if (session) {
                const ok = await (0, $c8ac4ec5c1859847$export$a16e60d0d9d0a6cf)(session.user);
                if (!alive) return;
                if (ok) setCurrentUser(session.user);
                else (0, $814748c4d1640136$export$7809a8af6f3e4c63)();
            }
            if (alive) setCheckingSession(false);
        })();
        return ()=>{
            alive = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!currentUser) return;
        const interval = setInterval(()=>{
            if (!(0, $814748c4d1640136$export$12151e9ef3722552)()) {
                (0, $c8ac4ec5c1859847$export$fab3fd6c390bad62)();
                setCurrentUser(null);
                setPage("home");
            }
        }, 30000);
        const onStorage = (e)=>{
            if (e.key === (0, $814748c4d1640136$export$8b437002c2b08d1) && !e.newValue) {
                (0, $c8ac4ec5c1859847$export$fab3fd6c390bad62)();
                setCurrentUser(null);
                setPage("home");
            }
        };
        window.addEventListener("storage", onStorage);
        return ()=>{
            clearInterval(interval);
            window.removeEventListener("storage", onStorage);
        };
    }, [
        currentUser
    ]);
    const handleNavigate = (key)=>{
        (0, $b1f811543f3e0211$export$6b2a7d5132615086)("open_page", {
            page: key
        });
        (0, $4a6071b6444d89fa$export$c40b91ede3abf83a)();
        setRoute(null);
        if ($1b8e0994176c9ade$var$MEMBER_ONLY.includes(key) && !currentUser) {
            setPendingPage(key);
            setShowLogin(true);
            return;
        }
        setPage(key);
    };
    const closeModals = ()=>{
        setShowLogin(false);
        setShowSignup(false);
        setPendingPage(null);
    };
    const handleAuthSuccess = async (userData)=>{
        (0, $814748c4d1640136$export$ccdf34816785229e)(userData);
        await (0, $c8ac4ec5c1859847$export$a16e60d0d9d0a6cf)(userData);
        setCurrentUser(userData);
        setShowLogin(false);
        setShowSignup(false);
        setPage(pendingPage || "home");
        setPendingPage(null);
    };
    const handleLogout = async ()=>{
        await (0, $276e2b1a147d904e$export$b0ac3a1c242cb1ea)();
        (0, $814748c4d1640136$export$7809a8af6f3e4c63)();
        (0, $c8ac4ec5c1859847$export$fab3fd6c390bad62)();
        setCurrentUser(null);
        setPage("home");
    };
    if (checkingSession) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "auth-loading",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "spinner-border text-secondary",
            role: "status"
        })
    });
    const activePage = !currentUser && $1b8e0994176c9ade$var$MEMBER_ONLY.includes(page) ? "home" : page;
    let content;
    if (route) content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd7229c0bec47ef0$export$2e2bcd8739ae039), {
        ticker: route.ticker,
        tab: route.tab,
        user: currentUser,
        onRequireLogin: ()=>setShowLogin(true)
    }, route.ticker);
    else if (activePage === "home") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ba0581fdbb1660$export$2e2bcd8739ae039), {});
    else if (activePage === "feed") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3163c93b9e14f42$export$2e2bcd8739ae039), {
        user: currentUser
    });
    else if (activePage === "companies") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75cbce5baaa063c0$export$2e2bcd8739ae039), {
        user: currentUser
    });
    else if (activePage === "screens") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a075e8c3bd1ab312$export$2e2bcd8739ae039), {
        user: currentUser
    }, currentUser.id);
    else if (activePage === "alerts") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $923b0b47856f1271$export$2e2bcd8739ae039), {
        user: currentUser
    }, currentUser.id);
    else if (activePage === "compare") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2e242a095574dbe$export$2e2bcd8739ae039), {});
    else if (activePage === "portfolio") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $199e0b543047ba11$export$2e2bcd8739ae039), {
        user: currentUser
    }, currentUser.id);
    else if (activePage === "watchlist") content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d7fd6f403e72730$export$2e2bcd8739ae039), {
        user: currentUser,
        onBack: ()=>setPage("home")
    }, currentUser.id);
    else content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$ComingSoon, {
        title: $1b8e0994176c9ade$var$TITLES[activePage] || "Page"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "home-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db9ed9a2274fc7a3$export$2e2bcd8739ae039), {
                user: currentUser,
                page: route ? "" : activePage,
                onNavigate: handleNavigate,
                onOpenLogin: ()=>setShowLogin(true),
                onOpenSignup: ()=>setShowSignup(true),
                onLogout: handleLogout
            }),
            content,
            showLogin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e24447910c2368c6$export$2e2bcd8739ae039), {
                onLogin: handleAuthSuccess,
                onClose: closeModals
            }),
            showSignup && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ba87e0b31e6dd0e$export$2e2bcd8739ae039), {
                onSignup: handleAuthSuccess,
                onClose: closeModals
            })
        ]
    });
}


const $34a83e38fb8b3bfc$var$container = document.getElementById("root");
const $34a83e38fb8b3bfc$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($34a83e38fb8b3bfc$var$container);
$34a83e38fb8b3bfc$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=screener836.922ee927.js.map
